<template>
    <div style="margin-top:-25px">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 text-left">
                <div class="d-flex align-items-center flex-wrap" style="gap: 16px;">
                    <h2 style="font-size: 40px; font-weight: 700; line-height: 48px; " class="mb-0 mt-2">Campaign Management</h2>
                    <div v-if="userType != 'client' && PredictQuotaCampaigns !== undefined && PredictMaxCampaigns !== undefined" class="quota-info-badge" style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background-color: #f0f0f0; border-radius: 8px; margin-top: 8px;">
                        <i class="fas fa-bullhorn" style="color: #409EFF;"></i>
                        <span style="font-size: 14px; font-weight: 600; color: #333;">
                            Your Quota: <span style="color: #409EFF;">{{PredictQuotaCampaigns || 0}}/{{PredictMaxCampaigns || 0}}</span> campaigns
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-3 pb-3">&nbsp;</div>

        <div class="row" id="processingArea">
             <div class="col-sm-12 col-md-12 col-lg-12">
                 <!-- <card> -->
                    <div class="d-flex flex-wrap" style="justify-content: space-between;">
                        <div class="d-flex align-items-center flex-wrap" style="column-gap:8px;row-gap:20px">
                        <div class='campaign-filter-item-wrapper'>
                                <span style="opacity:0.3">Showing</span>
                                <span v-for="(filter, index) in (optionCampaignStatus || [])" @click="applyFilter(filter)" :class="['--filter-item',{'--active':filterCampaignStatus === filter.value}]" :key='index'>{{filter.label}}</span>
                        </div>
                        <div class="container__input__campaign__management">
                            <base-input class='mb-0'>
                                <el-input type="text" class="search-input input__campaign__management" clearable prefix-icon="el-icon-search"
                                    placeholder="Search" v-model="searchQuery" aria-controls="datatables" @keyup.native.enter="searchKeyWord" @clear="searchKeyWord">
                                </el-input>
                            </base-input>
                        </div>
                        <SelectClientDropdown class="client-filter-anchor"></SelectClientDropdown>
                        </div>
                        <div class="container__filter__campaign__management">
                            <div>
                                <base-button size="sm" style="height:40px" class="button__filter__campaign__management create-campaign-anchor" :disabled="isLoadingCheckCampaignLimit" @click="AddEditClient('')"
                                    v-if="userType != 'client' && this.$global.menuLeadsPeek_create && (this.$global.betaFeature.predict_module && this.$global.betaFeature.predict_module.has_agreement && this.$global.betaFeature.predict_module.has_agreement === true)">
                                    <i class="mr-1" :class="isLoadingCheckCampaignLimit ? 'fas fa-spinner fa-spin' : 'fas fa-plus-circle'"></i> Add Campaign
                                </base-button>
                                <base-button size="sm" style="height:40px" class="button_filtercampaign_management" @click="startTour">
                                    <i class="mr-1 fas fa-question-circle"></i> Help
                                </base-button>
                            </div>
                        </div>
                    </div>
              

                   
                    
                    
                     
                     <transition name="fade">
                        <div v-if="fetchingCampaignData" >
                            <div style="min-height: 40vh; display: flex; justify-content: center; align-items: center;">
                                <i class="fas fa-spinner fa-spin" style="font-size: 40px;"></i>
                            </div>
                        </div>
                        <div v-else class='mt-3 mt-md-5 d-flex flex-column' style='gap: 16px' >
                            <card   class="mb-0" v-for="(campaign,index) in queriedData" :key="campaign.leadspeek_api_id">
                                <div  class='d-flex justify-content-between align-items-center flex-wrap cursor-pointer' style='gap: 8px'>
                                    <div class='campaign-card-title-info-wrapper' @click.stop>
                                        <!-- <span class="card-icon-styling" :style='{backgroundColor:colorOptions[(index * 7) % 4 + 1].background}'>
                                            <i class="fa-solid fa-bullhorn" :style="{color:colorOptions[(index * 7) % 4 + 1].color}"></i>
                                        </span> -->
                                        <div class='align-items-center d-flex flex-wrap' style='gap:16px'>
                                            <div class='campaign-card-title-info'>
                                                <span class='campaign-card-client-name'>{{campaign.company_name}}</span>
                                                <span class="campain-card-name d-flex justify-content-between"><span class='campaign-name-ellips'>{{campaign.campaign_name}}</span> <span class='arrows'><i class="fa-solid fa-arrow-up" :style="{opacity: currOrderBy == 'ascending' ? 0.3 : 0.6}" @click.stop="sortdynamic('campaign_name','ascending')"></i><i :style="{opacity: currOrderBy == 'descending' ? 0.3 : 0.6}" class="fa-solid fa-arrow-down" @click.stop="sortdynamic('campaign_name','descending')"></i></span></span>
                                                <span v-if="campaign.start_billing_date || campaign.last_lead_added" class='campaign-card-update-date'>
                                                    Last updated on {{ formatMDY(campaign.start_billing_date || campaign.last_lead_added) }}
                                                </span>
                                            </div>
                                            <div v-if="campaign.disabled == 'F' && campaign.active_user == 'T'" class='campaign-card-status-badge' style="background:rgb(0, 81, 97);color:white"><span >Running</span></div>
                                            <div v-if="campaign.disabled == 'T' && campaign.active_user == 'T'" class='campaign-card-status-badge' style="background:#fdae61"><span>Paused</span></div>
                                            <div v-if="campaign.active_user == 'F'" class='campaign-card-status-badge' style="background:rgb(147, 2, 30);color:white">
                                                <span>Stopped</span>
                                                <el-tooltip v-if="campaign.stop_after_billing_period == 'T'" class="ml-2" placement="top" :content="`Scheduled stop — active until ${campaign.lp_invoice_date_next_month}`">
                                                    <i class="fas fa-clock ml-1" style="font-size:12px"></i>
                                                </el-tooltip>
                                            </div>
                                            <!-- <div v-if="campaign.campaign_never_started == 'T' && campaign.active_user == 'F' && campaign.total_leads == '0'" class='campaign-card-status-badge' style="background:rgb(88, 92, 102);color:white"><span >Never Started</span></div> -->
                                            <div v-if="['queue', 'progress'].includes(campaign.fetch_report_status)" class='campaign-card-status-badge' style="background:rgb(88, 92, 102);color:white">
                                                <span>Processing Data <i class="fas fa-spinner fa-pulse ml-1"></i></span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class='d-flex justify-content-between align-items-center flex-wrap campaign-card-right-wrapper'>

                                        <div class='campaign-card-stat-wrapper' style='min-width: 253px;justify-content: flex-end;'>
                                            <div class='campaign-card-stat-block stat-block-id-anchor'>
                                                <span class='--stat-block-title'>ID</span>
                                                <span class='--stat-block-value'>{{campaign.leadspeek_api_id}} <span v-if="$global.globalviewmode && userTypeOri != 'sales' && $global.rootcomp">
                                                <!-- <span v-if="campaign.clientcampaignsid != ''" class="pl-2"><a :href="'https://app.simpli.fi/organizations/' +  campaign.clientorganizationid + '/campaigns/' + campaign.clientcampaignsid + ''" target="_blank"><i class="fas fa-chart-line" style="color:green"></i></a></span>
                                                <i v-if="campaignclientcampaignsid == ''" class="fas fa-exclamation-triangle pl-2" style="color:yellow"></i> -->
                                                
                                              </span>
                                              <span v-if="$global.globalviewmode && userTypeOri != 'sales' && $global.rootcomp && ($global.user_permissions == null || $global.user_permissions.report_analytics)">
                                                <span v-if="campaign.leadspeek_api_id != ''" class="pl-2"><a :href="'/configuration/report-analytics/?campaignid=' +  campaign.leadspeek_api_id + ''" target="_blank"><i class="fas fa-file-chart-line" style="color:gray"></i></a></span>
                                              </span></span>
                                            </div>
                                            <div class='campaign-card-stat-block stat-block-total-anchor'>
                                                <span class='--stat-block-title'>Total</span>
                                                <span class='--stat-block-value'>{{campaign.total_leads || 0}}</span>
                                            </div>
                                            <!-- <div class='campaign-card-stat-block stat-block-yesterday-anchor'>
                                                <span class='--stat-block-title'>Yesterday's</span>
                                                <span class='--stat-block-value'> <span :style="{ color: campaign.yerterday_leads > 1.1 * campaign.yerterday_previous_leads ? 'green' : campaign.yerterday_leads < 0.9 * campaign.yerterday_previous_leads ? 'red' : '' }">{{campaign.yerterday_leads}}</span></span>
                                            </div>
                                            <div class='campaign-card-stat-block stat-block-list-queue-id-anchor' v-if="$global.globalviewmode && userTypeOri != 'sales' && $global.rootcomp">
                                                <span class='--stat-block-title'>List Queue ID</span>
                                                <span class='--stat-block-value'>
                                                    <span>{{campaign.list_queue_id ? campaign.list_queue_id : '-'}}</span>
                                                </span>
                                            </div> -->
                                        </div>
                                        <div class='campaign-card-actions-block flex-column'>
                                            <div class='campaign-card-actions-block' style="justify-content:flex-end">
                                                <el-popover
                                                        v-if="false"
                                                        content="Edit This Campaign"
                                                        effect="light"
                                                        placement="top"
                                                        trigger="hover"
                                                    >
                                                    <span slot="reference" @click='handleExpandChange(campaign, queriedData)' class="card-action-icon-wrapper edit-btn-anchor">
                                                        <i class="fa-solid fa-pen"></i>
                                                    </span>
                                                </el-popover>
                                                <el-popover v-if="false" trigger="hover" content="Campaign Financials" placement="top">
                                                    <span slot="reference" @click.stop="handlePriceSet(index, campaign)" class="card-action-icon-wrapper campaign-financials-btn">
                                                        <i class="fa-solid fa-dollar-sign"></i>
                                                    </span>
                                                </el-popover>
                                                <el-popover v-if="false" trigger="hover" placement="top" content="Configure integrations">
                                                    <span slot="reference" @click.stop="handleIntegrationClick(index, campaign)" class="card-action-icon-wrapper campaign-integration-btn">
                                                        <i class="fas fa-plug"></i>
                                                    </span>
                                                </el-popover>

                                                <!-- DEMO NOT VIEW AS -->
                                                <el-popover
                                                    trigger="hover"
                                                    v-if="false"
                                                    :content="'Go to Google Sheet'"
                                                    placement="top"
                                                >
                                                    <span slot="reference" class="card-action-icon-wrapper google-sheet-anchor">
                                                        <!-- :href="'https://docs.google.com/spreadsheets/d/' + campaign.spreadsheet_id + '/edit#gid=0'"  -->
                                                        <a 
                                                            :href="
                                                                isCampaignTypeSelectedRow('b2c', campaign.business_type_id) ? 
                                                                'https://docs.google.com/spreadsheets/d/1f--p4QNiKtWo8p3aAscgzqziIP2l85PGuYy7GJ04MvY/edit?usp=sharing' : 
                                                                'https://docs.google.com/spreadsheets/d/1wJRFF4XsEW6T63ih7FW-gvWYCVVE6Pg_QvTGwgpc554/edit?usp=sharing'
                                                            "
                                                            target="_blank">
                                                            <i class="fab fa-google-drive"></i>
                                                        </a>
                                                    </span>
                                                </el-popover>

                                                <!-- REAL -->
                                                <!-- <el-popover
                                                    trigger="hover"
                                                    v-if="!$global.globalviewmode"
                                                    :content="GoogleConnectTrue && campaign.spreadsheet_id != '' ? 'Go to Google Sheet' : 'Download Excel'"
                                                    placement="top"
                                                >
                                                    <span slot="reference" class="card-action-icon-wrapper google-sheet-anchor">
                                                        <a v-if="GoogleConnectTrue && campaign.spreadsheet_id != ''" :href="'https://docs.google.com/spreadsheets/d/' + campaign.spreadsheet_id + '/edit#gid=0'" target="_blank"><i class="fab fa-google-drive"></i></a>
                                                        <i v-else class="fas fa-file-excel pl-2 pr-2" @click.stop="ExportLeadsData(index, campaign)"></i>
                                                    </span>
                                                </el-popover> -->

                                                <!-- DEMO VIEW AS -->
                                                <el-popover
                                                    trigger="hover"
                                                    v-if="false"
                                                    :content="'Go to Google Sheet'"
                                                    placement="top"
                                                >
                                                    <span slot="reference" class="card-action-icon-wrapper google-sheet-anchor">
                                                        <a 
                                                            :href="
                                                                isCampaignTypeSelectedRow('b2c', campaign.business_type_id) ? 
                                                                'https://docs.google.com/spreadsheets/d/1f--p4QNiKtWo8p3aAscgzqziIP2l85PGuYy7GJ04MvY/edit?usp=sharing' : 
                                                                'https://docs.google.com/spreadsheets/d/1wJRFF4XsEW6T63ih7FW-gvWYCVVE6Pg_QvTGwgpc554/edit?usp=sharing'
                                                            "
                                                            target="_blank">
                                                            <i class="fab fa-google-drive"></i>
                                                        </a>
                                                    </span>
                                                </el-popover>

                                                <!-- VIEW DETAIL ICON -->
                                                <el-popover content="View details" placement="top" trigger="hover">
                                                    <el-button
                                                        slot="reference"
                                                        :style="{
                                                            backgroundColor: 'transparent !important',
                                                            color: '#66d9ef !important'
                                                        }"
                                                        icon="el-icon-view"
                                                        size="mini"
                                                        circle
                                                        class="icon__button custom__icon__btn"
                                                        @click.stop="onViewCampaignDetail(index, campaign)"
                                                    ></el-button>
                                                </el-popover>

                                                <!-- DOWNLOAD ICON -->
                                                <el-popover content="Download" placement="top" trigger="hover">
                                                    <el-button
                                                        slot="reference"
                                                        :style="{ 
                                                            backgroundColor: 'transparent !important', 
                                                            color: '#66d9ef !important'
                                                        }"
                                                        icon="el-icon-download"
                                                        size="mini"
                                                        circle
                                                        class="icon__button custom__icon__btn icon_btn_download"
                                                        @click.stop="onDownload(index, campaign)"
                                                    ></el-button>
                                                </el-popover>
                                                
                                                <!-- REAL -->
                                                <!-- <el-popover
                                                    trigger="hover"
                                                    v-if="$global.globalviewmode"
                                                    :content="GoogleConnectTrue && campaign.spreadsheet_id != '' ? 'Go to Google Sheet' : 'Download Excel'"
                                                    placement="top"
                                                >
                                                    <span slot="reference" class="card-action-icon-wrapper google-sheet-anchor">
                                                        <a v-if="GoogleConnectTrue && campaign.spreadsheet_id != ''" :href="'https://docs.google.com/spreadsheets/d/' + campaign.spreadsheet_id + '/edit#gid=0'" target="_blank"><i class="fab fa-google-drive"></i></a>
                                                        <i v-else class="fas fa-file-excel pl-2 pr-2" @click.stop="ExportLeadsData(index, campaign)"></i>
                                                    </span>
                                                </el-popover> -->

                                                <el-popover trigger="hover" v-show="$store.getters.userData.user_type != 'client' && (campaign.payment_status != 'failed' || $store.getters.userData.manual_bill == 'T') && ( campaign.active_user == 'F' || (campaign.disabled == 'T' && campaign.active_user == 'T'))" :content="tooltip_campaign(index, campaign, 'play')" placement="top">
                                                    <span slot="reference" @click.stop="activepauseclient(index, campaign, 'play')" class="card-action-icon-wrapper play-pause-stop-anchor">
                                                        <i class="fas fa-play"></i>
                                                    </span>
                                                </el-popover>
                                                <el-popover v-if="false" trigger="hover" v-show="(campaign.disabled == 'F' && campaign.active_user == 'T')" :content="tooltip_campaign(index, campaign, 'pause')" effect="light" :open-delay="300" placement="top">
                                                    <span slot="reference" :class="{'cursornodrop': campaign.active_user == 'F' && (campaign.customer_card_id == '' && $store.getters.userData.manual_bill == 'F')}"  @click.stop="activepauseclient(index, campaign, 'pause')" class="card-action-icon-wrapper play-pause-stop-anchor" placement="top">
                                                        <i class="fas fa-pause"></i>
                                                    </span>
                                                </el-popover>
                                                <el-popover trigger="hover" v-show="$store.getters.userData.user_type != 'client' && ((campaign.disabled == 'F' && campaign.active_user == 'T') || (campaign.disabled == 'T' && campaign.active_user == 'T'))" :content="tooltip_campaign(index, campaign, 'stop')" placement="top">
                                                    <span slot="reference" @click.stop="handleDelete(index, campaign)" class="card-action-icon-wrapper play-pause-stop-anchor">
                                                        <i class="fas fa-stop"></i>
                                                    </span>
                                                </el-popover>
                                            </div>

                                            
                                        </div>
                                        <div @click.stop>
                                            <el-dropdown v-if="$store.getters.userData.user_type != 'client'" trigger="click">
                                                <span class="menu-drop-anchor" >
                                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                                </span>
                                                <el-dropdown-menu slot="dropdown" >
                                                    <div v-if="false" @click.stop='handleApproxLeadCountEdit(campaign, queriedData)'>
                                                        <el-dropdown-item >Search Volume Estimate</el-dropdown-item>
                                                    </div>
                                                     <!-- <div @click.stop='handleExpandChange(campaign, queriedData)'>
                                                        <el-dropdown-item >Edit</el-dropdown-item>
                                                    </div>
                                                    -->
                                                   <div v-if="false && campaign.disabled == 'T' && campaign.active_user == 'T'" @click.stop="activepauseclient(index, campaign, 'play')">
                                                        <el-dropdown-item>Play</el-dropdown-item>
                                                    </div>
                                                    <div v-if="false && campaign.disabled == 'F' && campaign.active_user == 'T'" @click.stop="activepauseclient(index, campaign, 'pause')">
                                                        <el-dropdown-item >Pause</el-dropdown-item>
                                                    </div>
                                                    <div v-if="false && campaign.active_user != 'F'" @click.stop="handleDelete(index, campaign)">
                                                        <el-dropdown-item>Stop</el-dropdown-item>
                                                    </div> 
                                                    <div v-if="$global.globalviewmode" @click.stop="archiveCampaign(index, campaign)">
                                                        <el-dropdown-item>Archive</el-dropdown-item>
                                                    </div>
                                                    <div v-if="false" @click.stop="showWhitelist(index, campaign)">
                                                        <el-dropdown-item>Exclusion</el-dropdown-item>
                                                    </div>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </div>
                                    </div>
                                </div> 
                            </card>
                            <div class="align-items-center d-flex justify-content-center text-center" style="height: 200px;" v-if='queriedData && queriedData.length <= 0'>
                                No campaigns found 
                            </div>  
                        </div>
                     </transition>
               
               
                        <div class="tab-footer pull-right">
                                    <div class="pt-3">
                                        <p class="card-category">
                                            Showing {{ (pagination && pagination.from) || 0 }} to {{ (pagination && pagination.to) || 0 }} of {{ (pagination && pagination.total) || 0 }} entries
                                        </p>
                                    </div>
                                        <base-pagination
                                        class="pagination-no-border pt-4"
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total="pagination.total"
                                        @input="changePage"
                                        >
                                        </base-pagination>
                                </div>


                 <!-- </card> -->
             </div>    
        </div>

                            

                            <!-- Modal General Information -->
                            <modal :show.sync="modals.helpguide" headerClasses="justify-content-center" modalContentClasses="">
                                <h4 slot="header" class="title title-up" v-html="modals.helpguideTitle"></h4>
                                <p class="text-center" v-html="modals.helpguideTxt">
                                </p>
                            
                                <template slot="footer">
                                <div class="container text-center pb-4">
                                    <base-button  @click.native="modals.helpguide = false">Close</base-button>
                                </div>
                                </template>
                            </modal>
                            <!-- Modal General Information -->

                     

                            <!-- Modal Setting Markup -->
                            <modal id="modalSetPrice" :show.sync="modals.pricesetup" headerClasses="justify-content-center" modalContentClasses="">
                              <h4 slot="header" class="title title-up">Campaign Financials For: <span style="color:#000000">{{LeadspeekCompany}}</span></h4>

                              <campaign-financials
                                :user-type="userType"
                                :txt-lead-service="txtLeadService"
                                :leadspeek-input-read-only="LeadspeekInputReadOnly"
                                :platform-fee.sync="LeadspeekPlatformFee"
                                :min-cost-month.sync="LeadspeekMinCostMonth"
                                :m-platform-fee="m_LeadspeekPlatformFee"
                                :m-min-cost-month="m_LeadspeekMinCostMonth"
                                :t-platform-fee="t_LeadspeekPlatformFee"
                                :t-min-cost-month="t_LeadspeekMinCostMonth"
                                :selects-payment-term="selectsPaymentTerm"
                                :prepaid-type="prepaidType"
                                :conti-duration-selection="contiDurationSelection"
                                :limit-lead="LeadspeekLimitLead"
                                :cost-per-lead="LeadspeekCostperlead"
                                :t-freq="t_freq"
                                :t-profit="t_profit"
                                @recalculate="profitcalculation"
                              />

                              

                          
                              <template slot="footer">
                                <div class="container text-center pb-4" >
                                  <base-button v-if="LeadspeekLimitLead > 0" @click.native="setModuleCost()">Ok, Set It Up!</base-button>
                                </div>
                              </template>
                            </modal>
                           <!-- Modal Setting Markup -->

                           <!-- WhiteList DB upload -->
                            <modal :show.sync="modals.whitelist" id="locatorWhitelist" headerClasses="justify-content-center" modalContentClasses="">
                              <h4 slot="header" class="title title-up">Exclusion List for this campaign</h4>
                              <div>
                                <!--UPLOAD-->
                                    <form enctype="multipart/form-data">
                                        <!--<h5>Drag & Drop your suppression List (file type should be .csv). Download <a href="#">example file</a></h5>-->
                                        <div class="dropbox">
                                        <input type="file" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                                            accept=".csv" class="input-file">
                                            <p v-if="isInitial">
                                            Drag your file here to upload<br/>or click to browse<br/>
                                            <!--<base-button type="info" round icon  @click="show_helpguide('suppression')">
                                                <i class="fas fa-question"></i>
                                            </base-button>-->
                                            </p>
                                            <p v-if="isSaving">
                                                Please Wait, your file being upload ...
                                            </p>
                                            <p v-if="isSuccess">
                                                Your Suppression file has been Submitted, Thank you!
                                            </p>
                                            <p v-if="isFailed">
                                                Whoops that did not work, please check your file for errors and try again
                                            </p>
                                        </div>
                                    </form>
                              </div>
                                <!-- <ul v-if="supressionProgress.length > 0" class="mt-2 mb-0 mx-0 p-0" style="list-style: none; max-height: 90px; overflow: auto;">
                                    <li v-for="(progress, index) in supressionProgress" :key="index" class="text-dark m-0 p-0">
                                        <i class="mr-2" :class="{'el-icon-loading': progress.status === 'progress', 'el-icon-circle-check': progress.status === 'done', 'el-icon-eleme': progress.status === 'queue'}"></i> 
                                        <span class="mr-2">{{ progress.filename }}</span> 
                                        <span v-if="progress.status === 'done'">{{ progress.status }}</span>
                                        <span>{{ progress.percentage }}%</span>
                                        <span>{{ progress.total_row }}/{{ progress.current_row }}</span>
                                    </li>
                                </ul> -->
                                <div v-if="supressionProgress.length > 0">
                                    <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                                      <div v-for="(value) in supressionProgress" :key="value.id">
                                          <div style="display: flex; width: 100%; gap: 8px;">
                                              <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                                              <div style="width: 100%;">
                                                  <p style="color: #000000; font-weight: 600; margin-bottom: 0px;">{{ value.filename }}</p>
                                                  <el-progress :percentage="value.percentage == null ? 0 : value.percentage"></el-progress>
                                                  <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                                              </div>
                                          </div>
                                          <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                                      </div>
                                </div>
                              <div class="pt-2 mt-3">
                                You have the ability to restrict your current database from being identified as a new contact. 
                                You can Exclude them by uploading a list of MD5 encrypted email addresses, 
                                or by uploading a list of email addresses and we will encrypt them for you. 
                                Do not include any other information in the file aside from the email address. 
                                You may upload lists of up to 10,000 records at a time. <a
                                 href='https://app.exactmatchmarketing.com/samplefile/suppressionlist.csv' target='_blank'>Click here</a> to download a Sample File
                              </div>
                              <div v-if="supressionDone.length > 0">
                                  <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                                    <div v-for="(value) in supressionDone" :key="value.id">
                                      <div style="display: flex; width: 100%; gap: 8px;">
                                          <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                                          <div style="width: 100%;">
                                              <p style="color: #000000; font-weight: 600; margin-bottom: 0px;">{{ value.filename }}</p>
                                              <el-progress :percentage="value.percentage" status="success"></el-progress>
                                              <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                                            </div>
                                        </div>
                                        <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                                    </div>
                                </div>
                              <a class="mt-2 d-inline-block" @click="purgeSuppressionList('campaign')" style="cursor: pointer;"><i class="fas fa-trash" ></i> Purge Existing Records</a>
                              <template slot="footer">
                                <div class="container text-center pb-4">
                                  <base-button  @click.native="modals.whitelist = false">Cancel</base-button>
                                </div>
                              </template>
                            </modal>
                           <!-- WhiteList DB upload -->

     <div id="popProcessing" class="popProcessing" style="display:none" v-html="popProcessingTxt">Please wait, updating campaign ....</div> 
     <!-- Integrations modal -->
     <modal :show.sync="modals.integrations" id="addIntegrations" modalContentClasses=""
            footerClasses="border-top">
       <h3 slot="header" class="title title-up">Add integrations to campaign #{{selectedRowData.leadspeek_api_id}}</h3>
        integrations = {{ integrations }} <br>
        <IntegrationModalBody
          ref="integrationBodyRef"
          v-model="selectedRowData"
          :integrations="integrations"
          :selected-integration.sync="selectedIntegration"
          :user-type="userType"
          :selects-administrator="selectsAdministrator"
          @close="modals.integrations = false"
          @saved="onIntegrationSaved"
          @loading-change="isLoadingSaveIntegration = $event"
        />
            <!-- Legacy integrations UI removed after refactor to IntegrationModalBody -->
            <!-- (cleaned) -->
            <div v-if="false">
                <div class="integratios-list-wrapper d-flex align-items-center gap-4 flex-wrap">
                    <div v-for="item in integrations" :key="item.slug"
                        class="integrations__modal-item-wrapper d-flex align-items-center justify-content-center shadow-sm border"
                        :class="{ '--active bg-blue text-secondary': item.slug === selectedIntegration }"
                        @click="integrationItemClick(item)">
                        <div class="integrations__modal-item">
                            <img
                                v-if="item.custom_img"
                                class="logo-wrap-campaign"
                                :src="item.custom_img"
                                alt="brand-logo"
                            />
                            <i v-else :class="item.custom_icon || item.logo" style="font-size: 36px;"></i>
                            <span class="integrarion-brand-name" style="text-align: center;">{{ item.custom_name || item.name }}</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-center shadow-sm add-new-integration-wrapper"
                        @click="redirectToAddIntegration">
                        <i class="fa-solid fa-plus" style="font-size: 36px;"></i>
                        <span class="integrarion-brand-name">Add integration</span>
                    </div>
                </div>
              
                <div class="mt-4">
                    <div v-if="selectedIntegration === 'googlesheet'" class="">
                        <div v-if="isGoogleInfoFetching" class="row" v-loading="true" id="loading"></div>
                        <div v-if="isLoadingResetSpreadsheet" class="row" v-loading="true" id="loading"></div>
                        <div v-else>
                            <base-input label="Client Emails Approved to View the Google Sheet:">
                                <textarea class="w-100" v-model="selectedRowData.report_sent_to" @keydown="handleKeydown" @paste="handlePaste"
                                    placeholder="Enter email, separate by new line" rows="4">
                                </textarea>
                                <span>Seperate the emails by space or comma</span>
                            </base-input>
                             <div class="has-label" :style="{display : userType === 'client' ? 'none' : 'block'}">
                                <label>Admins Approved for Google Sheet Administration</label>
                                <el-select multiple class="select-info select-fullwidth" size="large"
                                    v-model="selectedRowData.admin_notify_to" placeholder="You can select multiple Admin">
                                    <el-option v-for="option in selectsAdministrator.administratorList" class="select-info"
                                        :value="option.id" :label="option.name" :key="option.id">
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="mt-3">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                    @click="onSendTestSpreadsheet"
                                    circle
                                    :disabled="isLoadingSendTestSpreadsheet"
                                    ></el-button>
                                    <el-button type="text" :disabled="isLoadingSendTestSpreadsheet" @click="onSendTestSpreadsheet" style="margin-left: 0px;">Check Spreadsheet Connection</el-button>
                                </div>
                            </div>

                            <div class="mt-3">
                                <!-- MAIN SHEET -->
                                <div v-if="selectedRowData.spreadsheet_id" class="gsheet-grid mt-1">
                                    <a
                                    class="gsheet-item"
                                    :href="'https://docs.google.com/spreadsheets/d/' + selectedRowData.spreadsheet_id + '/edit#gid=0'"
                                    target="_blank"
                                    style="text-decoration: none; color: #222a42 !important;"
                                    >
                                        <span>Open google sheet</span>
                                        <el-tooltip content="Go to Google Sheet" effect="light" :open-delay="300" placement="top">
                                        <i class="fab fa-google-drive  ml-2" style="color:#6699CC"></i>
                                        </el-tooltip>
                                    </a>
                                </div>

                                <label v-if="filteredHistory.length" class="mt-3">History Spreadsheet</label>
                                <!-- HISTORY SHEET -->
                                <div v-if="filteredHistory.length" class="mt-2">
                                    <div class="history-grid">
                                        <a v-for="(item, index) in filteredHistory" :key="index" class="history-item"
                                        :href="'https://docs.google.com/spreadsheets/d/' + item.spreadsheet_id + '/edit#gid=0'" target="_blank"
                                        style="text-decoration: none; color: #222a42 !important;">
                                            <span class="history-label">
                                                History {{ index + 1 }} ({{ item.created_at }})
                                            </span>
                                            <el-tooltip content="View this spreadsheet" effect="light" :open-delay="300" placement="top">
                                            <i class="fab fa-google-drive ml-2" style="color:#CCCC66"></i>
                                            </el-tooltip>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <!-- <span v-if="selectedRowData.spreadsheet_id" class="d-block mt-4">Open google sheet <el-tooltip content="Go to Google Sheet" effect="light" :open-delay="300" placement="top">
                                <a class="pl-2 pr-2" style="color:white" :href="'https://docs.google.com/spreadsheets/d/' + selectedRowData.spreadsheet_id + '/edit#gid=0'" target="_blank"><i class="fab fa-google-drive" style="color:#6699CC"></i></a>
                            </el-tooltip></span> -->
                        </div>
                    </div>
                    <div v-if="selectedIntegration === 'sendgrid'" class="''">
                      <div v-if="isSendgridInfoFetching" class="row" v-loading="true" id="loading"></div>
                      <div v-else-if="errors.sendgrid">
                            <el-alert
                                title="Connection Issue"
                                type="warning"
                                description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                :closable="false"
                                show-icon>
                            </el-alert>
                        </div>
                        <div v-else>
                        <el-checkbox v-model="selectedRowData.sendgrid_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                        <div class="d-flex mt-2" style="gap: 4px;">

                            <div class="has-label flex-grow-1">
                                <label class="mb-0">Choose Action</label>
                                <el-select multiple class="select-info select-fullwidth" size="large"
                                    v-model="selectedRowData.sendgrid_action" placeholder="You can select multiple actions">
                                    <el-option v-for="option in sendGridActionsOptions" class="select-info" :value="option.id"
                                        :label="option.name" :key="option.id">
                                    </el-option>
                                </el-select>
                            </div>
                             
                            <div v-if="selectedRowData.sendgrid_action && selectedRowData.sendgrid_action.includes('add-to-list')" class="flex-grow-1">
                                <div class="warning-banner" v-if="sendGridListOptions.length < 1"><p>You don't have any active {{ nameIntegration }} list please create one</p></div>
    
                                <div v-else class="has-label">
                                    <label class="mb-0">Choose {{ nameIntegration }} list</label>
                                    <el-select multiple class="select-info select-fullwidth" size="large"
                                        v-model="selectedRowData.sendgrid_list" placeholder="You can select multiple actions">
                                        <el-option v-for="option in sendGridListOptions" class="select-info" :value="option.id"
                                            :label="option.name" :key="option.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="has-label mt-2" v-if="userType != 'client' && selectedSendgridAction.includes('campaign')">
                            <label class="mb-0">Campaign Id</label>
                            <el-input label="Campaign Id" class="select-info select-fullwidth" size="large"
                                v-model="sendGridcampaignId" placeholder="Enter Campaign Id">

                            </el-input>
                        </div> -->

                        <base-input v-if="userType != 'client' && selectedRowData.sendgrid_list && selectedRowData.sendgrid_list.includes('send-mail')"
                            label="Email format">
                            <textarea class="w-100" v-model="ClientReportSentTo" placeholder="Enter email format" rows="4">
                            </textarea>
                        </base-input>
                        <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                @click="onSendTestLead"
                                circle
                                :disabled="isLoadingSendTestLead"
                                ></el-button>
                                <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                            </div>
                            <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="'el-icon-view'"
                                    @click="onViewExampleData"
                                    circle
                                    ></el-button>
                                    <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                            </div>
                        </div>
                        </div>
                    </div>

                     <div v-if="selectedIntegration === 'gohighlevel'" class="">
                        <div v-if="isGoHighInfoFetching" class="row" v-loading="true" id="loading"></div>
                        <div v-else-if="errors.goHighLevel">
                            <el-alert
                                title="Connection Issue"
                                type="warning"
                                description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                :closable="false"
                                show-icon>
                            </el-alert>
                        </div>
                        <div v-else>
                        <el-checkbox v-model="selectedRowData.ghl_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                    

                    <div class="has-label mt-2" v-if="selectedIntegration === 'gohighlevel'">
                        <label class="mb-0">Choose Tags</label>
                        <el-select 
                            ref="selectGhlTags"
                            multiple 
                            allow-create
                            filterable
                            default-first-option
                            :reserve-keyword="false"
                            class="select-info select-fullwidth select-integration-ghl" 
                            size="large"
                            v-model="ghl_tags" 
                            placeholder="You can select multiple tags"
                            @change="changeGhlTags"
                            @focus="changeGhlTags"
                            @blur="changeGhlTags"
                            @visible-change="changeGhlTags"
                            @remove-tag="changeGhlTags"
                            @clear="changeGhlTags">
                            <el-option v-for="option in goHighLevelTagsOptions" :value="option.id"
                                :label="option.name" :key="option.id">
                                <span class="ellipsis-text">{{ option.name }}</span>
                            </el-option>
                        </el-select>

                        <div v-if="ghl_tags_remove.length > 0" class="mt-2 mb-2">
                            <p class="m-0 p-0">*This tag has an error in {{ nameIntegration }}.</p>
                        </div>
                        <!-- <div v-if="ghl_tags_remove.length > 0" class="tags-container" style="padding-left: 6px;">
                            <div
                                v-for="(item, index) in ghl_tags_remove"
                                :key="index"
                                :style="{ backgroundColor: 'red', color: 'white', padding: '1px 8px', borderRadius: '99px' }"
                                class="tag-item"
                            >
                                <span class="tag-text">{{ item }}</span>
                            </div>
                        </div> -->
                        
                        </div>
                        <div class="mt-3">
                            <TagsAutomation
                                :isLoadingTagsAutomation="isLoadingTagsAutomation"
                                :isErrorTagsAutomation="isErrorTagsAutomation"
                                :isActiveTagsAutomation="isActiveTagsAutomation"
                                :onTagsAutomation="onTagsAutomation"
                            />
                        </div>
                        <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                @click="onSendTestLead"
                                circle
                                :disabled="isLoadingSendTestLead"
                                ></el-button>
                                <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                            </div>
                            <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="'el-icon-view'"
                                    @click="onViewExampleData"
                                    circle
                                    ></el-button>
                                    <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div v-if="selectedIntegration === 'kartra'" class="''">
                      <div v-if="isKartraInfoFetching" class="row" v-loading="true" id="loading"></div>
                      <div v-else-if="errors.kartra">
                        <el-alert
                            title="Connection Issue"
                            type="warning"
                            description="There seems to be a problem with your integration. Please check your connection settings and try again."
                            :closable="false"
                            show-icon>
                        </el-alert>
                      </div>
                      <div v-else>
                          <el-checkbox v-model="selectedRowData.ghl_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                          <div class="d-flex mt-2" style="gap: 4px;">

                              <div class="flex-grow-1">
                                  <div class="warning-banner" v-if="kartraListOptions.length < 1"><p>You don't have any active {{ nameIntegration }} list please create one</p></div>
        
                                  <div v-else class="has-label">
                                      <label class="mb-0">Choose {{ nameIntegration }} list</label>
                                      <el-select multiple class="select-info select-fullwidth" size="large"
                                          v-model="selectedKartraList" placeholder="You can select multiple lists">
                                          <el-option v-for="option in kartraListOptions" class="select-info" :value="option"
                                              :label="option" :key="option">
                                          </el-option>
                                      </el-select>
                                  </div>
                              </div>    
                              <div class="flex-grow-1">
                                  <div class="warning-banner" v-if="kartraTagsOptions.length < 1"><p>You don't have any active {{ nameIntegration }} Tags please create one</p></div>
        
                                  <div v-else class="has-label">
                                      <label class="mb-0">Choose {{ nameIntegration }} Tags</label>
                                      <el-select multiple class="select-info select-fullwidth" size="large"
                                          v-model="selectedKartraTags" placeholder="You can select multiple tags">
                                          <el-option v-for="option in kartraTagsOptions" class="select-info" :value="option"
                                              :label="option" :key="option">
                                          </el-option>
                                      </el-select>
                                  </div>
                              </div>
                          </div>
                          <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                @click="onSendTestLead"
                                circle
                                :disabled="isLoadingSendTestLead"
                                ></el-button>
                                <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                            </div>
                            <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="'el-icon-view'"
                                    @click="onViewExampleData"
                                    circle
                                    ></el-button>
                                    <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                            </div>
                            </div>
                      </div>
                  </div>

                  <div v-if="selectedIntegration === 'zapier'" class="''">
                    
                        <div v-if="isZapierFetching" class="row" v-loading="true" id="loading"></div>
                        <div v-else>
                            <el-checkbox v-model="zapierEnable">Enable {{ nameIntegration }}</el-checkbox>
                            <div class="has-label mt-2">
                                <label class="mb-0">Enter your Webhook URL</label>
                                <div style="display: flex; flex-direction: column; gap: 8px;">
                                    
                                    <div v-for="(url, index) in zapierWebhook" :key="index" class="webhook-url-wrapper">
                                        <el-input type="text" clearable label="Enter your Webhook URL"
                                    placeholder="https://hooks.app.com/hooks/catch/....." class="flex-grow-1 mb-0"  v-model="zapierWebhook[index]"  aria-controls="datatables">
                                            
                                        </el-input>
                                       
                                        <span 
                                            v-if="index == 0" 
                                            class="add-webhook-url" 
                                            @click="addWebhookUrl">
                                            <i class="fa-solid fa-plus"></i>
                                        </span>
                                        <span 
                                            v-if="index != 0 && zapierWebhook.length > 1" 
                                            class="add-webhook-url" 
                                            @click="removeWebhookUrl(index)">
                                            <i class="fa-solid fa-minus"></i>
                                        </span>
                                    </div>
                                </div>
                                <p v-if="defaultWebhook" class="mt-2">you're using <b>default</b> client webhook, replace URL if you want to use custom webhook for this campaign  </p>
                                <p v-if="!defaultWebhook" class="mt-2">you're using <b>custom</b> webhook, just delete this URL and save. if you want to use default webhook for this campaign </p>
                                <label class="mb-0">Enter Tags</label>
                                <el-select 
                                    multiple 
                                    allow-create
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                    class="select-info select-fullwidth" 
                                    size="large"
                                    v-model="zapierTags" 
                                    placeholder="You can select multiple tags">
                                    <el-option v-for="option in zapierTagsOptions" class="select-info" :value="option.name"
                                        :label="option.name" :key="option.name">
                                    </el-option>
                                </el-select>
                                <!-- <label class="mt-2">Test Your Webhook ?</label> -->
                                <!-- <el-checkbox v-model="zapierTestEnable" class="d-block">Send Test Data</el-checkbox>
                                <p>* check and save to test</p> -->
                            </div>
                            <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                    @click="onSendTestLead"
                                    circle
                                    :disabled="isLoadingSendTestLead"
                                    ></el-button>
                                    <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                                </div>
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="'el-icon-view'"
                                    @click="onViewExampleData"
                                    circle
                                    ></el-button>
                                    <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                                </div>
                            </div>
                        </div>
                    </div>  
                    

                    <div v-if="selectedIntegration === 'mailboxpower'" class="">
                        <div v-if="isMailBoxPowerFetching" class="row" v-loading="true" id="loading"></div>
                        <div v-else-if="errors.mailboxPower">
                            <el-alert
                                title="Connection Issue"
                                type="warning"
                                description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                :closable="false"
                                show-icon>
                            </el-alert>
                        </div>
                        <div v-else>
                            <el-checkbox v-model="selectedRowData.mbp_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                        
                            <div class="has-label mt-2" v-if="selectedIntegration === 'mailboxpower'">
                                <label class="mb-0">Choose Groups</label>
                                <el-select 
                                    multiple 
                                    allow-create
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                    class="select-info select-fullwidth" 
                                    size="large"
                                    v-model="mbp_groups"
                                    placeholder="You can select multiple Groups">
                                    <el-option v-for="option in mailBoxPowerOptions" class="select-info" :value="option.id"
                                        :label="option.name" :key="option.id">
                                    </el-option>
                                </el-select>
                                
                                <div class="row" style="padding-left: 16px; margin-bottom: 10px; margin-top: 10px;">
                                    <el-radio v-model="mbp_options" label="state">State</el-radio>
                                    <el-radio v-model="mbp_options" label="zip">Zip Code</el-radio>
                                </div>

                                <div v-if="mbp_options == 'state'">
                                    <label class="mb-0">Choose States</label>
                                    <el-select 
                                        multiple 
                                        :allow-create="false"
                                        filterable
                                        default-first-option
                                        :reserve-keyword="false"
                                        class="select-info select-fullwidth" 
                                        size="large"
                                        v-model="mbp_states" 
                                        placeholder="You can select states">
                                        <el-option v-for="option in mailBoxPowerStates" class="select-info" :value="option.state_code"
                                            :label="option.state" :key="option.sifi_state_id">
                                        </el-option>
                                    </el-select>
                                </div>

                                <div v-if="mbp_options == 'zip'">
                                    <label class="mb-0">Upload Zip Code</label>
                                    <div style="margin-top: 5px;">
                                        <form enctype="multipart/form-data" style="display: flex; justify-content: start; align-items: center; gap: 16px;">
                                            <!-- <input type="file" :name="mailBoxpowerUploadZipName" :disabled="isMailBoxPowerSavingZip" accept=".csv" @change="mailBoxPowerFilesChange($event.target.name, $event.target.files)"> -->
                                            <el-upload
                                                ref="mailBoxPowerZip"
                                                class="upload-demo"
                                                :show-file-list="false"
                                                :auto-upload="false"
                                                action="#"
                                                :name="mailBoxpowerUploadZipName"
                                                :on-change="mailBoxPowerFilesChange">
                                                <el-button slot="trigger" size="small" type="primary">select file</el-button>
                                            </el-upload>
                                            <span>
                                                <i v-if="isMailBoxPowerSavingZip" class="fas fa-spinner fa-spin" style="font-size: 16px; margin-top: 8px;"></i>
                                            </span>
                                        </form>
                                    </div>
                                    <div class="row" style="margin-top: 3px;">
                                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                            <div class="form-group has-label">
                                                <el-input
                                                    class="mailboxzipcode"
                                                    type="textarea"
                                                    :rows="6"
                                                    :resize="'none'"
                                                    placeholder=""
                                                    v-model="mbp_zip"
                                                    @blur="removeEmptyLines">
                                                </el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <p v-if="mbp_groups_remove.length > 0">Attention: The following tags have been removed from {{ nameIntegration }}:</p>
                                    <p v-for="(item, index) in mbp_groups_remove" :key="index">
                                    - {{item}}
                                </p>
                            </div>
                            <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                    @click="onSendTestLead"
                                    circle
                                    :disabled="isLoadingSendTestLead"
                                    ></el-button>
                                    <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                                </div>
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="'el-icon-view'"
                                    @click="onViewExampleData"
                                    circle
                                    ></el-button>
                                    <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedIntegration === 'clickfunnels'">
                        <div style="display: flex; gap: 16px;">
                            <el-menu :default-active="menuClickFunnels" class="el-menu-vertical-demo" :collapse="isCollapseMenuClickFunnels">
                                <el-menu-item index="choose-tag" @click="handleClickMenuClickFunnels('choose-tag')">
                                    <i class="el-icon-menu"></i>
                                    <span slot="title">Tag Selection</span>
                                </el-menu-item>
                                <el-menu-item index="create-tag" @click="handleClickMenuClickFunnels('create-tag')">
                                    <i class="el-icon-circle-plus"></i>
                                    <span slot="title">Create Tag</span>
                                </el-menu-item>
                            </el-menu>
                            
                            <div v-if="menuClickFunnels === 'choose-tag'" style="flex: 1; display: flex; flex-direction: column;">
                                <div v-if="isLoadingGetTagsClickFunnels" class="row" v-loading="true" id="loading"></div>
                                <div v-else-if="errors.clickfunnels">
                                    <el-alert
                                        title="Connection Issue"
                                        type="warning"
                                        description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                        :closable="false"
                                        show-icon>
                                    </el-alert>
                                </div>
                                <div v-else>
                                    <p style="font-weight: 600; margin-bottom: 0px;">Tag Selection</p>

                                    <div style="margin-top: 16px;">
                                        <el-checkbox v-model="selectedRowData.clickfunnels_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                                        <p style="margin-bottom: 8px; margin-top: 16px;">Choose tags :</p>
                                        <el-select style="width: 100%;" v-model="listTagsClickFunnelsSelected" multiple placeholder="Select tags" value-key="id" class="click-funnels-tag-select">
                                            <el-option
                                                v-for="item in listTagsClickFunnels"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item"
                                                :collapse-tags="false"
                                                >
                                            </el-option>
                                        </el-select>
                                        <div style="margin-top: 16px;">
                                            <div v-if="isLoadingGetCampaignTagsClickFunnels" style="display: flex;">
                                                <div v-for="n in 3" :key="n" class="skeleton-tag"></div>
                                            </div>
                                            <div v-else class="tags-container">
                                                <div
                                                v-for="tag in listTagsClickFunnelsSelected"
                                                :key="tag.id"
                                                :style="{ backgroundColor: tag.color, color: getTextColor(tag.color), borderColor: tag.color }"
                                                class="tag-item"
                                                >
                                                    <span class="tag-text">{{ tag.name }}</span>
                                                    <i class="el-icon-close close-icon" @click="removeTagClickFunnels(tag)"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                                        <div style="display: flex; align-items: center; gap: 8px;">
                                            <el-button
                                            size="medium"
                                            :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                            @click="onSendTestLead"
                                            circle
                                            :disabled="isLoadingSendTestLead"
                                            ></el-button>
                                            <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                                        </div>
                                        <div style="display: flex; align-items: center; gap: 8px;">
                                                <el-button
                                                size="medium"
                                                :icon="'el-icon-view'"
                                                @click="onViewExampleData"
                                                circle
                                                ></el-button>
                                                <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="menuClickFunnels === 'create-tag'" style="flex: 1; display: flex; flex-direction: column;">
                                <!-- <div v-if="isLoadingGetTagsClickFunnels" class="row" v-loading="true" id="loading"></div>
                                <div v-else-if="errors.clickfunnels">
                                    <el-alert
                                        title="Connection Issue"
                                        type="warning"
                                        description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                        :closable="false"
                                        show-icon>
                                    </el-alert>
                                </div> -->
                                <div>
                                    <p style="font-weight: 600; margin-bottom: 0px;">New Contact Tag</p>

                                    <el-form label-position="top" :model="formNewTagClickFunnels" ref="formNewTagClickFunnels">
                                        <el-form-item
                                            label="Name :"
                                            prop="name"
                                            :rules="[
                                                { required: true, message: 'Name is required'},
                                            ]"
                                        >
                                            <el-input v-model="formNewTagClickFunnels.name" autocomplete="off"></el-input>
                                        </el-form-item>

                                        <el-form-item
                                            label="Color :"
                                            prop="color"
                                            :rules="[
                                                { required: true, message: 'Color is required'},
                                            ]"
                                        >
                                            <p style="font-weight: 600; font-size: 12px;">{{ formNewTagClickFunnels.color }}</p>
                                            <div style="display: flex; gap: 16px; flex-wrap: wrap;">
                                                <span v-for="(color) in colorsNewTagClickFunnels" :key="color.value" @click="onColorClickFunnels(color.value)" :style="{backgroundColor: color.value, height: '40px', width: '40px', borderRadius: '4px', border: color.value === formNewTagClickFunnels.color ? '4px solid white' : '', boxShadow: color.value === formNewTagClickFunnels.color ? `0 0 0 4px ${color.value}` : '', cursor: 'pointer'}"></span>
                                                <el-color-picker v-model="formNewTagClickFunnels.color"></el-color-picker>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                    <base-button :disabled="isLoadingCreateTagsClickFunnels" @click="onCreateTagsClickFunnels" style="margin-top: 24px;" :style="{width: isLoadingCreateTagsClickFunnels ? '120px' : '100px'}">
                                        <i v-if="isLoadingCreateTagsClickFunnels" class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i> Submit
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <template slot="footer">
                <div class="integrations-modal-footer-wrapper">
                    <div class="d-flex align-items-center justify-content-end">
                        <base-button v-if="this.$global.settingMenuShow && !this.$global.systemUser" simple size="sm"  style="height:40px"
                            @click="openHelpModal(2)">
                            <i class="fas fa-question"></i>
                        </base-button>
                        <base-button @click.native="modals.integrations = false">Cancel</base-button>
                        <base-button @click.native="$refs.integrationBodyRef && $refs.integrationBodyRef.save()" :disabled="isLoadingSaveIntegration">{{ isLoadingSaveIntegration ? "Saving..." : "Save" }}</base-button>
                    </div>
                </div>
            </template>
        </modal>
        <!-- Integrations modal -->
            <!-- create campaign modal end -->
        <modal 
            :show.sync="modals.campaign" 
            :closeOnOutsideClick="false"
            @close="onCreateCampaignModalAttemptClose"
            id="addCampaign"  
            bodyClasses='create-campaign-modal-body'
            footerClasses="border-top p-2"
            :showClose="false">
            <h3 slot="header" class="title title-up">New Campaign</h3>
            <step-indicator :steps="createCampaignSteps" :activeStep="campaignCreateActiveStep" ></step-indicator>
            <div v-if="campaignCreateActiveStep === 0" class="row mt-4">
                        
                        
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-12 col-md-12 col-lg-12 has-label pull-left">
                            <div style="display: flex; flex-direction: column; margin-bottom: 15px;">
                                <label>{{CompanyNamedisabled ? 'Client Name' : 'Select Client Name'}}</label>
                                <el-select class="select__form__client" size="large" placeholder="Select Client Name"
                                v-model="selectsCompany.companySelected"
                                @change="onCompanyChange(selectsCompany.companySelected);" :disabled="CompanyNamedisabled">
                                
                                    <el-option v-for="option in selectsCompany.companyList"
                                    :value="option.id" :label="option.company_name" :key="option.id">
                                    </el-option>
                                </el-select>
                                <small style="color:#942434 !important;" v-if="err_companySelect">* Client Company Is Required</small>
                            </div>
                        </div>
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-12 col-md-12 col-lg-12" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Contact Name" type="text" placeholder="Input Client Contact Name"
                                v-model="ClientFullName">
                            </base-input>
                        </div>
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-6 col-md-6 col-lg-6" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Email" type="email" placeholder="Input Client Email"
                                 v-model="ClientEmail">
                            </base-input>
                        </div>
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-6 col-md-6 col-lg-6" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Phone Number" type="text" placeholder="Input Client Phone"
                               v-model="ClientPhone">
                            </base-input>
                        </div>
                        <!-- <span v-if="this.$global.menuUserType != 'client'" class="selerator-campaign-create"></span> -->
                         <el-divider v-if="this.$global.menuUserType != 'client'" ></el-divider>
                        <div class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left">
                            <base-input label="Campaign Name" type="text" placeholder="Input Campaign Name"
                                v-model="ClientCampaignName" :maxlength="190" max="190" class='mb-0 pb-0' @keyup="clearErrorInput('ClientCampaignName')">
                            </base-input>
                            <small style="color:#942434 !important;" v-if="err_campaignName">* Campaign Name Is Required</small>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left">
                            <label>Custom Fields Configuration</label>
                            <el-select
                                class="select__form__client"
                                size="large"
                                placeholder="Select Custom Fields Configuration (Optional)"
                                v-model="selectedCustomFieldId"
                                clearable
                                @change="onCustomFieldsConfigChange"
                            >
                                <el-option
                                    v-for="field in customFieldsList"
                                    :key="field.id"
                                    :label="field.field_name || `Custom Fields Order #${field.id}`"
                                    :value="field.id"
                                >
                                </el-option>
                                <el-option
                                    :value="CUSTOM_FIELDS_OPTION_CUSTOM"
                                    :label="customFieldNameForCampaign ? customFieldNameForCampaign : '➕ Create custom configuration…'"
                                >
                                </el-option>
                            </el-select>
                            <small v-if="selectedCustomFieldId === CUSTOM_FIELDS_OPTION_CUSTOM && !(customFieldOrderOnlyForCampaign && customFieldOrderOnlyForCampaign.length)" class="text-muted d-block mt-1">Select fields and order in the modal, then save.</small>
                        </div>
                        <div v-if="false" class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left">
                            <label>Campaign Type</label>
                            <el-select
                                class="select__form__client"
                                size="large"
                                placeholder="Select Campaign Type"
                                v-model="ClientCampaignType"
                                @change="clearErrorInput('ClientCampaignType')"
                            >
                                <el-option
                                    v-for="opt in campaignTypeOptions"
                                    :key="opt.id"
                                    :label="opt.label"
                                    :value="opt.id"
                                    :disabled="opt.id === 2"
                                    style="height: auto !important;"
                                >
                                    <div class="campaign-type-option">
                                        <span class="campaign-type-option__title">{{ opt.label }}</span>
                                        <span class="campaign-type-option__desc">{{ opt.description }}</span>
                                    </div>
                                </el-option>
                            </el-select>
                            <small style="color:#942434 !important;" v-if="err_campaignType">* Campaign Type Is Required</small>
                        </div>
                       
                     
            
            </div>
            <div v-if="campaignCreateActiveStep === 1" class="row mt-5">
                <!-- <div class="text-center col-12">
                        <h2 class="step-into-title">Tell us about your business</h2>
                        <p class="step-info-desc">This information will help us tailor the AI to your specific needs.</p>
                </div>   -->
                <div class="col-12 col-12 d-flex flex-column" style="gap: 10px;">
                    <div class="d-flex flex-column" style="gap: 10px;">
                        <div>
                            <base-input label="Business name" type="text" placeholder="Input your business name "
                                v-model="campaignBusinessInfo.name" class='mb-0 pb-0' @keyup="clearErrorInput('campaignBusinessInfo.name')">
                            </base-input>
                            <small style="color:#942434 !important;" v-if="err_campaignBusinessName">* Businnes Name Is Required</small>
                        </div>
                        <div>
                            <base-input label="Website" type="text" placeholder="example.com"
                                v-model="campaignBusinessInfo.website" :maxlength="190" max="190" class='mb-0 pb-0' @keyup="clearErrorInput('campaignBusinessInfo.website')">
                            </base-input>
                            <small style="color:#942434 !important;" v-if="err_campaignBusinessWebsite">* Website Is Required</small>
                        </div>
                        <div>
                            <base-input :label="`Business industry`" class='mb-0 pb-0'>
                                <el-select
                                  v-model="campaignBusinessInfo.industry"
                                  placeholder="Select an industry"
                                  filterable
                                  clearable
                                  style="width: 100%"
                                  @change="businessIndustryChange"
                                >
                                  <el-option
                                    v-for="(industry) in businessIndustries"
                                    :key="industry.id"
                                    :label="industry.name"
                                    :value="industry.id"
                                  />
                                </el-select>
                            </base-input>
                            <small style="color:#942434 !important;" v-if="err_campaignBusinessIndustry">* Business Industry Is Required</small>
                        </div>
                        <!-- campaignBusinessInfo.industry === 'other' -->
                        <div v-if="isOtherIndustry">
                            <base-input label="Please specify your industry" class='mb-0 pb-0'>
                                <el-input
                                  v-model="campaignBusinessInfo.customIndustry"
                                  placeholder="Type your industry"
                                  clearable
                                  @keyup.native="clearErrorInput('campaignBusinessInfo.customIndustry')"
                                />
                            </base-input>
                            <small style="color:#942434 !important;" v-if="err_campaignBusinessCustomIndustry">* Specify Industry Is Required</small>
                        </div>
                        <!-- <base-input label="Business type" class='mb-0 pb-0'>
                            <el-select
                              v-model="campaignBusinessInfo.businessType"
                              placeholder="Select a business type"
                              clearable
                              style="width: 100%"
                            >
                              <el-option
                                v-for="(type, idx) in businessTypeOptions"
                                :key="idx"
                                :label="type"
                                :value="type"
                              />
                            </el-select>
                        </base-input> -->
                        <div>
                            <base-input label="What does your business do?" class='mb-0 pb-0'>
                                <textarea  class="form-control input-border textarea-custom-height" v-model="campaignBusinessInfo.businessDescription"
                                    placeholder="We help businesses grow their revenue with AI-powered marketing campaigns." rows="10" @keyup="clearErrorInput('campaignBusinessInfo.businessDescription')">
                                </textarea>
                            </base-input>
                            <small style="color:#942434 !important;" v-if="err_campaignBusinessDescription">* What Does Your Business Do Is Required</small>
                        </div>
                        <div v-if="false">
                            <base-input label="Who are your main competitors?" class='mb-0 pb-0'>
                                <textarea  class="form-control input-border" v-model="campaignBusinessInfo.competitors"
                                    placeholder="Competitor A, Competitor B, Competitor C" rows="3" @keyup="clearErrorInput('campaignBusinessInfo.competitors')">
                                </textarea>
                            </base-input>
                            <small style="color:#942434 !important;" v-if="err_campaignBusinessCompetitors">* Who Are Your Main Competitors Is Required</small>
                        </div>
                        <!-- <base-input label="Who is your ideal customer?" class='mb-0 pb-0'>
                            <textarea  class="form-control input-border" v-model="campaignBusinessInfo.idealCustomers"
                                placeholder="Marketing managers at B2B SaaS companies" rows="3">
                            </textarea>
                        </base-input> -->
                        
                        <!-- natinal, state, and zip -->
                        <ValidationObserver ref="form5" > 
                            <div class="form-group m-0 p-0">
                                <label>Your ideal customers are from</label>
                                
                                <div class="row">
                                    <div class="col-3">
                                        <base-checkbox name="nationaltargeting"  v-model="newcampaign.asec5_4_0_0"  @change="nationaltargetselected('asec5_4_0_0', $event)"  inline>National</base-checkbox>
                                </div>
                                    <div class="col-3">
                                        <base-checkbox name="state" v-model="newcampaign.asec5_4_0_1" @change="nationaltargetselected('asec5_4_0_1', $event)" inline>State</base-checkbox>
                                    </div>
                                    <div class="col-3">
                                        <base-checkbox name="zipcode" v-model="newcampaign.asec5_4_0_3" @change="nationaltargetselected('asec5_4_0_3', $event)" inline>Zip Code</base-checkbox>
                                    </div>
                                       <div class="col-3">
                                        <base-checkbox name="geo" v-model="newcampaign.geo" @change="nationaltargetselected('geo', $event)" inline>Select from location</base-checkbox>
                                    </div>
                                </div>
                                <small style="color:#942434 !important;" v-if="err_campaignCustomersFrom">* Your Ideal Customers Are From Is Required.</small>

                                <div class="border-box" v-if="newcampaign.asec5_4_0_1" id="boxState" style="margin-top: 8px">
                                  <label >Select By States</label>
                                  <div class="row">
                                      <div class="col-sm-12 col-md-12 col-lg-12" id="state-selector-wrapper">
                                              <base-input style='border:none !important;'>
                                                  <el-select
                                                      id="statelist"
                                                      v-model="selects.state"
                                                      class="select-primary "
                                                      name="statelist"
                                                      inline
                                                      size="large"
                                                      placeholder="Select State(s)"
                                                      filterable
                                                      default-first-option
                                                      multiple
                                                      @change="onStateChange"
                                                      >
                                                      <el-option
                                                      v-for="option in selects.statelist"
                                                      class="select-primary"
                                                      :label="option.state_name"
                                                      :value="option.state_code"
                                                      :key="option.state_code"
                                                      ></el-option>
                                                  </el-select>
                                              </base-input>
                                      </div>
                                  </div>
                                  <small style="color:#942434 !important;" v-if="err_campaignState">* State Is Required.</small>
                                </div>
                                <div class="border-box mt-2" v-if="newcampaign.asec5_4_0_3">
                                    <label class="label-border-box">List the zip codes that you want the customers to target, <strong>One postal code per line</strong>:</label>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                            <div class="form-group has-label">
                                                <ZipCodeTextArea v-model="newcampaign.asec5_3" @keyup="clearErrorInput('newcampaign.asec5_3')" />
                                                <small style='color:red !important;' id="err_locator_zip">* A minimum of 1 valid ZIP code and a maximum of 50 valid ZIP codes must be provided.</small> <br>
                                                <small style="color:#942434 !important;" v-if="err_campaignZipCode">* Zip Code Is Required.</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="newcampaign.geo" class="border-box mt-2">
                                    <GeoRadiusSelector
                                        :lat.sync="newcampaign.target_lat"
                                        :lng.sync="newcampaign.target_lng"
                                        :radius-miles.sync="newcampaign.target_radius_miles"
                                        :default-center="usDefaultCenter"
                                        :default-radius="newcampaign.target_radius_miles || 25"
                                    />
                                    <small style="color:#942434 !important;" v-if="err_campaignCustomersFrom">* Please drop a pin inside the United States and set a radius.</small>
                                </div>
                            </div>
                        </ValidationObserver>
                        <!-- natinal, state, and zip -->

                        
                    </div>

                    <div class="d-flex flex-column" style="gap: 16px; margin-top: 16px;">
                        <div>
                            <!-- Header dengan Title, Search, dan Upload Button dalam satu baris -->
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <span class="font-weight-600 text-dark" style="font-size: 16px;">Customer List</span>
                                
                                <div class="d-flex align-items-center" style="gap: 12px;">
                                    <el-input
                                        v-model="customerListSearchQuery"
                                        placeholder="Search"
                                        prefix-icon="el-icon-search"
                                        clearable
                                        @keyup.enter.native="onCustomerListSearch"
                                        @clear="onCustomerListSearchClear"
                                        style="width: 300px;"
                                    ></el-input>
                                    
                                    <el-button @click="modals.uploadUserClient = true" class="upload-button" icon="el-icon-upload2" plain>
                                        Upload Customer List
                                    </el-button>
                                </div>
                            </div>

                            <!-- for list custom list -->
                            <UserClient 
                                ref=userclient 
                                :userId="ClientUserID"
                                :initialSelection="selectedCustomerList"
                                :searchQuery="customerListSearchQuery"
                                @select="onCustomerListSelected"
                                @after-delete="onCustomerListDeleted">
                            </UserClient>
                            <!-- for list custom list -->
                            <small style="color:#942434 !important;" v-if="err_campaignCustomerList">* Customer List Is Required.</small>

                        </div>
                    </div>

               

                </div>    
            </div>
            <div v-if="campaignCreateActiveStep === 2" class="row mt-2">
                <LLMChatWindow
                    :disableChat="llmChatDisabled"
                    :sending="isMessageSending"
                    @send="sendChatMessage"
                    @retry="retryChatMessage"
                    :messages="messagesChat"
                    :campaignCreateActiveStep="campaignCreateActiveStep"
                >
                    <template v-slot:addon>
                        <div v-if="llmOptionPanels.length" class="llm-option-stack">
                            <div v-for="panel in llmOptionPanels" :key="panel.id" class="llm-option-panel">
                                <div class="llm-option-header">
                                    <span class="llm-option-title">{{ panel.title }}</span>
                                    <span v-if="panel.subtitle" class="llm-option-subtitle">{{ panel.subtitle }}</span>
                                </div>
                                <div class="llm-option-body" :class="{'is-inline': panel.layout === 'inline'}">
                                    <template v-if="panel.type === 'radio'">
                                        <label class="llm-option-chip" v-for="option in panel.options" :key="option.id">
                                            <input
                                                type="radio"
                                                :name="panel.id"
                                                :value="option.id"
                                                :checked="option.selected"
                                                @change="handleOptionSelect(panel, option)"
                                            />
                                            <div class="llm-option-copy">
                                                <span class="llm-option-label">{{ option.label }}</span>
                                                <span v-if="option.description" class="llm-option-desc">{{ option.description }}</span>
                                            </div>
                                        </label>
                                    </template>
                                    <template v-else>
                                        <button
                                            class="llm-option-chip button"
                                            v-for="option in panel.options"
                                            :key="option.id"
                                            type="button"
                                            @click="handleOptionSelect(panel, option)"
                                        >
                                            <div class="llm-option-copy">
                                                <span class="llm-option-label">{{ option.label }}</span>
                                                <span v-if="option.description" class="llm-option-desc">{{ option.description }}</span>
                                            </div>
                                        </button>
                                    </template>
                                </div>
                                <div v-if="panel.proceed" class="llm-option-footer">
                                    <el-button
                                        size="mini"
                                        type="primary"
                                        :disabled="panel.proceed.disabled"
                                        @click="handlePanelProceed(panel)"
                                    >
                                        {{ panel.proceed.label }}
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </template>
                </LLMChatWindow>
            </div>
            <div v-if="campaignCreateActiveStep === 3" class="row mt-2">
             
                <div class="step__header col-12 mt-3">
                     <h3 class="step__title m-0 p-0" style="font-size: 20px;font-weight: 700;color: #111827 !important;">Campaign Financial Setup</h3>
                 </div>
                
                <div class="col-12 mt-5">

                        <campaign-financials
                                :user-type="userType"
                                :txt-lead-service="txtLeadService"
                                :leadspeek-input-read-only="LeadspeekInputReadOnly"
                                :platform-fee.sync="LeadspeekPlatformFee"
                                :min-cost-month.sync="LeadspeekMinCostMonth"
                                :m-platform-fee="m_LeadspeekPlatformFee"
                                :m-min-cost-month="m_LeadspeekMinCostMonth"
                                :t-platform-fee="t_LeadspeekPlatformFee"
                                :t-min-cost-month="t_LeadspeekMinCostMonth"
                                :selects-payment-term="selectsPaymentTerm"
                                :prepaid-type="prepaidType"
                                :conti-duration-selection="contiDurationSelection"
                                :limit-lead="LeadspeekLimitLead"
                                :cost-per-lead="LeadspeekCostperlead"
                                :t-freq="t_freq"
                                :t-profit="t_profit"
                                @recalculate="profitcalculation"
                              />
                </div>
                
            </div>
            <div v-if="false" class="row mt-5">
                <div class="col-12">
                    <!-- selectedRowData = {{ selectedRowData }} <br>
                    integrations = {{ integrations }} <br>
                    selectedIntegration = {{ selectedIntegration }} <br>
                    userType = {{ userType }} <br>
                    selectsAdministrator = {{ selectsAdministrator }} <br>
                    onIntegrationSaved = {{ onIntegrationSaved }} <br> -->
                    <!-- v-if="selectedRowData && selectedRowData.id" -->
                    <IntegrationModalBody
                        v-model="selectedRowData"
                        :integrations="integrations"
                        :selected-integration.sync="selectedIntegration"
                        :user-type="userType"
                        :selects-administrator="selectsAdministrator"
                        @saved="onIntegrationSaved"
                        @loading-change="isLoadingSaveIntegration = $event"
                    />
                    <!-- <el-alert
                        v-else
                        title="Create campaign first"
                        type="info"
                        description="Complete previous steps to create a campaign before configuring integrations."
                        :closable="false"
                        show-icon
                    /> -->
                </div>
            </div>
            <template slot="footer">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <base-button size="sm" class="pull-right" id="btnSave" style="height:40px"
                        @click="updateCreateCampaignStep" v-text="campaignCreateActiveStep < 3 ? 'Next' : 'Finish and Start Campaign'">
                        <!-- @click="updateCreateCampaignStep" v-text="campaignCreateActiveStep < 4 ? 'Next' : 'Finish and Start Campaign'" -->
                    </base-button>
                    <base-button v-if="campaignCreateActiveStep > 0" simple size="sm" class="pull-right mr-4" style="height:40px"
                        @click="CancelAddEditClient('')">
                        Back
                    </base-button>
                    <base-button simple size="sm" class="pull-right mr-4" style="height:40px" @click="cancelCampaignForm">
                        Cancel
                    </base-button>
                </div>
            </template>
        </modal>
          <!-- create campaign modal end -->

          <!-- Custom Fields Configuration modal (create custom from campaign) -->
          <modal :show.sync="modals.customFieldsConfig" headerClasses="justify-content-center" size="large" @close="closeCustomFieldsConfigModal">
            <h4 slot="header" style="text-align: center; color: black !important;">Create Custom Fields Configuration</h4>
            <el-card shadow="never" class="custom-fields-config-modal-card">
              <div class="custom-fields-campaign-modal-content">
                <div class="custom-fields-section">
                  <div class="custom-fields-title">Configuration name <span style="color:#942434;">*</span></div>
                  <el-input
                    v-model="customFieldsConfig.fieldName"
                    placeholder="e.g. My Campaign Fields"
                    maxlength="255"
                    show-word-limit
                  ></el-input>
                  <div v-if="errorCustomFieldsConfig.fieldName" style="margin-top: 8px;">
                    <small style="color:#942434 !important;">* Configuration name is required</small>
                  </div>
                </div>
                <el-divider></el-divider>
                <div class="custom-fields-section">
                  <div class="custom-fields-title">Select custom fields</div>
                  <div class="custom-fields-list-inline">
                    <label
                      v-for="field in masterFieldsForCustom"
                      :key="field.id"
                      class="custom-field-item-inline"
                    >
                      <input
                        type="checkbox"
                        :value="field.id"
                        v-model="customFieldsConfig.selectedFieldIds"
                        @change="updateCustomConfigSelectedOrder"
                      />
                      <span>{{ field.field_name }}</span>
                    </label>
                  </div>
                </div>
                <el-divider></el-divider>
                <div class="custom-fields-section">
                  <div class="custom-fields-order-title">Selected order</div>
                  <div v-if="customFieldsConfig.selectedFieldIds.length === 0" class="custom-fields-empty-inline">No fields selected.</div>
                  <div
                    v-else
                    class="custom-fields-order-list-inline"
                    @dragover.prevent
                    @drop="handleCustomConfigDrop"
                  >
                    <div
                      v-for="(fieldId, index) in customFieldsConfig.selectedFieldIds"
                      :key="fieldId"
                      class="custom-fields-order-item-inline"
                      :class="{
                        'is-dragging': customFieldsConfigDraggedIndex === index,
                        'is-drag-over': customFieldsConfigDragOverIndex === index && customFieldsConfigDraggedIndex !== index
                      }"
                      draggable="true"
                      @dragstart="handleCustomConfigDragStart(index, $event)"
                      @dragend="handleCustomConfigDragEnd"
                      @dragover.prevent="handleCustomConfigDragOver(index)"
                      @dragleave="handleCustomConfigDragLeave"
                    >
                      <span class="order-label-inline">
                        <i class="el-icon-rank drag-handle-inline"></i>
                        {{ index + 1 }}. {{ getCustomFieldNameById(fieldId) }}
                      </span>
                      <div class="order-actions-inline">
                        <el-button size="mini" :disabled="index === 0" @click="moveCustomConfigField(fieldId, 'up')">Up</el-button>
                        <el-button size="mini" :disabled="index === customFieldsConfig.selectedFieldIds.length - 1" @click="moveCustomConfigField(fieldId, 'down')">Down</el-button>
                      </div>
                    </div>
                  </div>
                  <div v-if="errorCustomFieldsConfig.fieldOrder" style="margin-top: 8px;">
                    <small style="color:#942434 !important;">* Select at least one field</small>
                  </div>
                </div>
              </div>
              <div class="text-right" style="margin-top: 20px;">
                <base-button simple size="sm" class="mr-2 btn-custom-fields-modal-cancel" @click="closeCustomFieldsConfigModal">Cancel</base-button>
                <base-button size="sm" class="btn-custom-fields-modal-save" :disabled="isLoadingCustomFieldsConfig" @click="saveCustomFieldsConfigModal">
                  Save
                  <i v-if="isLoadingCustomFieldsConfig" class="fas fa-spinner fa-spin ml-1"></i>
                </base-button>
              </div>
            </el-card>
          </modal>
          <!-- Custom Fields Configuration modal end -->

            <!-- edit campaign modal start -->
            <modal v-if="false" :show.sync="modals.campaignEdit" id="editCampaign"  bodyClasses='create-campaign-modal-body'
            footerClasses="border-top p-2">
                <h3 slot="header" class="title title-up">Edit Campaign #{{selectedRowData.leadspeek_api_id}}</h3>
                <div class="row">
                
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-12 col-md-12 col-lg-12" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Client Name" type="text" placeholder="Input Client Name"
                                v-model="selectedRowData.company_name">
                            </base-input>
                    </div>
                    <div v-if="this.$global.menuUserType != 'client'" class="col-sm-12 col-md-12 col-lg-12" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Contact Name" type="text" placeholder="Input Client Contact Name"
                                v-model="selectedRowData.name">
                            </base-input>
                    </div>
                    <div v-if="this.$global.menuUserType != 'client'" class="col-sm-6 col-md-6 col-lg-6" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Email" type="email" placeholder="Input Client Email"
                                 v-model="selectedRowData.email">
                            </base-input>
                        </div>
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-6 col-md-6 col-lg-6" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Phone Number" type="text" placeholder="Input Client Phone"
                               v-model="selectedRowData.phonenum">
                            </base-input>
                        </div>
                        <span v-if="this.$global.menuUserType != 'client'" class="selerator-campaign-create"></span>
                        <div class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left">
                            <base-input label="Campaign Name" type="text" placeholder="Input Campaign Name"
                                v-model="selectedRowData.campaign_name" :maxlength="255" class='mb-0 pb-0'>
                            </base-input>
                            <small id="err_campaignname" style="display:none;color:#942434 !important;">
                                * Campaign Name is required
                            </small>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12" v-if="GoogleConnectTrue && spreadsheet_id != ''">
                            <base-input label="Client Emails Approved to View the Google Sheet:" >
                                <textarea class="form-control input-border" v-model="selectedRowData.report_sent_to"
                                    placeholder="Put client emails here, separate by new line" rows="50" @keydown="handleGsheetKeydowncreate" @paste="handleGSheetPasteCreate">
                                </textarea>
                            </base-input>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 has-label form-group" v-if="userType != 'client'">
                            <label>Admins Approved for Google Sheet Administration</label>
                            <el-select multiple class="select-info select-fullwidth" size="large"
                                v-model="selectedRowData.admin_notify_to"
                                placeholder="You can select multiple Admin">
                                <el-option v-for="option in selectsAdministrator.administratorList" class="select-info"
                                    :value="option.id" :label="option.name" :key="option.id">
                                </el-option>
                            </el-select>
                        </div>
                      <!--ADD QUESTIONNAIRE LOCATOR QUESTION-->
                       <ValidationObserver ref="form5" class="col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group" v-if="false">
                            <label>Campaign End Date:</label>
                            
                          
                                <base-input class="mb-0">
                                    <el-date-picker
                                        type="date"
                                        placeholder="Input end date"
                                        v-model="selectedRowData.ori_campaign_enddate"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </base-input> 
                                <small><em>* Campaign will not run automatically until you click play button</em></small>  
                                <div class="col-sm-12 col-md-12 col-lg-12"  :id="'err_startendcamp' + selectedRowData.id"  style="display:none">
                                    <label style="color:#942434" :id="'ErrStartEndCampaign' + selectedRowData.id" ></label>
                                </div>    
                            
                        </div>
                        <div class="form-group">
                            <label>Do you want to target locations by :</label>
                            <div class="row">
                                <div class="col-sm-4 col-md-4 col-lg-4">
                                    <base-checkbox name="nationaltargeting" v-model="selectedRowData.target_nt"  @change="nationaltargetselectedEdit('target_nt',selectedRowData, $event)"  inline>National Targeting</base-checkbox>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-4">
                                    <base-checkbox name="state" v-model="selectedRowData.target_state" @change="nationaltargetselectedEdit('target_state',selectedRowData, $event)" inline>State</base-checkbox>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-4">
                                    <base-checkbox name="zipcode" v-model="selectedRowData.target_zip" @change="nationaltargetselectedEdit('target_zip',selectedRowData, $event)" inline>Zip Code</base-checkbox>
                                </div>
                            </div>
                            <div class="border-box" id="boxState" v-if="selectedRowData.target_state" style="margin-top: 8px">
                              <label >Select By States</label>
                              <div class="row">
                                  <div class="col-sm-12 col-md-12 col-lg-12" id="state-selector-wrapper">
                                          <base-input style='border:none !important;'>
                                              <el-select
                                                  id="statelist"
                                                  v-model="selectedRowData.leadspeek_locator_state"
                                                  class="select-primary "
                                                  name="statelist"
                                                  inline
                                                  size="large"
                                                  placeholder="Select State(s)"
                                                  filterable
                                                  default-first-option
                                                  multiple
                                                  @change="onStateChange($event, selectedRowData)"
                                                  >
                                                  <el-option
                                                  v-for="option in selects.statelist"
                                                  class="select-primary"
                                                  :label="option.state_name"
                                                  :value="option.state_code"
                                                  :key="option.state_code"
                                                  ></el-option>
                                              </el-select>
                                          </base-input>
                                  </div>
                              </div>
                            </div>
                            <div class="border-box" id="boxState" v-if="selectedRowData.target_state">
                              <label >Select By Cities</label>
                              <div class="row">
                                  <div class="col-sm-12 col-md-12 col-lg-12" id="state-selector-wrapper">
                                    <el-select
                                        v-model="selectedRowData.leadspeek_locator_city"
                                        :class="[selectedRowData.leadspeek_locator_state.length > 1 || selectedRowData.leadspeek_locator_state.length == 0 ? 'disabled' : 'select-primary']"
                                        inline
                                        size="large"
                                        placeholder="Select By Cities"
                                        filterable
                                        default-first-option
                                        multiple
                                        remote
                                        @visible-change="onDropdownVisible"
                                        @change="onCityChange"
                                        no-match-text="Loading...."
                                        ref="select"
                                        :remote-method="onSearchCity"
                                        :disabled="selectedRowData.leadspeek_locator_state.length > 1 || selectedRowData.leadspeek_locator_state.length == 0"
                                        :style="[selectedRowData.leadspeek_locator_state.length > 1 || selectedRowData.leadspeek_locator_state.length == 0 ? {background: '#f5f7fa', color: '#c0c4cc !important', cursor: 'not-allowed !important'} : {}]"
                                        >
                                        <el-option
                                        v-for="(option) in optionsCity"
                                        class="select-primary"
                                        :label="option.city"
                                        :value="option.city"
                                        :key="option.city"
                                        ></el-option>
                                        <el-option v-if="isLoadingOptionsCity" value="loading" label="Loading...." disabled>
                                        </el-option>
                                    </el-select>
                                    <small>* You can select cities only if exactly one state is selected.</small>
                                  </div>
                              </div>
                            </div>
                            <div class="border-box mt-4" id="boxCityState" v-if="selectedRowData.target_zip">
                                <label class="label-border-box">List the zip codes that you want the campaign to target, <strong>One postal code per line</strong>:</label>
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                            <div class="form-group has-label">
                                                    <!-- <textarea
                                                        id="zipcodelist"
                                                        class="form-control input-border"
                                                        v-model="selectedRowData.leadspeek_locator_zip"
                                                        placeholder="" 
                                                        rows="5"
                                                        style="min-height:11rem; color: #222a42;"
                                                        @keydown="handleZipKeydowncreate" @paste="onPasteEditZipCodes($event, selectedRowData.leadspeek_locator_zip)"
                                                    >
                                                    </textarea> -->
                                                    <ZipCodeTextArea v-model="selectedRowData.leadspeek_locator_zip" />
                                                    <small style='color:red !important;' :id="'err_locator_zip' + selectedRowData.id">* A minimum of 1 valid ZIP code and a maximum of 50 valid ZIP codes must be provided.</small>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                            <div class="form-group" v-if="false">
                                <ValidationProvider
                                        name="How many contacts"
                                        rules="required|numeric|min_value:1"
                                        v-slot="{ passed, failed, errors }"
                                    >
                                    <base-input
                                        v-model="newcampaign.asec5_6"
                                        label="Do you want to cap the amount of contacts you receive per day? (Input should be numeric and greater than zero) *"
                                        placeholder="Input should be numeric and greater than zero"
                                        :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                    </ValidationProvider>
                            </div>
  
                            <el-divider></el-divider>
                            <div class="grid-container-campaign-information">
                                <el-card :shadow="rowCampaignInformationData == 'basic' ? 'always' : 'hover'" style="cursor: pointer;" :class="{ 'campaign-information-active': rowCampaignInformationData == 'basic' }" @click.native="onChangeRowCampaignInformationData('basic')">
                                    <i class="fas fa-user" style="font-size: 20px;"></i>
                                    <p style="font-size: 16px; font-weight: 600; margin: 0px;">Basic Information</p>
                                    <p style="font-size: 12px; opacity: 0.8; margin: 0px;">Basic Information contains general or essential data that is typically required for identification or standard usage.</p>
                                </el-card>
                                <el-card :shadow="rowCampaignInformationData == 'advanced' ? 'always' : 'hover'" style="cursor: pointer;" :class="{ 'campaign-information-active': rowCampaignInformationData == 'advanced' }" @click.native="onChangeRowCampaignInformationData('advanced')">
                                    <i class="fas fa-users-cog" style="font-size: 20px;"></i>
                                    <p style="font-size: 16px; font-weight: 600; margin: 0px;">Advanced Information</p>
                                    <p style="font-size: 12px; opacity: 0.8; margin: 0px;">Advanced Information includes additional, more specific data that is often relevant for advanced features or specific purposes. This may include preferences, choices, or technical details.</p>
                                </el-card>
                            </div>
                        <!-- <div class="col-sm-12 col-md-12 col-lg-12 pt-4"> -->
                            <div style="margin-top: 16px;" v-if="rowCampaignInformationData == 'basic'">
                                <div>
                                    <!-- <base-checkbox name="enabledphonenumber" v-model="selectedRowData.phoneenabled" inline>Enable
                                        Phone Number</base-checkbox> -->
                                        <el-checkbox   @input="openPhoneConfirmationModal('selectedRowData')" class="brand-checkbox" name="enabledphonenumber"  :value="selectedRowData.phoneenabled" inline>Enable
                                            Phone Number</el-checkbox>
                                </div>
                                <div>
                                    <base-checkbox name="enabledhomeaddress" v-model="selectedRowData.homeaddressenabled"
                                        inline>Enable Home Address</base-checkbox>
                                </div>
                                <div>
                                    <base-checkbox name="requireemailaddress" v-model="selectedRowData.require_email"
                                        inline>Require Email Address</base-checkbox>
                                </div>
                            </div>
                            
                            <div v-if="isLoadingAdvancedInformation">
                                <i class="el-icon-loading"></i>
                            </div>
                            <div v-else-if="isErrorAdvancedInformation" class="error-banner">Oops! Something went wrong. Please refresh the page and try again.</div>
                            <div v-else>
                                <div style="margin-top: 16px;" v-if="rowCampaignInformationData == 'advanced'">
                                    <el-checkbox class="checkbox-advanced-information" :indeterminate="isIndeterminateRowAdvancedInformation" v-model="checkAllRowAdvancedInformation" @change="onCheckAllRowAdvancedInformation">Check all</el-checkbox>
                                    <div class="container-checkbox-item-advanced-information">
                                        <div v-for="(value) in listAdvancedInformation" :key="value.type">
                                            <el-checkbox class="checkbox-advanced-information" :label="value.id" v-model="idRowAdvancedInformation" @change="onCheckItemRowAdvancedInformation">{{value.name}}</el-checkbox>
                                            <el-popover
                                                :title="value.name"
                                                width="220"
                                                trigger="hover"
                                                placement="right"
                                            >
                                                <ul style="list-style-type: disc;">
                                                    <li style="color: #222a42 !important;" v-for="(item, index) in value.description" :key="index">{{ item }}</li>
                                                </ul>
                                                <i slot="reference" class="fa fa-question-circle" style="cursor: pointer; margin-left: 8px;"></i>
                                            </el-popover>
                                        </div>
                                    </div>
                                    <el-divider content-position="left">Basic Information</el-divider>
                                    <div style="display: flex; flex-direction: column;">
                                        <el-checkbox   @input="openPhoneConfirmationModal('selectedRowData')" class="checkbox-advanced-information" name="enabledphonenumber"  :value="selectedRowData.phoneenabled" inline>Enable
                                            Phone Number</el-checkbox>
                                        <el-checkbox class="checkbox-advanced-information" v-model="selectedRowData.homeaddressenabled" @change="onCheckItemRowAdvancedInformation">Enable Home Address</el-checkbox>
                                        <el-checkbox class="checkbox-advanced-information" v-model="selectedRowData.require_email" @change="onCheckItemRowAdvancedInformation">Require Email Address</el-checkbox>
                                    </div>
                                </div>
                            </div>

                            <el-divider></el-divider>
                        <!-- </div> -->

                        <div class="pt-2">
                            <label>Contact Re-identification Time Limit:</label>
                            <div class="leads-re-identification-selector-wrapper">
                                <div v-for='item in ReidentificationTimeOptions.slice().reverse()' :key='item.value' :class="['leads-re-identification-selector',{'--active': selectedRowData.reidentification_type == item.value}]" @click='selectedRowData.reidentification_type = item.value'>
                                    {{item.label}}
                                </div>
                            </div>
                            <base-checkbox class="pt-2" name="ApplyReidentificationToAll" v-model="selectedRowData.applyreidentificationall" inline>Do not identify contacts already identified on other campaigns.</base-checkbox>
                            <br /><small>* Your contact could be Re-identified after the time limit you select.</small>
                        </div>
                    </ValidationObserver>
                     <div style="width: 100%; display: flex; justify-content: center; margin-top: 1rem;">
                        <el-popover
                            trigger="hover"
                            effect="light"
                            :open-delay="300"
                            placement="top"
                        >
                            <div style="max-width: 300px; text-align: left;">
                            In the boxes below, specify the keywords that your customer<br>
                            is searching for and reading about (contextual keywords).<br>
                            Keywords must be at least three letters long and no more than three words long.<br>
                            For best results, specify as many keywords as possible.<br>
                            You may enter them one at a time, or paste them in bulk separated by a comma.
                            </div>

                            <template #reference>
                            <div style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
                                <span style="font-weight: 700;">Keyword Control Panel</span>
                                <i class="fa fa-question-circle"></i>
                            </div>
                            </template>
                        </el-popover>
                    </div>
                        <div class="col-12 my-4" style="padding: 0px 15px;box-sizing:border-box;" v-if="newcampaign.asec5_9_1">
                            <div class="row" style="width:100%;margin: auto;">
                                
                                <div class="col-sm-6 col-md-6 col-lg-6 border" style="padding:15px">
                                    <ValidationProvider
                                            name="Keywords"
                                            rules="required"
                                            v-slot="{ passed, failed, errors }"
                                        >
                                        <label class="pb-2">Enter Search keywords one at a time and then press enter.*</label>
                                        <base-input>
                                            <tags-input 
                                            v-model="selectedRowData.leadspeek_locator_keyword"
                                            @change="updatekeywordbulkEdit(selectedRowData)"
                                            placeholder="Enter the keyword/phrases then press enter"
                                            :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]"
                                            ></tags-input>
                                        
                                        </base-input>                                              
                                        </ValidationProvider>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6 border" style="padding:15px; display: flex; flex-direction: column;">
                                    <label style="flex-shrink: 0;">Use this box to paste Search keywords separated by a comma.</label>
                                    <textarea
                                        class="form-control"
                                        v-model="selectedRowData.leadspeek_locator_keyword_bulk"
                                        @keyup="updatekeywordEdit($event.target.value,selectedRowData)"
                                        @keydown="handleKeydownCommaEdit($event,selectedRowData,'leadspeek_locator_keyword_bulk')"
                                        @blur="sanitizedkeywordEdit('keyword',selectedRowData)"
                                        placeholder="Seperate each term with a comma" rows="50" 
                                        style="flex-grow: 1; resize: none;max-height:none;height:calc(2.33571rem + 2px);">
                                    </textarea>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12" style="padding-block: 8px; padding-left: 0px; padding-right: 0px;">
                                                                    <p v-if="isErrorStopWordsEdit" style="color: red; font-size: 12px;">Some words in your input were not allowed and have been removed.</p>
                                                                    <p style="font-size: 12px;">
                                                                        <i class="el-icon-info"></i>
                                                                        The following keywords are restricted and will be automatically removed if entered: "<span style="font-weight: 600;">{{ stopWords.join(', ') }}</span>".<br>
                                                                        The total length of all keywords must not exceed 500 characters.<br>
                                                                        Keyword phrases should not have more than 3 words and cannot repeat a word in a keyword phrase.
                                                                    </p>
                            </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2" id="err_asec5_10" style="display:none">
                            <label style="color:#942434 !important;font-weight:bold">* Target Location and Keywords Field is required</label>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-12" v-if="tableDataPlayApprox.length > 0">

                    <hr />
                    <div>
                        <p style="font-size: 20px; font-weight: 600;">Recent History</p>
                        <p style="margin-bottom: 18px;">The below information is a 7 day lookback on our data systems.
                            The National Count is all search events, and includes duplicates and events that do not have contact information.
                            The Local Count is filtered to be geo-restricted, deduplicated, and only records with contact information. </p>
                    </div>
                   

                    <div>
                        <TableResultCountTools :data="tableDataPlayApprox"
                        :isProccessingLeadCount="isProccessingLeadCount"
                        :isFinishedApproxLeadCount="isFinishedApproxLeadCount"
                        @retrykeyword="handleRetryKeywordEdit" />
                    </div>
                    </div>
                 </div>
                 <template slot="footer">
                        <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex flex-row-reverse flex-wrap" style="gap:8px">
                            <base-button v-if="$global.menuLeadsPeek_update" size="sm"
                                                   :id="'btnSave' + selectedRowData.id" style="height:40px"
                                                    @click="ProcessAddEditClient(selectedRowData)">
                                                    Save
                                                </base-button>
                                                <base-button size="sm"  style="height:40px"
                                                    @click="CancelAddEditClient(selectedRowData)">
                                                    Cancel
                                                </base-button>
                                                <base-button v-if="selectedRowData.report_type == 'GoogleSheet' && GoogleConnectTrue" size="sm"
                                                    :id="'btnResend' + selectedRowData.id"
                                                    style="height:40px" @click="ResendLink(selectedRowData)">
                                                    Resend Google Sheet Link
                                                </base-button>
                        </div>
                </template>
            </modal>
          <!-- edit campaign modal end -->
          <VTour name="myTour" :steps="steps" :callbacks="tourCallbacks" :options="{ highlight: true }"></VTour>
           <!-- Approx lead count -->
           <modal :show.sync="modals.approxLead" id="editCampaign"  bodyClasses='create-campaign-modal-body'
            footerClasses="border-top p-2">
                <h3 slot="header" class="title title-up">Search Volume Estimate for Campaign #{{formApproxLeadCount.leadspeek_api_id}}</h3>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left ">
                            <base-input label="Email" type="text" placeholder="Email to receive ALC"
                                v-model="formApproxLeadCount.email"
                                :maxlength="255"
                                class='mb-0 pb-0 primary__text__color' 
                                @input="formApproxLeadCount.email = $event.toLowerCase()"
                                :class="[isProccessingLeadCount ? 'disabled' : '']">
                            </base-input>
                            <small id="err_campaignname" style="display:none;color:#942434 !important;">
                                * email is required
                            </small>
                        </div>
                    <div class="form-group col-12 mt-3">
                            <label>Do you want to target locations by :</label>
                            <div class="row">
                                <div class="col-sm-4 col-md-4 col-lg-4">
                                    <base-checkbox
                                        name="National Targeting"
                                        :checked="formApproxLeadCount.target_location == 'National Targeting'"
                                        @change="handleApproxLeadCountTargetLocationChange($event, 'National Targeting')"
                                        :disabled="isProccessingLeadCount"
                                        inline>
                                        <span style="color: #222a42;">
                                            National Targeting
                                        </span>
                                    </base-checkbox>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-4">
                                    <base-checkbox
                                        name="State"
                                        :checked="formApproxLeadCount.target_location == 'State'"
                                        @change="handleApproxLeadCountTargetLocationChange($event, 'State')"
                                        :disabled="isProccessingLeadCount"
                                        inline>
                                        <span style="color: #222a42;">
                                            State
                                        </span>
                                    </base-checkbox>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-4">
                                    <base-checkbox
                                        name="Zip Code"
                                        :checked="formApproxLeadCount.target_location == 'Zip Code'"
                                        @change="handleApproxLeadCountTargetLocationChange($event, 'Zip Code')"
                                        :disabled="isProccessingLeadCount"
                                        inline>
                                        <span style="color: #222a42;">
                                            Zip Code
                                        </span>
                                    </base-checkbox>
                                </div>
                            </div>
                            <div class="border-box" id="boxState" v-if="formApproxLeadCount.target_location == 'State'" style="margin-top: 8px;">
                              <label >Select By States</label>
                              <div class="row">
                                  <div class="col-sm-12 col-md-12 col-lg-12" id="state-selector-wrapper">
                                    <el-select
                                        id="statelist"
                                        v-model="formApproxLeadCount.states"
                                        :class="[isProccessingLeadCount ? 'disabled select-primary' : 'select-primary']"
                                        name="statelist"
                                        inline
                                        size="large"
                                        placeholder="Select State(s)"
                                        filterable
                                        default-first-option
                                        multiple
                                        @change="onStateChangeApproxLeadCount($event, formApproxLeadCount)"
                                        :disabled="isProccessingLeadCount"
                                        :style="[isProccessingLeadCount ? {background: '#f5f7fa', color: '#c0c4cc !important', cursor: 'not-allowed !important'} : {}]"
                                        >
                                        <el-option
                                        v-for="option in selects.statelist"
                                        class="select-primary"
                                        :label="option.state_name"
                                        :value="option.state_code"
                                        :key="option.state_code"
                                        ></el-option>
                                    </el-select>
                                  </div>
                              </div>
                            </div>
                            <div class="border-box" id="boxState" v-if="formApproxLeadCount.target_location == 'State'" style="margin-top: 8px;">
                              <label >Select By Cities</label>
                              <div class="row">
                                  <div class="col-sm-12 col-md-12 col-lg-12" id="state-selector-wrapper">
                                    <el-select
                                        v-model="formApproxLeadCount.cities"
                                        :class="[formApproxLeadCount.states.length > 1 || formApproxLeadCount.states.length == 0 || isProccessingLeadCount ? 'disabled select-primary' : 'select-primary']"
                                        inline
                                        size="large"
                                        placeholder="Select By Cities"
                                        filterable
                                        default-first-option
                                        multiple
                                        remote
                                        @visible-change="onDropdownVisible"
                                        @change="onCityChange"
                                        no-match-text="Loading...."
                                        ref="select"
                                        :remote-method="onSearchCity"
                                        :disabled="formApproxLeadCount.states.length > 1 || formApproxLeadCount.states.length == 0 || isProccessingLeadCount"
                                        :style="[formApproxLeadCount.states.length > 1 || formApproxLeadCount.states.length == 0  || isProccessingLeadCount ? {background: '#f5f7fa', color: '#c0c4cc !important', cursor: 'not-allowed !important'} : {}]"
                                        >
                                        <el-option
                                        v-for="(option) in optionsCity"
                                        class="select-primary"
                                        :label="option.city"
                                        :value="option.city"
                                        :key="option.city"
                                        ></el-option>
                                        <el-option v-if="isLoadingOptionsCity" value="loading" label="Loading...." disabled>
                                        </el-option>
                                    </el-select>
                                    <small>* You can select cities only if exactly one state is selected.</small>
                                  </div>
                              </div>
                            </div>
                            <div class="border-box mt-4" id="boxCityState" v-if="formApproxLeadCount.target_location == 'Zip Code'">
                                <label class="label-border-box">List the zip codes that you want the campaign to target, <strong>One postal code per line</strong>:</label>
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                            <div class="form-group has-label">
                                                    <!-- <textarea
                                                        id="zipcodelist"
                                                        class="form-control input-border"
                                                        :class="[isProccessingLeadCount ? 'disabled' : '']"
                                                        v-model="formApproxLeadCount.zip_code"
                                                        placeholder="" 
                                                        rows="5"
                                                        style="min-height:11rem"
                                                        @keydown="handleApproxLeadCountZipKeydowncreate"
                                                        @paste="onPasteEditZipCodes($event, formApproxLeadCount.zip_code, 'ApproxLeadCount')"
                                                        :disabled="isProccessingLeadCount"
                                                        :style="[isProccessingLeadCount ? {background: '#f5f7fa', color: '#c1b9b9 !important', cursor: 'not-allowed !important'} : {}]"
                                                    >
                                                    </textarea> -->
                                                    <ZipCodeTextArea
                                                        v-model="formApproxLeadCount.zip_code"
                                                        :customClass="isProccessingLeadCount ? 'disabled' : ''"
                                                        :disabled="isProccessingLeadCount"
                                                        :customStyle="isProccessingLeadCount ? {background: '#f5f7fa', color: '#c1b9b9', cursor: 'not-allowed'} : {}"
                                                    />
                                                    <small style='color:red !important;' :id="'err_locator_zip' + selectedRowData.id">* A minimum of 1 valid ZIP code and a maximum of 50 valid ZIP codes must be provided.</small>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    <div style="width: 100%; display: flex; justify-content: center; margin-top: 1rem;">
                        <el-popover
                            trigger="hover"
                            effect="light"
                            :open-delay="300"
                            placement="top"
                        >
                            <div style="max-width: 300px; text-align: left;">
                            In the boxes below, specify the keywords that your customer<br>
                            is searching for and reading about (contextual keywords).<br>
                            Keywords must be at least three letters long and no more than three words long.<br>
                            For best results, specify as many keywords as possible.<br>
                            You may enter them one at a time, or paste them in bulk separated by a comma.
                            </div>

                            <template #reference>
                            <div style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
                                <span style="font-weight: 700;">Keyword Control Panel</span>
                                <i class="fa fa-question-circle"></i>
                            </div>
                            </template>
                        </el-popover>
                    </div>
                        <div class="col-12 my-4" style="padding: 0px 15px;box-sizing:border-box;">
                            <div class="row" style="width:100%;margin: auto;">
                                
                                <div class="col-sm-6 col-md-6 col-lg-6 border" style="padding:15px" :style="[isProccessingLeadCount ? {background: '#f5f7fa', cursor: 'not-allowed'} : {}]">
                                    <ValidationProvider
                                            name="Keywords"
                                            rules="required"
                                            v-slot="{ passed, failed, errors }"
                                        >
                                        <label class="pb-2">Enter Search keywords one at a time and then press enter.*</label>
                                        <base-input>
                                            <tags-input
                                            :disabled="isProccessingLeadCount"
                                            :disableRemove="isProccessingLeadCount"
                                            v-model="formApproxLeadCount.keyword"
                                            @change="updateApproxLeadCountKeywordBulkEdit(formApproxLeadCount)"
                                            placeholder="Enter the keyword/phrases then press enter"
                                            :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]"
                                            ></tags-input>
                                        
                                        </base-input>                                              
                                        </ValidationProvider>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6 border" style="padding:15px; display: flex; flex-direction: column;" :style="[isProccessingLeadCount ? {background: '#f5f7fa', cursor: 'not-allowed'} : {}]">
                                    <label style="flex-shrink: 0;">Use this box to paste Search keywords separated by a comma.</label>
                                    <textarea
                                        :class="[isProccessingLeadCount ? 'disabled' : '']"
                                        class="form-control primary__text__color"
                                        v-model="formApproxLeadCount.keyword_bulk"
                                        @keyup="updateKeywordEditApproxLeadCount($event.target.value,formApproxLeadCount)"
                                        @keydown="handleKeydownCommaEditApproxLeadCount($event,formApproxLeadCount,'keyword_bulk')"
                                        @blur="sanitizedKeywordEditApproxLeadCount(formApproxLeadCount)"
                                        placeholder="Seperate each term with a comma" rows="50" 
                                        style="flex-grow: 1; resize: none;max-height:none;height:calc(2.33571rem + 2px);">
                                    </textarea>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12" style="padding-block: 8px; padding-left: 0px; padding-right: 0px;">
                                                                    <p v-if="isErrorStopWordsEdit" style="color: red; font-size: 12px;">Some words in your input were not allowed and have been removed.</p>
                                                                    <p style="font-size: 12px;">
                                                                        <i class="el-icon-info"></i>
                                                                        The following keywords are restricted and will be automatically removed if entered: "<span style="font-weight: 600;">{{ stopWords.join(', ') }}</span>".<br>
                                                                        The total length of all keywords must not exceed 500 characters.<br>
                                                                        Keyword phrases should not have more than 3 words and cannot repeat a word in a keyword phrase.
                                                                    </p>
                            </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2" id="err_asec5_10" style="display:none">
                            <label style="color:#942434 !important;font-weight:bold">* Target Location and Keywords Field is required</label>
                        </div>
                        <!-- only show if count is present -->
                        <div v-if="isErrorFetchLeadCount" class="error-banner"><p>Something went wrong. Please try again.</p></div>
                        <div v-if="isProccessingLeadCount" class="info-banner"><p style="display: flex; align-items: center;"> <i class="el-icon-loading" style="margin-right: 8px; font-size: 18px;"></i>Please wait a few minutes and the results will display below. You may close this window while you wait and check back later. There is no need to refresh this page.</p></div>
                        <div v-if="isRowsTableDataApproxReady()">

                        <hr />
                        <div>
                            <p style="font-size: 20px; font-weight: 600;">Recent History</p>
                            <p style="margin-bottom: 18px;">The below information is a 7 day lookback on our data systems.
                            The National Count is all search events, and includes duplicates and events that do not have contact information.
                            The Local Count is filtered to be geo-restricted, deduplicated, and only records with contact information. </p>
                        </div>
                        <div>
                            <TableResultCountTools 
                            :data="tableDataApprox"
                            :isProccessingLeadCount="isProccessingLeadCount"
                            :isFinishedApproxLeadCount="isFinishedApproxLeadCount"
                            @retrykeyword="handleRetryKeyword"/>
                        </div>
                    </div>

                        <!-- <div style="display: flex; justify-content: flex-end; margin-top: 16px;">
                            <el-pagination
                                layout="prev, pager, next"
                                :current-page="currentPageDataApprox"
                                :page-size="pageSizeDataApprox"
                                :total="tableDataApprox.length"
                                @current-change="handlePageChangeDataApprox"
                            >
                            </el-pagination>
                        </div> -->
                    </div>
                </div>
                <template slot="footer">
                        <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex flex-row-reverse flex-wrap" style="gap:8px">
                            <base-button :disabled="isLoadingGetCount || isProccessingLeadCount" size="sm" style="height:40px"
                                @click="handleGetCountApproxLead">
                                <i v-if="isLoadingGetCount" class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i> Get Count
                            </base-button>
                            <!-- only present if we have count -->
                            <base-button v-if="isDefaultTargetLocation && isFinishedApproxLeadCount" :disabled="isLoadingAddToCampaign || isProccessingLeadCount" size="sm" style="height:40px"
                                @click="handleAddToCampaignApproxLead">
                                <i v-if="isLoadingAddToCampaign" class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i> Add to campaign
                            </base-button>
                            <base-button :simple="true" size="sm"   style="height:40px"
                                @click="handleCancelApproxLead">
                                Close
                            </base-button>
                                                
                        </div>
                </template>
           </modal>

            <!-- approx lead count -->
            <modal :show.sync="modals.helpVideos" headerClasses="">
            <div slot="header" class="d-flex flex-column gap-4"><h4  class="title title-up">{{activeHelpItem.title}}</h4> 
              
             </div>
            <div v-if="modals.helpVideos" v-html="activeHelpItem.embedVideoCode"></div>
            <p class="text-dark mt-4" style="font-size: 14px;" v-html="activeHelpItem.desc"></p>
        </modal>

        <!-- modal add customer list -->
        <AddLocalUserClient 
            v-model="modals.uploadUserClient"
            :companyList="selectsCompany.companyList"
            :userId="ClientUserID"
            :isCompanyNamedisabled="CompanyNamedisabled"
            @upload-finished="onUploadCustomerFinished">
        </AddLocalUserClient>
        <!-- modal add customer list -->

        <!-- Report Download Modal -->
        <ReportPredictDownloadModal
            v-model="modals.reportDownload"
            :campaignId="reportDownloadCampaign.id"
            :campaignName="reportDownloadCampaign.name"
        />
        <!-- Report Download Modal -->

        <!-- Campaign Detail Modal (combined Step 1 + Step 2) -->
        <modal
            v-model="modals.viewCampaignDetail"
            :show.sync="modals.viewCampaignDetail"
            modalContentClasses="campaign-detail-modal"
            bodyClasses="create-campaign-modal-body"
            headerClasses="d-flex justify-content-between align-items-center"
        >
            <h3 slot="header" class="title title-up mb-0">Campaign Details #{{ selectedRowData.leadspeek_api_id }}</h3>

            <div class="campaign-detail-body">
                <!-- Basic Information Section -->
                <div class="campaign-detail-section">
                    <p class="campaign-detail-section-title">Basic Information</p>
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12" v-if="selectedRowData.company_name">
                            <base-input label="Client Name" type="text" 
                                :value="selectedRowData.company_name" disabled>
                            </base-input>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <base-input label="Contact Name" type="text" 
                                :value="selectedRowData.name" disabled>
                            </base-input>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6">
                            <base-input label="Email" type="email" 
                                :value="selectedRowData.email" disabled>
                            </base-input>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6">
                            <base-input label="Phone Number" type="text" 
                                :value="selectedRowData.phonenum" disabled>
                            </base-input>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <base-input label="Campaign Name" type="text" 
                                :value="selectedRowData.campaign_name" disabled>
                            </base-input>
                        </div>
                    </div>
                </div>

                <el-divider></el-divider>

                <!-- Business Information Section -->
                <div class="campaign-detail-section">
                    <p class="campaign-detail-section-title">Business Information</p>
                    <div class="row">
                        <div v-if="this.$global.globalviewmode" class="col-12">
                            <base-input label="Expression" type="text" 
                                :value="selectedRowData.final_expression" disabled>
                            </base-input>
                        </div>
                        <div class="col-12">
                            <base-input label="Business name" type="text" 
                                :value="selectedRowData.business_name" disabled>
                            </base-input>
                        </div>
                        <div class="col-12">
                            <base-input label="Website" type="text" 
                                :value="selectedRowData.website" disabled>
                            </base-input>
                        </div>
                        <div class="col-12">
                            <base-input label="Business industry">
                                <el-select
                                  v-model="selectedRowData.business_industry_id"
                                  placeholder="Select an industry"
                                  filterable
                                  clearable
                                  style="width: 100%"
                                  disabled
                                >
                                  <el-option
                                    v-for="(industry) in businessIndustries"
                                    :key="industry.id"
                                    :label="industry.name"
                                    :value="industry.id"
                                  />
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-12">
                            <base-input label="What does your business do?">
                                <textarea class="form-control input-border textarea-disabled textarea-custom-height" 
                                    :value="selectedRowData.business_description" 
                                    rows="5"
                                    readonly>
                                </textarea>
                            </base-input>
                        </div>
                        <div v-if="false" class="col-12">
                            <base-input label="Who are your main competitors?">
                                <textarea class="form-control input-border" 
                                    :value="selectedRowData.business_competitors" 
                                    rows="3"
                                    readonly>
                                </textarea>
                            </base-input>
                        </div>
                        
                        <!-- Your ideal customers are from - Checkbox style -->
                        <div class="col-12">
                            <div class="form-group m-0 p-0">
                                <label>Your ideal customers are from</label>
                                <div class="row">
                                    <div class="col-3">
                                        <base-checkbox v-model="selectedRowData.target_nt" disabled inline>National</base-checkbox>
                                    </div>
                                    <div class="col-3">
                                        <base-checkbox v-model="selectedRowData.target_state" disabled inline>State</base-checkbox>
                                    </div>
                                    <div class="col-3">
                                        <base-checkbox v-model="selectedRowData.target_zip" disabled inline>Zip Code</base-checkbox>
                                    </div>
                                    <div class="col-3">
                                        <base-checkbox v-model="selectedRowData.target_location" disabled inline>Select from location</base-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12" v-if="selectedRowData.target_state">
                            <div class="border-box" style="margin-top: 8px">
                                <label style="margin-bottom: 6px;">Select By States</label>
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12" id="state-selector-wrapper">
                                        <base-input style='border:none !important;'>
                                            <el-select
                                                id="statelist"
                                                v-model="selectedRowData.leadspeek_locator_state"
                                                class="select-primary"
                                                name="statelist"
                                                inline
                                                size="large"
                                                placeholder="Select State(s)"
                                                filterable
                                                default-first-option
                                                multiple
                                                disabled
                                            >
                                                <el-option
                                                    v-for="option in selects.statelist"
                                                    class="select-primary"
                                                    :label="option.state_name"
                                                    :value="option.state_code"
                                                    :key="option.state_code"
                                                ></el-option>
                                            </el-select>
                                        </base-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12" v-if="selectedRowData.target_zip">
                            <div class="border-box mt-2">
                                <label class="label-border-box">List the zip codes that you want the customers to target, <strong>One postal code per line</strong>:</label>
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                        <div class="form-group has-label">
                                            <ZipCodeTextArea v-model="selectedRowData.leadspeek_locator_zip" :disabled="true" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="col-12" v-if="selectedRowData.target_location">
                            <div class="border-box mt-2">
                                <GeoRadiusSelector
                                    :lat.sync="selectedRowData.leadspeek_latitude"
                                    :lng.sync="selectedRowData.leadspeek_longitude"
                                    :radius-miles.sync="selectedRowData.leadspeek_radius"
                                    :default-center="usDefaultCenter"
                                    :default-radius="selectedRowData.leadspeek_radius || 25"
                                    :readonly="true"
                                />
                            </div>
                        </div>

                        <!-- Customer List Section -->
                        <UserClientEdit 
                            :customer-list="selectedRowData.predict_customers || []"
                        />
                    </div>
                </div>

                <el-divider v-if="selectedRowData.final_analyze_customers"></el-divider>

                <!-- Analyze Customer Section -->
                <div v-if="selectedRowData.final_analyze_customers" class="campaign-detail-section">    
                    <p class="campaign-detail-section-title">Customer Analysis Choices</p>
                    
                    <div class="analysis-choices-container">
                        <!-- Persona Selection Card -->
                        <div v-if="selectedRowData.final_analyze_customers.persona" class="analysis-choice-item">
                            <div class="choice-content">
                                <span class="choice-name">{{ selectedRowData.final_analyze_customers.persona.name }}</span>
                                <p class="choice-description">{{ selectedRowData.final_analyze_customers.persona.description }}</p>
                            </div>
                        </div>

                        <!-- Strategy Selection Card -->
                        <div v-if="selectedRowData.final_analyze_customers.strategy" class="analysis-choice-item">
                            <div class="choice-content">
                                <span class="choice-name">{{ selectedRowData.final_analyze_customers.strategy.label }}</span>
                                <p class="choice-description">{{ selectedRowData.final_analyze_customers.strategy.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template slot="footer">
                <div class="d-flex justify-content-end" style="gap:8px; width:100%; padding: 0 20px 12px 0;">
                    <base-button simple @click="modals.viewCampaignDetail = false">Close</base-button>
                </div>
            </template>
        </modal>
        <!-- Campaign Detail Modal (combined Step 1 + Step 2) -->
       
    </div>
</template>
<script>
import { DatePicker,Table, TableColumn, Select, Option,Checkbox, Badge, Switch, Dropdown, DropdownMenu, DropdownItem, CollapseItem, Collapse, RadioGroup, Radio, Pagination, Button, Alert, Upload, Divider, Card, Popover, Menu, MenuItem, MenuItemGroup, Input, Form, FormItem, ColorPicker, Tag, Progress, Notification } from 'element-ui';
import { BasePagination,BaseCheckbox, Modal, TableResultCountTools, ZipCodeTextArea } from 'src/components';
import { TagsInput } from '/src/components/index';
import Fuse from 'fuse.js';
import swal from 'sweetalert2';
import { html, json } from 'd3';
import axios from 'axios';
import { mapActions } from "vuex";
import SelectClientDropdown from '@/components/SelectClientDropdown.vue'
import { extend } from "vee-validate";
import { required, numeric, regex, confirmed, min_value } from "vee-validate/dist/rules";
var CHECK_GROUPCOMPANY;
const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
import Vue from 'vue';
import VTour from '../../../../components/Tour/VTour.vue';
import { Loading } from 'element-ui';
import { decryptData } from '../../../../helpers/crypto'
import TagsAutomation from '../../../../components/Pages/Campaign/TagsAutomation.vue';
import IntegrationModalBody from '../../../../components/Pages/Campaign/IntegrationModalBody.vue';
import StepIndicator from '../../../../components/StepIndicator.vue';
import UserClient from '../../../../components/Tables/UserClient.vue'; // for list user client / customer
import UserClientEdit from '../../../../components/Tables/UserClientEdit.vue'; // for customer list in campaign detail
import AddLocalUserClient from "@/components/Modals/AddLocalUserClient.vue"; // for list add client / customer
import LLMChatWindow from '../../../../components/LLMChatWindow.vue';
import GeoRadiusSelector from '@/components/GeoRadiusSelector.vue';
import ReportPredictDownloadModal from '@/components/Modals/ReportPredictDownloadModal.vue';
import StopCampaignModal from '@/utils/stopCampaignModal';
Vue.use(Loading.directive);
extend("required", required);
extend("numeric", numeric);
extend("regex", regex);
extend("confirmed", confirmed);
extend("min_value",min_value);

const SAMPLE_CUSTOMER_LIST_URL = 'https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/media/mcpwatttestfile.csv';
const DEFAULT_MARKET_BASE_CONTEXT = 'Ideal customer analysis from uploaded CSV';
const DEFAULT_TARGETING_STRATEGY_OPTIONS = [
    { id: 'precision', label: 'Precision', description: 'Need high-quality, precise matches' },
    { id: 'balanced', label: 'Balanced', description: 'General audience building' },
    { id: 'reach', label: 'Reach', description: 'Need maximum audience size' },
];

export default {
 
    components: {
        Modal,
        CampaignFinancials: () => import('@/components/CampaignFinancials.vue'),
        UserClientEdit,
        //Collapse,
        VTour,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Checkbox.name]: Checkbox,
        [Badge.name]: Badge,
        [Switch.name]: Switch,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Pagination.name]: Pagination,
        [Button.name]: Button,
        [Alert.name]: Alert,
        [Upload.name]: Upload,
        [Divider.name]: Divider,
        [Popover.name]: Popover,
        [Menu.name]: Menu,
        [MenuItemGroup.name]: MenuItemGroup,
        [MenuItem.name]: MenuItem,
        [Input.name]: Input,
        [Form.name]: Form,
        [FormItem.name]: FormItem,
        [ColorPicker.name]: ColorPicker,
        [Tag.name]: Tag,
        [Progress.name]: Progress,
        BasePagination,
        BaseCheckbox,
        TagsInput,
        SelectClientDropdown,
        TableResultCountTools,
        'el-card': Card,
        TagsAutomation,
        IntegrationModalBody,
        ZipCodeTextArea,
        StepIndicator,
        UserClient,
        AddLocalUserClient,
        LLMChatWindow,
        GeoRadiusSelector,
        ReportPredictDownloadModal,
    },
    data() {
        return {
            selectedCustomerList: null,
            customerListSearchQuery: "",
            locationMode:'true',
            disableChat:false,
            campaignCreateActiveStep:0,
            // Store final selections from AI option panels
            final_analyze_customers: { persona: null, strategy: null },
            availableContacts: null, // Store available contacts count
            createCampaignSteps: [
                { name: 'Basic Information' },
                { name: 'Business Information' },
                { name: 'Predict Profile' },
                // {name:'Campaign Financials'},
                { name: 'Integration Setup' }
            ],
            messagesChat: [],
            usDefaultCenter: [37.0902, -95.7129],
            currentIcp: '',
            icpCsvUrl: SAMPLE_CUSTOMER_LIST_URL,
            icpMarketBaseContext: DEFAULT_MARKET_BASE_CONTEXT,
            icpAnalysisText: '',
            icpQueryParams: {},
            icpMetadata: {},
            lastUpdatedExpression: null,
            icpPersonas: [],
            audienceCsvKey: null,
            personaRefinements: [],
            pendingPersonaIndex: null,
            selectedTargetingStrategy: null,
            pendingTargetingStrategy: null,
            strategyPanelReady: false,
            strategyLoading: false,
            targetingStrategyOptions: DEFAULT_TARGETING_STRATEGY_OPTIONS.map(option => ({ ...option })),
            selectedPersonaIndex: null,
            personaSelectorVisible: false,
            dynamicLlmOptionPanels: [],
            llmQuickActions: [],
            isGeneratingICP: false,
            campaignBusinessInfo:{
                name:'',
                website:'',
                idealCustomers:'',
                businessDescription:'',
                competitors:'',
                industry:'', // attach id
                customIndustry:'',
                businessType:'',
                customerUploadSources: {},
                crmProvider:'', // attach id
                crmApiKey:''
            },
            // businessIndustries: [
            //     'Advertising & Marketing',
            //     'Aerospace & Defense',
            //     'Agriculture',
            //     'Automotive',
            //     'Biotech & Life Sciences',
            //     'Business Services',
            //     'Construction',
            //     'Consumer Goods',
            //     'Consulting',
            //     'Education',
            //     'Energy & Utilities',
            //     'Engineering',
            //     'Entertainment & Media',
            //     'Financial Services',
            //     'Food & Beverage',
            //     'Government & Public Sector',
            //     'Healthcare & Medical',
            //     'Hospitality & Travel',
            //     'Insurance',
            //     'Internet & Software',
            //     'IT & Managed Services',
            //     'Legal',
            //     'Logistics & Supply Chain',
            //     'Manufacturing',
            //     'Nonprofit & NGOs',
            //     'Pharmaceuticals',
            //     'Real Estate',
            //     'Restaurants',
            //     'Retail & Ecommerce',
            //     'Telecommunications',
            //     'Transportation',
            //     'Wholesale & Distribution',
            //     'Other'
            // ],
            businessIndustries: [
                { 
                    id: 1, 
                    slug: 'advertising_and_marketing', 
                    name: 'Advertising & Marketing' 
                },
                { 
                    id: 2, 
                    slug: 'aerospace_and_defense', 
                    name: 'Aerospace & Defense' 
                },
                { 
                    id: 3, 
                    slug: 'agriculture', 
                    name: 'Agriculture' 
                },
                { 
                    id: 4, 
                    slug: 'automotive', 
                    name: 'Automotive' 
                },
                { 
                    id: 5, 
                    slug: 'biotech_and_life_sciences', 
                    name: 'Biotech & Life Sciences' 
                },
                { 
                    id: 6, 
                    slug: 'business_services', 
                    name: 'Business Services' 
                },
                { 
                    id: 7, 
                    slug: 'construction', 
                    name: 'Construction' 
                },
                { 
                    id: 8, 
                    slug: 'consumer_goods', 
                    name: 'Consumer Goods' 
                },
                { 
                    id: 9, 
                    slug: 'consulting', 
                    name: 'Consulting' 
                },
                { 
                    id: 10, 
                    slug: 'education', 
                    name: 'Education' 
                },
                { 
                    id: 11, 
                    slug: 'energy_and_utilities', 
                    name: 'Energy & Utilities' 
                },
                { 
                    id: 12, 
                    slug: 'engineering', 
                    name: 'Engineering' 
                },
                { 
                    id: 13, 
                    slug: 'entertainment_and_media', 
                    name: 'Entertainment & Media' 
                },
                { 
                    id: 14, 
                    slug: 'financial_services', 
                    name: 'Financial Services' 
                },
                { 
                    id: 15, 
                    slug: 'food_and_beverage', 
                    name: 'Food & Beverage' 
                },
                { 
                    id: 16, 
                    slug: 'government_and_public_sector', 
                    name: 'Government & Public Sector' 
                },
                { 
                    id: 17, 
                    slug: 'healthcare_and_medical', 
                    name: 'Healthcare & Medical' 
                },
                { 
                    id: 18, 
                    slug: 'hospitality_and_travel', 
                    name: 'Hospitality & Travel' 
                },
                { 
                    id: 19, 
                    slug: 'insurance', 
                    name: 'Insurance' 
                },
                { 
                    id: 20, 
                    slug: 'internet_and_software', 
                    name: 'Internet & Software' 
                },
                { 
                    id: 21, 
                    slug: 'it_and_managed_services', 
                    name: 'IT & Managed Services' 
                },
                { 
                    id: 22, 
                    slug: 'legal', 
                    name: 'Legal' 
                },
                { 
                    id: 23, 
                    slug: 'logistics_and_supply_chain', 
                    name: 'Logistics & Supply Chain' 
                },
                { 
                    id: 24, 
                    slug: 'manufacturing', 
                    name: 'Manufacturing' 
                },
                { 
                    id: 25, 
                    slug: 'nonprofit_and_ngos', 
                    name: 'Nonprofit & NGOs' 
                },
                { 
                    id: 26, 
                    slug: 'pharmaceuticals', 
                    name: 'Pharmaceuticals' 
                },
                { 
                    id: 27, 
                    slug: 'real_estate', 
                    name: 'Real Estate' 
                },
                { 
                    id: 28, 
                    slug: 'restaurants', 
                    name: 'Restaurants' 
                },
                { 
                    id: 29, 
                    slug: 'retail_and_ecommerce', 
                    name: 'Retail & Ecommerce' 
                },
                { 
                    id: 30, 
                    slug: 'telecommunications', 
                    name: 'Telecommunications' 
                },
                { 
                    id: 31, 
                    slug: 'transportation', 
                    name: 'Transportation' 
                },
                { 
                    id: 32, 
                    slug: 'wholesale_and_distribution', 
                    name: 'Wholesale & Distribution' 
                },
                { 
                    id: 33, 
                    slug: 'other', 
                    name: 'Other' 
                }
            ],
            businessTypeOptions: [
                'B2B',
                'B2C',
                'D2C',
                'B2B2C',
                'C2C',
                'Marketplace',
                'SaaS',
                'Services',
                'E-commerce',
                'Nonprofit',
                'Government',
                'Franchise'
            ],
            customerUploadSourceOptions: [
                {
                    id: 1,
                    slug: 'crm',
                    name: 'CRM',
                },
                { 
                    id: 2,
                    slug: 'local',
                    name: 'Local List',
                }
            ],
            // crmOptions: [
            //     'HubSpot',
            //     'Salesforce',
            //     'Zoho CRM',
            //     'Pipedrive',
            //     'Freshsales',
            //     'Copper',
            //     'Insightly',
            //     'Keap (Infusionsoft)',
            //     'ActiveCampaign',
            //     'Mailchimp',
            //     'Close',
            //     'GoHighLevel',
            //     'Monday Sales CRM',
            //     'Nutshell',
            //     'SugarCRM',
            // ],
            crmOptions: [
                { 
                    id: 1, 
                    slug: 'hubspot', 
                    name: 'HubSpot' 
                },
                { 
                    id: 2, 
                    slug: 'salesforce', 
                    name: 'Salesforce' 
                },
                { 
                    id: 3, 
                    slug: 'zoho_crm', 
                    name: 'Zoho CRM' 
                },
                { 
                    id: 4, 
                    slug: 'pipedrive', 
                    name: 'Pipedrive' 
                },
                { 
                    id: 5, 
                    slug: 'freshsales', 
                    name: 'Freshsales' 
                },
                { 
                    id: 6, 
                    slug: 'copper', 
                    name: 'Copper' 
                },
                { 
                    id: 7, 
                    slug: 'insightly', 
                    name: 'Insightly' 
                },
                { 
                    id: 8, 
                    slug: 'keap_infusionsoft', 
                    name: 'Keap (Infusionsoft)' 
                },
                { 
                    id: 9, 
                    slug: 'activecampaign', 
                    name: 'ActiveCampaign' 
                },
                { 
                    id: 10, 
                    slug: 'mailchimp', 
                    name: 'Mailchimp' 
                },
                { 
                    id: 11, 
                    slug: 'close', 
                    name: 'Close' 
                },
                { 
                    id: 12, 
                    slug: 'gohighlevel', 
                    name: 'GoHighLevel' 
                },
                { 
                    id: 13, 
                    slug: 'monday_sales_crm', 
                    name: 'Monday Sales CRM' 
                },
                { 
                    id: 14, 
                    slug: 'nutshell', 
                    name: 'Nutshell' 
                },
                { 
                    id: 15, 
                    slug: 'sugarcrm', 
                    name: 'SugarCRM' 
                }
            ],
            isMessageSending:false,
            tourCallbacks:{
                onSkip:this.removeDummyItemFromQueriedData,
                onFinish:this.removeDummyItemFromQueriedData,
                onStop:this.removeDummyItemFromQueriedData,

            },
            helpContentMap:[
                {   title:'Agency Site Campaign Creation',
                    embedVideoCode:'<iframe src="https://drive.google.com/file/d/14KMM2Wbb5vmc-TSiWFNqLrBOzz-p4mwd/preview" width="100%" height="480" allow="autoplay"></iframe>',
                    desc:'Lets create a Site campaign, In the upper right corner of your screen you will click Add Campaign<br>If you have already selected the client on the main dashboard, their name will appear at the top for a reference to make sure you are creating a campaign for the correct client. If you were viewing all your clients then you will select your client at this point.<br>In the campaign name, You will want to give the campaign a very clear name, such as homepage for ABC landscaping. This field is searchable so be descriptive.<br>In the URL section, you want to put the main URL where you are actually placing the code. One campaign code is good for an entire website as long as it is placed in the global head. You do not need a campaign per page. When the contact is identified we will display the complete URL of the landing page including any Facebook or Google ID or any UTM information in the URL.<br>Your clients email address is preloaded to be a viewer in the Google sheet, if you are using the Google sheet integration. You may also put additional email addresses to add them as viewers. One per line.<br>You may add additional administrators here in the box and select them. They will receive notifications about the campaign as well as be added as an editor to the Google sheet.<br>Next you will select the data options that will correspond with your campaign goals.<br>Next to you will check this box if you are putting the embed code in a tag manager. Our servers check to make sure the code is installed properly and when it is installed in a tag manager we will modify this process.<br>Finally you will select your Re-identification options. This setting depends on the industry of your client. Some industries will gladly pay to receive a notification when someone comes back to their website after a certain amount of time.<br>The final option is to block cross campaign identification. This is not typically used.<br>After ensuring that everything looks good. Press the Save button and the campaign will be created. The next steps are to install the identification code on the clients website, verify the financial settings, verify the Integrations and then press Play to begin identifying website traffic..<br>Editing a campaign is a similar process. You may edit a campaign while it is running, paused or stopped. There is no need to stop a campaign to edit it.'
                },
                {   title:'Agency Site Embed Code',
                    embedVideoCode:'<iframe src="https://drive.google.com/file/d/1_X9mia303zidQ1S7Fh41mYKEY7SGsuhq/preview" width="100%" height="480" allow="autoplay"></iframe>',
                    desc:'This is where you will find the embed code that corresponds to this specific campaign. Make sure to copy and paste the entire code and do not format the text if you are sharing it to a team member.<br>A common mistake occurs if this code is shared as a simple text paste in slack.<br>To avoid this issue you can press the back tick button three times in slack ``` and it will change the slack text box into a code text box.<br>A great way to share it is by using Notepad to ensure the code integrity and to save it in a plain text .txt document and then attach that .txt document to the email or message. Do not share it in a word mac document.'
                },
                {   title:'Agency Campaign Integrations and Plugins',
                    embedVideoCode:'<iframe src="https://drive.google.com/file/d/1qpxWlUPJzXY8lRdLKchWOcR25PvyXvPG/preview" width="100%" height="480" allow="autoplay"></iframe>',
                    desc:"Here you can control the integrations and plugins on the campaign level on behalf of your client. As long as the API key is connected to the client's account, then the integration will appear here to be managed.<br>If you give your clients campaign edit access, they also have the ability to add Integration API keys under their profile in the lower left corner, and to adjust the integrations on a per-campaign basis.<br>As you add integrations to this campaign, make sure to check the box to connect to the particular integration and then also select the tags, or options, or lists that are appropriate for that client's needs. We do pull the lists and tags from the integration partner and display them as options to be selected. We also allow you to type in a tag and it will be created in the clients highlevel account.<br>If you are working with the webhooks, make sure that the webhook is set up as a POST web hook and that there are no firewalls or other security measures keeping our servers from sending the data. You can also add additional tags to the webhook. You can also send test data multiple times by checking the box to send test data and clicking the save button. This will allow you to troubleshoot and configure your web hook to your client's needs.<br>Make sure that the checkbox to enable the particular integration or web hook is checked and make sure to click the save button when you are done editing.<br>Clicking the add integration button will simply take you to your client management screen where you can then add their API keys as needed"
                },
            ],
            activeHelpItem: {   title:'Agency Site Campaign Creation',
                    embedVideoCode:'<iframe src="https://drive.google.com/file/d/14KMM2Wbb5vmc-TSiWFNqLrBOzz-p4mwd/preview" width="100%" height="480" allow="autoplay"></iframe>',
                    desc:'Lets create a Site campaign, In the upper right corner of your screen you will click Add Campaign<br>If you have already selected the client on the main dashboard, their name will appear at the top for a reference to make sure you are creating a campaign for the correct client. If you were viewing all your clients then you will select your client at this point.<br>In the campaign name, You will want to give the campaign a very clear name, such as homepage for ABC landscaping. This field is searchable so be descriptive.<br>In the URL section, you want to put the main URL where you are actually placing the code. One campaign code is good for an entire website as long as it is placed in the global head. You do not need a campaign per page. When the contact is identified we will display the complete URL of the landing page including any Facebook or Google ID or any UTM information in the URL.<br>Your clients email address is preloaded to be a viewer in the Google sheet, if you are using the Google sheet integration. You may also put additional email addresses to add them as viewers. One per line.<br>You may add additional administrators here in the box and select them. They will receive notifications about the campaign as well as be added as an editor to the Google sheet.<br>Next you will select the data options that will correspond with your campaign goals.<br>Next to you will check this box if you are putting the embed code in a tag manager. Our servers check to make sure the code is installed properly and when it is installed in a tag manager we will modify this process.<br>Finally you will select your Re-identification options. This setting depends on the industry of your client. Some industries will gladly pay to receive a notification when someone comes back to their website after a certain amount of time.<br>The final option is to block cross campaign identification. This is not typically used.<br>After ensuring that everything looks good. Press the Save button and the campaign will be created. The next steps are to install the identification code on the clients website, verify the financial settings, verify the Integrations and then press Play to begin identifying website traffic..<br>Editing a campaign is a similar process. You may edit a campaign while it is running, paused or stopped. There is no need to stop a campaign to edit it.'
            },
            dummyCampaignData:{
    "id": 'dummy-campaign-item',
    "report_type": "GoogleSheet",
    "leadspeek_type": "local",
    "leadspeek_locator_zip": "",
    "leadspeek_locator_desc": null,
    "leadspeek_locator_keyword": "",
    "leadspeek_locator_keyword_contextual": "",
    "leadspeek_locator_state": "",
    "leadspeek_locator_state_external": "",
    "gtminstalled": "T",
    "leadspeek_locator_city": "",
    "leadspeek_locator_city_external": "",
    "leadspeek_locator_require": "FirstName,LastName,MailingAddress,Phone",
    "hide_phone": "T",
    "national_targeting": "F",
    "location_target": "Focus",
    "start_billing_date": "2024-06-24 02:58:33",
    "phoneenabled": "T",
    "homeaddressenabled": "T",
    "reidentification_type": "never",
    "require_email": "T",
    "file_url": "",
    "report_sent_to": "harrison+clientailead@exactmatchmarketing.com\nharrison.budiman@gmail.com\nharrison@uncommonreach.com\ndaniel@exactmatchmarketing.com",
    "admin_notify_to": [
        143,
        165
    ],
    "leadspeek_api_id": "123456",
    "active": "F",
    "disabled": "T",
    "active_user": "T",
    "clientorganizationid": "123456",
    "clientcampaignsid": "",
    "leads_amount_notification": 500,
    "total_leads": 6,
    "last_lead_added": "03-22-2024",
    "spreadsheet_id": "absced_dummy",
    "filename": "",
    "customer_payment_id": "absced_dummy",
    "customer_card_id": "absced_dummy",
    "company_parent": 'abs',
    "company_root_id": 'abs',
    "ongoing_leads": 0,
    "last_lead_check": "22-03-2024",
    "lifetime_cost": 30,
    "cost_perlead": 3,
    "lp_max_lead_month": 0,
    "lp_min_cost_month": 2,
    "paymentterm": "Prepaid",
    "continual_buy_options": false,
    "topupoptions": "onetime",
    "leadsbuy": 50,
    "stopcontinual": "F",
    "platformfee": 1,
    "lp_limit_startdate": "2024-06-21 00:00:00",
    "lp_enddate": "",
    "report_frequency_id": "5_minutes",
    "lp_limit_leads": 9,
    "lp_limit_freq": "day",
    "user_id": 151,
    "name": "Client Name",
    "email": "harrison+clientailead@exactmatchmarketing.com",
    "phonenum": "(989) 898-9898",
    "company_name": "Client Name",
    "company_id": 'abs',
    "group_company_id": 'abs',
    "campaign_name": "NY Realtor New",
    "campaign_startdate": "0000-00-00 00:00:00",
    "campaign_enddate": "",
    "ori_campaign_startdate": "0000-00-00 00:00:00",
    "ori_campaign_enddate": "",
    "url_code": "https://test.com",
    "url_code_thankyou": "",
    "url_code_ads": "",
    "embeddedcode_crawl": "T",
    "embedded_status": "test.com<br/>(Make sure the domain begins with https:// or domain can not be found)",
    "questionnaire_answers": "\"\"",
    "trysera": "F",
    "archived": "F",
    "timezone": "America/Chicago",
    "applyreidentificationall": "F",
    "m_paymentterm": "Weekly",
    "m_platformfee": 0,
    "m_lp_max_lead_month": null,
    "m_lp_min_cost_month": null,
    "m_cost_perlead": null,
    "m_lp_limit_leads": 0,
    "m_lp_limit_freq": "day",
    "m_lp_limit_startdate": null,
    "m_lp_enddate": null,
    "sendgrid_is_active": 0,
    "googlesheet_is_active": 0,
    "sendgrid_action": "",
    "sendgrid_list": "",
    "ghl_is_active": 0,
    "payment_status": "success",
    "created_at": "2023-12-07T04:41:18.000000Z",
    "target_nt": false,
    "target_state": false,
    "target_city": false,
    "target_zip": false,
    "selects_state": [],
    "selects_citylist": [],
    "selects_city": [],
    "selects_citystate": [],
    "selects_citystatelist": [],
    "leadspeek_locator_keyword_bulk": "",
    "total_cost": 18,
    "yerterday_leads": 0,
    "yerterday_previous_leads": 0
},
            steps: [
          {
            target: '.campaign-filter-item-wrapper', 
            content: 'Sort your campaigns to see only the statuses you are looking for',
            // params: {
            //   placement: 'top'
            // }
            params: {
                 enableScrolling: false,
            },
          },
          {
            target: '.container__input__campaign__management',  // We're using document.querySelector() under the hood
            content: 'Search by campaign name or ID',
            params: {
                 enableScrolling: false,
            },
          },
        //   {
        //     target: '.client-filter-anchor',  // We're using document.querySelector() under the hood
        //     content: 'Filter to view only specific clients',
        //     params: {
        //          enableScrolling: false,
        //     },
        //   },
          {
            target: '.create-campaign-anchor',
            content: 'Click here to add a new campaign',
            params: {
                 enableScrolling: false,
            },
         
          },
          {
            target: '.campaign-card-client-name',
            content: 'This is the name of your client',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.campain-card-name',
            content: 'This is the name of your campaign.',
            params: {
                 enableScrolling: false,
            },
          },
          {
            target: '.campaign-card-status-badge',
            content: 'This is the current status of the campaign',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.campaign-card-update-date',
            content: 'This is the date that the campaign last received contacts',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.stat-block-id-anchor',
            content: 'This is the campaign ID, Please reference this when opening any support requests',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.stat-block-total-anchor',
            content: 'This is the total number of contacts ever generated by this campaign',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.stat-block-yesterday-anchor',
            content: 'This is the number of contacts generated Yesterday by this campaign',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.stat-block-list-queue-id-anchor',
            content: 'This is the ID generated from BIG DBM',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.edit-btn-anchor',
            content: 'Click this button to edit the campaign. A campaign can </br> be edited at any time and during any status',
            params: {
                 enableScrolling: false,
            },
            
          },
         
          {
            target: '.campaign-financials-btn',
            content: ' Click this button to edit the financials for this campaign, </br>including the maximum number of contacts per day.',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.campaign-integration-btn',
            content: this.$global.settingMenuShow && !this.$global.systemUser ? "<span style='display:block;text-align:left;'>Click this button to add or edit the Plugins and </br> Integrations for this campaign</span><br><iframe src='https://drive.google.com/file/d/1qpxWlUPJzXY8lRdLKchWOcR25PvyXvPG/preview' width='800'' height='360' allow='autoplay'></iframe>" : 'Click this button to add or edit the Plugins and </br> Integrations for this campaign',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.google-sheet-anchor',
            content: 'Click this button to quickly view the Google Sheet or </br> Spreadsheet of contacts for this campaign',
            params: {
                 enableScrolling: false,
            },
          },
          {
            target: '.play-pause-stop-anchor',
            content: 'Click these buttons to Start, Pause, or Stop the campaign',
            params: {
                 enableScrolling: false,
            },
          },
          {
            target: '.menu-drop-anchor',
            content: 'Expand this section to Archive this campaign or </br> to edit the Exclusion List for this campaign',
            params: {
                 enableScrolling: false,
            },
          },
  
        
       
        ],
            clientdefaultprice:'',
            isLoadingCompanyList: false,
            isLoadingFilterCampaign: false,
              ReidentificationTimeOptions: [
                {
                    value: 'never',
                    label: 'Never'
                },
                {
                    value: '1 week',
                    label: '1 Week'
                },
                {
                    value: '1 month',
                    label: '1 Month'
                },
                {
                    value: '3 months',
                    label: '3 Months'
                },
                {
                    value: '6 months',
                    label: '6 Months'
                },
                {
                    value: '1 year',
                    label: '1 Year'
                },
            ],
            rootcostagency: '',
            defaultFilters: ['Campaign Status'],
            clientTypeLead: '',
            errMaxCostPerLead: false,
            errMinCostAgencyPerLead: false,
            minimumCostPerLead: '',

            clientMinLeadDayEnhance: '',
            errMinLeadDay: false, 
            
            LeadspeekMinimumLeadsPerDay: 0,
            LeadspeekMinimumLeadsPerDayAdd: 0,

            showInputLeadspeekPerDay: false,
            showInputLeadspeekPerDayAdd: false,
            
            errMinClientLeadDay: false,
            errMinClientLeadDayAdd: false,

            prepaidType: '',  
            contiDurationSelection: false,  
            totalLeads: {
                continualTopUp: '',
                oneTime: '',
            },
            lp_user_id: '',
            remainingBalanceLeads: '',
            err_totalleads: false,
            minimumLeadPrepaidOneTime: 50,
            isContainulTopUpStop: false,
            
            // date picker settings 
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                },
            },
            /** FOR SUPRESSION UPLOAD FILE */
            uploadedFiles: [],
            uploadError: null,
            currentStatus: null,
            uploadFieldName: 'suppressionfile',
            /** FOR SUPRESSION UPLOAD FILE */
             tableDataOri:[],
             tableData: [],
             fuseSearch: null,
             searchedData: [],
             searchQuery: '',
             formpass: true,
             isKartraInfoFetching: false,
             isGoHighInfoFetching: false,
             isSendgridInfoFetching: false,
             isGoogleInfoFetching: false,
             isProcessRefundPrepaid: false,
             isZapierFetching: false,
             isMailBoxPowerFetching: false,
             pagination: {
                perPage: 10,
                currentPage: 1,
                // perPageOptions: [],
                total: 0,
                from: 0,
                to: 0,
            },
            modals: {
                helpguide: false,
                approxLead:false,
                helpguideTitle:'',
                helpguideTxt: '',
                embededcode: false,
                pricesetup: false,
                campaign: false,
                campaignEdit: false,
                pricesetup: false,
                questionnaire: false,
                integrations: false,
                whitelist: false,
                helpVideos:false,
                uploadUserClient: false,
                reportDownload: false,
                viewCampaignDetail: false,
                customFieldsConfig: false,
            },
            skipCampaignClosePrompt: false,
            reportDownloadCampaign: {
                id: "",
                name: ""
            }, // untuk menyimpan campaign yg akan di-download reportnya
            selects: {
                state: [],
                statelist: [],
                Citystate: [],
                Citystatelist: [],
                city: [],
                citylist: [],
                country: ['8180'],
                countrylist: [
                    {
                        'country' : 'United States',
                        'country_code' : '8180',
                    }
                ],
            },
            tags: {
                keywordlist: [],
                keywordlistbulk:[],
                keywordlistContextual:[],
                keywordlistContextualBulk:[],
            },
            newcampaign: {
                'asec5_4_0_0': false,
                'asec5_4_0_1': false,
                'asec5_4_0_2': false,
                'asec5_4_0_3': false,
                'asec5_4': [],
                'asec5_4_1': [],
                'asec5_4_2': [],
                'asec5_3': '',
                'asec5_5': '',
                'asec5_6': '10',
                
                'asec5_9_1': true,
                'asec5_10': [],
                'asec5_10_1': [],
                'asec6_5': 'FirstName,LastName,MailingAddress,Phone',

                'startdatecampaign': '',
                'enddatecampaign': '',
                geo:false,
                target_lat: 37.0902,
                target_lng: -95.7129,
                target_radius_miles: 25,
            },

            questionnaire: {
                'asec5_1': '',
                'asec5_2': '',
                'asec5_3': '',
                'asec5_4_0_1': false,
                'asec5_4_0_2': false,
                'asec5_4_0_3': false,
                'asec5_4_2': '',
                'asec5_4': '',
                'asec5_5': '',
                'asec5_6': '',
                'asec5_7': '',
                'asec5_8': '',

                'asec5_9_1': false,
                'asec5_9_2': false,
                'asec5_9_3': false,
                'asec5_9_4': false,
                'asec5_10': '',
                'asec5_11': '',
                'asec5_12': '',
                'asec5_13': '',
                'asec5_14': '',

                'asec6_1': '',
                'asec6_2': '',
                'asec6_3': '',
                'asec6_4': '',
                'asec6_5': '',
                'asec6_6': false,
                'asec6_7': '',

                'campaign_name': '',
                'nationaltargeting': false,
                'locatorstate': '',
                'locatorcity': '',
                'locatorzip': '',
                'locatorkeyword': '',
                'startcampaign':'',
                'endcampaign': '',
                'enablehomeaddress': false,
                'enablephonenumber': false,
            },
            companyID:'',
            activeClientCompanyID: '',

            ClientCompanyName: '',
            ClientCampaignName: '',
            ClientCampaignType: '', // attach id
            selectedCustomFieldId: null,
            customFieldsList: [],
            CUSTOM_FIELDS_OPTION_CUSTOM: '__custom__',
            customFieldsConfig: {
                fieldName: '',
                selectedFieldIds: []
            },
            masterFieldsForCustom: [],
            customFieldOrderOnlyForCampaign: null,
            customFieldNameForCampaign: null,
            customFieldsConfigDraggedIndex: null,
            customFieldsConfigDragOverIndex: null,
            isLoadingCustomFieldsConfig: false,
            errorCustomFieldsConfig: { fieldName: false, fieldOrder: false },
            campaignTypeOptions: [
                {
                    id: 1,
                    slug: 'b2c', // slug
                    name: 'B2C', // name
                    label: 'Individual Consumers ($349 per month)', // label
                    description: 'Includes an Ideal Customer Profile of your target customers, plus daily updates on individuals that match it. (B2C)', // description
                    price: 349,
                },
                {
                    id: 2,
                    slug: 'b2b',
                    name: 'B2B',
                    label: 'Business Customers ($899 per month)',
                    description: 'Coming Soon',
                    price: 899,
                }
            ],
            ClientFullName: '',
            ClientEmail: '',
            ClientPhone: '',
            ClientPerLead: '500',
            ClientUserID: '',
            ClientReportSentTo:'',
            ClientUrlCode: '',
            ClientUrlCodeThankyou: '',
            ClientCompanyID: '',
            ClientCompanyParent: '',
            
            ClientEmbededCode: '',
            ClientOrganizationID: '',
            ClientCampaignID: '',

            popProcessingTxt: 'Please wait, adding new campaign ....',
        
            GoogleConnectFalse: false,
            GoogleConnectTrue: false,
            CompanyNamedisabled: false,

            tmpdefaultadmin : [],
            tmpClientReportSentTo: '',

            checkboxes: {
                hide_phone:true,
                phoneenabled:false,
                homeaddressenabled:true,
                requireemailaddress:true,
                ApplyReidentificationToAll: false,
            },

            radios: {
                reportType: 'GoogleSheet',
                locationTarget: 'Focus',
            },
            selectsAdministrator: {
                administratorSelected: [],
                administratorList: [],
            },
            selectsCompany: {
                companyId: '',
                companySelected: '',
                companyList: [],
                campaignList: [],
                campaignSelected: [],
            },
            selectsGroupCompany: {
                companyGroupID: '',
                newCompanyGroupName: '',
                companyGroupAddEdit:false,
                companyGroupSelected: '',
                companyGroupList: [],
            },

            ClientActiveID: '',
            
            LeadspeekPlatformFee: '0',
            m_LeadspeekPlatformFee: '0',
            t_LeadspeekPlatformFee: '0',
            LeadspeekCompany: '',
            LeadspeekclientEmail: '',
            LeadspeekCostperlead: '0',
            m_LeadspeekCostperlead: '0',
            t_LeadspeekCostperlead: '0',
            LeadspeekMaxLead: '0',
            LeadspeekMinCostMonth: '0',
            m_LeadspeekMinCostMonth: '0',
            m_LeadspeekLimitLead: '10',
            t_LeadspeekMinCostMonth: '0',
            LeadspeekLimitLead: '10',
            LeadspeekEnableMinimumLeadsPerDayAdd: false,
            LeadspeekEnableMinimumLeadsPerDay: false, 
            LeadspeekClientActiveIndex: '',
            LeadspeekMaxDateStart: '',
            LeadspeekDateEnd: '',
            LeadspeekMaxDateVisible: false,

            userIdCampaign: '',
            spreadsheetHistory: [],

            t_estleadspermonth: '0',

            LeadspeekInputReadOnly: false,
            OnlyPrepaidDisabled: false,
            ActiveLeadspeekID: '',
            LeadspeekActive: '',
            LeadspeekDisabled: '',
            LeadspeekActiveUser: '',

            StartDateCampaign: '',
            EndDateCampaign: '',
            ErrStartEndCampaign: '',

            leadlocatorname: '',
            leadlocalname: '',

            t_profit: '0',
            t_freqshow: 'week',
            t_freq: '4',
            t_cost: '0',

            txtLeadService: 'per week',
            txtLeadIncluded: 'in that weekly charge',
            txtLeadOver: 'from the weekly charge',

            selectsPaymentTerm: {
                PaymentTermSelect: 'Weekly',
                PaymentTerm: [
                    // { value: 'One Time', label: 'One Time'},
                    // { value: 'Weekly', label: 'Weekly'},
                    // { value: 'Monthly', label: 'Monthly'},
                ],
            },
            selectsAppModule: {
                    AppModuleSelect: 'LeadsPeek',
                    AppModule: [
                       // { value: 'Ads Design', label: 'Ads Design' },
                       // { value: 'Campaign', label: 'Campaign' },
                        { value: 'LeadsPeek', label: 'LeadsPeek' },
                    ],
                    LeadsLimitSelect: 'Day',
                    LeadsLimit: [
                        //{ value: 'Month', label: 'Month'},
                        { value: 'Day', label: 'Day'},
                        //{ value: 'Max', label: 'Max'},
                    ],
            },

            costagency : {
                predict : {
                    'Prepaid' : {
                        PredictMaxCampaigns: '1',
                        PredictMinCostMonth: '0',
                        PredictQuotaCampaigns: '0',
                    }
                }
            },

            PredictMaxCampaigns: 1,
            PredictCountCampaigns: 0,
            PredictQuotaCampaigns: 0,

            // locatorlead: {
            //     FirstName_LastName: '0',
            //     FirstName_LastName_MailingAddress: '0',
            //     FirstName_LastName_MailingAddress_Phone: '0',
            // },

            defaultCostCampaign : {
                paymentterm: 'Weekly',
                EnhancePlatformFee: '0',
                EnhanceCostperlead: '0',
                EnhanceMinCostMonth: '0',
                EnhanceLeadsPerday: '0',
                EnhanceMinimumLeadDay: '0',

                enhance : {
                    'Weekly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '0',
                    },
                    'Monthly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '0',
                    },
                    'OneTime' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '0',
                    },
                    'Prepaid' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '10',
                    }
                },
            },

            Reidentificationtime: '1 year',
            userTypeOri: '',
            userType:'',

            err_companySelect:false,
            err_campaignName: false,
            err_campaignType: false,
            err_campaignBusinessName: false,
            err_campaignBusinessWebsite: false,
            err_campaignBusinessIndustry: false,
            err_campaignBusinessCustomIndustry: false,
            err_campaignBusinessDescription: false,
            err_campaignBusinessCompetitors: false,
            err_campaignBusinessCustomerUploadSources: false,
            err_campaignBusinessCrmProvider: false,
            err_campaignBusinessCrmApiKey: false,
            err_campaignCustomersFrom: false,
            err_campaignState: false,
            err_campaignZipCode: false,
            err_campaignCustomerList: false,
            
            fetchingCampaignData:false,
            whiteListLeadspeekID: '',
            whiteListCompanyId: '',
            whiteListLeadspeekApiId: '',
            disabledaddcampaign: true,
            sendGridActionsOptions: [
                {
                    id: 'add-to-list',
                    name: 'Add to list'
                },
                {
                    id: 'create-contact',
                    name: 'Create a contact'
                },

            ],

            goHighLevelTagsOptions: [],
            ghl_tags : [],
            ghl_tags_remove: [],

            mailBoxPowerOptions: [],
            mbp_groups: [],
            mbp_groups_remove: [],
            mailBoxPowerStates: [],
            mbp_states: [],
            mbp_zip: '',
            mbp_options: 'state',
            mailBoxpowerUploadZipName: 'mailboxpoweupload',
            isMailBoxPowerSavingZip: false,

            sendGridListOptions: [
            ],
            selectedSendgridAction: [],
            selectedSendgridList: [],
            selectedKartraList: [],
            selectedKartraTags: [],
            kartraTagsOptions: [],
            kartraListOptions: [],
            sendGridcampaignId: '',
            integrations: [
            ],
            isLoadingSaveIntegration: false,
            zapierEnable: false,
            zapierTestEnable: false,
            zapierTags : [],
            zapierTagsOptions: [],
            zapierWebhook: [''],
            defaultWebhook: true,
            selectedIntegration: 'googlesheet',
            currentRowIndex: 0,
            selectedRowData: {},
            currSortBy: '',
            currOrderBy: '',
            spreadsheet_id: '',

            supressionProgress: [],
            supressionDone: [],
            supressionInterval: '',
            supressionTimeout: '',
            refreshInterval: null,
            filterCampaignStatus: 'all',
            dropdownVisible: '',
            optionCampaignStatus: [
                {
                    value: 'all',
                    label: 'All'
                },
                {
                    value: 'play',
                    label: 'Running'
                },
                {
                    value: 'paused',
                    label: 'Paused'
                },
                {
                    value: 'stop',
                    label: 'Stopped'
                },
            ],
            stopWords: [''],
            isErrorStopWords: false,
            isErrorStopWordsEdit: false,
            stateCode: [],
            selectedCity: '',
            optionsCity: [],
            isLoadingOptionsCity: false,
            limitOptionsCity: 50,
            totalCity: 0,
            searchCity: '',
            prevCampaignFinancial: null,
            formApproxLeadCount: {
                campaign_id: '',
                leadspeek_api_id: '',
                company_id: '',
                user_id: '',
                email: '',
                target_location: '',
                states: [],
                cities: [],
                zip_code: '',
                keyword: [],
                keyword_bulk: [],
                rows: [],
            },
            formApproxLeadCountRetry: {
                campaign_id: '',
                leadspeek_api_id: '',
                company_id: '',
                user_id: '',
                email: '',
                target_location: '',
                states: [],
                cities: [],
                zip_code: '',
                keyword: [],
            },
            prevFormApproxLeadCount: null,
            prevRowData: null,
            isLoadingAddToCampaign: false,
            isLoadingGetCount: false,
            isLoadingCheckCampaignLimit: false,
            isDefaultTargetLocation: true,
            isProccessingLeadCount: false,
            isFinishedApproxLeadCount: false,
            isErrorFetchLeadCount: false,
            intervalFetchLeadCount: null,
            tableDataApprox: [],
            tableDataPlayApprox: [],
            isLoadingSendTestLead: false,
            errors: {
                sendgrid: false,
                mailboxPower: false,
                goHighLevel: false,
                webhook: false,
                kartra: false,
                clickfunnels: false,
            },
            isLoadingAdvancedInformation: false,
            isErrorAdvancedInformation: false,
            listAdvancedInformation: [],
            campaignInformationData: 'basic',
            rowCampaignInformationData: 'basic',
            checkAllAdvancedInformation: false,
            checkAllRowAdvancedInformation: false,
            idAdvancedInformation: [],
            idRowAdvancedInformation: [],
            isIndeterminateAdvancedInformation: false,
            isIndeterminateRowAdvancedInformation: false,
            menuClickFunnels: 'choose-tag',
            listTagsClickFunnels: [],
            listTagsClickFunnelsSelected: [],
            formNewTagClickFunnels: {
                name: '',
                color: '',
            },
            colorsNewTagClickFunnels: [
                {
                    value: '#9c73d2',
                },
                {
                    value: '#48cdfe',
                },
                {
                    value: '#53f3ed',
                },
                {
                    value: '#47e37f',
                },
                {
                    value: '#f2593d',
                },
                {
                    value: '#f68421',
                },
                {
                    value: '#f9de00',
                },
                {
                    value: '#929292',
                },
                {
                    value: '#5645ef',
                },
            ],
            isLoadingResetSpreadsheet: false,
            isLoadingGetTagsClickFunnels: false,
            isLoadingCreateTagsClickFunnels: false,
            isLoadingGetCampaignTagsClickFunnels: false,
            isCollapseMenuClickFunnels: window.innerWidth < 768,
            LeadspeekLimitLeadDB: 0,
            windowWidth: window.innerWidth,
            isLoadingTagsAutomation: false,
            isErrorTagsAutomation: false,
            isActiveTagsAutomation: false,
            nameIntegration: '',
            advanceExampleDataUrl: 'https://sitesettings-api-docs.vercel.app/agency/informations/send-test'
        }
    },

    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        },
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
         queriedData: {
         get() {
            // Ensure tableData and searchedData are arrays
            const tableData = Array.isArray(this.tableData) ? this.tableData : [];
            const searchedData = Array.isArray(this.searchedData) ? this.searchedData : [];
            
            let result = tableData;
            if (searchedData.length > 0) {
                result = searchedData;
            }
            return result;
        },
         set(value) {
             if (Array.isArray(value)) {
            if (this.searchedData.length > 0) {
                this.searchedData = value;
            }else{
                this.tableData = value
            }
            
            } else {
             console.warn('queriedData expects an array.');
         }
         }
        },
        to() {
            if (!this.pagination) return 0;
            const perPage = this.pagination.perPage || 10;
            let highBound = this.from + perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            if (!this.pagination) return 0;
            return (this.pagination.perPage || 10) * ((this.pagination.currentPage || 1) - 1);
        },
        total() {
            const searchedData = Array.isArray(this.searchedData) ? this.searchedData : [];
            const tableData = Array.isArray(this.tableData) ? this.tableData : [];
            return searchedData.length > 0
                ? searchedData.length
                : tableData.length;
        },
         llmOptionPanels() {
            // Prefer one primary panel, but always add quick actions after persona selection.
            const personaPanel = this.buildPersonaOptionPanel();
            if (personaPanel) {
                return [personaPanel];
            }

            const strategyPanel = this.buildStrategyOptionPanel();
            const dynamicPanel = Array.isArray(this.dynamicLlmOptionPanels)
                ? this.dynamicLlmOptionPanels.find(panel => panel && Array.isArray(panel.options) && panel.options.length && panel.visible !== false)
                : null;
            const quickActionsPanel = this.buildQuickActionsPanel();

            const panels = [];
            const primaryPanel = strategyPanel || dynamicPanel;
            if (primaryPanel) {
                panels.push(primaryPanel);
            }
            if (quickActionsPanel) {
                panels.push(quickActionsPanel);
            }

            return panels;
        },

        // paginatedDataApprox(){
        //     const start = (this.currentPageDataApprox - 1) * this.pageSizeDataApprox;
        //     const end = this.currentPageDataApprox * this.pageSizeDataApprox;
        //     return this.tableDataApprox.slice(start, end);
        // }
        computedWidth() {
            return this.windowWidth > 1024 ? 780 : this.windowWidth - 200;
        },
        filteredHistory() {
            return this.spreadsheetHistory || [];
        },
        isOtherIndustry() {
            return this.businessIndustries.some(item => item.id == this.campaignBusinessInfo.industry && item.slug == 'other')
        },
        isLlmChatReady() {
            return this.selectedPersonaIndex !== null
                && this.selectedPersonaIndex !== undefined
                && !!this.selectedTargetingStrategy;
        },
        llmChatDisabled() {
            return this.disableChat || !this.isLlmChatReady;
        },
     
    },

    methods: {
        ...mapActions(["getUserSendgridList", 'getUserIntegrationList', "updateCompanyIntegrationConfiguration","geUsertKartraList","geUsertKartraDetails",'getSelectedKartraListAndTags','userLogSaved']),
        validateBetaFeature(type) {
            if(type == 'predict_module') {
                if(!this.$global.betaFeature.predict_module.is_beta || this.$global.betaFeature.predict_module.apply_to_all_agency || this.$global.isBeta) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        },
        formatMDY(dateString) {
            if (!dateString) return '';
            const d = new Date(dateString);
            if (isNaN(d.getTime())) return '';
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return `${mm}-${dd}-${yyyy}`;
        },
        safeJsonParse(value) {
            try {
                return JSON.parse(value);
            } catch (e) {
                return null;
            }
        },
        normalizeList(value) {
            if (Array.isArray(value)) {
                return value.filter(item => !!item);
            }
            if (typeof value === 'string') {
                const parsed = this.safeJsonParse(value);
                if (Array.isArray(parsed)) {
                    return parsed.filter(item => !!item);
                }
                return value
                    .split(/[,\n]/)
                    .map(item => item.trim())
                    .filter(item => !!item);
            }
            return [];
        },
        displayList(value) {
            return this.normalizeList(value);
        },
        formatZipList(value) {
            return this.normalizeList(value).join('\n');
        },
        formatCoordinate(value) {
            const num = Number(value);
            return Number.isFinite(num) ? num.toFixed(4) : '-';
        },
        formatRadius(value) {
            const num = Number(value);
            return Number.isFinite(num) ? `${num} miles` : '-';
        },
        onCustomerListSelected(customerList) {
            // Simpan customer list yang dipilih (termasuk URL)
            this.selectedCustomerList = customerList;
            // Clear error saat user select customer list
            this.err_campaignCustomerList = false;
            // console.log('Customer list selected:', {
            //     id: customerList.id,
            //     name: customerList.name,
            //     url: customerList.url
            // });
        },
        onCustomerListDeleted(customerList) {
            // console.log('onCustomerListDeleted', customerList);
            const customerListId = customerList && customerList.id ? customerList.id : null;
            // Jika customer list yang dihapus adalah yang sedang dipilih, maka clear selectedCustomerList
            if (customerListId && this.selectedCustomerList && this.selectedCustomerList.id === customerListId) {
                this.selectedCustomerList = null;
            }
        },
        onCustomerListSearch() {
            // Trigger search in UserClient component when Enter is pressed
            if (this.$refs.userclient) {
                this.$refs.userclient.onSearch();
            }
        },
        onCustomerListSearchClear() {
            // Clear search query
            this.customerListSearchQuery = "";
            // Wait for prop to update before triggering search
            this.$nextTick(() => {
                this.onCustomerListSearch();
            });
        },
        async cancelCampaignForm() {
            await this.promptCloseCreateCampaignModal();
        },
        resetBusinessInfoErrors() {
            this.err_campaignBusinessName = false;
            this.err_campaignBusinessWebsite = false;
            this.err_campaignBusinessIndustry = false;
            this.err_campaignBusinessCustomIndustry = false;
            this.err_campaignBusinessDescription = false;
            this.err_campaignBusinessCompetitors = false;
            this.err_campaignBusinessCustomerUploadSources = false;
            this.err_campaignBusinessCrmProvider = false;
            this.err_campaignBusinessCrmApiKey = false;
            this.err_campaignCustomersFrom = false;
            this.err_campaignState = false;
            this.err_campaignZipCode = false;
            this.err_campaignCustomerList = false;
        },
        clearCampaignForm() {
            this.campaignCreateActiveStep = 0;
            this.ClientFullName = '';
            this.ClientEmail = '';
            this.ClientPhone = '';
            this.ClientUserID = '';
            this.ClientCompanyName = '';
            this.selectsCompany.companySelected = '';
            this.selectsCompany.companyId = '';            
            this.ClientCampaignName = '';
            this.selectedCustomFieldId = null;
            this.customFieldOrderOnlyForCampaign = null;
            this.customFieldNameForCampaign = null;
            this.initCampaignType(); // ubah jadi b2c di awal
            this.campaignBusinessInfo.name = '';
            this.campaignBusinessInfo.website = '';
            this.campaignBusinessInfo.industry = '';
            this.campaignBusinessInfo.customIndustry = '';
            this.campaignBusinessInfo.businessDescription = '';
            this.campaignBusinessInfo.competitors = '';
            this.campaignBusinessInfo.crmProvider = '';
            this.campaignBusinessInfo.crmApiKey = '';
            this.initCustomerUploadSources(); // ubah jadi crm saja yang ke select
            this.initTargetingType(); // ubah targeting menjadi national targeting yang ke select
            this.initCrmOptions();
            this.customerListSearchQuery = "";
            this.selectedCustomerList = null; // Clear customer list selection
            this.newcampaign.geo = false;
            this.selects.state = [];
            this.newcampaign.asec5_3 = [];
            this.LeadspeekPlatformFee = '0';
            this.LeadspeekMinCostMonth = '0';
            this.icpCsvUrl = SAMPLE_CUSTOMER_LIST_URL;
            this.icpMarketBaseContext = DEFAULT_MARKET_BASE_CONTEXT;
            this.icpAnalysisText = '';
            this.icpQueryParams = {};
            this.icpMetadata = {};
            this.icpPersonas = [];
            this.isGeneratingICP = false;
            this.isMessageSending = false;
            this.setDefaultMessagesChat();
            this.newcampaign.target_lat = this.usDefaultCenter[0];
            this.newcampaign.target_lng = this.usDefaultCenter[1];
            this.newcampaign.target_radius_miles = 25;
            this.err_companySelect = false;
            this.err_campaignName = false;
            this.err_campaignType = false;
            this.resetBusinessInfoErrors();
        },
        async fetchCustomFieldsList() {
            try {
                const companyId = this.$store.getters.userData.company_id;
                const response = await this.$store.dispatch('getPredictCustomFieldsList', {
                    companyId: companyId,
                    all: true
                });

                if(response.result === 'success' && response.customFieldsLists && response.customFieldsLists.data) {
                    this.customFieldsList = response.customFieldsLists.data;
                    if (this.selectedCustomFieldId !== this.CUSTOM_FIELDS_OPTION_CUSTOM) {
                        const defaultField = this.customFieldsList.find(field => field.is_default === true);
                        if(defaultField) {
                            this.selectedCustomFieldId = defaultField.id;
                        } else if (this.selectedCustomFieldId !== this.CUSTOM_FIELDS_OPTION_CUSTOM) {
                            this.selectedCustomFieldId = null;
                        }
                    }
                } else {
                    this.customFieldsList = [];
                    if (this.selectedCustomFieldId !== this.CUSTOM_FIELDS_OPTION_CUSTOM) this.selectedCustomFieldId = null;
                }
            } catch(error) {
                console.error('Error fetching custom fields list:', error);
                this.customFieldsList = [];
                if (this.selectedCustomFieldId !== this.CUSTOM_FIELDS_OPTION_CUSTOM) this.selectedCustomFieldId = null;
            }
        },
        onCustomFieldsConfigChange(value) {
            if (value === this.CUSTOM_FIELDS_OPTION_CUSTOM) {
                this.openCustomFieldsConfigModal();
            } else {
                this.customFieldOrderOnlyForCampaign = null;
                this.customFieldNameForCampaign = null;
            }
        },
        openCustomFieldsConfigModal() {
            this.customFieldsConfig = { fieldName: '', selectedFieldIds: [] };
            this.errorCustomFieldsConfig = { fieldName: false, fieldOrder: false };
            this.modals.customFieldsConfig = true;
            this.fetchMasterFieldsForCustom();
        },
        closeCustomFieldsConfigModal() {
            this.modals.customFieldsConfig = false;
            // Reset form so next open is clean (same behavior for X and Cancel)
            this.customFieldsConfig = { fieldName: '', selectedFieldIds: [] };
            this.errorCustomFieldsConfig = { fieldName: false, fieldOrder: false };
            // Clear Custom Fields Configuration dropdown when user cancels/closes (so it doesn't stay on "Create custom configuration...")
            if (this.selectedCustomFieldId === this.CUSTOM_FIELDS_OPTION_CUSTOM) {
                this.selectedCustomFieldId = null;
                this.customFieldOrderOnlyForCampaign = null;
                this.customFieldNameForCampaign = null;
            }
        },
        async fetchMasterFieldsForCustom() {
            try {
                const response = await this.$store.dispatch('getPredictCustomFieldsMasters');
                if (response.result === 'success' && response.masterFields) {
                    this.masterFieldsForCustom = response.masterFields;
                } else {
                    this.masterFieldsForCustom = [];
                }
            } catch (e) {
                console.error('Error fetching master fields for custom config:', e);
                this.masterFieldsForCustom = [];
            }
        },
        updateCustomConfigSelectedOrder() {
            this.customFieldsConfig.selectedFieldIds = this.customFieldsConfig.selectedFieldIds.filter(id =>
                this.masterFieldsForCustom.some(f => f.id === id)
            );
        },
        moveCustomConfigField(fieldId, direction) {
            const list = this.customFieldsConfig.selectedFieldIds;
            const index = list.indexOf(fieldId);
            if (index === -1) return;
            const targetIndex = direction === 'up' ? index - 1 : index + 1;
            if (targetIndex < 0 || targetIndex >= list.length) return;
            const arr = [...list];
            [arr[index], arr[targetIndex]] = [arr[targetIndex], arr[index]];
            this.customFieldsConfig.selectedFieldIds = arr;
        },
        getCustomFieldNameById(fieldId) {
            const field = this.masterFieldsForCustom.find(f => f.id === fieldId);
            return field ? field.field_name : `Field #${fieldId}`;
        },
        handleCustomConfigDragStart(index, event) {
            this.customFieldsConfigDraggedIndex = index;
            event.dataTransfer.effectAllowed = 'move';
            const item = event.target.closest('.custom-fields-order-item-inline');
            if (item) item.style.opacity = '0.5';
        },
        handleCustomConfigDragEnd(event) {
            const item = event.target.closest('.custom-fields-order-item-inline');
            if (item) item.style.opacity = '1';
            this.customFieldsConfigDraggedIndex = null;
            this.customFieldsConfigDragOverIndex = null;
        },
        handleCustomConfigDragOver(index) {
            if (this.customFieldsConfigDraggedIndex !== null && this.customFieldsConfigDraggedIndex !== index) {
                this.customFieldsConfigDragOverIndex = index;
            }
        },
        handleCustomConfigDragLeave() {
            this.customFieldsConfigDragOverIndex = null;
        },
        handleCustomConfigDrop(event) {
            event.preventDefault();
            if (this.customFieldsConfigDraggedIndex === null || this.customFieldsConfigDragOverIndex === null) return;
            const list = [...this.customFieldsConfig.selectedFieldIds];
            const [item] = list.splice(this.customFieldsConfigDraggedIndex, 1);
            list.splice(this.customFieldsConfigDragOverIndex, 0, item);
            this.customFieldsConfig.selectedFieldIds = list;
            this.customFieldsConfigDraggedIndex = null;
            this.customFieldsConfigDragOverIndex = null;
        },
        async saveCustomFieldsConfigModal() {
            const { fieldName, selectedFieldIds } = this.customFieldsConfig;
            this.errorCustomFieldsConfig = { fieldName: false, fieldOrder: false };
            if (!fieldName || !String(fieldName).trim()) {
                this.errorCustomFieldsConfig.fieldName = true;
                return;
            }
            if (selectedFieldIds.length === 0) {
                this.errorCustomFieldsConfig.fieldOrder = true;
                return;
            }
            this.customFieldNameForCampaign = String(fieldName).trim();
            this.customFieldOrderOnlyForCampaign = [...selectedFieldIds];
            this.selectedCustomFieldId = this.CUSTOM_FIELDS_OPTION_CUSTOM;
            this.$notify({ type: 'success', message: 'Custom configuration applied to this campaign', icon: 'fas fa-check' });
            this.modals.customFieldsConfig = false;
        },
        selectCrmChange() {
            this.clearErrorInput('campaignBusinessInfo.crmProvider')
            this.generateDummyCrmApiKey();
        },
        customerUploadSourcesChange(event, slug) {
            const checked = event.target.checked;
            
            this.clearErrorInput('campaignBusinessInfo.customerUploadSources')
            
            if (slug == 'crm') {
                if (checked) { // jika di checked
                    this.initCrmOptions();
                } else { // jika uncheck
                    this.campaignBusinessInfo.crmProvider = '';
                    this.campaignBusinessInfo.crmApiKey = '';
                }
            } else if (slug == 'local') {
                // code
            }
        },
        businessIndustryChange(event) {
            this.campaignBusinessInfo.customIndustry = '';
            this.clearErrorInput('campaignBusinessInfo.industry');
        },
        async onUploadCustomerFinished(customerID) {
            try {
                if (this.modals.editCampaign) {
                    // code 
                } else {
                    if (this.$refs.userclient) {
                        await this.$refs.userclient.refresh();
                    }
                }
            } finally {
                // console.log('finnaly onUploadCustomerFinished')
            }
        },
        getBusinessResources() {
            this
            .$store
            .dispatch('getBusinessResources')
            .then(response => {
                this.businessIndustries = response.businessIndustries;
                this.crmOptions = response.crmOptions;
                this.campaignTypeOptions = response.campaignTypeOptions;
                this.customerUploadSourceOptions = response.customerUploadSourceOptions;

                // init targeting
                this.initTargetingType();
                // init targeting

                // Init customerUpload v-model
                this.initCustomerUploadSources();
                // Init customerUpload v-model

                // Init campaign type
                this.initCampaignType()
                // Init campaign type

                // Init CRM first ghl
                this.initCrmOptions();
                // Init CRM first ghl

                // Init customer source
                // const customerUploadSourceLocal = this.customerUploadSourceOptions.find(item => item.slug === 'local');
                // const customerUploadSourceCRM = this.customerUploadSourceOptions.find(item => item.slug === 'crm');
                // if (customerUploadSourceCRM && customerUploadSourceCRM.id) {
                //     this.campaignBusinessInfo.customerUploadSources = [];
                //     // this.campaignBusinessInfo.customerUploadSources.push(customerUploadSourceLocal.id);
                //     this.campaignBusinessInfo.customerUploadSources.push(customerUploadSourceCRM.id);
                // }
                // Init customer source
            })
            .catch(error => {
                console.error(error);
            });
        },
        initTargetingType() {
            this.newcampaign.asec5_4_0_0 = true;
            this.newcampaign.asec5_4_0_1 = false;
            this.newcampaign.asec5_4_0_3 = false;
            this.newcampaign.target_lat = this.usDefaultCenter[0];
            this.newcampaign.target_lng = this.usDefaultCenter[1];
            this.newcampaign.target_radius_miles = this.newcampaign.target_radius_miles || 25;
            this.newcampaign.nationaltargeting = false;
        },
        initCrmOptions() {
            const crmOptionsGHL = this.crmOptions.find(item => item.slug === 'gohighlevel')
            if (crmOptionsGHL && crmOptionsGHL.id) {
                this.campaignBusinessInfo.crmProvider = crmOptionsGHL.id
                this.generateDummyCrmApiKey();
            }
        },
        initCustomerUploadSources() {
            if (Array.isArray(this.customerUploadSourceOptions)) {
                this.campaignBusinessInfo.customerUploadSources = {};
                const newCustomerUploadSources = {}
                
                this.customerUploadSourceOptions.forEach(opt => {
                    newCustomerUploadSources[opt.slug] = {
                        id: opt.id,
                        slug: opt.slug,
                        name: opt.name,
                        value: (opt.slug == 'crm') 
                    }
                })
                this.$set(this.campaignBusinessInfo, 'customerUploadSources', newCustomerUploadSources)
            }
            // console.log(this.campaignBusinessInfo);
        },
        initCampaignType() {
            const campaignTypeB2C = this.campaignTypeOptions.find(item => item.slug === 'b2c');
            if (campaignTypeB2C && campaignTypeB2C.id) {
                this.ClientCampaignType = campaignTypeB2C.id;
            }
        },
        generateDummyCrmApiKey() {
            // random panjang antara 50 dan 70
            const length = Math.floor(Math.random() * (70 - 50 + 1)) + 50

            // generate string acak
            this.campaignBusinessInfo.crmApiKey = Array.from({ length }, () =>
                Math.random().toString(36).charAt(2)
            ).join('')
        },
        notificationError(message) {
            setTimeout(() => {
                Notification({ 
                    message: `
                        <p style="display: flex; align-items: center; color: #000; font-size: 14px; font-weight: bold;">
                            <i class="el-notification__icon el-icon-error" style="margin-right: 10px;"></i> 
                            <span style="font-size: 16px; font-family: 'Poppins', sans-serif;">Error</span>
                        </p>
                        <p style="color: #000; font-size: 14px; margin-top: 10px; font-family: 'Poppins', sans-serif;">
                            ${message || 'Server might be busy please try again later.'}
                        </p>
                    `,
                    duration: 4000,
                    dangerouslyUseHTMLString: true,
                })
            },1)
        },
        onIntegrationSaved() {
            this.$notify({ type: 'success', message: 'Integrations saved' });
        },
        isCampaignTypeSelected(option) {
            const selected = this.campaignTypeOptions.find(item => item.id === this.ClientCampaignType);
            return selected ? selected.slug === option : false;
        },
        isCampaignTypeSelectedRow(option, business_type_id) {
            const selected = this.campaignTypeOptions.find(item => item.id == business_type_id);
            return selected ? selected.slug === option : false;
        },
        validationCreateCampaignStep(step) {
            const handlers = {
                0: () => {
                    let isSuccess = true;
                    // console.log(`handlers-${step}}`, {
                    //     'this.selectsCompany.companySelected': this.selectsCompany.companySelected,
                    //     'this.ClientCampaignName': this.ClientCampaignName,
                    //     'this.ClientCampaignType': this.ClientCampaignType,
                    // })
                    if (!this.selectsCompany.companySelected || this.selectsCompany.companySelected.trim() == '') {
                        this.notificationError('Client Company Is Required')
                        this.err_companySelect = true;
                        isSuccess = false;
                    }
                    if (!this.ClientCampaignName || this.ClientCampaignName.trim() == '') {
                        this.notificationError('Campaign Name Is Required')
                        this.err_campaignName = true;
                        isSuccess = false;
                    }
                    if (!this.ClientCampaignType) {
                        this.notificationError('Campaign Type Is Required')
                        this.err_campaignType = true;
                        isSuccess = false;
                    }
                    if (!this.campaignTypeOptions.some(option => option.id == this.ClientCampaignType)) {
                        const validTypes = this.campaignTypeOptions.map(opt => opt.slug.toUpperCase()).join(' or ')
                        this.notificationError(`Campaign Type must be ${validTypes}`)
                        isSuccess = false;
                    }
                    if (this.selectedCustomFieldId === this.CUSTOM_FIELDS_OPTION_CUSTOM) {
                        if (!this.customFieldNameForCampaign || !String(this.customFieldNameForCampaign).trim()) {
                            this.notificationError('Custom fields configuration name is required.')
                            isSuccess = false;
                        } else if (!this.customFieldOrderOnlyForCampaign || !this.customFieldOrderOnlyForCampaign.length) {
                            this.notificationError('Please complete the custom fields configuration (select fields and save) or choose another configuration.')
                            isSuccess = false;
                        }
                    }
                    return isSuccess;
                },
                1: () => {
                    let isSuccess = true;
                    // console.log(`handlers-${step}}`, {
                    //     'this.campaignBusinessInfo.name': this.campaignBusinessInfo.name,
                    //     'this.campaignBusinessInfo.website': this.campaignBusinessInfo.website,
                    //     'this.campaignBusinessInfo.industry': this.campaignBusinessInfo.industry,
                    //     'this.campaignBusinessInfo.customIndustry': this.campaignBusinessInfo.customIndustry,
                    //     'this.campaignBusinessInfo.businessDescription': this.campaignBusinessInfo.businessDescription,
                    //     'this.campaignBusinessInfo.competitors': this.campaignBusinessInfo.competitors,
                    //     'this.newcampaign.asec5_4_0_0': this.newcampaign.asec5_4_0_0,
                    //     'this.newcampaign.asec5_4_0_1': this.newcampaign.asec5_4_0_1,
                    //     'this.newcampaign.asec5_4_0_3': this.newcampaign.asec5_4_0_3,
                    //     'this.selects.state': this.selects.state,
                    //     'this.newcampaign.asec5_3': this.newcampaign.asec5_3,
                    //     'this.campaignBusinessInfo.customerUploadSources': this.campaignBusinessInfo.customerUploadSources,
                    //     'this.campaignBusinessInfo.crmProvider': this.campaignBusinessInfo.crmProvider,
                    //     'this.campaignBusinessInfo.crmApiKey': this.campaignBusinessInfo.crmApiKey,
                    // });
                    if (this.campaignBusinessInfo.customerUploadSources) {
                        Object.keys(this.campaignBusinessInfo.customerUploadSources).forEach(key => {
                            this.campaignBusinessInfo.customerUploadSources[key].value = false;
                        });
                    }
                    this.campaignBusinessInfo.crmProvider = '';
                    this.campaignBusinessInfo.crmApiKey = '';
                    if (!this.campaignBusinessInfo.name || this.campaignBusinessInfo.name.trim() == '') { // business name
                        this.notificationError('Businnes Name Is Required')
                        this.err_campaignBusinessName = true;
                        isSuccess = false;
                    }
                    if (!this.campaignBusinessInfo.website || this.campaignBusinessInfo.website.trim() == '') { // website
                        this.notificationError('Website Is Required')
                        this.err_campaignBusinessWebsite = true;
                        isSuccess = false;
                    }
                    if (!this.campaignBusinessInfo.industry) { // business industry
                        this.notificationError('Business Industry Is Required')
                        this.err_campaignBusinessIndustry = true;
                        isSuccess = false;
                    }
                    if (this.isOtherIndustry && (!this.campaignBusinessInfo.customIndustry || this.campaignBusinessInfo.customIndustry.trim() == '')) { // specify industry
                        this.notificationError('Specify Industry Is Required')
                        this.err_campaignBusinessCustomIndustry = true;
                        isSuccess = false;
                    }
                    if (!this.campaignBusinessInfo.businessDescription || this.campaignBusinessInfo.businessDescription.trim() == '') { // business description
                        this.notificationError('What Does Your Business Do Is Required')
                        this.err_campaignBusinessDescription = true;
                        isSuccess = false;
                    }
                    // if (!this.campaignBusinessInfo.competitors || this.campaignBusinessInfo.competitors.trim() == '') { // business competitors
                    //     this.notificationError('Who Are Your Main Competitors Is Required')
                    //     this.err_campaignBusinessCompetitors = true;
                    //     isSuccess = false;
                    // }
                    if (!this.newcampaign.asec5_4_0_0 && !this.newcampaign.asec5_4_0_1 && !this.newcampaign.asec5_4_0_3 && !this.newcampaign.geo) { // jika tidak memilih ke-3 checkbox national, state, zip
                        this.notificationError('Your Ideal Customers Are From Is Required.')
                        this.err_campaignCustomersFrom = true;
                        isSuccess = false;
                    }
                    if (this.newcampaign.asec5_4_0_1 && this.selects.state.length <= 0) { // jika memilih state dan input state nya kosong
                        this.notificationError('A Minimum Of 1 Select State.')
                        this.err_campaignState = true;
                        isSuccess = false;
                    }
                    if (this.newcampaign.asec5_4_0_3 && (!this.newcampaign.asec5_3 || this.newcampaign.asec5_3.trim() == '')) { // jika memilih zip dan input zip nya kosong
                        this.notificationError('Zip Code Is Required.')
                        this.err_campaignZipCode = true;
                        isSuccess = false;
                    }
                    if (this.newcampaign.geo && (!this.newcampaign.target_lat || !this.newcampaign.target_lng || !this.newcampaign.target_radius_miles)) {
                        this.notificationError('From Location Is Required')
                        this.err_campaignFromLocation = true;
                        isSuccess = false;
                    }
                    if (!this.selectedCustomerList || !this.selectedCustomerList.id) { // jika belum select customer list
                        this.notificationError('Customer List Is Required.')
                        this.err_campaignCustomerList = true;
                        isSuccess = false;
                    }
                    return isSuccess;
                },
                2: () => {
                    // Validate chat step - ensure no errors and chat is complete
                    let isSuccess = true;
                    
                    // Check if chat is currently sending
                    if (this.isMessageSending) {
                        this.notificationError('Please wait for the chat to finish before proceeding.');
                        isSuccess = false;
                    }
                    
                    // Check if there are any error messages in chat
                    const hasErrors = Array.isArray(this.messagesChat) && 
                        this.messagesChat.some(msg => 
                            msg.assistant && msg.assistant.error === true
                        );
                    
                    if (hasErrors) {
                        this.notificationError('Please retry failed messages before proceeding to the next step.');
                        isSuccess = false;
                    }
                    
                    // Check if chat has any messages (at least some interaction happened)
                    if (!Array.isArray(this.messagesChat) || this.messagesChat.length === 0) {
                        this.notificationError('Please complete the chat session before proceeding.');
                        isSuccess = false;
                    }
                    
                    return isSuccess;
                }
            }

            if (handlers[step]) {
                return handlers[step]();
            }

            return true;
        },
        setDefaultMessagesChat() {
            this.messagesChat = [];
            this.currentIcp = '';
            this.icpQueryParams = {};
            this.icpMetadata = {};
            this.icpPersonas = [];
            this.audienceCsvKey = null;
            this.personaRefinements = [];
            this.pendingPersonaIndex = null;
            this.selectedTargetingStrategy = null;
            this.pendingTargetingStrategy = null;
            this.strategyPanelReady = false;
            this.strategyLoading = false;
            this.selectedPersonaIndex = null;
            this.personaSelectorVisible = false;
            this.availableContacts = null; // Reset available contacts
            this.icpAnalysisText = '';
            this.dynamicLlmOptionPanels = [];
        },
        getSelectedIndustryName() {
            const industry = this.businessIndustries.find(item => item.id == this.campaignBusinessInfo.industry);
            if (this.isOtherIndustry && this.campaignBusinessInfo.customIndustry) {
                return this.campaignBusinessInfo.customIndustry;
            }
            if (industry && industry.name) {
                return industry.name;
            }
            return this.campaignBusinessInfo.industry || '';
        },
        buildBusinessLocation() {
            const locations = [];
            if (this.newcampaign.asec5_4_0_0) {
                locations.push('National');
            }

            if (this.newcampaign.asec5_4_0_1 && Array.isArray(this.selects.state) && this.selects.state.length > 0) {
                const states = this.selects.state.map((stateCode) => {
                    const matched = Array.isArray(this.selects.statelist)
                        ? this.selects.statelist.find((item) => item.state_code === stateCode)
                        : null;
                    return matched ? matched.state_name : stateCode;
                });
                locations.push(`States: ${states.join(', ')}`);
            }

            if (this.newcampaign.asec5_4_0_3 && this.newcampaign.asec5_3) {
                const zipCodes = (this.newcampaign.asec5_3 || '')
                    .split(/\r?\n|,|;/)
                    .map(code => code.trim())
                    .filter(Boolean);
                if (zipCodes.length) {
                    locations.push(`ZIP codes: ${zipCodes.join(', ')}`);
                }
            }

            return locations.join('; ');
        },
        buildMarketBaseContext() {
            const parts = [];
            const name = (this.campaignBusinessInfo.name || '').trim();
            const industry = (this.getSelectedIndustryName() || '').trim();
            const description = (this.campaignBusinessInfo.businessDescription || '').trim();
            const competitors = (this.campaignBusinessInfo.competitors || '').trim();
            const location = (this.buildBusinessLocation() || '').trim();
            const additionalContext = (this.icpMarketBaseContext || '').trim();

            if (name) parts.push(`Business Name: ${name}`);
            if (industry) parts.push(`Industry: ${industry}`);
            if (description) parts.push(`Description: ${description}`);
            if (competitors) parts.push(`Competitors: ${competitors}`);
            if (location) parts.push(`Location: ${location}`);
            if (additionalContext) parts.push(`Additional Context: ${additionalContext}`);

            return parts.join(' | ');
        },
        buildPersonaSummaryMessage(personas = [],data) {
            if (!Array.isArray(personas) || !personas.length) return '';
            // if(data.analysis && data.analysis.analysis && data.analysis.analysis.icp_synthesis && data.analysis.analysis.icp_synthesis.icp_analysis && data.analysis.analysis.icp_synthesis.icp_analysis.summary){
            //     return data.analysis.analysis.icp_synthesis.icp_analysis.summary
            // }
            return personas.map((p, idx) => {
                const title = p && p.name ? p.name : `Persona ${idx + 1}`;
                const desc = this.buildPersonaDescription(p);
                return `**${title}**\n${desc}`;
            }).join('\n\n');
        },
        buildPersonaOptionPanel() {
            if (!this.personaSelectorVisible || !Array.isArray(this.icpPersonas) || !this.icpPersonas.length) return null;
            const selectedIndex = this.pendingPersonaIndex !== null && this.pendingPersonaIndex !== undefined
                ? this.pendingPersonaIndex
                : this.selectedPersonaIndex;
            const canProceed = selectedIndex !== null && selectedIndex !== undefined;
            return {
                id: 'llm-persona-panel',
                title: 'We’ve analyzed the following ICP personas and their traits—please select one to proceed',
                type: 'radio',
                proceed: {
                    label: 'Proceed',
                    disabled: !canProceed || this.isMessageSending,
                    onClick: () => this.confirmPersonaSelection(),
                },
                options: this.icpPersonas.map((persona, idx) => ({
                    id: `persona-${idx}`,
                    label: persona && persona.name ? persona.name : `Persona ${idx + 1}`,
                    description: persona && persona.description ? persona.description : '',
                    selected: selectedIndex === idx,
                    action: 'persona-select',
                    value: idx,
                    onSelect: () => this.onPersonaOptionSelect(idx),
                })),
            };
        },
        buildPersonaDescription(persona) {
            if (!persona || typeof persona !== 'object') return '';
            // Prefer description but fall back to other likely keys we might receive.
            return persona.description
                || persona.summary
                || persona.persona_description
                || persona.icp_description
                || persona.details
                || '';
        },
        buildPersonaUserMessage(persona, idx) {
            const personaName = persona && persona.name ? persona.name : `Persona ${idx + 1}`;
            const personaDescription = this.buildPersonaDescription(persona);
            return personaDescription ? `**${personaName}**\n${personaDescription}` : personaName;
        },
        buildStrategyOptionPanel() {
            if (!Array.isArray(this.targetingStrategyOptions)
                || !this.targetingStrategyOptions.length
                || this.selectedPersonaIndex === null
                || this.selectedTargetingStrategy
                || !this.strategyPanelReady) {
                return null;
            }
            const selectedStrategy = this.pendingTargetingStrategy !== null && this.pendingTargetingStrategy !== undefined
                ? this.pendingTargetingStrategy
                : this.selectedTargetingStrategy;
            const canProceed = selectedStrategy !== null && selectedStrategy !== undefined;
            return {
                id: 'llm-strategy-panel',
                title: 'Select targeting strategy',
                subtitle: 'Choose your tradeoff between precision and reach.',
                type: 'radio',
                proceed: {
                    label: 'Proceed',
                    disabled: !canProceed || this.strategyLoading || this.isMessageSending,
                    onClick: () => this.confirmStrategySelection(),
                },
                options: this.targetingStrategyOptions.map(opt => ({
                    id: opt.id,
                    label: opt.label,
                    description: opt.description,
                    selected: selectedStrategy === opt.id,
                    action: 'strategy-select',
                    value: opt.id,
                    onSelect: () => this.onStrategyOptionSelect(opt.id),
                })),
            };
        },
        buildQuickActionsPanel() {
            if (this.isMessageSending) return null;
            const hasIcp = this.currentIcp && String(this.currentIcp).trim().length > 0;
            const hasPersonaSelected = this.selectedPersonaIndex !== null && this.selectedPersonaIndex !== undefined;
            const options = Array.isArray(this.llmQuickActions)
                ? this.llmQuickActions
                    .filter(opt => opt && opt.label && opt.visible !== false)
                    .map(opt => ({
                        ...opt,
                        id: opt.id || opt.label,
                        action: opt.action || 'send-message',
                    }))
                : [];
             const canProceedToNextStep = Number(this.campaignCreateActiveStep) === 2
                && hasPersonaSelected
                && !!this.selectedTargetingStrategy;

            // When personas exist but the panel is hidden (after selecting), offer a quick re-open button.
            if (Array.isArray(this.icpPersonas) && this.icpPersonas.length && !this.personaSelectorVisible) {
                options.unshift({
                    id: 'choose-persona',
                    label: 'Change persona',
                    description: 'Pick a different persona',
                    action: 'open-persona-selector',
                });
            }

            const canChangeStrategy = Array.isArray(this.targetingStrategyOptions)
                && this.targetingStrategyOptions.length
                && this.selectedPersonaIndex !== null
                && this.selectedTargetingStrategy;

            if (canChangeStrategy) {
                options.unshift({
                    id: 'choose-strategy',
                    label: 'Change strategy',
                    description: 'Pick a different targeting strategy',
                    action: 'open-strategy-selector',
                });
            }

            if (canProceedToNextStep) {
                options.push({
                    id: 'proceed-next-step',
                    label: 'Proceed with selection',
                    description: 'Save and Continue to the next step in the campaign setup.',
                    action: 'proceed-next-step',
                });
            }

            if ((!hasIcp && !hasPersonaSelected) || !hasPersonaSelected || !options.length) return null;

            return {
                id: 'llm-quick-actions',
                title: 'Quick actions',
                subtitle: 'Send a preset request to the assistant',
                type: 'button',
                layout: 'inline',
                options,
            };
        },
        handleOptionSelect(panel, option) {
            if (!panel || !option) return;

            if (typeof option.onSelect === 'function') {
                option.onSelect(option, panel);
                return;
            }

            if (option.action === 'persona-select') {
                const idx = typeof option.value === 'number' ? option.value : parseInt(option.value, 10);
                if (!isNaN(idx)) {
                    this.onPersonaSelect(idx);
                }
                return;
            }

            if (option.action === 'open-strategy-selector') {
                this.openStrategySelector();
                return;
            }

            if (option.action === 'send-message') {
                const payload = option.payload || option.message || option.text || option.label;
                if (payload && !this.disableChat && !this.isMessageSending) {
                    this.sendChatMessage(payload);
                }
                return;
            }

            if (option.action === 'proceed-next-step') {
                this.updateCreateCampaignStep();
                return;
            }

            if (option.action === 'emit-event' && option.event) {
                this.$emit(option.event, { panel, option });
            }

            if (option.action === 'open-persona-selector') {
                this.openPersonaSelector();
            }
        },
        handlePanelProceed(panel) {
            if (!panel || !panel.proceed || typeof panel.proceed.onClick !== 'function') return;
            panel.proceed.onClick();
        },
        setDynamicLlmOptionPanels(panels = []) {
            if (!Array.isArray(panels)) {
                this.dynamicLlmOptionPanels = [];
                return;
            }

            this.dynamicLlmOptionPanels = panels.map((panel, idx) => ({
                ...panel,
                id: panel.id || `llm-panel-${idx}`,
            }));
        },
        onPersonaOptionSelect(idx) {
            this.pendingPersonaIndex = idx;
        },
        confirmPersonaSelection() {
            const idx = this.pendingPersonaIndex;
            if (idx === null || idx === undefined) return;
            this.pendingPersonaIndex = null;
            this.onPersonaSelect(idx);
        },
        async onPersonaSelect(idx) {
            // Clear error messages when selecting a new persona
            this.clearErrorMessages();
            
            this.selectedPersonaIndex = idx;
            this.personaRefinements = [];
            this.pendingTargetingStrategy = null;
            this.targetingStrategyOptions = DEFAULT_TARGETING_STRATEGY_OPTIONS.map(option => ({ ...option }));
            this.availableContacts = null; // Reset available contacts when persona changes
            const persona = Array.isArray(this.icpPersonas) ? this.icpPersonas[idx] : null;
            const personaMessage = this.buildPersonaUserMessage(persona, idx);
            this.messagesChat.push({ assistant: null, user: { text: personaMessage } });
            // Persist the confirmed persona selection
            if (persona) {
                const personaId = persona.id != null ? persona.id : `persona-${idx}`;
                this.final_analyze_customers = {
                    ...(this.final_analyze_customers || {}),
                    persona: {
                        index: idx,
                        id: personaId,
                        name: persona.name || `Persona ${idx + 1}`,
                        description: this.buildPersonaDescription(persona) || ''
                    }
                };
            }
            this.applyPersonaSelection(idx);
            this.personaSelectorVisible = false;
            this.selectedTargetingStrategy = null;
            this.strategyPanelReady = false;
            this.strategyLoading = true;
            this.isMessageSending = true;
            
            // Store messages before calling triggerAudienceGenerationForPersona
            const messagesBefore = [...this.messagesChat];
            
            try {
                await this.triggerAudienceGenerationForPersona(idx, null, null, { includeStrategy: false });
                
                // Wait for Vue to update messagesChat
                await this.$nextTick();
                
                // Check if any error message was added after triggerAudienceGenerationForPersona
                const hasError = this.messagesChat.some((msg, index) => 
                    index >= messagesBefore.length &&
                    msg.assistant &&
                    msg.assistant.error === true
                );
                
                // Only show strategy selector if no error occurred
                if (!hasError) {
                    this.messagesChat.push({ assistant: { text: 'Select targeting strategy:' }, user: null });
                    this.strategyPanelReady = true;
                }
            } catch (error) {
                // Error is already handled in triggerAudienceGenerationForPersona
                // Don't show strategy selector if error occurred
                console.error('Error in onPersonaSelect:', error);
            } finally {
                this.strategyLoading = false;
                this.isMessageSending = false;
            }
        },
        applyPersonaSelection(idxOverride = null) {
            if (!Array.isArray(this.icpPersonas) || this.icpPersonas.length === 0) return;
            const idxRaw = idxOverride !== null && idxOverride !== undefined ? idxOverride : this.selectedPersonaIndex;
            const idx = typeof idxRaw === 'number' ? idxRaw : parseInt(idxRaw, 10);
            if (isNaN(idx) || idx < 0 || idx >= this.icpPersonas.length) return;

            const persona = this.icpPersonas[idx];
            const expressions = persona && persona.expressions ? persona.expressions : {};
            const chosenExpression = expressions.precision || expressions.balanced || expressions.reach || null;

            if (chosenExpression) {
                this.icpQueryParams = {
                    ...(this.icpQueryParams || {}),
                    expression: chosenExpression,
                };
            }

            if (persona && persona.description) {
                this.currentIcp = persona.description;
            }

            // Hide selector and remove any prior auto-generated "Persona selected" assistant notices.
            this.personaSelectorVisible = false;
            // this.messagesChat = this.messagesChat.filter(entry => {
            //     const text = entry && entry.assistant && entry.assistant.text ? String(entry.assistant.text) : '';
            //     return !/^Persona selected:/i.test(text.trim());
            // });
        },
        // Remove error messages from chat when user chooses a new action
        clearErrorMessages() {
            this.messagesChat = this.messagesChat.filter(msg => 
                !(msg.assistant && msg.assistant.error === true && msg.retryData)
            );
        },
        openPersonaSelector() {
            if (Array.isArray(this.icpPersonas) && this.icpPersonas.length) {
                // Clear error messages when opening persona selector
                this.clearErrorMessages();
                this.pendingPersonaIndex = this.selectedPersonaIndex;
                this.personaSelectorVisible = true;
            }
        },
        openStrategySelector() {
            const hasStrategies = Array.isArray(this.targetingStrategyOptions) && this.targetingStrategyOptions.length > 0;
            const personaChosen = this.selectedPersonaIndex !== null && this.selectedPersonaIndex !== undefined;
            if (!hasStrategies || !personaChosen) return;

            // Clear error messages when opening strategy selector
            this.clearErrorMessages();
            this.pendingTargetingStrategy = this.selectedTargetingStrategy;
            this.selectedTargetingStrategy = null;
            this.strategyPanelReady = false;
            this.messagesChat.push({ assistant: { text: 'Select targeting strategy:' }, user: null });
            this.strategyPanelReady = true;
        },
        getSelectedPersonaName() {
            const idx = this.selectedPersonaIndex;
            if (!Array.isArray(this.icpPersonas) || this.icpPersonas.length === 0) return '';
            if (typeof idx !== 'number' || idx < 0 || idx >= this.icpPersonas.length) return '';
            const persona = this.icpPersonas[idx];
            return persona && persona.name ? persona.name : '';
        },
        updateStrategyOptionsFromOverview(overview = []) {
            if (!Array.isArray(overview) || overview.length === 0) return;
            const overviewByStrategy = overview.reduce((acc, entry) => {
                if (!entry || !entry.strategy) return acc;
                acc[String(entry.strategy).toLowerCase()] = entry;
                return acc;
            }, {});
            const fallbackPersonaName = this.getSelectedPersonaName();
            this.targetingStrategyOptions = (this.targetingStrategyOptions || []).map(option => {
                const entry = overviewByStrategy[String(option.id).toLowerCase()];
                if (!entry) return option;
                const totalRaw = entry.total;
                const totalValueRaw = Number.isFinite(Number(totalRaw)) ? Number(totalRaw) : totalRaw;
                const totalValue = Number.isFinite(Number(totalValueRaw))
                    ? Number(totalValueRaw).toLocaleString('en-US')
                    : totalValueRaw;
                const personaName = entry.name || fallbackPersonaName;
                if (!personaName || totalValue === undefined || totalValue === null || Number.isNaN(totalValue)) {
                    return option;
                }
               const upodatedLabel = `${option.label} (available contacts : ${totalValue})`
                const defaultDescription = option.description ? ` ${option.description}` : '';
                return {
                    ...option,
                    description: `${option.label} strategy for persona ${personaName} has a total available audience of ${totalValue}.Ideal for ${defaultDescription}. Select to proceed`,
                    label:upodatedLabel,
                    availableContacts: totalValueRaw, // Store numeric value for saving
                };
            });
        },
        async preparePredictProfileMessages() {
            if (this.isGeneratingICP) return;
            const csvUrl = (this.selectedCustomerList && this.selectedCustomerList.url) 
                ? (this.selectedCustomerList.url)
                : ("");
            const baseContext = this.buildMarketBaseContext();

            if (!baseContext) {
                this.notificationError('Market context is required to generate an ICP.');
                return;
            }

            this.isGeneratingICP = true;
            this.isMessageSending = true;
            this.icpAnalysisText = '';
            this.setDefaultMessagesChat();

            try {
                // Previously posted to /icp/generate with multipart CSV upload; switched to URL-based workflow.
                const payload = {
                    csvUrl,
                    marketContext: {
                        base_context: baseContext,
                    },
                };
                const geoFilter = this.buildGeoFilterPayload();
                if (this.newcampaign.geo && geoFilter) {
                    payload.geoFilter = geoFilter;
                }

                const derivedFileName = csvUrl.split('/').pop();
                if (derivedFileName) {
                    payload.csvFileName = derivedFileName;
                }
                this.icpCsvUrl = csvUrl;
                const { data } = await axios.post('/audience/from-csv-url', payload);
                const analysis = data && typeof data === 'object' ? data.analysis || {} : {};
                const icpDescription = (data && (data.icp_description || data.icpAnalysis))
                    || analysis.icp_description
                    || analysis.icpDescription;
                const queryParams = (data && data.query_params && typeof data.query_params === 'object' ? data.query_params : null)
                    || (analysis && analysis.query_params && typeof analysis.query_params === 'object' ? analysis.query_params : null)
                    || (analysis && analysis.expressions && typeof analysis.expressions === 'object' ? analysis.expressions : {});
                const metadata = (data && data.metadata && typeof data.metadata === 'object' ? data.metadata : null)
                    || (analysis && analysis.metadata && typeof analysis.metadata === 'object' ? analysis.metadata : {});
                const csvKey = (data && (data.csvKey || data.csv_key))
                    || (data && data.audience && (data.audience.csvKey || data.audience.csv_key))
                    || (analysis && (analysis.csvKey || analysis.csv_key))
                    || (analysis && analysis.metadata && (analysis.metadata.csvKey || analysis.metadata.csv_key))
                    || (analysis && analysis.analysis && (analysis.analysis.csvKey || analysis.analysis.csv_key))
                    || (metadata && (metadata.csvKey || metadata.csv_key))
                    || null;
                const personas = (data && Array.isArray(data.personas) ? data.personas : null)
                    || (analysis && Array.isArray(analysis.personas) ? analysis.personas : null)
                    || (analysis && analysis.analysis && analysis.analysis.icp_synthesis && Array.isArray(analysis.analysis.icp_synthesis.personas) ? analysis.analysis.icp_synthesis.personas : []);

                if (icpDescription || (personas && personas.length)) {
                    this.icpAnalysisText = icpDescription;
                    this.currentIcp = icpDescription;
                    this.icpQueryParams = queryParams;
                    this.icpMetadata = metadata;
                    this.audienceCsvKey = csvKey;
                    this.personaRefinements = [];
                    this.icpPersonas = personas || [];
                    this.selectedPersonaIndex = null;
                    this.pendingPersonaIndex = null;
                    this.pendingTargetingStrategy = null;
                    this.personaSelectorVisible = Array.isArray(this.icpPersonas) && this.icpPersonas.length > 0;
                    const personaSummary = this.buildPersonaSummaryMessage(this.icpPersonas,data);
                    const initialMessages = [];
                    if (icpDescription) {
                        initialMessages.push({ assistant: { text: icpDescription }, user: null });
                    }
                    if (personaSummary) {
                        initialMessages.push({ assistant: { text: personaSummary }, user: null });
                    }
                    this.messagesChat = initialMessages.length ? initialMessages : [{
                        assistant: { text: 'Personas generated.' },
                        user: null
                    }];
                    return;
                }

                this.icpQueryParams = {};
                this.icpMetadata = {};
                this.notificationError('Unable to get ICP analysis from the provided CSV URL.');
            } catch (error) {
                console.error('Failed to prepare predict profile messages', error);
                const responseData = error && error.response && error.response.data ? error.response.data : {};
                const baseError = (responseData && (responseData.error || responseData.message)) ? (responseData.error || responseData.message) : '';
                const detailError = responseData && responseData.details ? responseData.details : '';
                const runIdValue = responseData && (responseData.runId || responseData.run_id) ? (responseData.runId || responseData.run_id) : '';
                const runId = runIdValue ? `Run ID: ${runIdValue}` : '';
                const messageError = [baseError, detailError, runId].filter(Boolean).join(' - ') || 'Unable to generate ICP analysis.';
                this.icpQueryParams = {};
                this.icpMetadata = {};
                this.notificationError(messageError);
                
                // Remove any existing error messages from preparePredictProfileMessages to avoid duplicates
                this.messagesChat = this.messagesChat.filter(msg => 
                    !(msg.assistant && msg.assistant.error === true && 
                      msg.retryData && 
                      msg.retryData.type === 'preparePredictProfileMessages')
                );
                
                // Store retry data for this error message
                const geoFilter = this.buildGeoFilterPayload();
                const errorMessage = {
                    assistant: { 
                        text: 'I ran into an issue generating the ICP analysis. Please try again.',
                        error: true
                    }, 
                    user: null,
                    retryData: {
                        type: 'preparePredictProfileMessages',
                        csvUrl: csvUrl,
                        baseContext: baseContext,
                        geoFilter: geoFilter
                    }
                };
                this.messagesChat.push(errorMessage);
            } finally {
                this.isGeneratingICP = false;
                this.isMessageSending = false;
            }
        },
        async useDummyCustomerList() {
            if (this.isGeneratingICP) return;
            this.icpCsvUrl = SAMPLE_CUSTOMER_LIST_URL;
            if (!this.icpMarketBaseContext) {
                this.icpMarketBaseContext = DEFAULT_MARKET_BASE_CONTEXT;
            }
            await this.preparePredictProfileMessages();
        },
        async updateCreateCampaignStep(){
            // TO DO
            // save the campaign in first step 
            // send data to provider in first step from backed and in create campaign response send the campaign Profile with campaign ID and other info
            if (this.isGeneratingICP) return;
            this.disableChat = false;
            // if (this.campaignCreateActiveStep < 4) {
            if (this.campaignCreateActiveStep < 3) {
                if (!this.validationCreateCampaignStep(this.campaignCreateActiveStep)) {
                    return;
                }

                const nextStep = this.campaignCreateActiveStep + 1;

                if (nextStep === 2) {
                    this.campaignCreateActiveStep = nextStep;
                    await this.preparePredictProfileMessages();
                } else {
                    this.campaignCreateActiveStep = nextStep;
                    
                    // for financials - ACTIVE STEP 3
                    if (this.campaignCreateActiveStep === 3) {
                        this.LeadspeekPlatformFee = '0';
                        this.LeadspeekMinCostMonth = '0';

                        // await this.getMasterAgencyCost();
                        // this.LeadspeekPlatformFee = this.clientdefaultprice.predict.Prepaid.PredictPlatformFee;
                        // this.LeadspeekMinCostMonth = this.clientdefaultprice.predict.Prepaid.PredictMinCostMonth;
                        
                        // const campaignTypeSelected = this.campaignTypeOptions.find(item => item.id == this.ClientCampaignType);
                        // this.m_LeadspeekPlatformFee = (campaignTypeSelected && campaignTypeSelected.price) ? campaignTypeSelected.price : 0 ;
                        // this.m_LeadspeekMinCostMonth = this.m_LeadspeekPlatformFee;
                        // this.LeadspeekPlatformFee = this.m_LeadspeekPlatformFee;
                        // this.LeadspeekMinCostMonth = this.m_LeadspeekPlatformFee;
                    }
                    // for financials

                    // Integration Setup - HIDDEN
                    // if (this.campaignCreateActiveStep === 4) {
                    // if (this.campaignCreateActiveStep === 3) {
                    //     this.prepareIntegrationsForCreateStep()
                    // }
                }
            } else {
                this.ProcessAddEditClient('')
            }
        },
        async prepareIntegrationsForCreateStep(){
            try {
                // if (!this.selectedRowData || !this.selectedRowData.company_id) return;
                // const data = await this.getUserIntegrationList({ companyID: this.selectedRowData.company_id, companyParent: this.selectedRowData.company_parent })
                // temp hard code 
                this.selectedRowData = {
                    id: 999999999,
                    spreadsheet_id: 'xxxxxx',
                    company_id: this.ClientCompanyID,
                    company_parent: this.ClientCompanyParent,
                    leadspeek_api_id: 999999999,
                }

                // console.log({ companyID: this.ClientCompanyID, companyParent: this.ClientCompanyParent })
                const data = await this.getUserIntegrationList({ companyID: this.ClientCompanyID, companyParent: this.ClientCompanyParent })
                // console.log(data);

                const conditionSpreadsheet = []
                if (this.selectedRowData.spreadsheet_id) {
                    conditionSpreadsheet.push({
                        name: 'Google Sheet',
                        description: '',
                        logo: 'fa-brands fa-google-drive',
                        active: '3',
                        slug: 'googlesheet',
                        custom_icon: null,
                        custom_description: null,
                        custom_img: null,
                        custom_name: null,
                        custom_slug: null,
                    })
                }
                this.integrations = conditionSpreadsheet
                if (Array.isArray(data) && data.length > 0) {
                    data.forEach(item => {
                        if(item.company_integration_details.slug === 'sendgrid'){
                            this.selectedRowData.sendgrid_is_active =  this.selectedRowData.sendgrid_is_active === 1
                        }
                        this.integrations.push(item.company_integration_details)
                    })
                }

                // inject integrations simplifi
                this.integrations.push({
                    "id": 99,
                    "name": "Simplify AD",
                    "slug": "simplify_ad",
                    "logo": "",
                    "type": "mail",
                    "status": 1,
                    "referralcode": "",
                    "custom_fields": "",
                    "created_at": "2025-09-11T16:19:22.000000Z",
                    "custom_name": null,
                    "custom_slug": null,
                    "custom_icon": null,
                    "custom_img": "",
                    "custom_description": null
                })
                // inject integrations simplifi

                this.selectedIntegration = this.selectedRowData.spreadsheet_id ? 'googlesheet' : (this.integrations[0] ? this.integrations[0].slug : 'googlesheet')
            } catch (e) {
                // swallow
            }
        },
        // Build LLM conversation context from current chat transcript (no system prompt)
        buildLlmConversation() {
            const convo = [];
            for (const entry of this.messagesChat) {
                // Maintain chronological order: assistant first (older), then user (newer)
                if (entry.assistant && (entry.assistant.text || entry.assistant.html)) {
                    const content = entry.assistant.text || entry.assistant.html;
                    convo.push({ role: 'assistant', content: String(content) });
                }
                if (entry.user && (entry.user.text || entry.user.html)) {
                    const content = entry.user.text || entry.user.html;
                    convo.push({ role: 'user', content: String(content) });
                }
            }
            return convo;
        },

        // Send message through local chat API endpoint
        // Send message through local chat API endpoint
        async sendChatMessage2(text) {
            const content = (text || '').trim();
            if (!content) return;

            const last = this.messagesChat[this.messagesChat.length - 1];
            if (last && last.assistant && !last.user) {
                this.$set(last, 'user', { text: content });
            } else {
                this.messagesChat.push({ assistant: null, user: { text: content } });
            }

            const businessForLLM = {
                ...this.campaignBusinessInfo,
                industry: this.getSelectedIndustryName()
            };
            
            this.isMessageSending = true;
            try {
                const response = await fetch('http://localhost:3000/chat', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ query: this.messagesChat,businessInfo:businessForLLM })
                });

                if (!response.ok) {
                    throw new Error(`Chat API responded with ${response.status}`);
                }

                const contentType = response.headers.get('content-type') || '';
                let data = null;
                if (contentType.includes('application/json')) {
                    data = await response.json();
                } else {
                    data = await response.text();
                }

                // console.log('Chat API response:', typeof data, typeof data.response);

                let replyText = '';
                if (typeof data === 'string') {
                    replyText = data;
                } else if (data && typeof data.response === 'string') {
                    replyText = data.response;
                } else if (data && typeof data.message === 'string') {
                    replyText = data.message;
                }

                if (replyText) {
                    this.messagesChat.push({ assistant: { text: replyText }, user: null });
                }
            } catch (error) {
                console.error('Chat API error:', error);
                this.$notify && this.$notify({ type: 'danger', message: 'Chat service is unavailable. Please try again.' });
                this.messagesChat.push({ assistant: { text: 'I ran into an error processing that. Please try again.' }, user: null });
            } finally {
                this.isMessageSending = false;
            }
        },

        getCurrentIcpPayload() {
            if (this.currentIcp && this.currentIcp.trim()) {
                return this.currentIcp;
            }
            for (let i = this.messagesChat.length - 1; i >= 0; i--) {
                const entry = this.messagesChat[i];
                if (entry.assistant && entry.assistant.text) {
                    return entry.assistant.text;
                }
            }
            return '';
        },

        buildAudienceMarketContext(refinements = []) {
            const baseContext = this.buildMarketBaseContext();
            const context = { base_context: baseContext };
            const cleanedRefinements = Array.isArray(refinements)
                ? refinements.map(r => (r || '').toString().trim()).filter(Boolean)
                : [];
            if (cleanedRefinements.length) {
                context.refinements = cleanedRefinements;
            }
            return context;
        },

        buildGeoFilterPayload() {
            if (!this.newcampaign || !this.newcampaign.geo) return null;
            const lat = Number(this.newcampaign.target_lat);
            const lng = Number(this.newcampaign.target_lng);
            const radius = Number(this.newcampaign.target_radius_miles);
            // console.log(this.newcampaign.target_lat,this.newcampaign.target_lng,this.newcampaign.target_radius_miles)
            if (![lat, lng, radius].every(Number.isFinite)) return null;
            return {
                latitude: lat,
                longitude: lng,
                radius_miles: radius,
            };
        },
        extractItemSummary(payload) {
            return payload && typeof payload.summary === 'string'
                ? payload.summary.trim()
                : '';
        },

        addPersonaRefinement(message) {
            const trimmed = (message || '').toString().trim();
            if (!trimmed) return;
            if (!Array.isArray(this.personaRefinements)) {
                this.personaRefinements = [];
            }
            this.personaRefinements.push(trimmed);
        },

        onStrategyOptionSelect(strategyId) {
            if (!strategyId) return;
            this.pendingTargetingStrategy = strategyId;
        },
        confirmStrategySelection() {
            const strategyId = this.pendingTargetingStrategy;
            if (!strategyId) return;
            this.pendingTargetingStrategy = null;
            this.onTargetingStrategySelect(strategyId);
        },
        onTargetingStrategySelect(strategyId) {
            if (!strategyId) return;
            
            // Clear error messages when selecting a new strategy
            this.clearErrorMessages();
            
            this.personaRefinements = [];
            const chosen = (this.targetingStrategyOptions || []).find(opt => opt.id === strategyId);
            if (chosen) {
                this.messagesChat.push({ assistant: null, user: { text: chosen.label || strategyId } });
            }
            this.selectedTargetingStrategy = strategyId;
            // Persist the confirmed strategy selection
            this.final_analyze_customers = {
                ...(this.final_analyze_customers || {}),
                strategy: {
                    id: strategyId,
                    label: (chosen && chosen.label) || String(strategyId),
                    description: (chosen && chosen.description) || ''
                }
            };
            // Store available contacts count
            this.availableContacts = (chosen && chosen.availableContacts !== undefined) ? chosen.availableContacts : null;
            this.strategyLoading = true;
            this.isMessageSending = true;
            this.triggerAudienceGenerationForPersona(null, null, strategyId)
                .catch(() => {})
                .finally(() => {
                    this.strategyLoading = false;
                    this.isMessageSending = false;
                });
        },

        resolveAudienceCsvKey() {
            if (this.audienceCsvKey) return this.audienceCsvKey;
            if (this.icpMetadata && (this.icpMetadata.csvKey || this.icpMetadata.csv_key)) {
                return this.icpMetadata.csvKey || this.icpMetadata.csv_key;
            }
            return null;
        },

        async triggerAudienceGenerationForPersona(idxOverride = null, refinementsOverride = null, strategyOverride = null, options = null) {
            const personas = Array.isArray(this.icpPersonas) ? this.icpPersonas : [];
            const personaIndexRaw = idxOverride !== null && idxOverride !== undefined
                ? idxOverride
                : this.selectedPersonaIndex;
            const personaIndex = typeof personaIndexRaw === 'number' ? personaIndexRaw : parseInt(personaIndexRaw, 10);
            const csvKey = this.resolveAudienceCsvKey();
            if (!csvKey || !personas.length || isNaN(personaIndex) || personaIndex < 0 || personaIndex >= personas.length) {
                console.warn('Audience generation skipped', { csvKey, personasCount: personas.length, personaIndex });
                return;
            }

            const refinements = refinementsOverride !== null && refinementsOverride !== undefined
                ? refinementsOverride
                : this.personaRefinements;
            const includeStrategy = !options || options.includeStrategy !== false;
            const strategy = includeStrategy ? (strategyOverride || this.selectedTargetingStrategy || null) : null;

            const marketContext = this.buildAudienceMarketContext(refinements);
            const geoFilter = this.buildGeoFilterPayload();
            const requestPayload = {
                csvKey,
                personas,
                marketContext,
                personaIndex,
            };
            if (includeStrategy && strategy) {
                requestPayload.strategy = strategy;
            }
            if (this.lastUpdatedExpression) {
                requestPayload.lastUpdatedExpression = this.lastUpdatedExpression;
            }
            if (this.newcampaign.geo && geoFilter) {
                requestPayload.geoFilter = geoFilter;
            }

            try {
                console.log(requestPayload,'hellooooooo')
                // return;
                const response = await axios.post('/audience/from-csv-key', requestPayload);
                const overview = (response && response.data && Array.isArray(response.data.overview) && response.data.overview)
                    || (response && response.data && response.data.audience && Array.isArray(response.data.audience.overview) && response.data.audience.overview)
                    || null;
                if (overview) {
                    this.updateStrategyOptionsFromOverview(overview);
                }
                const finalExpression =
                    (response && response.data && (response.data.finalExpression || response.data.final_expression)) ||
                    null;
                if (finalExpression) {
                    this.lastUpdatedExpression = finalExpression;
                }
                const itemSummary = this.extractItemSummary(response && response.data ? response.data : null);
                if (itemSummary) {
                    this.messagesChat.push({ assistant: { text: itemSummary }, user: null });
                }
            } catch (error) {
                // Log quietly; do not block user flow
                console.error('Failed to trigger audience generation', error);
                
                // Remove any existing error messages from the same operation to avoid duplicates
                this.messagesChat = this.messagesChat.filter(msg => 
                    !(msg.assistant && msg.assistant.error === true && 
                      msg.retryData && 
                      msg.retryData.refinements !== undefined)
                );
                
                // Store retry data for this error message
                const errorMessage = {
                    assistant: { 
                        text: 'I ran into an issue. Please try again.',
                        error: true
                    }, 
                    user: null,
                    retryData: {
                        refinements: refinements,
                        personaIndex: personaIndex,
                        strategy: strategy,
                        marketContext: marketContext,
                        geoFilter: geoFilter,
                        csvKey: csvKey,
                        personas: personas,
                        idxOverride: idxOverride,
                        refinementsOverride: refinementsOverride,
                        strategyOverride: strategyOverride,
                        options: options
                    }
                };
                this.messagesChat.push(errorMessage);
            }
        },

        // Send message to LLM backend API with updated ICP flow
        async sendChatMessage(text) {
            const content = (text || '').trim();
            if (!content) return;
        
            // Optimistically add user message
            const last = this.messagesChat[this.messagesChat.length - 1];
            if (last && last.assistant && !last.user) {
                this.$set(last, 'user', { text: content });
            } else {
                this.messagesChat.push({ assistant: null, user: { text: content } });
            }
            this.isMessageSending = true;
            // const START_REGEX = /\b(start|launch|kick\s*off)\b.*\bcampaign\b/i;
            const START_REGEX = /\b(yes|start|launch|kick\s*off)\b(?:.\bcampaign\b)?/i;
            if (START_REGEX.test(text)) {
                this.disableChat = true;
                await new Promise(resolve => setTimeout(resolve, 2000));
                this.messagesChat.push({ assistant: { text: "Campaign is ready to start, proceed to next step to finish setup." }, user: null });
              
                this.isMessageSending = false;
                return 
            }        
            try {
                this.addPersonaRefinement(content);
                const refinements = Array.isArray(this.personaRefinements) ? [...this.personaRefinements] : [content];
                await this.triggerAudienceGenerationForPersona(null, refinements);
            } catch (err) {
                console.error('Audience refinement error:', err);
                const responseData = err && err.response && err.response.data ? err.response.data : {};
                const baseError = (responseData && (responseData.error || responseData.message)) ? (responseData.error || responseData.message) : 'Unable to update audience. Please try again.';
                const detailError = responseData && responseData.details ? (typeof responseData.details === 'string' ? responseData.details : JSON.stringify(responseData.details)) : '';
                const runId = responseData && responseData.runId ? `Run ID: ${responseData.runId}` : '';
                const messageError = [baseError, detailError, runId].filter(Boolean).join(' - ');
                this.$notify && this.$notify({ type: 'danger', message: messageError });
                
                // Remove any existing error messages from sendChatMessage to avoid duplicates
                this.messagesChat = this.messagesChat.filter(msg => 
                    !(msg.assistant && msg.assistant.error === true && 
                      msg.retryData && 
                      msg.retryData.text !== undefined)
                );
                
                // Store retry data for this error message
                const refinements = Array.isArray(this.personaRefinements) ? [...this.personaRefinements] : [content];
                const errorMessage = {
                    assistant: { 
                        text: 'I ran into an error processing that. Please try again.',
                        error: true
                    }, 
                    user: null,
                    retryData: {
                        text: content,
                        refinements: refinements
                    }
                };
                this.messagesChat.push(errorMessage);
            } finally {
                this.isMessageSending = false;
            }
        },
        
        // Retry a failed message
        async retryChatMessage(messageIndex) {
            console.log('retryChatMessage called with index:', messageIndex);
            
            if (messageIndex < 0 || messageIndex >= this.messagesChat.length) {
                console.warn('Invalid message index:', messageIndex);
                return;
            }
            
            if (this.isMessageSending) {
                console.warn('Already sending message, retry blocked');
                return; // Prevent retry while sending
            }
            
            const message = this.messagesChat[messageIndex];
            console.log('Message to retry:', message);
            
            if (!message || !message.retryData) {
                console.warn('Message or retryData not found:', { message, retryData: message && message.retryData });
                return;
            }
            
            const retryData = message.retryData;
            console.log('Retry data:', retryData);
            
            // Remove the error message
            this.messagesChat.splice(messageIndex, 1);
            
            // Retry based on retryData type
            if (retryData.type === 'preparePredictProfileMessages') {
                console.log('Retrying preparePredictProfileMessages');
                // Retry from preparePredictProfileMessages
                // Reset flags first to ensure preparePredictProfileMessages can run
                this.isGeneratingICP = false;
                this.isMessageSending = false;
                
                try {
                    await this.preparePredictProfileMessages();
                } catch (error) {
                    console.error('Retry failed:', error);
                }
            } else if (retryData.text) {
                console.log('Retrying sendChatMessage with text:', retryData.text);
                // Retry from sendChatMessage
                await this.sendChatMessage(retryData.text);
            } else if (retryData.refinements !== undefined || retryData.personaIndex !== undefined) {
                console.log('Retrying triggerAudienceGenerationForPersona');
                // Retry from triggerAudienceGenerationForPersona
                this.isMessageSending = true;
                try {
                    // Use the stored override values if available, otherwise use the retryData values
                    const idxOverride = retryData.idxOverride !== undefined ? retryData.idxOverride : retryData.personaIndex;
                    const refinementsOverride = retryData.refinementsOverride !== undefined ? retryData.refinementsOverride : retryData.refinements;
                    const strategyOverride = retryData.strategyOverride !== undefined ? retryData.strategyOverride : retryData.strategy;
                    
                    await this.triggerAudienceGenerationForPersona(
                        idxOverride,
                        refinementsOverride,
                        strategyOverride,
                        retryData.options
                    );
                } catch (error) {
                    console.error('Retry failed:', error);
                } finally {
                    this.isMessageSending = false;
                }
            } else {
                console.warn('Unknown retry data type:', retryData);
            }
        },
        onDownload(index, campaign) {
            // Open report download modal
            if (!campaign || !campaign.leadspeek_api_id) return;
            
            this.reportDownloadCampaign.id = campaign.leadspeek_api_id;
            this.reportDownloadCampaign.name = campaign.campaign_name || 'Campaign';
            
            this.$nextTick(() => {
                this.modals.reportDownload = true;
            });
        },
        onViewCampaignDetail(index, row) {
            // console.log(row);
            this.selectedRowData = row;

            // from customer
            row.target_nt = false;
            row.target_state = false;
            row.target_zip = false;
            row.target_location = false;
            if (row.national_targeting == 'T') {
                row.target_nt = true;
            } else {
                if (row.leadspeek_locator_zip != "" && row.leadspeek_locator_zip != null) {
                    row.target_zip = true;
                    row.leadspeek_locator_zip = this.replaceCommaLine(row.leadspeek_locator_zip);
                }
                if (row.leadspeek_locator_state != "" && row.leadspeek_locator_state != null) {
                    row.target_state = true;
                    this.selectedRowData.leadspeek_locator_state = row.leadspeek_locator_state.split(',');
                }
                if (row.leadspeek_latitude != "" && row.leadspeek_longitude != "" && row.leadspeek_radius != "") {
                    row.target_location = true;
                    this.selectedRowData.leadspeek_latitude = row.leadspeek_latitude;
                    this.selectedRowData.leadspeek_longitude = row.leadspeek_longitude;
                    this.selectedRowData.leadspeek_radius = row.leadspeek_radius;
                }
            }
            // from customer

            this.modals.viewCampaignDetail = true;
        },
        async refundTopupPrepaid() {
            // validation
            if(!(this.LeadspeekActive == 'F' && this.LeadspeekDisabled == 'T' && this.LeadspeekActiveUser == 'F')) {
                this.$notify({
                    type: 'danger',
                    message: 'Please stop the campaign before refund campaign.',
                    icon: 'fas fa-bug'
                });
                return;
            }
            if(this.remainingBalanceLeads == 0) {
                this.$notify({
                    type: 'danger',
                    message: 'You cannot a refund because your remaining balance is 0 contact.',
                    icon: 'fas fa-bug'
                });
                return;
            }
            if(this.selectsPaymentTerm.PaymentTermSelect != 'Prepaid') {
                this.$notify({
                    type: 'danger',
                    message: 'Payment type campaign must be a prepaid.',
                    icon: 'fas fa-bug'
                });
                return;
            }
            // validation

            // calculate estimate price refund
            let amountRefundAgency = 0;
            try {
                this.isProcessRefundPrepaid = true;

                const payload = { leadspeek_api_id: this.ActiveLeadspeekID };
                const response = await this.$store.dispatch('estimateRefundCampaignPrepaid', payload);
                // console.log(response);

                this.isProcessRefundPrepaid = false;
                amountRefundAgency = typeof(response.amountRefundAgency) ? response.amountRefundAgency : 0; 
            } catch (error) {
                // console.error(error);
                this.isProcessRefundPrepaid = false;
                this.$notify({
                    type: 'danger',
                    message: typeof(error.response.data.mesage) != 'undefined' ? error.response.data.mesage : 'Something Went Wrong',
                    icon: 'fas fa-bug'
                });
                return;
            }
            // calculate estimate price refund

            // process refund 
            const userData = this.$store.getters.userData;
            const result = await swal.fire({
                title: 'Refund Campaign',
                html: `Are you sure you want to refund the campaign? Once the refund is processed, an amount of <span style="font-weight: bold">$${amountRefundAgency}</span> will be returned to your data wallet agency. This action cannot be undone and any remaining balance contact will be forfeited`,
                icon: '',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-default btn-fill mr-3',
                    cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Yes, refund it!',
                buttonsStyling: false
            });
            if (result.isConfirmed) {
                try {
                    this.isProcessRefundPrepaid = true;

                    const payload = { 
                        leadspeek_api_id: this.ActiveLeadspeekID,
                        company_id: userData.user_type == 'client' ? userData.company_parent : userData.company_id,
                        ip_user: userData.ip_login,
                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        payment_type: 'refund_campaign',
                    };
                    const response = await this.$store.dispatch('refundCampaignPrepaid', payload);
                    // console.log(response);

                    this.remainingBalanceLeads = (typeof(response.remainingBalanceLeads) != 'undefined') ? response.remainingBalanceLeads : 0;
                    this.isContainulTopUpStop = (typeof(response.stopContinual) != 'undefined' && response.stopContinual == 'T') ? true : false;
                    this.isProcessRefundPrepaid = false;
                    this.GetClientList(this.currSortBy,this.currOrderBy)
                    this.$notify({
                        type: 'success',
                        message: typeof(response.message) != 'undefined' ? response.message : 'Refund Campaign Was Successful.',
                        icon: 'fas fa-bug'
                    });
                } catch (error) {
                    // console.error(error);
                    this.isProcessRefundPrepaid = false;
                    this.$notify({
                        type: 'danger',
                        message: typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something Went Wrong',
                        icon: 'fas fa-bug'
                    });
                }
            }
            // process refund
        },
        changeGhlTags() {
            this.$nextTick(() => {
                document.querySelectorAll('.select-integration-ghl .el-tag.el-tag--info.el-tag--small.el-tag--light').forEach((element, index) => {
                    const textOption = element.querySelector('.el-select__tags-text').textContent.trim();
                    if(this.ghl_tags_remove.includes(textOption)) {
                        element.classList.add('red-tag');
                    } else {
                        element.classList.remove('red-tag');
                    }
                });
            });
        },
        keydownInputGhlTags() {
            this.changeGhlTags();
        },
        validationMinLeadPrepaidOneTime() {
            if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.prepaidType == 'onetime' && Number(this.totalLeads.oneTime) < Number(this.minimumLeadPrepaidOneTime)) {
                this.totalLeads.oneTime = this.minimumLeadPrepaidOneTime;
                this.err_totalleads = false;
                this.profitcalculation();
            }
        },
        handleRetryKeyword(param){
            this.formApproxLeadCountRetry.campaign_id = this.formApproxLeadCount.campaign_id;
            this.formApproxLeadCountRetry.leadspeek_api_id = this.formApproxLeadCount.leadspeek_api_id;
            this.formApproxLeadCountRetry.company_id = this.formApproxLeadCount.company_id;
            this.formApproxLeadCountRetry.user_id = this.formApproxLeadCount.user_id;
            this.formApproxLeadCountRetry.email = this.formApproxLeadCount.email;
            this.formApproxLeadCountRetry.keyword = [param.keyword];
            this.formApproxLeadCountRetry.target_location = param.target_location;
            this.formApproxLeadCountRetry.cities = param.cities;
            this.formApproxLeadCountRetry.states = param.states;
            this.formApproxLeadCountRetry.zip_code = param.zip_code;
            this.formApproxLeadCountRetry.type = 'retry';

            this.isLoadingGetCount = true
            const payloadApproxLeadCount = { ...this.formApproxLeadCountRetry };            

            delete payloadApproxLeadCount.keyword_bulk
            if (payloadApproxLeadCount.target_location === 'National Targeting') {
                delete payloadApproxLeadCount.states;
                delete payloadApproxLeadCount.cities;
                delete payloadApproxLeadCount.zip_code;
            } else if (payloadApproxLeadCount.target_location === 'State') {
                delete payloadApproxLeadCount.zip_code;
            } else if (payloadApproxLeadCount.target_location === 'Zip Code') {
                delete payloadApproxLeadCount.states;
                delete payloadApproxLeadCount.cities;
            }

            this.$store.dispatch('onApproxLeadCount', payloadApproxLeadCount).then(response => {
                this.$notify({
                    type: 'success',
                    message: response.message,
                    icon: 'tim-icons icon-bell-55'
                });  
                this.isLoadingGetCount = false
                this.modals.approxLead = false

                this.userLogsGetCount(payloadApproxLeadCount)
            }, err => {
                this.isLoadingGetCount = false
                this.$notify({
                    type: 'danger',
                    message: 'Sorry there is something wrong, pleast try again later',
                    icon: 'fas fa-exclamation-circle'
                });  
            })
        },
        handleRetryKeywordEdit(param){
            this.formApproxLeadCountRetry.campaign_id = this.selectedRowData.id;
            this.formApproxLeadCountRetry.leadspeek_api_id = this.selectedRowData.leadspeek_api_id;
            this.formApproxLeadCountRetry.company_id = this.selectedRowData.company_id;
            this.formApproxLeadCountRetry.user_id = this.selectedRowData.user_id;
            this.formApproxLeadCountRetry.email = this.selectedRowData.email;
            this.formApproxLeadCountRetry.keyword = [param.keyword];
            this.formApproxLeadCountRetry.target_location = param.target_location;
            this.formApproxLeadCountRetry.cities = param.cities.includes(',') 
                                                    ? param.cities.split(',') 
                                                    : [param.cities];
            this.formApproxLeadCountRetry.states = param.states.includes(',') 
                                                    ? param.states.split(',') 
                                                    : [param.states];
            this.formApproxLeadCountRetry.zip_code = param.zip_code;
            this.formApproxLeadCountRetry.type = 'retry_play';

            this.isLoadingGetCount = true
            const payloadApproxLeadCount = { ...this.formApproxLeadCountRetry };            

            delete payloadApproxLeadCount.keyword_bulk
            if (payloadApproxLeadCount.target_location === 'National Targeting') {
                delete payloadApproxLeadCount.states;
                delete payloadApproxLeadCount.cities;
                delete payloadApproxLeadCount.zip_code;
            } else if (payloadApproxLeadCount.target_location === 'State') {
                delete payloadApproxLeadCount.zip_code;
            } else if (payloadApproxLeadCount.target_location === 'Zip Code') {
                delete payloadApproxLeadCount.states;
                delete payloadApproxLeadCount.cities;
            }

            this.$store.dispatch('onApproxLeadCount', payloadApproxLeadCount).then(response => {
                this.$notify({
                    type: 'success',
                    message: response.message,
                    icon: 'tim-icons icon-bell-55'
                });  
                this.isLoadingGetCount = false
                this.modals.approxLead = false

                this.userLogsGetCount(payloadApproxLeadCount)
            }, err => {
                this.isLoadingGetCount = false
                this.$notify({
                    type: 'danger',
                    message: 'Sorry there is something wrong, pleast try again later',
                    icon: 'fas fa-exclamation-circle'
                });  
            })
        },
        removeEmptyLines() {
            this.mbp_zip = this.mbp_zip
                               .split('\n') // Pisahkan setiap baris berdasarkan newline
                               .filter(line => line.trim() !== '') // Hapus baris kosong atau hanya spasi
                               .join('\n'); // Gabungkan kembali menjadi teks dengan newline
        },
        mailBoxPowerFilesChange(fieldName, fileList) {
            this.isMailBoxPowerSavingZip = true;

            /* VALIDATION EXTENSION */
            const fileExtension = fieldName.name.split('.').pop();
            
            if(fileExtension != 'csv') {
                this.$notify({
                    type: 'danger',
                    message: 'file must be CSV',
                    icon: 'tim-icons icon-bell-55'
                });
                this.mailBoxPowerFilesReset();
                return false;
            }
            /* VALIDATION EXTENSION */

            // handle file changes
            if (!fileList.length) return;
            
            // append the files to FormData
            const formData = new FormData();
            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(this.mailBoxpowerUploadZipName, fileList[x].raw, fileList[x].name);
            });
            formData.append("leadspeek_api_id", this.selectedRowData.leadspeek_api_id);
            // append the files to FormData

            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Access-Control-Allow-Origin' : '*',
                }
           };

           axios.post('/mailboxpower/upload-zipcode', formData, config)
                .then(response => {
                    // console.log(response);
                    this.mailBoxPowerFilesReset();

                    if(response.data.result == 'success') {
                        this.$notify({
                            type: 'success',
                            message: response.data.message,
                            icon: 'tim-icons icon-bell-55'
                        });

                        this.mbp_zip = response.data.mbpzip;
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.mailBoxPowerFilesReset();

                    this.$notify({
                        type: 'danger',
                        message: error.response.data.message,
                        icon: 'tim-icons icon-bell-55'
                    });
                });
        },
        mailBoxPowerFilesReset() {
            this.isMailBoxPowerSavingZip = false;
            this.mailBoxpowerUploadZipName = 'mailboxpoweupload';
            this.$refs.mailBoxPowerZip.clearFiles();
        },
        openHelpModal(index){
            this.activeHelpItem = this.helpContentMap[index]
            this.modals.helpVideos = true;
        },
        openPhoneConfirmationModal(val){
            const userData = this.$store.getters.userData
            if (this[val].phoneenabled) {
                this[val].phoneenabled = false
                if(val == 'checkboxes') {
                    this.onCheckItemAdvancedInformation();
                } else if(val == 'selectedRowData') {
                    this.onCheckItemRowAdvancedInformation();   
                }

                var _campaignID = '';
                let userId = '';

                if (val != 'checkboxes') {
                    _campaignID = '#' + this[val].leadspeek_api_id;
                    userId = this.selectedRowData.user_id;
                }else{
                    _campaignID = this.ClientCampaignName;
                    userId = this.ClientUserID;
                }

                // let data = {
                //     userID: userData.id,
                //     action: "disabled phone number on campaign",
                //     desc: "campaign " + _campaignID,
                //     userIP: this.$store.getters.userData.ip_login,
                // }

                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                // if (userViewMode) {
                //     const userRoot = decryptData(localStorage.getItem('userDataOri'));
                //     data.userID = userRoot.id;
                // }
                
                // this.userLogSaved({ data});
                this.$store.dispatch('onSaveUserLogs', {
                    desc: "campaign " + _campaignID,
                    action: "disabled phone number on campaign",
                    target_id: userId,
                })
                return
            }
            swal.fire({
                  title: "<span style='font-size:21px;'>Phone numbers are provided without warranty or guarantee. The end-user is responsible for verifying the Do-Not-Call status of each number and ensuring compliance with all applicable laws. The end-user must obtain all necessary permissions before making calls or sending messages<span>",
                  text: '',
                  icon: '',
                  showCancelButton: true,
                  customClass: {
                  confirmButton: 'btn btn-fill mr-3',
                  cancelButton: 'btn btn-danger btn-fill'
                  },
                  confirmButtonText: "I Agree",
                  buttonsStyling: false
          }).then(result => {
            // API CAll For Storing Confirmation From The USER
            if (result.isConfirmed) {
                var _campaignID = '';
                let userId = '';

                if (val != 'checkboxes') {
                    _campaignID = '#' + this[val].leadspeek_api_id;
                    userId = this.selectedRowData.user_id;
                }else{
                    _campaignID = this.ClientCampaignName;
                    userId = this.ClientUserID;
                }

                // let data = {
                //     userID: userData.id,
                //     action: "enabled phone number on campaign",
                //     desc: "Agreed with pop up information (enabled phone number) on campaign " + _campaignID,
                //     userIP: this.$store.getters.userData.ip_login,
                // }
                
                // this.userLogSaved({ data});
                this.$store.dispatch('onSaveUserLogs', {
                    desc: "Agreed with pop up information (enabled phone number) on campaign " + _campaignID,
                    action: "enabled phone number on campaign",
                    target_id: userId,
                })

            }
            // API Call END
            this[val].phoneenabled = result.isConfirmed ? true : false
            if(val == 'checkboxes') {
                this.onCheckItemAdvancedInformation();
            } else if(val == 'selectedRowData') {
                this.onCheckItemRowAdvancedInformation();
              }

          });
        },
        async openSaveConfirmationModal(val){
            const userData = this.$store.getters.userData;
            
            return  swal.fire({
                  title: "<span style='font-size:21px;'>Phone Numbers Are Not Enabled <br> <b>Please Confirm</b>?</span>",
                  text: "Phone numbers are provided without warranty or guarantee. The end-user is responsible for verifying the Do-Not-Call status of each number and ensuring compliance with all applicable laws. The end-user must obtain all necessary permissions before making calls or sending messages",
                  icon: '',
                  width: '600px',
                  showConfirmButton: true,
                  showCancelButton: true,
                  customClass: {
                    confirmButton: 'btn btn-fill mr-3',
                    cancelButton: 'btn btn-fill'
                  },
                  confirmButtonText: "Include Phone Numbers",
                  cancelButtonText: "Exclude Phone Numbers",
                  buttonsStyling: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false
          }).then(result => {
            // API CAll For Storing Phone Confirmation From The USER
            var _campaignID = '';
            let userId = '';

            if (val != 'add') {
                _campaignID = '#id=' + val;
                // userId = this.selectedRowData.user_id;
                userId = this.userIdCampaign;
            }else{
                _campaignID = this.ClientCampaignName;
                userId = this.ClientUserID;
            }

            if (result.isConfirmed) {
                

                // let data = {
                //     userID: userData.id,
                //     action: "Agree modal save campaign",
                //     desc: "Agree save campaign with enable phone number on campaign " + _campaignID,
                //     userIP: this.$store.getters.userData.ip_login,
                // }

                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                // if(userViewMode){
                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                //     data.userID = userRoot.id;
                // }
                // this.userLogSaved({ data });
                this.$store.dispatch('onSaveUserLogs', {
                    desc: "Agree save campaign with enable phone number on campaign " + _campaignID,
                    action: "Agree modal save campaign",
                    target_id: userId,
                })

                return true;
            } else if (result.isDismissed && result.dismiss === swal.DismissReason.cancel) {
                // let data = {
                //     userID: userData.id,
                //     action: "Don't Agree modal save campaign",
                //     desc: "Don't Agree save campaign with enable phone number on campaign " + _campaignID,
                //     userIP: this.$store.getters.userData.ip_login,
                // }

                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                // if(userViewMode){
                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                //     data.userID = userRoot.id;
                // }
                // this.userLogSaved({ data });
                this.$store.dispatch('onSaveUserLogs', {
                    desc: "Don't Agree save campaign with enable phone number on campaign " + _campaignID,
                    action: "Don't Agree modal save campaign",
                    target_id: userId,
                })

                return false;
            } else {
                return null; // cancel or dismissed
            }
                  
          });
        },
        startTour(){
            const updatedData = [this.dummyCampaignData, ...this.queriedData];
            this.queriedData = updatedData;
            this.$tours['myTour'].start()
        },
        removeDummyItemFromQueriedData() {
            
            const updatedData = this.queriedData.filter(
                     (item) => item.id !== 'dummy-campaign-item'
            );
             this.queriedData = updatedData;
        },
        addWebhookUrl() {
            this.zapierWebhook.push('');
        },
        removeWebhookUrl(index) {
            if (this.zapierWebhook.length > 1) {
                this.zapierWebhook.splice(index, 1);
            }
        },
        validateCostPerLeadUnderCostAgency(type) {
            if(type == 'Weekly') {
                // const rootCostPerLeadMin = (this.costagency.enhance.Weekly.EnhanceCostperlead > this.rootcostagency.enhance.Weekly.EnhanceCostperlead) ? this.costagency.enhance.Weekly.EnhanceCostperlead : this.rootcostagency.enhance.Weekly.EnhanceCostperlead;
                const rootCostPerLeadMin = this.costagency.enhance.Weekly.EnhanceCostperlead;
                if((Number(this.LeadspeekCostperlead) < Number(rootCostPerLeadMin) && this.LeadspeekCostperlead != 0) || this.LeadspeekCostperlead === '') {
                    this.LeadspeekCostperlead = rootCostPerLeadMin;
                    this.errMinCostAgencyPerLead = false;
                }
            } else if(type == 'Monthly') {
                // const rootCostPerLeadMin = (this.costagency.enhance.Monthly.EnhanceCostperlead > this.rootcostagency.enhance.Monthly.EnhanceCostperlead) ? this.costagency.enhance.Monthly.EnhanceCostperlead : this.rootcostagency.enhance.Monthly.EnhanceCostperlead;
                const rootCostPerLeadMin = this.costagency.enhance.Monthly.EnhanceCostperlead;
                if((Number(this.LeadspeekCostperlead) < Number(rootCostPerLeadMin) && this.LeadspeekCostperlead != 0) || this.LeadspeekCostperlead === '') {
                    this.LeadspeekCostperlead = rootCostPerLeadMin;
                    this.errMinCostAgencyPerLead = false;
                }
            } else if(type == 'One Time') {
                // const rootCostPerLeadMin = (this.costagency.enhance.OneTime.EnhanceCostperlead > this.rootcostagency.enhance.OneTime.EnhanceCostperlead) ? this.costagency.enhance.OneTime.EnhanceCostperlead : this.rootcostagency.enhance.OneTime.EnhanceCostperlead;
                const rootCostPerLeadMin = this.costagency.enhance.OneTime.EnhanceCostperlead;
                if((Number(this.LeadspeekCostperlead) < Number(rootCostPerLeadMin) && this.LeadspeekCostperlead != 0) || this.LeadspeekCostperlead === '') {
                    this.LeadspeekCostperlead = rootCostPerLeadMin;
                    this.errMinCostAgencyPerLead = false;
                }
            } else if(type == 'Prepaid') {
                // const rootCostPerLeadMin = (this.costagency.enhance.Prepaid.EnhanceCostperlead > this.rootcostagency.enhance.Prepaid.EnhanceCostperlead) ? this.costagency.enhance.Prepaid.EnhanceCostperlead : this.rootcostagency.enhance.Prepaid.EnhanceCostperlead;
                const rootCostPerLeadMin = this.costagency.enhance.Prepaid.EnhanceCostperlead;
                if((Number(this.LeadspeekCostperlead) < Number(rootCostPerLeadMin) && this.LeadspeekCostperlead != 0) || this.LeadspeekCostperlead === '') {
                    this.LeadspeekCostperlead = rootCostPerLeadMin;
                    this.errMinCostAgencyPerLead = false;
                }
            }
        },
        validateMinimumCostPerLead() {
            if(this.clientTypeLead.type !== 'clientcaplead') {
                if(this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    this.validateCostPerLeadUnderCostAgency('Weekly');
                    this.profitcalculation();
                } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    this.validateCostPerLeadUnderCostAgency('Monthly');
                    this.profitcalculation();
                } else if(this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    this.validateCostPerLeadUnderCostAgency('One Time');
                    this.profitcalculation();
                } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    this.validateCostPerLeadUnderCostAgency('Prepaid');
                    this.profitcalculation();
                }
            }
        },
        validateMinContactPerDayKeyup(type) {
            if(type == 'price_campaign') {
                if(Number(this.LeadspeekMinimumLeadsPerDay) > Number(this.LeadspeekLimitLead)) {
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                    this.profitcalculation();
                }
            } else if(type == 'create_campaign') {
                if(Number(this.LeadspeekMinimumLeadsPerDayAdd) > Number(this.newcampaign.asec5_6)) {
                    this.newcampaign.asec5_6 = this.LeadspeekMinimumLeadsPerDayAdd;
                }
            } 
        },
        validateMinContactPerDayBlur(type) {
            if(type == 'price_campaign') {
                if(this.LeadspeekMinimumLeadsPerDay == '') {
                    this.LeadspeekMinimumLeadsPerDay = 1;
                }
            } else if(type == 'create_campaign') {
                if(this.LeadspeekMinimumLeadsPerDayAdd == '') {
                    this.LeadspeekMinimumLeadsPerDayAdd = 1;
                }
            }
        },
        validateMinLeadsPerDayKeyup() {
            if(this.LeadspeekEnableMinimumLeadsPerDayAdd == true) {
                if(Number(this.newcampaign.asec5_6) < Number(this.LeadspeekMinimumLeadsPerDayAdd)) {
                    this.errMinClientLeadDayAdd = true;
                } else {
                    this.errMinClientLeadDayAdd = false;
                }
            } else {
                if(Number(this.newcampaign.asec5_6) < 1) {
                    this.errMinClientLeadDayAdd = true;
                } else {
                    this.errMinClientLeadDayAdd = false;
                }
            }
        },
        validateMinLeadsPerDayBlur(type) {
            if(type == 'price_campaign') {
                if (this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.errMinClientLeadDay = false;
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                    this.profitcalculation();
                }
            } else if(type == 'create_campaign') {
                this.errMinClientLeadDayAdd = false;
                this.showInputLeadspeekPerDayAdd = this.LeadspeekEnableMinimumLeadsPerDayAdd;

                if(this.newcampaign.asec5_6 == '') {
                    this.newcampaign.asec5_6 = 1;
                }

                if(this.LeadspeekEnableMinimumLeadsPerDayAdd == true) {
                    if((Number(this.newcampaign.asec5_6) < Number(this.LeadspeekMinimumLeadsPerDayAdd)) || (this.newcampaign.asec5_6 == this.LeadspeekMinimumLeadsPerDayAdd && this.LeadspeekMinimumLeadsPerDayAdd == 1)) {
                        this.newcampaign.asec5_6 = this.LeadspeekMinimumLeadsPerDayAdd;
                    }
                }
            }
        },
        validateMinLead() {
            if((this.clientMinLeadDayEnhance !== '') && (Number(this.LeadspeekLimitLead) < Number(this.clientMinLeadDayEnhance))) {
                this.errMinLeadDay = false;
                this.LeadspeekLimitLead = this.clientMinLeadDayEnhance 
                this.profitcalculation();
            } else {
                this.validateMinLeadsPerDayBlur('price_campaign');
            }
        },
        updateWeeklyMonthlyToggle(){
         this.totalLeads.continualTopUp = this.contiDurationSelection ? (this.LeadspeekLimitLead * 7 ) * 4 : (this.LeadspeekLimitLead * 7)
         this.profitcalculation();
        },
        checkStatusFileUpload() {

            clearInterval(this.supressionInterval);

            /** START CHECK IF THERE IS ANYTHING NOT DONE */
            this.$store.dispatch('jobProgress', {
                leadspeekID: this.whiteListLeadspeekID,
                companyId: this.whiteListCompanyId,
                leadspeekApiId: this.whiteListLeadspeekApiId,
                campaignType: 'campaign',
            })
            .then(response => {
                this.supressionProgress = response.data.jobProgress;
                this.supressionDone = response.data.jobDone;

                if(this.supressionProgress.length > 0) {
                    this.supressionTimeout = setTimeout(() => {
                        this.supressionInterval = setInterval(() => {
                            this.$store.dispatch('jobProgress', {
                                leadspeekID: this.whiteListLeadspeekID,
                                companyId: this.whiteListCompanyId,
                                leadspeekApiId: this.whiteListLeadspeekApiId,
                                campaignType: 'campaign',
                            })
                            .then(response => {
                                this.supressionProgress = response.data.jobProgress;
                                this.supressionDone = response.data.jobDone;
                                
                                if(this.supressionProgress.length == 0) {
                                    clearTimeout(this.supressionTimeout);
                                    clearInterval(this.supressionInterval);
                                }
                            })
                            .catch(error => {
                                console.error(error);
                            })
                        }, 2000);
                    }, 2000);
                } else {
                    clearTimeout(this.supressionTimeout);
                    clearInterval(this.supressionInterval); 
                }
            })
            .catch(error => {
                console.error(error);
            })
            /** START CHECK IF THERE IS ANYTHING NOT DONE */
        },
        ...mapActions(["getUserSendgridList", 'getUserIntegrationList', "updateCompanyIntegrationConfiguration","geUsertKartraList","geUsertKartraDetails",'getSelectedKartraListAndTags', "getAgencyZapierDetails", "getCampaignZapierDetails", "getCampaignZapierTags", "getAgencyZapierTags"]),
        stopContinualTopUp() {
            this.$store.dispatch('stopContinualTopUp', {
                leadspeek_api_id: this.ActiveLeadspeekID,
                lp_limit_freq: this.selectsAppModule.LeadsLimitSelect 
            })
            .then(response => {
                if(!response.data.status) {
                    this.$notify({
                        type: 'danger',
                        message: response.data.message,
                        icon: 'fa fa-save'
                    })
                } else {
                    this.isContainulTopUpStop = response.data.stop_continue === 'T' ? true : false;
                    this.GetClientList(this.currSortBy,this.currOrderBy);   
                    // console.log(response);
                }
            })
            .catch(error => {
                console.error(error);
            })
        },
        validationLeadToBuy(input) {
            if (Number(input) < 50) {
                this.err_totalleads = true;
            } else {
                this.err_totalleads = false;
            }
        },
        ExportLeadsData(index, row) {
            var leadsExportStart = this.format_date(this.$moment(row.created_at).format('YYYY-MM-DD') + " 00:00:00",true,false);
            var leadsExportEnd = this.format_date(this.$moment().format('YYYY-MM-DD') + " 23:59:59", true, false);
            if(row.created_at != '' && row.id != '') {
                //window.open(process.env.VUE_APP_DATASERVER_URL + '/leadspeek/report/lead/export/' + this.companyID + '/' + this.ClientActiveID + '/' + this.LeaddatePickerStart + '/' + this.LeaddatePickerEnd, "_blank");
                document.location = process.env.VUE_APP_DATASERVER_URL + '/leadspeek/report/lead/export/' + row.company_id + '/' + row.id + '/' + leadsExportStart + '/' + leadsExportEnd;
            }
        },
        changePage(event){
            this.GetClientList(this.currSortBy,this.currOrderBy);
        },
        handleKeydown(event) {
            if (event.key === ' ' || event.key === ',') {
                event.preventDefault(); // Prevent the default action (space or comma)
                this.selectedRowData.report_sent_to += '\n'; // Add a newline
            }
        },
        handlePaste(event) {
            event.preventDefault(); // Prevent the default paste action
            // Get the pasted data and replace commas with newline characters
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            const modifiedText = pastedText.replace(/,/g, '\n');
            // Insert the modified text at the current cursor position
            const cursorPos = event.target.selectionStart;
            const textBeforeCursor = this.selectedRowData.report_sent_to.substring(0, cursorPos);
            const textAfterCursor = this.selectedRowData.report_sent_to.substring(cursorPos);
            this.selectedRowData.report_sent_to = textBeforeCursor + modifiedText + textAfterCursor;
        },
        handleGsheetKeydowncreate(event) {
            if (event.key === ' ' || event.key === ',') {
                event.preventDefault(); // Prevent the default action (space or comma)
                this.ClientReportSentTo += '\n'; // Add a newline
            }
        },
        handleGSheetPasteCreate(event) {
            event.preventDefault(); // Prevent the default paste action
            // Get the pasted data and replace commas with newline characters
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            const modifiedText = pastedText.replace(/,/g, '\n');
            // Insert the modified text at the current cursor position
            const cursorPos = event.target.selectionStart;
            const textBeforeCursor = this.ClientReportSentTo.substring(0, cursorPos);
            const textAfterCursor = this.ClientReportSentTo.substring(cursorPos);
            this.ClientReportSentTo = textBeforeCursor + modifiedText + textAfterCursor;
        },
        handleZipKeydown(event) {
            if (event.key === ' ' || event.key === ',') {
                event.preventDefault(); // Prevent the default action (space or comma)
                // Check if the current line has content before adding a newline
                this.selectedRowData.leadspeek_locator_zip += '\n'; // Add a newline
                }
                this.selectedRowData.leadspeek_locator_zip =  this.selectedRowData.leadspeek_locator_zip.replace(/\n{2,}/g, '\n');
        },
        handleZipPasteCreate(event) {
            event.preventDefault(); // Prevent the default paste action
            // Get the pasted data and replace commas with newline characters
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            let modifiedText = pastedText.replace(/,/g, '\n');
            modifiedText = modifiedText.replace(/\s+/g, '\n');
            // Insert the modified text at the current cursor position
            const cursorPos = event.target.selectionStart;
            const textBeforeCursor = this.newcampaign.asec5_3.substring(0, cursorPos);
            const textAfterCursor = this.newcampaign.asec5_3.substring(cursorPos);
            this.newcampaign.asec5_3 = textBeforeCursor + modifiedText + textAfterCursor;
            this.newcampaign.asec5_3 = this.newcampaign.asec5_3.replace(/\n{2,}/g, '\n');
        },  
         handleZipKeydowncreate(event) {
            if (event.key === ' ' || event.key === ',') {
                event.preventDefault(); // Prevent the default action (space or comma)
                // Check if the current line has content before adding a newline
                 this.newcampaign.asec5_3 += '\n'; // Add a newline
                }
                this.newcampaign.asec5_3 = this.newcampaign.asec5_3.replace(/\n{2,}/g, '\n');
        },
        handleApproxLeadCountZipKeydowncreate(event) {
            if (event.key === ' ' || event.key === ',') {
                event.preventDefault(); // Prevent the default action (space or comma)
                // Check if the current line has content before adding a newline
                 this.formApproxLeadCount.zip_code += '\n'; // Add a newline
                }
                this.formApproxLeadCount.zip_code = this.formApproxLeadCount.zip_code.replace(/\n{2,}/g, '\n');
        },
        handleZipPaste(event) {
            event.preventDefault(); // Prevent the default paste action
            // Get the pasted data and replace commas with newline characters
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            let modifiedText = pastedText.replace(/,/g, '\n');
            modifiedText = modifiedText.replace(/\s+/g, '\n');
            // Insert the modified text at the current cursor position
            const cursorPos = event.target.selectionStart;
            const textBeforeCursor = this.selectedRowData.leadspeek_locator_zip.substring(0, cursorPos);
            const textAfterCursor = this.selectedRowData.leadspeek_locator_zip.substring(cursorPos);
            this.selectedRowData.leadspeek_locator_zip = textBeforeCursor + modifiedText + textAfterCursor;
            this.selectedRowData.leadspeek_locator_zip =   this.selectedRowData.leadspeek_locator_zip.replace(/\n{2,}/g, '\n');
        },
        async handleIntegrationClick(index, row) {
            this.selectedRowData = row
            this.currentRowIndex = index
            // console.log(this.selectedRowData.company_id,this.selectedRowData.company_parent,'hello')
            let data = await this.getUserIntegrationList({ companyID: this.selectedRowData.company_id, companyParent: this.selectedRowData.company_parent })
            let conditionSpreadsheet = []

            if(row.spreadsheet_id != ''){
                conditionSpreadsheet.push({
                    name: 'Google Sheet',
                    description: 'Deliver Exceptional Email Experiences with SendGrid',
                    logo: 'fa-brands fa-google-drive',
                    active: '3',
                    slug: 'googlesheet',
                    custom_icon: null,
                    custom_description: null,
                    custom_img: null,
                    custom_name: null,
                    custom_slug: null,
                })
            }
            this.integrations = conditionSpreadsheet

            if (data.length > 0) {
                data.forEach(item => {
                    if(item.company_integration_details.slug === 'sendgrid'){
                        this.selectedRowData.sendgrid_is_active =  this.selectedRowData.sendgrid_is_active === 1
                    }
                    this.integrations.push(item.company_integration_details)
                });
            }
            this.ghl_tags = [];
            this.ghl_tags_remove = [];
            this.selectedRowData.ghl_is_active = 0;
            this.selectedIntegration = 'googlesheet'
            this.nameIntegration = row.spreadsheet_id != '' ? 'Google Sheet' : '';
            this.sendGridListOptions =  this.getUserSendgridList({ companyID: this.selectedRowData.company_id })
            this.modals.integrations = true;
        },
        // saveIntegrationConfiguration is handled by IntegrationModalBody
        validateIntegrationFields() {
            return true
            if (this.selectedRowData.sendgrid_action && this.selectedRowData.sendgrid_action.length < 1) {
                this.$notify({
                    type: 'primary',
                    message: 'Please select at least one action',
                    icon: 'fas fa-bug'
                });
                return false
            }
            if (this.selectedRowData.sendgrid_action && this.selectedRowData.sendgrid_action.includes('add-to-list') && this.selectedRowData.sendgrid_list.length < 1) {
                this.$notify({
                    type: 'primary',
                    message: 'Please select at least one sendgrid list',
                    icon: 'fas fa-bug'
                });
                return false
            }
         
        },
        prefillSendgridIntegrationData() {
            this.selectedSendgridAction =this.selectedRowData.sendgrid_action ? this.selectedRowData.sendgrid_action : '' ;
            this.selectedSendgridList = this.selectedRowData.sendgrid_list ? this.selectedRowData.sendgrid_list : ''
        },
        async integrationItemClick(item) {
            this.nameIntegration = item.custom_name || item.name;
            
            if(item.slug === this.selectedIntegration){
                return;
            }

            this.selectedIntegration = item.slug
            if( this.selectedIntegration === 'sendgrid'){
                this.isSendgridInfoFetching = true;
                this.errors.sendgrid = false;
                this.selectedSendgridAction = []
                this.selectedSendgridList = []
                let res = await this.getUserSendgridList({ companyID: this.selectedRowData.company_id })
                if(res.error){
                    this.isSendgridInfoFetching = false;
                    this.errors.sendgrid = true;
                    return;
                }
                this.sendGridListOptions = res
                this.prefillSendgridIntegrationData()
                this.isSendgridInfoFetching = false;
            }else if( this.selectedIntegration === 'gohighlevel'){
                this.isGoHighInfoFetching = true;
                this.errors.goHighLevel = false;
                this.ghl_tags = [];
                this.ghl_tags_remove = [];
                this.selectedRowData.ghl_is_active = 0;

                this.$store.dispatch('getGoHighLevelTags', {
                    companyID: this.selectedRowData.company_id,
                }).then(response => {

                    this.goHighLevelTagsOptions = response.param.tags.map((item) => {
                        return { id: item.id + '|' + item.name, name: item.name }
                    });
                    
                    //this.selectedRowData.ghl_is_active =  this.selectedRowData.ghl_is_active === 1
                    
                    this.$store.dispatch('getGhlUserTags', {
                            campaignID: this.selectedRowData.leadspeek_api_id,
                            companyID: this.selectedRowData.company_id,
                            userIP: this.$store.getters.userData.ip_login,
                        }).then(response => {
                            this.ghl_tags = [];
                            response.param.map((item) => {
                                // this.ghl_tags.push(item.id + '|' + item.name);
                                if(typeof(item.id) == 'undefined') {
                                    this.ghl_tags.push(item.name);
                                } else {
                                    this.ghl_tags.push(item.id + '|' + item.name);
                                }
                            });
                            this.selectedRowData.ghl_is_active = response.ghlactive === 1;
                            this.ghl_tags_remove = response.tagremove;
                            this.isGoHighInfoFetching = false;
                            
                            setTimeout(() => {
                                const inputGhlTags = this.$refs.selectGhlTags.$el.querySelector('.select-integration-ghl .el-select__input');
                                if (inputGhlTags) {
                                    inputGhlTags.addEventListener('keyup', this.keydownInputGhlTags);
                                }
                                this.changeGhlTags('getGhlUserTags');
                            }, 100);
                        },error => {
                            this.isGoHighInfoFetching = false;
                            this.errors.goHighLevel = true;
                        });
                },error => {
                    this.isGoHighInfoFetching = false;
                    this.errors.goHighLevel = true;
                });

                this.getStatusKeywordToTags('gohighlevel')
            }else if( this.selectedIntegration === 'kartra'){
                this.onKartraIntegrationSelect()
            }else if( this.selectedIntegration === 'googlesheet'){     
                this.isGoogleInfoFetching = true;
                this.sendGridListOptions = await this.getUserSendgridList({ companyID: this.selectedRowData.company_id })
                this.isGoogleInfoFetching = false;
            }else if(this.selectedIntegration === 'zapier') {
                this.isZapierFetching = true;
                const campaign_webhook = await this.getCampaignZapierDetails({campaign_id: this.selectedRowData.id})
                const campaign_tags = await this.getCampaignZapierTags({campaign_id: this.selectedRowData.id})
                const agency_webhook = await this.getAgencyZapierDetails({ company_id: this.selectedRowData.company_id})
                const agency_tags = await this.getAgencyZapierTags({ company_id: this.selectedRowData.company_id})
                this.zapierTagsOptions = []
                if(agency_tags){
                    this.zapierTagsOptions = agency_tags.map((item) => {
                            return {name: item.name }
                        });
                }
                if ((campaign_webhook.zap_webhook != '' && campaign_webhook.zap_webhook != null) && campaign_webhook.zap_webhook != agency_webhook.api_key) {
                    this.defaultWebhook = false;
                    this.zapierEnable = campaign_webhook.zap_is_active === 1
                    this.zapierWebhook = campaign_webhook.zap_webhook
                    this.leadspeek_api_id = this.selectedRowData.leadspeek_api_id
                    this.zapierTags = [];
                    if (campaign_tags.zap_tags) {
                        campaign_tags.zap_tags.map((item) => {
                                this.zapierTags.push(item.name);
                        });
                    }
                }else{
                    this.defaultWebhook = true;
                    this.zapierEnable = campaign_webhook.zap_is_active === 1
                    this.zapierWebhook = []
                    if (agency_webhook[0].api_key) {
                        agency_webhook[0].api_key.forEach(item => {
                            this.zapierWebhook.push(item)
                        });
                    }
                    this.leadspeek_api_id = this.selectedRowData.leadspeek_api_id
                    this.zapierTags = [];
                    if (campaign_tags.zap_tags) {
                        campaign_tags.zap_tags.map((item) => {
                                this.zapierTags.push(item.name);
                        });
                    }
                }
                this.isZapierFetching = false;
            }else if(this.selectedIntegration === 'mailboxpower') {
                this.isMailBoxPowerFetching = true;
                this.errors.mailboxPower = false;
                this.mbp_groups = [];
                this.mbp_groups_remove = [];
                this.selectedRowData.mbp_is_active = 0;

                this.$store.dispatch('getMailBoxPowerGroups', {
                    companyID: this.selectedRowData.company_id,
                    campaignID: this.selectedRowData.leadspeek_api_id,
                })
                .then(response => {
                    // console.log({action: 'getMailBoxPowerGroups', response: response});
                    this.mailBoxPowerOptions = response.param.map((item) => {
                        return { id: item.ID + '|' + item.NAME, name: item.NAME }
                    });
                    this.mailBoxPowerStates = response.states;
                    // console.log({'this.isMailBoxPowerFetching': this.isMailBoxPowerFetching,'this.mailBoxPowerOptions': this.mailBoxPowerOptions});

                    this.$store.dispatch('getMailBoxPowerUserGroups', {
                        campaignID: this.selectedRowData.leadspeek_api_id,
                        companyID: this.selectedRowData.company_id,
                    })
                    .then(response => {
                        // console.log({action: 'getMailBoxPowerUserGroups', response: response});

                        this.mbp_groups = [];
                        response.param.map((item) => {
                            this.mbp_groups.push(item.id + '|' + item.name);
                        });

                        this.mbp_states = response.mbpstates;
                        this.mbp_zip = response.mbpzip;
                        this.mbp_options = response.mbpoptions;
                        this.selectedRowData.mbp_is_active = response.mbpactive === 1;
                        this.mbp_groups_remove = response.mbpremove;
                        this.isMailBoxPowerFetching = false;
                        // console.log({'this.mbp_groups': this.mbp_groups,'this.mbp_states': this.mbp_states});
                    })
                    .catch(error => {
                        this.isMailBoxPowerFetching = false;
                        this.errors.mailboxPower = true;
                    });
                })
                .catch(error => {
                    this.isMailBoxPowerFetching = false;
                    this.errors.mailboxPower = true;
                })
            } else if (this.selectedIntegration === 'clickfunnels'){
                this.getListTagsClickFunnels();
            }
        },
        async onKartraIntegrationSelect(){
                this.isKartraInfoFetching = true
                this.errors.kartra = false
                this.selectedKartraList = []
                this.selectedKartraTags = []
                const data = {
                    campaign_id: this.selectedRowData.id,
                    company_id: this.selectedRowData.company_parent,
                    integration_slug: this.selectedIntegration,
                }
                let res = await this.geUsertKartraDetails({ companyID: this.selectedRowData.company_id })
                if(res.error){
                    this.errors.kartra = true;
                    this.isKartraInfoFetching = false
                    return;
                }

                let resListandTag = await this.getSelectedKartraListAndTags({data})
                this.selectedRowData.ghl_is_active = resListandTag.data.kartra_is_active  === 1 
                this.selectedKartraTags = resListandTag.data.tag
                this.selectedKartraList = resListandTag.data.list
                this.kartraTagsOptions = res.tags ?  res.tags : []
                this.kartraListOptions = res.lists ?  res.lists : []
                this.isKartraInfoFetching = false
                // this.prefillSendgridIntegrationData()
        },
        async redirectToAddIntegration() {
            if (this.$store.getters.userData.user_type === 'client') {
                this.$router.push({ name: 'Integration List' })
            } else {
                this.$router.push({ name: 'Client List' })
            }
        },
        handleExpandChange(row, expandedRows) {
            const rowIndex = this.tableData.findIndex((item) => item.id === row.id);
            
            if (expandedRows.includes(row)) {
                // Row is expanded
               this.rowClickedEdit(rowIndex,row);
            //    this.updatekeywordcontextualBulkEdit(row)


               //console.log('Expanded:', row.name, 'Index:', rowIndex);
            } else {
                // Row is collapsed
                this.ClearClientFormEdit(row);
                //console.log('Collapsed:', row.name, 'Index:', rowIndex);
            }
        },
        handleApproxLeadCountEdit(row, expandedRows) {
            const rowIndex = this.tableData.findIndex((item) => item.id === row.id);
            
            if (expandedRows.includes(row)) {
                // Row is expanded
               this.rowClickedApprox(rowIndex,row);
               this.selectedRowData = row
            //    this.updatekeywordcontextualBulkEdit(row)


               //console.log('Expanded:', row.name, 'Index:', rowIndex);
            } else {
                // Row is collapsed
                this.ClearClientFormEdit(row);
                //console.log('Collapsed:', row.name, 'Index:', rowIndex);
            }
        },
        show_helpguide(helptype) {
            if (helptype == 'suppression') {
                this.modals.helpguideTitle = "Whitelist Your Current Database"
                this.modals.helpguideTxt = "We do not want to charge you for anyone who is currently in your database. You can Whitelist them by providing an encrypted list of email addresses, or by uploading a list of email addresses and we will encrypt them for you. Do not include any other information in the file aside from the email address. <a href='/samplefile/suppressionlist.csv' target='_blank'>Click here</a> to download a Sample File"
            }

            this.modals.helpguide = true;
        },
        searchKeyWord() {
                  this.pagination.currentPage = 1;
                  this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
            
        },
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
            this.uploadFieldName = 'suppressionfile';
            $('input[type="file"]').val(null);
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

           //console.log(formData);

           const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Access-Control-Allow-Origin' : '*',
                }
           };

            /* UPLOAD FILE */
                axios.post(process.env.VUE_APP_APISERVER_URL + '/api/leadspeek/suppressionlist/upload', formData, config)
                .then(response => {
                    //console.log(response.data);
                    if(response.data.result == 'success') {
                        this.currentStatus = STATUS_SUCCESS;
                        this.reset();
                    }else{
                        this.currentStatus = STATUS_FAILED;
                        this.reset();
                    }
                })
                .catch(error => {
                    //console.log(error);
                    this.currentStatus = STATUS_FAILED;
                    this.reset();
                    //reject(error)
                })
            /* UPLOAD FILE */
            setTimeout(() => {
                this.checkStatusFileUpload()
            }, 2000)
        },
        purgeSuppressionList(action){
            swal.fire({
                title: 'Record Purge Confirmation',
                text: "Are you sure you want to purge existing records?",
                showCancelButton: true,
                confirmButtonColor: 'blue',
                cancelButtonColor: 'red',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.isConfirmed) {
                    // Perform the deletion
                    this.$store.dispatch('purgeSuppressionList', {
                        paramID: this.whiteListLeadspeekID,
                        campaignType: action,
                    }).then(response => {
                        this.supressionDone = [];
                        if (response.result === 'success') {
                            swal.fire({
                                icon: 'success',
                                title: response.title,
                                text: response.msg,
                                confirmButtonText: 'OK'
                            });
                        } else {
                            swal.fire({
                                icon: 'error',
                                title: response.title,
                                text: response.msg,
                                confirmButtonText: 'OK'
                            });
                        }
                    }).catch(error => {
                        swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'There was an error processing your request.',
                            confirmButtonText: 'OK'
                        });
                    });
                }
            });
        },
        filesChange(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();

            if (!fileList.length) return;
            const file = fileList[0];
            const validCSV = /\.(csv)$/i.test(file.name);

            if (!validCSV) {
                this.$notify({
                    type: 'danger',
                    message: 'Invalid file format. This upload only supports CSV files.',
                    icon: 'fas fa-bug'
                })

                return;
            }

            // append the files to FormData
            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                const fileMapping = fileList[x];
                const cleanFileName = fileMapping.name
                    .replace(/\s+/g, "_")
                    .replace(/[^a-zA-Z0-9_.-]/g, "")
                    .toLowerCase();

                const newFile = new File([fileMapping], cleanFileName, { type: fileMapping.type });

                formData.append(fieldName, newFile, cleanFileName);
            });
            
            formData.append("leadspeekID",this.whiteListLeadspeekID);
            
            // save it
            this.save(formData);
        },
        showWhitelist(index,row) {
            this.whiteListLeadspeekID = row.id;
            this.whiteListCompanyId = row.company_id;
            this.whiteListLeadspeekApiId = row.leadspeek_api_id;
            this.modals.whitelist = true;

            this.checkStatusFileUpload();
        },
        format_date(valdate,convert = false,toClientTime = false){
            if (valdate) {

                if (convert) {
                    // Set the source and target timezones
                    const sourceTimezone = this.$global.clientTimezone; 
                    const targetTimezone = this.$global.systemTimezone;
                    if (toClientTime) {
                        const sourceTimezone = this.$global.systemTimezone; 
                        const targetTimezone = this.$global.clientTimezone; 
                    }

                    // Parse the input time in the source timezone
                    const sourceMoment = this.$moment.tz(valdate, sourceTimezone);

                    // Convert the time to the target timezone
                    const targetMoment = sourceMoment.clone().tz(targetTimezone);

                    return targetMoment.format('YYYY-MM-DD HH:mm:ss');
                }else{

                    return this.$moment(valdate).format('YYYY-MM-DD HH:mm:ss');
                }
            }
        },
        nationaltargetselectedEdit(currentChangeItem,row, event) {  
            const isChecked = event.target.checked

            this.selectedRowData.target_nt = currentChangeItem == 'target_nt' && isChecked ? true : false;
            this.selectedRowData.target_state = currentChangeItem == 'target_state' && isChecked ? true : false;
            this.selectedRowData.target_zip = currentChangeItem == 'target_zip' && isChecked ? true : false;
            // if (status) {
            //     if (row.target_nt == true) {
            //         row.target_state = false;
            //         row.target_city = false;
            //         row.target_zip = false;
            //         //this.radios.locationTarget = "Focus";
            //     }
            // }else{
            //     if (row.target_state || row.target_city || row.target_zip) {
            //         row.target_nt = false;
            //     }
            // }
        },
        updatekeywordbulk() {
            const filterInput = this.tags.keywordlist.map(sentence => {
                const words = sentence.split(' ');

                const filteredWords = words.filter(word => {
                    return !this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase());
                });

                const containsStopWords = words.some(word => 
                    this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase())
                );

                this.isErrorStopWords = containsStopWords

                return filteredWords.join(' ');
            }).filter(sentence => sentence.trim().length > 0);

            this.tags.keywordlistbulk = filterInput;
            this.tags.keywordlist = filterInput;

            this.sanitizedkeyword('keyword');
        },
        updatekeywordbulkEdit(row) {
           
            const filterInput = row.leadspeek_locator_keyword.map(sentence => {
                const words = sentence.split(' ');

                const filteredWords = words.filter(word => {
                    return !this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase());
                });

                const containsStopWords = words.some(word => 
                    this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase())
                );

                this.isErrorStopWordsEdit = containsStopWords

                return filteredWords.join(' ');
            }).filter(sentence => sentence.trim().length > 0);
            row.leadspeek_locator_keyword = filterInput
            row.leadspeek_locator_keyword_bulk = filterInput;
          
            this.sanitizedkeywordEdit('keyword',row);
        },
        updateApproxLeadCountKeywordBulkEdit(row) {
           
           const filterInput = row.keyword.map(sentence => {
               const words = sentence.split(' ');

               const filteredWords = words.filter(word => {
                   return !this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase());
               });

               const containsStopWords = words.some(word => 
                   this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase())
               );

               this.isErrorStopWordsEdit = containsStopWords

               return filteredWords.join(' ');
           }).filter(sentence => sentence.trim().length > 0);
           row.keyword = filterInput
           row.keyword_bulk = filterInput;
         
           this.sanitizedKeywordEditApproxLeadCount(row);
       },
        updatekeywordcontextualBulkEdit(row) {
            row.leadspeek_locator_keyword_contextual_bulk = row.leadspeek_locator_keyword_contextual;
            this.sanitizedkeywordEdit('contextual',row);
        },
        updatekeywordcontextual(keyword) {
            this.tags.keywordlistContextual = keyword.split(",");
            // this.sanitizedkeyword('contextual');
        }, 
        updatekeywordcontextualBulk(keyword) {
            this.tags.keywordlistContextualBulk = this.tags.keywordlistContextual;
            this.sanitizedkeyword('contextual');
        },
        handleKeydownComma(event,type){
            if (this.tags[type] && event.key === 'Enter') {
                event.preventDefault();
                const keywords = this.tags.keywordlist.join(',') + ',';
                this.tags[type] = keywords

                if(keywords == ','){
                    this.tags[type] = ''
                }

                 // add comma with sanitized
                this.sanitizedkeyword('keyword')
                const newKeywords = this.tags.keywordlist.join(',') + ',';
                this.tags[type] = newKeywords
            }
        }, 
        handleKeydownCommaEdit(event,row,type){
            if ( event.key === 'Enter') {
                event.preventDefault();
                const keywords = row.leadspeek_locator_keyword.join(',') + ','
                row[type] = keywords
                if(row[type] == ','){
                    row[type] = ''
                }

                // add comma with sanitized
                this.sanitizedkeywordEdit(event, row)
                const newKeywords = row.leadspeek_locator_keyword.join(',') + ','
                row[type] = newKeywords
            }
        },
        handleKeydownCommaEditApproxLeadCount(event,row,type){
            if ( event.key === 'Enter') {
                event.preventDefault();
                const keywords = row.keyword.join(',')
                row[type] = keywords
                if(row[type] == ','){
                    row[type] = ''
                }

                // add comma with sanitized
                this.sanitizedKeywordEditApproxLeadCount(row)
                const newKeywords = row.keyword.join(',')
                row[type] = newKeywords
            }
        },
        updatekeyword(event,keyword) {
           const inputKeyword = keyword.split(',')

           const filterInput = inputKeyword.map(sentence => {
                const words = sentence.split(' ');

                const filteredWords = words.filter(word => {
                    return !this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase());
                });

                const containsStopWords = words.some(word => 
                    this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase())
                );

                this.isErrorStopWords = containsStopWords

                return filteredWords.join(' ');
            }).filter(sentence => sentence.trim().length > 0);
           
            if(this.customTrim(keyword) == "") {
                this.tags.keywordlist = [];
            }else{
                this.tags.keywordlist = filterInput
            }
        },
         updatekeywordEdit(keyword,row) {
            const inputKeyword = keyword.split(',')
            const filterInput = inputKeyword.map(sentence => {
                const words = sentence.split(' ');

                const filteredWords = words.filter(word => {
                    return !this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase());
                });

                const containsStopWords = words.some(word => 
                    this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase())
                );

                this.isErrorStopWordsEdit = containsStopWords

                return filteredWords.join(' ');
            }).filter(sentence => sentence.trim().length > 0);

            if(this.customTrim(keyword) == "") {
                row.leadspeek_locator_keyword = [];
            }else{
                row.leadspeek_locator_keyword = filterInput;
            }
        },
        updateKeywordEditApproxLeadCount(keyword,row) {
            const inputKeyword = keyword.split(',')
            const filterInput = inputKeyword.map(sentence => {
                const words = sentence.split(' ');

                const filteredWords = words.filter(word => {
                    return !this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase());
                });

                const containsStopWords = words.some(word => 
                    this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase())
                );

                this.isErrorStopWordsEdit = containsStopWords

                return filteredWords.join(' ');
            }).filter(sentence => sentence.trim().length > 0);

            if(this.customTrim(keyword) == "") {
                row.keyword = [];
            }else{
                row.keyword = filterInput;
            }
        },
       
        updatekeywordcontextualEdit(keyword,row) {
            row.leadspeek_locator_keyword_contextual = keyword.split(",");
        },
        customTrim(str) {
            return str.replace(/^\s+|\s+$/g, '');
        },
        sanitizedkeyword(section) { 
            const minLengthRegex = /^.{3,}$/;
            const maxWordsRegex = /^(?:\S+\s*){1,3}$/;
            if (section == 'keyword') {
                var keylenght = this.tags.keywordlist.length;    
                var tmp = this.tags.keywordlist;
                this.tags.keywordlist = [];
                var k = 0;
                for(var i=0;i<keylenght;i++) {
                    // Check both conditions using the regular expressions.
                    var _words = this.customTrim(tmp[i]);
                    if (minLengthRegex.test(_words) && maxWordsRegex.test(_words)) {
                        this.tags.keywordlist[k] = _words;
                        k++;
                    }
                }
                // let trimmedKeywords = [];
                // let totalLength = 0;
                
                let keywords = Array.isArray(this.tags.keywordlistbulk) 
                    ? this.tags.keywordlistbulk.join(',').split(',')
                    : this.tags.keywordlistbulk.split(',');
                let trimmedKeywords = [];
                let totalLength = 0;

                for (let keyword of keywords) {
                    keyword = keyword.trim();
                    if (totalLength + keyword.length + (trimmedKeywords.length > 0 ? 1 : 0) <= 500) {
                        trimmedKeywords.push(keyword);
                        totalLength += keyword.length + (trimmedKeywords.length > 1 ? 1 : 0); // Add 1 for comma
                    } else {
                        this.$notify({
                            type: 'warning',
                            message: `Keyword "${keyword}" was removed to stay within the 500 character limit.`
                        });
                        break;
                    }
                }
                trimmedKeywords = trimmedKeywords.filter(keyword => {
                    if ((keyword.match(/\s+/g) || []).length <= 2) {
                        return true;
                    } else {
                        this.$notify({
                            type: 'warning',
                            message: `Keyword "${keyword}" was removed because it contains more than 3 words.`
                        });
                        return false;
                    }
                });
                
                const filterInput = trimmedKeywords.map(sentence => {
                    const words = sentence.split(' ');

                    const filteredWords = words.filter(word => {
                        return !this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase());
                    });

                    const containsStopWords = words.some(word => 
                        this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase())
                    );

                    this.isErrorStopWords = containsStopWords

                    return filteredWords.join(' ');
                }).filter(sentence => sentence.trim().length > 0);
                            

                // this.tags.keywordlistbulk = trimmedKeywords.join(',');
                // this.tags.keywordlist = trimmedKeywords;
           

                // if (trimmedKeywords.length < this.tags.keywordlist.length) {
                //     this.$notify({
                //         type: 'warning',
                //         message: 'Some keywords were removed to stay within the 500 character limit.'
                //     });
                // }

                this.tags.keywordlist = filterInput;
                this.tags.keywordlistbulk = filterInput;
            }else{
                var keylenght = this.tags.keywordlistContextual.length;
                var tmp = this.tags.keywordlistContextual;
                this.tags.keywordlistContextual = [];
                var k = 0;
                for(var i=0;i<keylenght;i++) {
                    // Check both conditions using the regular expressions.
                    var _words = this.customTrim(tmp[i]);
                    if (minLengthRegex.test(_words) && maxWordsRegex.test(_words)) {
                        this.tags.keywordlistContextual[k] = _words;
                        k++;
                    }
                }
                this.tags.keywordlistContextualBulk = this.tags.keywordlistContextual;
            }
        },
        sanitizedkeywordEdit(section,row) { 
           
            const minLengthRegex = /^.{3,}$/;
            const maxWordsRegex = /^(?:\S+\s*){1,3}$/;
            // if (section == 'keyword') {
                var keylenght = row.leadspeek_locator_keyword.length;    
                var tmp = row.leadspeek_locator_keyword;
                row.leadspeek_locator_keyword = [];
                var k = 0;
                for(var i=0;i<keylenght;i++) {
                    // Check both conditions using the regular expressions.
                    var _words = this.customTrim(tmp[i]);
                    if (minLengthRegex.test(_words) && maxWordsRegex.test(_words)) {
                        row.leadspeek_locator_keyword[k] = _words;
                        k++;
                    }
                }
               
                // let tmp = row.leadspeek_locator_keyword;
                // row.leadspeek_locator_keyword = row.leadspeek_locator_keyword.filter(keyword => keyword.length <= 500);
                // if (row.leadspeek_locator_keyword.length < tmp.length) {
                //     this.$notify({
                //         type: 'warning',
                //         message: 'Keywords exceeding 500 characters have been removed.'
                //     });
                // }
                // let trimmedKeywords = [];
                // let totalLength = 0;
                
                // for (let keyword of row.leadspeek_locator_keyword) {
                //     if (totalLength + keyword.length <= 500) {
                //         trimmedKeywords.push(keyword);
                //         totalLength += keyword.length;
                //     } else if (totalLength < 500) {
                //         let remainingSpace = 500 - totalLength;
                //         // trimmedKeywords.push(keyword.substring(0, remainingSpace));
                //         this.$notify({
                //             type: 'warning',
                //             message: `Keyword "${keyword}" has been removed to stay within the 500 character limit.`
                //         });
                //         break;
                //     } else {
                //         break;
                //     }
                // }
                // console.log(row.leadspeek_locator_keyword_bulk,'excess')
                let keywords = Array.isArray(row.leadspeek_locator_keyword_bulk) 
                    ? row.leadspeek_locator_keyword_bulk.join(',').split(',')
                    : row.leadspeek_locator_keyword_bulk.split(',');
                // let keywords = row.leadspeek_locator_keyword_bulk.split(',');
                let trimmedKeywords = [];
                let totalLength = 0;

                for (let keyword of keywords) {
                    keyword = keyword.trim();
                    if (totalLength + keyword.length + (trimmedKeywords.length > 0 ? 1 : 0) <= 500) {
                        trimmedKeywords.push(keyword);
                        totalLength += keyword.length + (trimmedKeywords.length > 1 ? 1 : 0); // Add 1 for comma
                    } else {
                        this.$notify({
                            type: 'warning',
                            message: `Keyword "${keyword}" was removed to stay within the 500 character limit.`
                        });
                        break;
                    }
                }

                trimmedKeywords = trimmedKeywords.filter(keyword => {
                    if ((keyword.match(/\s+/g) || []).length <= 2) {
                        return true;
                    } else {
                        this.$notify({
                            type: 'warning',
                            message: `Keyword "${keyword}" was removed because it contains more than 3 words.`
                        });
                        return false;
                    }
                });
                
                const filterInput = trimmedKeywords.map(sentence => {
                    const words = sentence.split(' ');

                    const filteredWords = words.filter(word => {
                        return !this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase());
                    });

                    const containsStopWords = words.some(word => 
                        this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase())
                    );

                    this.isErrorStopWords = containsStopWords

                    return filteredWords.join(' ');
                }).filter(sentence => sentence.trim().length > 0);

                // row.leadspeek_locator_keyword_bulk = trimmedKeywords.join(',');
                // row.leadspeek_locator_keyword  = trimmedKeywords;
                // let trimmedKeywords = row.leadspeek_locator_keyword.map(keyword => {
                //     if (keyword.length > 500) {
                //         this.$notify({
                //             type: 'warning',
                //             message: `Keyword "${keyword.substring(0, 20)}..." has been trimmed to 500 characters.`
                //         });
                //         return keyword.substring(0, 500);
                //     }
                //     return keyword;
                // });
                row.leadspeek_locator_keyword = filterInput;
                row.leadspeek_locator_keyword_bulk = filterInput;
               
            // }else{
            //     var keylenght = row.leadspeek_locator_keyword_contextual.length;
            //     var tmp = row.leadspeek_locator_keyword_contextual;
            //     row.leadspeek_locator_keyword_contextual = [];
            //     var k = 0;
            //     for(var i=0;i<keylenght;i++) {
            //         // Check both conditions using the regular expressions.
            //          var _words = this.customTrim(tmp[i]);
            //         if (minLengthRegex.test(_words) && maxWordsRegex.test(_words)) {
            //             row.leadspeek_locator_keyword_contextual[k] = _words;
            //             k++;
            //         }
            //     }
            //     row.leadspeek_locator_keyword_contextual_bulk = row.leadspeek_locator_keyword_contextual;
            // }
        },
        sanitizedKeywordEditApproxLeadCount(row) { 
            const minLengthRegex = /^.{3,}$/;
            const maxWordsRegex = /^(?:\S+\s*){1,3}$/;
            var keylenght = row.keyword.length;    
            var tmp = row.keyword;
            row.keyword = [];
            var k = 0;
            for(var i=0;i<keylenght;i++) {
                // Check both conditions using the regular expressions.
                var _words = this.customTrim(tmp[i]);
                if (minLengthRegex.test(_words) && maxWordsRegex.test(_words)) {
                    row.keyword[k] = _words;
                    k++;
                }
            }
               
            let keywords = Array.isArray(row.keyword_bulk) 
                ? row.keyword_bulk.join(',').split(',')
                : row.keyword_bulk.split(',');
            let trimmedKeywords = [];
            let totalLength = 0;

            for (let keyword of keywords) {
                keyword = keyword.trim();
                if (totalLength + keyword.length + (trimmedKeywords.length > 0 ? 1 : 0) <= 500) {
                    trimmedKeywords.push(keyword);
                    totalLength += keyword.length + (trimmedKeywords.length > 1 ? 1 : 0); // Add 1 for comma
                } else {
                    this.$notify({
                        type: 'warning',
                        message: `Keyword "${keyword}" was removed to stay within the 500 character limit.`
                    });
                    break;
                }
            }

            trimmedKeywords = trimmedKeywords.filter(keyword => {
                if ((keyword.match(/\s+/g) || []).length <= 2) {
                    return true;
                } else {
                    this.$notify({
                        type: 'warning',
                        message: `Keyword "${keyword}" was removed because it contains more than 3 words.`
                    });
                    return false;
                }
            });

            // if (trimmedKeywords.length > 1) {
            //     this.$notify({
            //         type: 'warning',
            //         message: 'Only one keyword is allowed. Extra keywords were removed.'
            //     });
            //     trimmedKeywords = [trimmedKeywords[0]];
            // }
                
            const filterInput = trimmedKeywords.map(sentence => {
                const words = sentence.split(' ');

                const filteredWords = words.filter(word => {
                    return !this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase());
                });

                const containsStopWords = words.some(word => 
                    this.stopWords.some(stopWord => word.toLowerCase() === stopWord.toLowerCase())
                );

                this.isErrorStopWords = containsStopWords

                return filteredWords.join(' ');
            }).filter(sentence => sentence.trim().length > 0);

            row.keyword = filterInput;
            row.keyword_bulk = filterInput;
        },
        archiveCampaign(index,row) {
            if (row.disabled == 'T' && row.active_user == 'F') {
                swal.fire({
                    title: "Are you sure you want to archive this campaign?",
                    text: '',
                    icon: '',
                    showCancelButton: true,
                    customClass: {
                    confirmButton: 'btn btn-default btn-fill',
                    cancelButton: 'btn btn-danger btn-fill'
                    },
                    confirmButtonText: 'Archive this campaign',
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('archiveCampaign', {
                            lpuserid: row.id,
                            status: 'T',
                        }).then(response => {
                            if(response.result == 'success') {
                                this.deleteRow(row);
                                
                                this.$notify({
                                    type: 'success',
                                    message: 'Campaign has been archive.',
                                    icon: 'far fa-save'
                                });  
                            }

                            // LOGS ACTION
                            let descriptionLogs = `campaign id: ${row.leadspeek_api_id} | campaign type: ${row.leadspeek_type} `
                            const userData = this.$store.getters.userData
                            // const data = {
                            //     userID: userData.id,
                            //     action: 'Campaign archive',
                            //     desc: descriptionLogs,
                            //     userIP: this.$store.getters.userData.ip_login,
                            // }
                            // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                            // if (userViewMode) {
                            //     const userRoot = decryptData(localStorage.getItem('userDataOri'));
                            //     data.userID = userRoot.id;
                            // }
                            // this.userLogSaved({ data});
                            this.$store.dispatch('onSaveUserLogs', {
                                desc: descriptionLogs,
                                action: 'Campaign archive',
                                target_id: row.user_id,
                            })
                            // LOGS ACTION
                        },error => {
                            this.$notify({
                                type: 'primary',
                                message: 'Sorry there is something wrong, pleast try again later',
                                icon: 'fas fa-bug'
                            }); 

                        });
                    }

                });

            }else{
                    this.$notify({
                    type: 'primary',
                    message: 'Please stop the campaign before archive it.',
                    icon: 'fas fa-bug'
                }); 
            }
        },
        nationaltargetselected(currentChangeItem, event) {
            const isChecked = event.target.checked

            this.newcampaign.asec5_4_0_0 = currentChangeItem == 'asec5_4_0_0' && isChecked ? true : false;;
            this.newcampaign.asec5_4_0_1 = currentChangeItem == 'asec5_4_0_1' && isChecked ? true : false;;
            this.newcampaign.asec5_4_0_3 = currentChangeItem == 'asec5_4_0_3' && isChecked ? true : false;;
            this.newcampaign.geo = currentChangeItem == 'geo' && isChecked ? true : false;

            if(this.newcampaign.asec5_4_0_0){
                this.selectedCity = []
                this.selects.state = [];
                this.selects.city = [];
                this.selects.Citystate = [];
            }

            if(this.newcampaign.asec5_4_0_1){
                this.newcampaign.asec5_4_0_0 = false;
                this.newcampaign.asec5_3 = '';
            }

            if(this.newcampaign.asec5_4_0_3){
                this.selectedCity = []
                this.selects.state = [];
                this.selects.city = [];
                this.selects.Citystate = [];
            }
            if(this.newcampaign.geo){
                this.newcampaign.target_lat = this.usDefaultCenter[0];
                this.newcampaign.target_lng = this.usDefaultCenter[1];
                this.newcampaign.target_radius_miles = 25;
            }
          
            this.clearErrorInput('nationaltargetingselected')
            
            // if (status) {
            //     //console.log(this.questionnaire.asec5_4_0_0);
            //     if (this.newcampaign.asec5_4_0_0 == true) {
            //         // this.newcampaign.asec5_4_0_1 = false;
            //         // this.newcampaign.asec5_4_0_2 = false;
            //         // this.newcampaign.asec5_4_0_3 = false;
            //         this.radios.locationTarget = "Focus";

            //         this.selects.state = [];
            //         this.selects.city = [];
            //         this.selects.Citystate = [];
            //         this.newcampaign.asec5_3 = '';
            //         //this.newcampaign.asec5_4_1 = this.selects.country;
            //         //this.newcampaign.asec5_10 = this.tags.keywordlist;
            //         //this.newcampaign.asec5_10_1 = this.tags.keywordlistContextual;
            //         //this.newcampaign.asec5_4_2 = this.selects.city;
            //     }
            // }else{
            //     if (this.newcampaign.asec5_4_0_1 || this.newcampaign.asec5_4_0_2 || this.newcampaign.asec5_4_0_3) {
            //         // this.newcampaign.asec5_4_0_0 = false;
            //     }
            //     if(!this.newcampaign.asec5_4_0_1) {
            //         this.selects.state = [];
            //     }

            //     if(!this.newcampaign.asec5_4_0_2) {
            //         this.selects.city = [];
            //         this.selects.Citystate = [];
            //     }

            //     if(!this.newcampaign.asec5_4_0_3) {
            //         this.newcampaign.asec5_3 = '';
            //     }
            // }
        },
         redirectaddclient() {
            this.$router.push({ name: 'Client List' })
         },
         onCityStateChange() {
            if (this.selects.Citystate != '') {
                $('#boxCityState').addClass('disabled-area');
                this.$store.dispatch('getCityStateList',{
                citystate:this.selects.Citystate,
                }).then(response => {
                    //console.log(response.params.geo_targets);
                    this.selects.citylist = response.params.geo_targets;
                    $('#boxCityState').removeClass('disabled-area');
                },error => {
                    $('#boxCityState').removeClass('disabled-area');
                });
            }else{
                $('#boxCityState').removeClass('disabled-area');
            }
            return false;
         },
         onCityStateChangeEdit(row) {
            if (row.selects_citystate != '') {
                $('#boxCityState').addClass('disabled-area');
                this.$store.dispatch('getCityStateList',{
                citystate:row.selects_citystate,
                }).then(response => {
                    //console.log(response.params.geo_targets);
                    row.selects_citylist = response.params.geo_targets;
                    $('#boxCityState').removeClass('disabled-area');
                },error => {
                    $('#boxCityState').removeClass('disabled-area');
                });
            }else{
                $('#boxCityState').removeClass('disabled-area');
            }
            return false;
         },
         getStateList() {
            this.$store.dispatch('getLocationBigDbm', {
                type: 'state',
                param: '',
                limit: '',
                search: '',
            }).then(response => {
                this.selects.statelist = response.data
            }, error => {
                console.error(error);
            })
         },
         tooltip_campaign(index,row,stat) {
            if (stat == 'play') {
                if (row.disabled == 'T' && row.active_user == 'F' && row.customer_card_id != '') {
                    return "Start Campaign";
                }else if (row.disabled == 'F' && row.active_user == 'T' && row.customer_card_id != '') {
                    return "Campaign is Running";
                }else if (row.active_user == 'F' && (row.customer_card_id == '' && this.$store.getters.userData.manual_bill == 'F')) {
                    return "Campaign can not start before your complete payment information"
                }else{
                    return "Start Campaign";
                }
            }else if (stat == 'pause') {
                if (row.disabled == 'F' && row.active_user == 'F' && row.customer_card_id != '') {
                    return "Pause Campaign";
                }else if (row.disabled == 'T' && row.active_user == 'T' && row.customer_card_id != '') {
                    return "Campaign is Paused";
                }else if (row.active_user == 'F' && (row.customer_card_id == '' && this.$store.getters.userData.manual_bill == 'F')) {
                    return "Campaign can not start before your complete payment information"
                }else{
                    return "Pause Campaign";
                }
                
            }else if (stat == 'stop') {
                if (row.active_user == 'T' && row.customer_card_id != '') {
                    return "Stop Campaign";
                }else if (row.active_user == 'F' && row.customer_card_id != '') {
                    return "Campaign is Stopped";
                }else if (row.active_user == 'F' && (row.customer_card_id == '' && this.$store.getters.userData.manual_bill == 'F')) {
                    return "Campaign can not start before your complete payment information"
                }else{
                    return "Stop Campaign";
                }
            }

            return ""
        },
        setModuleCost() {
            if((this.totalLeads.oneTime < 50) && (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid')) {
                this.$notify({
                    type: 'danger',
                    message: 'Minimum 50 lead',
                    icon: 'far fa-save'
                });
            } 
            if (this.LeadspeekCostperlead == 0 && this.LeadspeekMinCostMonth > 0 && this.userType == 'client' && this.LeadspeekLimitLead != this.LeadspeekLimitLeadDB){
                // console.log(this.LeadspeekCostperlead);
                // console.log(this.LeadspeekMinCostMonth);
                // console.log(this.userType);
                // console.log(this.LeadspeekLimitLead);
                // console.log(this.LeadspeekLimitLeadDB);
                this.$notify({
                    type: 'danger',
                    message: "Contact per day can't be changed..",
                    icon: 'far fa-save'
                });
            }
            else {
            //if (this.selectsAppModule.AppModuleSelect == 'Leads Peek') {
                /** SET MODULE COST */
                this.$store.dispatch('ClientModuleCost', {
                        companyID: this.companyID,
                        ClientID: this.ClientActiveID,
                        ModuleName: this.selectsAppModule.AppModuleSelect,
                        CostSet: this.LeadspeekCostperlead,
                        CostMonth: this.LeadspeekMinCostMonth,
                        CostMaxLead: this.LeadspeekMaxLead,
                        LimitLead: this.LeadspeekLimitLead,
                        enableMinimumLimitLeads: this.LeadspeekEnableMinimumLeadsPerDay,
                        minimumLimitLeads: this.LeadspeekMinimumLeadsPerDay,
                        LimitLeadFreq: this.selectsAppModule.LeadsLimitSelect,
                        LimitLeadStart: this.$moment(this.LeadspeekMaxDateStart).format('YYYY-MM-DD'),
                        LimitLeadEnd: this.format_date(this.$moment(this.LeadspeekDateEnd).format('YYYY-MM-DD') + " 23:59:59",true,false),
                        PaymentTerm: this.selectsPaymentTerm.PaymentTermSelect,
                        contiDurationSelection: this.contiDurationSelection,
                        topupoptions: this.prepaidType,
                        leadsbuy: this.prepaidType == 'continual' ? this.totalLeads.continualTopUp : this.totalLeads.oneTime,
                        PlatformFee: this.LeadspeekPlatformFee,
                        LeadspeekApiId: this.ActiveLeadspeekID,
                        idUser: this.$store.getters.userData.id,
                        ipAddress: this.$store.getters.userData.ip_login,
                        idSys: this.$global.idsys
                    }).then(response => {
                        //console.log(response[0]);
                        /** UPDATE ROW */
                        //this.tableData[this.LeadspeekClientActiveIndex].lp_min_cost_month = this.LeadspeekMinCostMonth
                        
                        // USER LOGS EDIT
                        let descriptionLogs = "";
                        const { billingFrequency, topUpOptions, setupFee, campaignFee, costPerLead, leadPerDay, contiDurationSelection, enableMinimumLeadPerDay, minimumLeadPerDay } = this.prevCampaignFinancial;
                        const updates = [
                            { label: "Billing Frequency", prev: billingFrequency, new: this.selectsPaymentTerm.PaymentTermSelect },
                            { label: "Duration Continual Selection", prev: contiDurationSelection ? 'Monthly' : 'Weekly', new: this.contiDurationSelection ? 'Monthly' : 'Weekly' },
                            { label: "Top Up Options", prev: topUpOptions, new: this.prepaidType },
                            { label: "Set Up Fee", prev: setupFee, new: this.LeadspeekPlatformFee },
                            { label: "Campaign Fee", prev: campaignFee, new: this.LeadspeekMinCostMonth },
                            { label: "Cost Per Lead", prev: costPerLead, new: this.LeadspeekCostperlead },
                            { label: "Limit Leads Per Day", prev: leadPerDay, new: this.LeadspeekLimitLead },
                            { label: "Enable Minimum Leads Per Day", prev: enableMinimumLeadPerDay, new: this.LeadspeekEnableMinimumLeadsPerDay },
                            { label: "Minimum Leads Per Day", prev: minimumLeadPerDay, new: this.LeadspeekMinimumLeadsPerDay },
                        ];

                        updates.forEach(({ label, prev, new: newValue }) => {
                            if (prev !== newValue) {
                                descriptionLogs += `${label} : Update values from ${prev} to ${newValue} | `;
                            } else {
                                descriptionLogs += `${label} : No changes, value remains ${prev} | `;
                            }
                        });
                        
                        if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid'){
                            descriptionLogs += `Remaining Balance : ${this.remainingBalanceLeads} | `;
                            descriptionLogs += `Leads Buy : ${this.prepaidType == 'continual' ? this.totalLeads.continualTopUp : this.totalLeads.oneTime} | `;
                        }

                        descriptionLogs = descriptionLogs.trim().replace(/\|$/, "");
                        const desc = descriptionLogs ? descriptionLogs : 'No updates were made as all values remain unchanged.';

                        const userData = this.$store.getters.userData
                        // const data = {
                        //     userID: userData.id,
                        //     action: 'Edit Campaign Financial Enhance',
                        //     desc: `Campaign Id: ${this.ActiveLeadspeekID} | ${desc}`,
                        //     userIP: this.$store.getters.userData.ip_login,
                        // }
                        // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                        // if (userViewMode) {
                        //     const userRoot = decryptData(localStorage.getItem('userDataOri'));
                        //     data.userID = userRoot.id;
                        // }
                        // this.userLogSaved({ data});
                        this.$store.dispatch('onSaveUserLogs', {
                            desc: `Campaign Id: ${this.ActiveLeadspeekID} | ${desc}`,
                            action: 'Edit Campaign Financial Enhance',
                            // target_id: this.selectedRowData.user_id,
                            target_id: this.userIdCampaign,
                        })
                        // USER LOGS EDIT

                        this.modals.pricesetup = false;

                        if(typeof(response.result) != 'undefined' && (response.result == 'failed_campaign_already_active' || response.result == 'failed_campaign_already_paused')) {
                            this.GetClientList();
                            this.$notify({
                                type: 'danger',
                                message: response.message,
                                icon: 'fas fa-bug'
                            });
                            return false;
                        }
                        
                        /** UPDATE ROW */
                        this.tableData.filter((item) => {
                            if (item.id == this.ClientActiveID){
                                item.lp_min_cost_month = this.LeadspeekMinCostMonth
                                item.lp_max_lead_month = this.LeadspeekMaxLead
                                item.cost_perlead = this.LeadspeekCostperlead
                                item.lp_limit_leads = this.LeadspeekLimitLead
                                item.enable_minimum_limit_leads = (this.LeadspeekEnableMinimumLeadsPerDay)?'T':'F'
                                item.minimum_limit_leads = this.LeadspeekMinimumLeadsPerDay;
                                item.lp_limit_freq = this.selectsAppModule.LeadsLimitSelect
                                item.lp_limit_startdate = this.LeadspeekMaxDateStart
                                item.lp_enddate = this.LeadspeekDateEnd
                                item.paymentterm = this.selectsPaymentTerm.PaymentTermSelect
                                item.platformfee = this.LeadspeekPlatformFee
                                item.topupoptions = this.prepaidType
                                item.leadsbuy = this.prepaidType == 'continual' ? this.totalLeads.continualTopUp : this.totalLeads.oneTime
                                item.stopcontinual =  (this.isContainulTopUpStop)? 'T':'F'
                                item.continual_buy_options = this.contiDurationSelection;
                            }
                        })
                        /** UPDATE ROW */

                        this.$notify({
                            type: 'success',
                            message: 'Data has been updated successfully',
                            icon: 'far fa-save'
                        });  
                    },error => {
                        
                });
                /** SET MODULE COST */
            }
        },
        paymentTermChange() {
            if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                this.txtLeadService = 'per week';
                this.txtLeadIncluded = 'in that weekly charge';
                this.txtLeadOver ='from the weekly charge';

                if (typeof(this.costagency.enhance.Weekly.EnhanceLeadsPerday) == 'undefined') {
                    this.costagency.enhance.Weekly.EnhanceLeadsPerday = (this.clientMinLeadDayEnhance !== '') ? this.clientMinLeadDayEnhance : "10"
                }

                this.m_LeadspeekPlatformFee = this.costagency.enhance.Weekly.EnhancePlatformFee;
                this.m_LeadspeekCostperlead = this.costagency.enhance.Weekly.EnhanceCostperlead;
                this.m_LeadspeekMinCostMonth = this.costagency.enhance.Weekly.EnhanceMinCostMonth;
                this.m_LeadspeekLimitLead = this.clientdefaultprice.enhance.Weekly.EnhanceLeadsPerday;
                this.m_LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.enhance.Weekly.EnhanceLeadsPerday) != 'undefined' ? this.clientdefaultprice.enhance.Weekly.EnhanceLeadsPerday : 10;

                this.LeadspeekPlatformFee = this.m_LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.m_LeadspeekCostperlead; 
                this.LeadspeekMinCostMonth = this.m_LeadspeekMinCostMonth;
                this.LeadspeekLimitLead = this.m_LeadspeekLimitLead;
                this.LeadspeekMinimumLeadsPerDay = this.m_LeadspeekMinimumLeadsPerDay >= 1 ? this.m_LeadspeekMinimumLeadsPerDay : 1;

                /*if (this.selectsPaymentTerm.PaymentTermSelect != this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.locator.Weekly.LocatorPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.locator.Weekly.LocatorCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.locator.Weekly.LocatorMinCostMonth;
                }else{*/
                if (this.selectsPaymentTerm.PaymentTermSelect == this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.EnhancePlatformFee
                    this.LeadspeekCostperlead = this.defaultCostCampaign.EnhanceCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.EnhanceMinCostMonth;
                    this.LeadspeekLimitLead = this.defaultCostCampaign.EnhanceLeadsPerday;

                    if(this.defaultCostCampaign.EnhanceMinimumLeadDay != null && this.defaultCostCampaign.EnhanceMinimumLeadDay != '') {
                        this.LeadspeekMinimumLeadsPerDay = this.defaultCostCampaign.EnhanceMinimumLeadDay;
                    }
                }else{
                    if (this.clientdefaultprice != "") {
                        this.LeadspeekPlatformFee = this.clientdefaultprice.enhance.Weekly.EnhancePlatformFee;
                        this.LeadspeekCostperlead = this.clientdefaultprice.enhance.Weekly.EnhanceCostperlead;
                        this.LeadspeekMinCostMonth = this.clientdefaultprice.enhance.Weekly.EnhanceMinCostMonth;
                    }else{
                        this.LeadspeekPlatformFee = this.defaultCostCampaign.enhance.Weekly.EnhancePlatformFee;
                        this.LeadspeekCostperlead = this.defaultCostCampaign.enhance.Weekly.EnhanceCostperlead;
                        this.LeadspeekMinCostMonth = this.defaultCostCampaign.enhance.Weekly.EnhanceMinCostMonth;
                        //this.LeadspeekLimitLead = this.defaultCostCampaign.enhance.Weekly.EnhanceLeadsPerday;
                    }
                }

                if((this.clientMinLeadDayEnhance !== '') && (Number(this.LeadspeekLimitLead) < Number(this.clientMinLeadDayEnhance))) {
                    this.LeadspeekLimitLead = this.clientMinLeadDayEnhance;
                }

                /* VALIDATE MINIMUM LED PER DAY */
                if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                }
                /* VALIDATE MINIMUM LED PER DAY */

                if(this.clientTypeLead.type !== 'clientcaplead') {
                    this.validateCostPerLeadUnderCostAgency('Weekly');
                }
            }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                this.txtLeadService = 'per month';
                this.txtLeadIncluded = 'in that monthly charge';
                this.txtLeadOver ='from the monthly charge';

                if (typeof(this.costagency.enhance.Monthly.EnhanceLeadsPerday) == 'undefined') {
                    // this.costagency.enhance.Monthly.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.enhance.Monthly.EnhanceLeadsPerday = (this.clientMinLeadDayEnhance !== '') ? this.clientMinLeadDayEnhance : "10";
                }

                this.m_LeadspeekPlatformFee = this.costagency.enhance.Monthly.EnhancePlatformFee;
                this.m_LeadspeekCostperlead = this.costagency.enhance.Monthly.EnhanceCostperlead;
                this.m_LeadspeekMinCostMonth = this.costagency.enhance.Monthly.EnhanceMinCostMonth;
                this.m_LeadspeekLimitLead = this.clientdefaultprice.enhance.Monthly.EnhanceLeadsPerday;
                this.m_LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.enhance.Monthly.EnhanceLeadsPerday) != 'undefined' ? this.clientdefaultprice.enhance.Monthly.EnhanceLeadsPerday : 10;

                this.LeadspeekPlatformFee = this.m_LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.m_LeadspeekCostperlead; 
                this.LeadspeekMinCostMonth = this.m_LeadspeekMinCostMonth;
                this.LeadspeekLimitLead = this.m_LeadspeekLimitLead;
                this.LeadspeekMinimumLeadsPerDay = this.m_LeadspeekMinimumLeadsPerDay >= 1 ? this.m_LeadspeekMinimumLeadsPerDay : 1;

                /*if (this.selectsPaymentTerm.PaymentTermSelect != this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.locator.Monthly.LocatorPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.locator.Monthly.LocatorCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.locator.Monthly.LocatorMinCostMonth;
                }else{*/
                if (this.selectsPaymentTerm.PaymentTermSelect == this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.EnhancePlatformFee
                    this.LeadspeekCostperlead = this.defaultCostCampaign.EnhanceCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.EnhanceMinCostMonth;
                    this.LeadspeekLimitLead = this.defaultCostCampaign.EnhanceLeadsPerday;

                    if(this.defaultCostCampaign.EnhanceMinimumLeadDay != null && this.defaultCostCampaign.EnhanceMinimumLeadDay != '') {
                        this.LeadspeekMinimumLeadsPerDay = this.defaultCostCampaign.EnhanceMinimumLeadDay;
                    }
                }else{
                    if (this.clientdefaultprice != "") {
                        this.LeadspeekPlatformFee = this.clientdefaultprice.enhance.Monthly.EnhancePlatformFee;
                        this.LeadspeekCostperlead = this.clientdefaultprice.enhance.Monthly.EnhanceCostperlead;
                        this.LeadspeekMinCostMonth = this.clientdefaultprice.enhance.Monthly.EnhanceMinCostMonth;
                    }else{
                        this.LeadspeekPlatformFee = this.defaultCostCampaign.enhance.Monthly.EnhancePlatformFee;
                        this.LeadspeekCostperlead = this.defaultCostCampaign.enhance.Monthly.EnhanceCostperlead;
                        this.LeadspeekMinCostMonth = this.defaultCostCampaign.enhance.Monthly.EnhanceMinCostMonth;
                        //this.LeadspeekLimitLead = this.defaultCostCampaign.enhance.Monthly.EnhanceLeadsPerday;
                    }
                }

                if((this.clientMinLeadDayEnhance !== '') && (Number(this.LeadspeekLimitLead) < Number(this.clientMinLeadDayEnhance))) {
                    this.LeadspeekLimitLead = this.clientMinLeadDayEnhance;
                }

                /* VALIDATE MINIMUM LED PER DAY */
                if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                }
                /* VALIDATE MINIMUM LED PER DAY */

                if(this.clientTypeLead.type !== 'clientcaplead') {
                    this.validateCostPerLeadUnderCostAgency('Monthly');

                }
            } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                this.txtLeadService = 'per month';
                this.txtLeadIncluded = 'in that week charge';
                this.txtLeadOver = 'from the week charge';

                if (typeof(this.costagency.enhance.Prepaid) == 'undefined') {
                    this.$set(this.costagency.enhance,'Prepaid',{
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                        LocatorLeadsPerday: '10',
                    });
                }

                if (typeof(this.costagency.enhance.Prepaid.EnhanceLeadsPerday) == 'undefined') {
                    this.$set(this.costagency.enhance.Prepaid, 'EnhanceLeadsPerday', '10');
                    this.costagency.enhance.Prepaid.EnhanceLeadsPerday = '10';
                    
                }
                
                this.m_LeadspeekPlatformFee = this.costagency.enhance.Prepaid.EnhancePlatformFee;
                this.m_LeadspeekCostperlead = this.costagency.enhance.Prepaid.EnhanceCostperlead;
                this.m_LeadspeekMinCostMonth = this.costagency.enhance.Prepaid.EnhanceMinCostMonth;
                this.m_LeadspeekLimitLead = this.clientdefaultprice.enhance.Prepaid.EnhanceLeadsPerday;
                this.m_LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.enhance.Prepaid.EnhanceLeadsPerday) != 'undefined' ? this.clientdefaultprice.enhance.Prepaid.EnhanceLeadsPerday : 10;

                this.LeadspeekPlatformFee = this.m_LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.m_LeadspeekCostperlead; 
                this.LeadspeekMinCostMonth = this.m_LeadspeekMinCostMonth;
                this.LeadspeekLimitLead = this.m_LeadspeekLimitLead;
                this.LeadspeekMinimumLeadsPerDay = this.m_LeadspeekMinimumLeadsPerDay >= 1 ? this.m_LeadspeekMinimumLeadsPerDay : 1;

                if (this.selectsPaymentTerm.PaymentTermSelect == this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.EnhancePlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.EnhanceCostperlead
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.EnhanceMinCostMonth;
                    this.LeadspeekLimitLead = this.defaultCostCampaign.EnhanceLeadsPerday;
                    
                    if(this.defaultCostCampaign.EnhanceMinimumLeadDay != null && this.defaultCostCampaign.EnhanceMinimumLeadDay != '') {
                        this.LeadspeekMinimumLeadsPerDay = this.defaultCostCampaign.EnhanceMinimumLeadDay;
                    }
                }else{
                    if (this.clientdefaultprice != "") {
                        this.LeadspeekPlatformFee = this.clientdefaultprice.enhance.Prepaid.EnhancePlatformFee;
                        this.LeadspeekCostperlead = this.clientdefaultprice.enhance.Prepaid.EnhanceCostperlead
                        this.LeadspeekMinCostMonth = this.clientdefaultprice.enhance.Prepaid.EnhanceMinCostMonth;
                    }else{
                        this.LeadspeekPlatformFee = this.defaultCostCampaign.enhance.Prepaid.EnhancePlatformFee;
                        this.LeadspeekCostperlead = this.defaultCostCampaign.enhance.Prepaid.EnhanceCostperlead
                        this.LeadspeekMinCostMonth = this.defaultCostCampaign.enhance.Prepaid.EnhanceMinCostMonth;
                        //this.LeadspeekLimitLead = this.defaultCostCampaign.enhance.Prepaid.EnhanceLeadsPerday;
                    }
                }

                if(this.clientTypeLead.type !== 'clientcaplead') {
                    this.validateCostPerLeadUnderCostAgency('Prepaid');
                }

                if((this.clientMinLeadDayEnhance !== '') && (Number(this.LeadspeekLimitLead) < Number(this.clientMinLeadDayEnhance))) {
                    this.LeadspeekLimitLead = this.clientMinLeadDayEnhance;
                }

                /* VALIDATE MINIMUM LED PER DAY */
                if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                }
                /* VALIDATE MINIMUM LED PER DAY */
            } else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                this.txtLeadService = '';
                this.txtLeadIncluded = '';
                this.txtLeadOver ='';

                this.m_LeadspeekPlatformFee = this.costagency.enhance.OneTime.EnhancePlatformFee;
                this.m_LeadspeekCostperlead = this.costagency.enhance.OneTime.EnhanceCostperlead;
                this.m_LeadspeekMinCostMonth = this.costagency.enhance.OneTime.EnhanceMinCostMonth;
                this.m_LeadspeekLimitLead = this.clientdefaultprice.enhance.OneTime.EnhanceLeadsPerday;
                this.m_LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.enhance.OneTime.EnhanceLeadsPerday) != 'undefined' ? this.clientdefaultprice.enhance.OneTime.EnhanceLeadsPerday : 10;

                this.LeadspeekPlatformFee = this.m_LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.m_LeadspeekCostperlead; 
                this.LeadspeekMinCostMonth = this.m_LeadspeekMinCostMonth;
                this.LeadspeekLimitLead = this.m_LeadspeekLimitLead;
                this.LeadspeekMinimumLeadsPerDay = this.m_LeadspeekMinimumLeadsPerDay >= 1 ? this.m_LeadspeekMinimumLeadsPerDay : 1;

                /*if (this.selectsPaymentTerm.PaymentTermSelect != this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.locator.OneTime.LocatorPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.locator.OneTime.LocatorCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.locator.OneTime.LocatorMinCostMonth;
                }else{*/
                if (this.selectsPaymentTerm.PaymentTermSelect == this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.EnhancePlatformFee
                    this.LeadspeekCostperlead = this.defaultCostCampaign.EnhanceCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.EnhanceMinCostMonth;
                    this.LeadspeekLimitLead = this.defaultCostCampaign.EnhanceLeadsPerday;

                    if(this.defaultCostCampaign.EnhanceMinimumLeadDay != null && this.defaultCostCampaign.EnhanceMinimumLeadDay != '') {
                        this.LeadspeekMinimumLeadsPerDay = this.defaultCostCampaign.EnhanceMinimumLeadDay;
                    }
                }

                if((this.clientMinLeadDayEnhance !== '') && (Number(this.LeadspeekLimitLead) < Number(this.clientMinLeadDayEnhance))) {
                    this.LeadspeekLimitLead = this.clientMinLeadDayEnhance;
                }

                /* VALIDATE MINIMUM LED PER DAY */
                if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                }
                /* VALIDATE MINIMUM LED PER DAY */

                if(this.clientTypeLead.type !== 'clientcaplead') {
                    this.validateCostPerLeadUnderCostAgency('One Time');
                }
            }

            // USER LOGS EDIT
            const updateLogs = {
                ...this.prevCampaignFinancial,
                contiDurationSelection: this.contiDurationSelection ? 'Monthly' : 'Weekly',
                topUpOptions: this.prepaidType,
                setupFee: this.LeadspeekPlatformFee,
                campaignFee: this.LeadspeekMinCostMonth,
                costPerLead: this.LeadspeekCostperlead,
                leadPerDay: this.LeadspeekLimitLead,
                enableMinimumLeadPerDay: this.LeadspeekEnableMinimumLeadsPerDay,
                minimumLeadPerDay: this.LeadspeekMinimumLeadsPerDay,
            }

            this.prevCampaignFinancial = updateLogs
            // USER LOGS EDIT

            /** CALCULATION PROFIT PER TERM */
                this.profitcalculation();
            /** CALCULATION PROFIT PER TERM */
        },
        checkLeadsType() {
            if (this.selectsAppModule.LeadsLimitSelect == 'Max') {
                this.LeadspeekMaxDateVisible = true;
            }else{
                this.LeadspeekMaxDateVisible = false;
            }
        },
        formatPrice(value) {
            if (isNaN(value)) {
                return "0";
            }
            
            //let val = (value/1).toFixed(2).replace(',', '.')
            let val = (value/1).toFixed(2)
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        onInput(input, field) {
            if (input == "0") {
                if(field == 'LeadspeekLimitLead') {
                    this.LeadspeekLimitLead = 1;
                } else if (field == 'newcampaign.asec5_6') {
                    this.newcampaign.asec5_6 = 1;
                } else if(field == 'LeadspeekMinimumLeadsPerDayAdd') {
                    this.LeadspeekMinimumLeadsPerDayAdd = 1;
                } else if(field == 'LeadspeekMinimumLeadsPerDay') {
                    this.LeadspeekMinimumLeadsPerDay = 1;
                }
            }
        },
        restrictInput(event,inputType) {
            const input = event.target.value;
            // Allow backspace, arrow keys, and other non-character keys
            const char = event.key;
            if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
                return; 
            }

            if (inputType == 'integer') {
                if (!/^\d$/.test(char)) {
                    event.preventDefault();
                }
            }

            // Check if the character is not a number
            if (!char.match(/[0-9]/) && char !== '.') {
                event.preventDefault();
            }

            // Allow only one period
            if (char === '.' && input.includes('.')) {
                event.preventDefault();
            }
        },

        profitcalculation_() {
            this.t_LeadspeekPlatformFee = this.LeadspeekPlatformFee - this.m_LeadspeekPlatformFee;
            this.t_LeadspeekMinCostMonth = this.LeadspeekMinCostMonth - this.m_LeadspeekMinCostMonth;
            this.t_LeadspeekCostperlead = this.LeadspeekCostperlead - this.m_LeadspeekCostperlead;
            
            if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                this.t_profit = this.formatPrice(this.t_LeadspeekPlatformFee + this.t_LeadspeekMinCostMonth - (this.m_LeadspeekCostperlead * this.LeadspeekMaxLead));
                this.t_LeadspeekCostperlead = this.formatPrice(this.m_LeadspeekCostperlead * this.LeadspeekMaxLead);
                this.t_freqshow = '';
                this.t_LeadspeekPlatformFee = this.formatPrice(this.t_LeadspeekPlatformFee);
                this.t_LeadspeekMinCostMonth = this.formatPrice(this.t_LeadspeekMinCostMonth);
            }else{
                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    this.t_freqshow = 'week';
                    this.t_freq = '1';
                }else {
                    this.t_freqshow = 'month';
                    this.t_freq = '4';
                }
                var _estleadspermonth = ((this.LeadspeekLimitLead * 7) * this.t_freq) * this.t_LeadspeekCostperlead;
                this.t_estleadspermonth = this.formatPrice(_estleadspermonth);
                this.t_profit =  this.formatPrice(this.t_LeadspeekMinCostMonth + _estleadspermonth);
                this.t_LeadspeekCostperlead = this.formatPrice(this.t_LeadspeekCostperlead);
                this.t_LeadspeekPlatformFee = this.formatPrice(this.t_LeadspeekPlatformFee);
                this.t_LeadspeekMinCostMonth = this.formatPrice(this.t_LeadspeekMinCostMonth);
            }
        },

        calculationMinimumCostPerLead() {
            if(this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    const m_LeadspeekCostperlead = (this.LeadspeekCostperlead * this.clientTypeLead.value) / 100;
                    // const rootCostPerLeadMin = (this.costagency.enhance.Weekly.EnhanceCostperlead > this.rootcostagency.enhance.Weekly.EnhanceCostperlead) ? this.costagency.enhance.Weekly.EnhanceCostperlead : this.rootcostagency.enhance.Weekly.EnhanceCostperlead;
                    const rootCostPerLeadMin = this.costagency.enhance.Weekly.EnhanceCostperlead;
                    const rootCostPerLeadMax = (rootCostPerLeadMin) / (this.clientTypeLead.value / 100);

                    if((Number(this.LeadspeekCostperlead) < Number(rootCostPerLeadMin) && this.LeadspeekCostperlead != 0) || this.LeadspeekCostperlead === '') {
                        this.m_LeadspeekCostperlead = rootCostPerLeadMin;
                        this.minimumCostPerLead = rootCostPerLeadMin;
                        this.errMinCostAgencyPerLead = true;
                    } else {
                        this.errMinCostAgencyPerLead = false;
                    }

                    if(this.clientTypeLead.type == 'clientcapleadpercentage') {
                        if(Number(this.LeadspeekCostperlead) > Number(rootCostPerLeadMax)) {
                            this.m_LeadspeekCostperlead = m_LeadspeekCostperlead;
                            this.errMinCostAgencyPerLead = false;
                        } else if(Number(this.LeadspeekCostperlead) <= Number(rootCostPerLeadMax) && Number(this.LeadspeekCostperlead) >= Number(rootCostPerLeadMin)) {
                            this.m_LeadspeekCostperlead = rootCostPerLeadMin;
                            this.errMinCostAgencyPerLead = false;
                        } 
                    }
                } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    const m_LeadspeekCostperlead = (this.LeadspeekCostperlead * this.clientTypeLead.value) / 100;
                    // const rootCostPerLeadMin = (this.costagency.enhance.Monthly.EnhanceCostperlead > this.rootcostagency.enhance.Monthly.EnhanceCostperlead) ? this.costagency.enhance.Monthly.EnhanceCostperlead : this.rootcostagency.enhance.Monthly.EnhanceCostperlead;
                    const rootCostPerLeadMin = this.costagency.enhance.Monthly.EnhanceCostperlead;
                    const rootCostPerLeadMax = (rootCostPerLeadMin) / (this.clientTypeLead.value / 100);
                    
                    if((Number(this.LeadspeekCostperlead) < Number(rootCostPerLeadMin) && this.LeadspeekCostperlead != 0) || this.LeadspeekCostperlead === '') {
                        this.m_LeadspeekCostperlead = rootCostPerLeadMin;
                        this.minimumCostPerLead = rootCostPerLeadMin;
                        this.errMinCostAgencyPerLead = true;
                    } else {
                        this.errMinCostAgencyPerLead = false;
                    }

                    if(this.clientTypeLead.type == 'clientcapleadpercentage') {
                        if(Number(this.LeadspeekCostperlead) > Number(rootCostPerLeadMax)) {
                            this.m_LeadspeekCostperlead = m_LeadspeekCostperlead;
                            this.errMinCostAgencyPerLead = false;
                        } else if(Number(this.LeadspeekCostperlead) <= Number(rootCostPerLeadMax) && Number(this.LeadspeekCostperlead) >= Number(rootCostPerLeadMin)) {
                            this.m_LeadspeekCostperlead = rootCostPerLeadMin;
                            this.errMinCostAgencyPerLead = false;
                        } 
                    }
                } else if(this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    const m_LeadspeekCostperlead = (this.LeadspeekCostperlead * this.clientTypeLead.value) / 100;
                    // const rootCostPerLeadMin = (this.costagency.enhance.OneTime.EnhanceCostperlead > this.rootcostagency.enhance.OneTime.EnhanceCostperlead) ? this.costagency.enhance.OneTime.EnhanceCostperlead : this.rootcostagency.enhance.OneTime.EnhanceCostperlead;
                    const rootCostPerLeadMin = this.costagency.enhance.OneTime.EnhanceCostperlead;
                    const rootCostPerLeadMax = (rootCostPerLeadMin) / (this.clientTypeLead.value / 100);

                    if((Number(this.LeadspeekCostperlead) < Number(rootCostPerLeadMin) && this.LeadspeekCostperlead != 0) || this.LeadspeekCostperlead === '') {
                        this.m_LeadspeekCostperlead = rootCostPerLeadMin;
                        this.minimumCostPerLead = rootCostPerLeadMin;
                        this.errMinCostAgencyPerLead = true;
                    } else {
                        this.errMinCostAgencyPerLead = false;
                    }

                    if(this.clientTypeLead.type == 'clientcapleadpercentage') {
                        if(Number(this.LeadspeekCostperlead) > Number(rootCostPerLeadMax)) {
                            this.m_LeadspeekCostperlead = m_LeadspeekCostperlead;
                            this.errMinCostAgencyPerLead = false;
                        } else if(Number(this.LeadspeekCostperlead) <= Number(rootCostPerLeadMax) && Number(this.LeadspeekCostperlead) >= Number(rootCostPerLeadMin)) {
                            this.m_LeadspeekCostperlead = rootCostPerLeadMin;
                            this.errMinCostAgencyPerLead = false;
                        } 
                    }
                } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    const m_LeadspeekCostperlead = (this.LeadspeekCostperlead * this.clientTypeLead.value) / 100;
                    // const rootCostPerLeadMin = (this.costagency.enhance.Prepaid.EnhanceCostperlead > this.rootcostagency.enhance.Prepaid.EnhanceCostperlead) ? this.costagency.enhance.Prepaid.EnhanceCostperlead : this.rootcostagency.enhance.Prepaid.EnhanceCostperlead;
                    const rootCostPerLeadMin = this.costagency.enhance.Prepaid.EnhanceCostperlead;
                    const rootCostPerLeadMax = (rootCostPerLeadMin) / (this.clientTypeLead.value / 100);

                    if((Number(this.LeadspeekCostperlead) < Number(rootCostPerLeadMin) && this.LeadspeekCostperlead != 0) || this.LeadspeekCostperlead === '') {
                        this.m_LeadspeekCostperlead = rootCostPerLeadMin;
                        this.minimumCostPerLead = rootCostPerLeadMin;
                        this.errMinCostAgencyPerLead = true;
                    } else {
                        this.errMinCostAgencyPerLead = false;
                    }

                    if(this.clientTypeLead.type == 'clientcapleadpercentage') {
                        if(Number(this.LeadspeekCostperlead) > Number(rootCostPerLeadMax)) {
                            this.m_LeadspeekCostperlead = m_LeadspeekCostperlead;
                            this.errMinCostAgencyPerLead = false;
                        } else if(Number(this.LeadspeekCostperlead) <= Number(rootCostPerLeadMax) && Number(this.LeadspeekCostperlead) >= Number(rootCostPerLeadMin)) {
                            this.m_LeadspeekCostperlead = rootCostPerLeadMin;
                            this.errMinCostAgencyPerLead = false;
                        } 
                    }
                }
        },

        // new function profitcalculation, add estimate client cost - AGIES
        profitcalculation() {
            if(this.clientTypeLead.type === 'clientcaplead') {
                if(this.LeadspeekCostperlead > this.clientTypeLead.value) {
                    this.errMaxCostPerLead = true;
                    this.LeadspeekCostperlead = this.clientTypeLead.value;
                } else {
                    this.errMaxCostPerLead = false;
                }
            } else if(this.clientTypeLead.type != 'clientcaplead') {
                this.calculationMinimumCostPerLead();
            }

            if((this.clientMinLeadDayEnhance !== '') && (Number(this.LeadspeekLimitLead) < Number(this.clientMinLeadDayEnhance))) {
                this.errMinLeadDay = true;
            } else {
                this.errMinLeadDay = false;
            }

            /* VALIDATE MINIMUM LED PER DAY */
            if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                this.errMinClientLeadDay = true;
            } else {
                this.errMinClientLeadDay = false;
            }
            /* VALIDATE MINIMUM LED PER DAY */

            if (this.LeadspeekLimitLead == "") {
                return false;
            }
            this.t_LeadspeekPlatformFee = this.LeadspeekPlatformFee - this.m_LeadspeekPlatformFee;
            this.t_LeadspeekMinCostMonth = this.LeadspeekMinCostMonth - this.m_LeadspeekMinCostMonth;
            this.t_LeadspeekCostperlead = this.LeadspeekCostperlead - this.m_LeadspeekCostperlead;

            if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                //console.log(this.t_LeadspeekPlatformFee + ' | ' +  this.t_LeadspeekMinCostMonth + ' | ' + this.m_LeadspeekCostperlead + ' | ' + this.LeadspeekMaxLead);
                this.t_profit = this.formatPrice(this.t_LeadspeekPlatformFee + this.t_LeadspeekMinCostMonth - (this.m_LeadspeekCostperlead * this.LeadspeekMaxLead));
                this.t_LeadspeekCostperlead = this.formatPrice(this.m_LeadspeekCostperlead * this.LeadspeekMaxLead);
                this.t_freqshow = '';
            } else {
                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    this.t_freqshow = 'week';
                    this.t_freq = '1';
                } else {
                    this.t_freqshow = 'month';
                    this.t_freq = '4';
                }
                var _estleadspermonth = ((this.LeadspeekLimitLead * 7) * this.t_freq) * this.t_LeadspeekCostperlead;
                this.t_cost = this.formatPrice( this.t_LeadspeekMinCostMonth + (((this.LeadspeekCostperlead * this.LeadspeekLimitLead) * 7) * parseInt(this.t_freq)));
                this.t_estleadspermonth = this.formatPrice(_estleadspermonth);
                this.t_profit = this.formatPrice(this.t_LeadspeekMinCostMonth + _estleadspermonth);

                if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.contiDurationSelection) {
                    this.t_profit = this.formatPrice(this.t_LeadspeekPlatformFee + (_estleadspermonth));
                } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && !this.contiDurationSelection) {
                    this.t_profit = this.formatPrice(this.t_LeadspeekPlatformFee + (_estleadspermonth / 4));
                }

                this.t_LeadspeekCostperlead = this.formatPrice(this.t_LeadspeekCostperlead);

                if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.prepaidType == 'continual') {
                    this.totalLeads.continualTopUp = this.contiDurationSelection ? (this.LeadspeekLimitLead * 7) * 4: (this.LeadspeekLimitLead * 7);
                }

            }
        },

        showQuestionnaire(index,row) {

            this.questionnaire.campaign_name = row.campaign_name;
            this.questionnaire.nationaltargeting = (row.national_targeting == 'T')?true:false;
            this.questionnaire.locatorstate = row.leadspeek_locator_state;
            this.questionnaire.locatorcity = row.leadspeek_locator_city;
            this.questionnaire.locatorzip = row.leadspeek_locator_zip;

            this.questionnaire.startcampaign = row.campaign_startdate;
            this.questionnaire.endcampaign = row.campaign_enddate;
            this.questionnaire.enablehomeaddress = (row.homeaddressenabled == 'T')?true:false; 
            this.questionnaire.enablephonenumber = (row.phoneenabled == 'T')?true:false;
            this.questionnaire.locatorkeyword = row.leadspeek_locator_keyword;

            var aq = JSON.parse(row.questionnaire_answers);
            this.questionnaire.asec5_1 = aq.asec5_1;
            this.questionnaire.asec5_2 = aq.asec5_2;
            this.questionnaire.asec5_3 = aq.asec5_3;
            this.questionnaire.asec5_4_0_1 = aq.asec5_4_0_1;
            this.questionnaire.asec5_4_0_2 = aq.asec5_4_0_2,
            this.questionnaire.asec5_4_0_3 = aq.asec5_4_0_3,
            this.questionnaire.asec5_4_2 = aq.asec5_4_2;
            this.questionnaire.asec5_4 = aq.asec5_4;
            this.questionnaire.asec5_5 = aq.asec5_5;
            this.questionnaire.asec5_6 = aq.asec5_6;
            this.questionnaire.asec5_7 = aq.asec5_7;

            var tmpArray = row.file_url.split("|");
            var usrfile = "";
            for(let k=0;k<tmpArray.length;k++) {
                usrfile = usrfile + "- <a style='font-weight:bold' href='" + process.env.VUE_APP_CDNQUESTIONNAIRE + tmpArray[k] + "' target='_blank'>" + tmpArray[k] + "</a><br/>";
            }

            this.questionnaire.asec5_8 = usrfile;

            this.questionnaire.asec5_9_1 = aq.asec5_9_1;
            this.questionnaire.asec5_9_2 = aq.asec5_9_2;
            this.questionnaire.asec5_9_3 = aq.asec5_9_3;
            this.questionnaire.asec5_9_4 = aq.asec5_9_4;

            this.questionnaire.asec5_10 = aq.asec5_10;
            this.questionnaire.asec5_11 = aq.asec5_11;
            this.questionnaire.asec5_12 = aq.asec5_12;
            this.questionnaire.asec5_13 = aq.asec5_13;
            this.questionnaire.asec5_14 = aq.asec5_14;
            
            this.questionnaire.asec6_1 = (aq.asec6_1 == "GoogleSheet")?"Google Sheet":"Google Sheet";
            if (typeof(aq.asec6_2) != 'undefined'){
                this.questionnaire.asec6_2 = aq.asec6_2.replace('_',' ');
            }
            this.questionnaire.asec6_3 = (typeof(aq.asec6_3) == 'undefined')?'':aq.asec6_3;
            this.questionnaire.asec6_4 = (typeof(aq.asec6_4) == 'undefined')?'':aq.asec6_4;

            if (aq.asec6_5 == "FirstName,LastName,MailingAddress") {
                this.questionnaire.asec6_5 = "Emails, names and mailing addresses: $2.00 (Best for sending mailers.)";
            }else if (aq.asec6_5 == "FirstName,LastName") {
                this.questionnaire.asec6_5 = "Emails and Names: $1.50 (Best for email campaigns and Facebook retargeting.)";
            }else if (aq.asec6_5 == "FirstName,LastName,MailingAddress,Phone") {
                this.questionnaire.asec6_5 = "Emails, names, mailing addresses and phone number: $3.00";
            }
            
            this.questionnaire.asec6_6 = (aq.asec6_6)?"I understand and agree to follow the law and will notify anyone using these contacts of the law.":"";
            this.questionnaire.asec6_7 = aq.asec6_7;
            
            this.LeadspeekCompany = row.campaign_name + ' #' + row.leadspeek_api_id + ' (' + row.company_name + ')';
            this.modals.questionnaire = true;
        },
        resetAgencyCost() {
            this.m_LeadspeekPlatformFee = '0';
            this.m_LeadspeekCostperlead = '0';
            this.m_LeadspeekMinCostMonth = '0';
        },
        async getMasterAgencyCost() {
            this.resetAgencyCost();
            await this.$store.dispatch('getGeneralSetting', {
                companyID: this.companyID,
                settingname: 'costagency',
                idSys: this.$global.idsys,
                pk: this.ClientUserID,
            }).then(response => {
                // console.log(response.data);
                if (response.data != '') {
                    this.costagency = response.data;
                    // this.rootcostagency = response.rootcostagency;
                    // this.clientTypeLead = response.clientTypeLead;
                    // this.clientMinLeadDayEnhance = response.clientMinLeadDayEnhance;
                    this.clientdefaultprice = response.clientDefaultPrice;
                    
                    // Set Predict quota and max campaigns from costagency
                    if (response.data && response.data.predict && response.data.predict.Prepaid) {
                        this.PredictQuotaCampaigns = response.data.predict.Prepaid.PredictQuotaCampaigns || '0';
                        if(response.data.predict.Prepaid.PredictMaxCampaignsPrev){
                            this.PredictMaxCampaigns = response.data.predict.Prepaid.PredictMaxCampaignsPrev || '1';
                        }else{
                            this.PredictMaxCampaigns = response.data.predict.Prepaid.PredictMaxCampaigns || '1';
                        }
                    }

                    // if((this.clientMinLeadDayEnhance !== '') && (Number(this.LeadspeekLimitLead) < Number(this.clientMinLeadDayEnhance))) {
                    //     this.LeadspeekLimitLead = this.clientMinLeadDayEnhance;
                    // }

                    // /* VALIDATE MINIMUM LED PER DAY */
                    // if(this.LeadspeekMinimumLeadsPerDay == null) {
                    //     if(this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    //         this.LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.enhance.Weekly.EnhanceLeadsPerday) != 'undefined' ? this.clientdefaultprice.enhance.Weekly.EnhanceLeadsPerday : 10;
                    //     } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    //         this.LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.enhance.Monthly.EnhanceLeadsPerday) != 'undefined' ? this.clientdefaultprice.enhance.Monthly.EnhanceLeadsPerday : 10;
                    //     } else if(this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    //         this.LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.enhance.OneTime.EnhanceLeadsPerday) != 'undefined' ? this.clientdefaultprice.enhance.OneTime.EnhanceLeadsPerday : 10;
                    //     } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    //         this.LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.enhance.Prepaid.EnhanceLeadsPerday) != 'undefined' ? this.clientdefaultprice.enhance.Prepaid.EnhanceLeadsPerday : 10;
                    //     }
                    // }
                    
                    // this.LeadspeekMinimumLeadsPerDay = this.LeadspeekMinimumLeadsPerDay >= 1 ? this.LeadspeekMinimumLeadsPerDay : 1;

                    // if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {    
                    //     this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                    // }
                    // /* VALIDATE MINIMUM LED PER DAY */

                    // if (typeof(this.costagency.enhance.Prepaid) == 'undefined') {
                    //     this.$set(this.costagency.enhance,'Prepaid',{
                    //         EnhancePlatformFee: '0',
                    //         EnhanceCostperlead: '0',
                    //         EnhanceMinCostMonth: '0',
                    //         EnhanceLeadsPerday: '10',
                    //     });
                    // }

                    // if (typeof(this.costagency.enhance.Prepaid.EnhanceLeadsPerday) === 'undefined') {
                    //     this.$set(this.costagency.enhance.Prepaid, 'EnhanceLeadsPerday', '10');
                    //     this.costagency.enhance.Prepaid.EnhanceLeadsPerday = '10';
                    // }

                    // if (this.selectsPaymentTerm.PaymentTermSelect =='Weekly') {
                    //     if(this.clientTypeLead.type !== 'clientcaplead') {
                    //         this.validateCostPerLeadUnderCostAgency('Weekly');
                    //     }
                    //     this.m_LeadspeekPlatformFee = this.costagency.enhance.Weekly.EnhancePlatformFee;
                    //     this.m_LeadspeekCostperlead = this.costagency.enhance.Weekly.EnhanceCostperlead;
                    //     this.m_LeadspeekMinCostMonth = this.costagency.enhance.Weekly.EnhanceMinCostMonth;
                    // }else if (this.selectsPaymentTerm.PaymentTermSelect =='Monthly') {
                    //     if(this.clientTypeLead.type !== 'clientcaplead') {
                    //         this.validateCostPerLeadUnderCostAgency('Monthly');

                    //     }
                    //     this.m_LeadspeekPlatformFee = this.costagency.enhance.Monthly.EnhancePlatformFee;
                    //     this.m_LeadspeekCostperlead = this.costagency.enhance.Monthly.EnhanceCostperlead;
                    //     this.m_LeadspeekMinCostMonth = this.costagency.enhance.Monthly.EnhanceMinCostMonth;
                    // }else if (this.selectsPaymentTerm.PaymentTermSelect =='One Time') {
                    //     if(this.clientTypeLead.type !== 'clientcaplead') {
                    //         this.validateCostPerLeadUnderCostAgency('One Time');
                    //     }
                    //     this.m_LeadspeekPlatformFee = this.costagency.enhance.OneTime.EnhancePlatformFee;
                    //     this.m_LeadspeekCostperlead = this.costagency.enhance.OneTime.EnhanceCostperlead;
                    //     this.m_LeadspeekMinCostMonth = this.costagency.enhance.OneTime.EnhanceMinCostMonth;
                    // }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    //     if(this.clientTypeLead.type !== 'clientcaplead') {
                    //         this.validateCostPerLeadUnderCostAgency('Prepaid');
                    //     }
                    //     this.m_LeadspeekPlatformFee = this.costagency.enhance.Prepaid.EnhancePlatformFee;
                    //     this.m_LeadspeekCostperlead = this.costagency.enhance.Prepaid.EnhanceCostperlead;
                    //     this.m_LeadspeekMinCostMonth = this.costagency.enhance.Prepaid.EnhanceMinCostMonth;
                    //     this.m_LeadspeekLimitLead = this.costagency.enhance.Prepaid.EnhanceLeadsPerday;
                    // }

                    //     this.paymentTermChange();

                    //  /** CALCULATION PROFIT PER TERM */
                    //     this.profitcalculation();
                    // /** CALCULATION PROFIT PER TERM */
                }else{
                    // this.m_LeadspeekPlatformFee = '0';
                    // this.m_LeadspeekCostperlead = '0';
                    // this.m_LeadspeekMinCostMonth = '0';
                }
                
                // /** HACK TEMPORARY FOR TRYSERA CAMPAIGN STILL */
                // let campaignIDexception = ["2530","2558","2559","2581","2560","2555","2546","2441","2563","2562"];
                // let leadpriceException = ["0.15","0.15","0.15","0.17","0.17","0.17","0.17","0.17","0.17","0.17"];
                // const searchexecption = campaignIDexception.indexOf(this.ActiveLeadspeekID);
                
                // if (searchexecption >= 0) {
                //     this.m_LeadspeekCostperlead = leadpriceException[searchexecption];
                // }
                // /** HACK TEMPORARY FOR TRYSERA CAMPAIGN STILL */

                // /** CALCULATION PROFIT PER TERM */
                //     this.profitcalculation();
                // /** CALCULATION PROFIT PER TERM */

                // this.modals.pricesetup = true;
                
            },error => {
                    
            });
        },
        handlePriceSet(index, row) {
            this.prevCampaignFinancial = {
                billingFrequency: row.paymentterm,
                topUpOptions: row.topupoptions,
                setupFee: row.platformfee,
                campaignFee: row.lp_min_cost_month,
                costPerLead: row.cost_perlead,
                leadPerDay: row.lp_limit_leads,
                contiDurationSelection: row.continual_buy_options,
                enableMinimumLeadPerDay: row.enable_minimum_limit_leads,
                minimumLeadPerDay: row.minimum_limit_leads,
            }
            //console.log(row);
            this.activeClientCompanyID = row.company_id;
            this.ClientActiveID = row.id;
            this.selectsPaymentTerm.PaymentTermSelect = row.paymentterm;
            this.LeadspeekCostperlead = row.cost_perlead;
            this.LeadspeekMaxLead = row.lp_max_lead_month;
            this.LeadspeekMinCostMonth = row.lp_min_cost_month;
            this.LeadspeekLimitLead = row.lp_limit_leads;
            this.LeadspeekEnableMinimumLeadsPerDay = row.enable_minimum_limit_leads == 'T' ? true : false;
            this.LeadspeekMinimumLeadsPerDay = row.minimum_limit_leads;
            this.LeadspeekLimitLeadDB = row.lp_limit_leads;
            this.selectsAppModule.LeadsLimitSelect = row.lp_limit_freq;
            this.LeadspeekCompany = row.campaign_name + ' #' + row.leadspeek_api_id + ' (' + row.company_name + ')';
            this.LeadspeekclientEmail = row.email;
            this.LeadspeekClientActiveIndex = index;
            this.LeadspeekPlatformFee = row.platformfee;
            this.ActiveLeadspeekID = row.leadspeek_api_id;
            this.LeadspeekActive =  row.active;
            this.LeadspeekDisabled =  row.disabled;
            this.LeadspeekActiveUser =  row.active_user;
            this.userIdCampaign = row.user_id;

            this.totalLeads.oneTime = 50;
            if(row.paymentterm == 'Prepaid' && row.topupoptions == 'onetime') {
                this.totalLeads.oneTime = row.leadsbuy;
            }
            
            this.LeadspeekType = row.leadspeek_type;
            this.prepaidType = row.topupoptions ? row.topupoptions : 'continual';
            this.isContainulTopUpStop = (row.stopcontinual === 'T')?true:false;
            this.contiDurationSelection = row.continual_buy_options;
            
            this.defaultCostCampaign.paymentterm = row.paymentterm;
            this.defaultCostCampaign.EnhancePlatformFee = row.platformfee;
            this.defaultCostCampaign.EnhanceMinCostMonth = row.lp_min_cost_month;
            this.defaultCostCampaign.EnhanceCostperlead = row.cost_perlead;
            this.defaultCostCampaign.EnhanceLeadsPerday = row.lp_limit_leads;
            this.defaultCostCampaign.EnhanceMinimumLeadDay = row.minimum_limit_leads;

            if (row.lp_limit_startdate == '' || row.lp_limit_startdate ==  null) {
                this.LeadspeekMaxDateStart = this.$moment().format('YYYY-MM-DD HH:mm:ss');
            }else{
                this.LeadspeekMaxDateStart = this.$moment(row.lp_limit_startdate).format('YYYY-MM-DD HH:mm:ss');
            }
            if (row.lp_enddate == '' || row.lp_enddate ==  null) {
                this.LeadspeekDateEnd = '';
            }else{
                this.LeadspeekDateEnd = this.$moment(row.lp_enddate).format('YYYY-MM-DD HH:mm:ss');
            }
            if (row.lp_limit_freq == 'max') {
                this.LeadspeekMaxDateVisible = true;
            }else{
                this.LeadspeekMaxDateVisible = false;
            }
            if (
                (row.paymentterm != 'Prepaid') &&
                (
                    (row.active == 'T' && row.disabled == 'F' && row.active_user == 'T') || // play
                    (row.active == 'F' && row.disabled == 'T' && row.active_user == 'T') || // paused
                    (row.active == 'F' && row.disabled == 'F' && row.active_user == 'T')    // paused on run
                )
            ) {
                this.LeadspeekInputReadOnly = true;
            } else {
                this.LeadspeekInputReadOnly = false;
                if (row.paymentterm == 'Prepaid' && row.active_user == 'F' && row.active == 'F') {
                    this.OnlyPrepaidDisabled = false;
                }else if (row.paymentterm != 'Prepaid' && row.active_user == 'F' && row.active == 'F') {
                    this.OnlyPrepaidDisabled = false;
                }else{
                    this.OnlyPrepaidDisabled = true;
                }
            }

            /** GET MASTER AGENCY COST */
            this.getMasterAgencyCost();
            /** GET MASTER AGENCY COST */

            /* GET remaining balance leads */
            this.getRemainingBalanceLeads();
            /* GET remaining balance leads */
        },
        getRemainingBalanceLeads() {
            this.$store.dispatch(`getRemainingBalanceLeads`, {
                leadspeek_api_id: this.ActiveLeadspeekID
            })
            .then(response => {
                this.remainingBalanceLeads = response.data.remainingBalanceLeads ? response.data.remainingBalanceLeads : 0;
            })
            .catch(error => {
                console.error(error);
            })
        },
        chkHideShowCol(row) {
            if (row.hide_phone == 'T') {
                row.hide_phone = 'F';
            }else{
                row.hide_phone = 'T';
            }
        },
        companyGroupChange(_companyGroupSelected,id) {
            if (id == '') {
                for(let i=0;i<this.selectsGroupCompany.companyGroupList.length;i++) {
                    if (this.selectsGroupCompany.companyGroupList[i].id == _companyGroupSelected) {
                        this.selectsGroupCompany.companyGroupID = this.selectsGroupCompany.companyGroupList[i].id;
                        this.selectsGroupCompany.newCompanyGroupName = this.selectsGroupCompany.companyGroupList[i].group_name;
                    }
                }
            }else{
                for(let i=0;i<this.selectsGroupCompany.companyGroupList.length;i++) {
                    if (this.selectsGroupCompany.companyGroupList[i].id == _companyGroupSelected) {
                        id.group_company_id = this.selectsGroupCompany.companyGroupList[i].id;
                        id.group_name = this.selectsGroupCompany.companyGroupList[i].group_name;
                    }
                }
            }
        },
        processAddEditCompanyGroup(id) {

            if (id == '') {
                this.$store.dispatch('AddEditGroupCompany', {
                    companyGroupID: this.selectsGroupCompany.companyGroupID,
                    companyGroupName: this.selectsGroupCompany.newCompanyGroupName,
                    companyID: this.companyID,
                    moduleID: '3',
                }).then(response => {
                    //console.log(response[0]);
                    if(response.result == 'success') {
                        if(response.params.action == 'Add') {
                            this.selectsGroupCompany.companyGroupList.push({'id':response.params.id,'group_name':response.params.group_name});
                            this.$global.selectsGroupCompany.companyGroupList.push({'id':response.params.id,'group_name':response.params.group_name});
                            this.selectsGroupCompany.companyGroupSelected = response.params.id;
                            this.selectsGroupCompany.companyGroupID = response.params.id;
                            this.selectsGroupCompany.newCompanyGroupName = response.params.group_name;
                            
                        }else if(response.params.action == 'Edit') {
                            /** UPDATE */
                            for(let i=0;i<this.selectsGroupCompany.companyGroupList.length;i++) {
                                if (this.selectsGroupCompany.companyGroupList[i].id == response.params.id) {
                                    this.selectsGroupCompany.newCompanyGroupName = response.params.group_name;
                                    this.selectsGroupCompany.companyGroupList[i].group_name = response.params.group_name;
                                }
                            }

                            for(let i=0;i<this.$global.selectsGroupCompany.companyGroupList.length;i++) {
                                if (this.$global.selectsGroupCompany.companyGroupList[i].id == response.params.id) {
                                    this.$global.selectsGroupCompany.companyGroupList[i].group_name = response.params.group_name;
                                }
                            }

                            
                            /** UPDATE */
                        }

                        $('#editGroupName' + id).hide();
                        $('#listGroupName' + id).show();

                    }
                    
                    this.$notify({
                        type: 'success',
                        message: 'Invitation has been sent!',
                        icon: 'far fa-save'
                    });  

                },error => {
                
                    this.$notify({
                        type: 'primary',
                        message: 'Sorry there is something wrong, pleast try again later',
                        icon: 'fas fa-bug'
                    }); 
                });

            }else{
                 
                 this.$store.dispatch('AddEditGroupCompany', {
                    companyGroupID: id.group_company_id,
                    companyGroupName: id.group_name,
                    companyID: this.companyID,
                    moduleID: '3',
                }).then(response => {
                    //console.log(response[0]);
                    if(response.result == 'success') {
                        if(response.params.action == 'Add') {
                            this.selectsGroupCompany.companyGroupList.push({'id':response.params.id,'group_name':response.params.group_name});
                            this.$global.selectsGroupCompany.companyGroupList.push({'id':response.params.id,'group_name':response.params.group_name});
                            id.group_company_id = response.params.id;
                            id.group_name = response.params.group_name;
                            //this.selectsGroupCompany.companyGroupID = response.params.id;
                            //this.selectsGroupCompany.newCompanyGroupName = response.params.group_name;
                            
                        }else if(response.params.action == 'Edit') {
                            /** UPDATE */
                            for(let i=0;i<this.selectsGroupCompany.companyGroupList.length;i++) {
                                if (this.selectsGroupCompany.companyGroupList[i].id == response.params.id) {
                                    id.group_name = response.params.group_name;
                                    //this.selectsGroupCompany.newCompanyGroupName = response.params.group_name;
                                    this.selectsGroupCompany.companyGroupList[i].group_name = response.params.group_name;
                                }
                            }

                            for(let i=0;i<this.$global.selectsGroupCompany.companyGroupList.length;i++) {
                                if (this.$global.selectsGroupCompany.companyGroupList[i].id == response.params.id) {
                                    this.$global.selectsGroupCompany.companyGroupList[i].group_name = response.params.group_name;
                                }
                            }

                            
                            /** UPDATE */
                        }

                        id = id.id;
                        $('#editGroupName' + id).hide();
                        $('#listGroupName' + id).show();

                    }
                    
                    this.$notify({
                        type: 'success',
                        message: 'Invitation has been sent!',
                        icon: 'far fa-save'
                    });  

                },error => {
                
                    this.$notify({
                        type: 'primary',
                        message: 'Sorry there is something wrong, pleast try again later',
                        icon: 'fas fa-bug'
                    }); 
                });
            }
        },
        cancelAddeditCompanyGroup(id) {
            if(id == '') {
                this.selectsGroupCompany.companyGroupSelected = '';
                this.selectsGroupCompany.companyGroupID = '';
                this.selectsGroupCompany.newCompanyGroupName = ''
            }else{
                id = id.id;
            }
            $('#editGroupName' + id).hide();
            $('#listGroupName' + id).show();
        },
        removeCompanyGroup(act,id) {
            var _companyGroupID;
        
            if (id == ''){
                _companyGroupID = this.selectsGroupCompany.companyGroupID;
            }else{
                _companyGroupID = id.group_company_id;
            }

            swal.fire({
                title: 'Are you sure want to delete this?',
                text: `You won't be able to revert this!`,
                icon: '',
                showCancelButton: true,
                customClass: {
                confirmButton: 'btn btn-default btn-fill',
                cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Ok',
                buttonsStyling: false
            }).then(result => {
                    if (result.value) {
                        /** REMOVE COMPANY GROUP */
                        
                            this.$store.dispatch('RemoveCompanyGroup', {
                                companyID: this.companyID,
                                companyGroupID: _companyGroupID,
                            }).then(response => {
                                 
                                     this.selectsGroupCompany.companyGroupSelected = '';
                                     this.selectsGroupCompany.companyGroupID = '';
                                     this.selectsGroupCompany.newCompanyGroupName = '';
                                 
                                     id.group_company_id = '';
                                     id.group_name = '';
                                 
                                /** REMOVE THE COMPANY GROUP FROM ARRAY */
                                for(let i=0;i<this.selectsGroupCompany.companyGroupList.length;i++) {
                                    if (this.selectsGroupCompany.companyGroupList[i].id == _companyGroupID) {
                                        this.selectsGroupCompany.companyGroupList.splice(i,1);
                                    }
                                }

                                for(let i=0;i<this.$global.selectsGroupCompany.companyGroupList.length;i++) {
                                    if (this.$global.selectsGroupCompany.companyGroupList[i].id == _companyGroupID) {
                                        this.$global.selectsGroupCompany.companyGroupList.splice(i,1);
                                    }
                                }
                                /** REMOVE THE COMPANY GROUP FROM ARRAY */
                                swal.fire({
                                    title: 'Deleted!',
                                    text: `You deleted Company Group`,
                                    icon: 'success',
                                    confirmButtonClass: 'btn btn-default btn-fill',
                                    buttonsStyling: false
                                });
                            },error => {
                                
                            });
                            
                        /** REMOVE COMPANY GROUP */    
                    }
            });
            
        },
        addeditCompanyGroup(act,id) {
            if (id == '') {
                if (act == 'Add') {
                    this.selectsGroupCompany.companyGroupID = '';
                    this.selectsGroupCompany.newCompanyGroupName = '';
                }else if (act == 'Edit') {
                    if (this.selectsGroupCompany.companyGroupID == ''){
                        return;
                    }
                }
            }else{ 
                if (act == 'Add') {
                    id.group_company_id = '';
                    id.group_name = '';
                }else if (act == 'Edit') {
                    if (id.group_company_id == ''){
                        return;
                    }
                    //id.group_company_id = this.selectsGroupCompany.companyGroupID;
                    //id.group_name = this.selectsGroupCompany.newCompanyGroupName;
                }

                id = id.id;
            }
            
            $('#listGroupName' + id).hide();
            $('#editGroupName' + id).show();
           
        },
        sortcolumn: function(a,b) {
            return a.value - b.value;
        },
        sortdate: function(a,b) {
            return new Date(a.last_lead_added) - new Date(b.last_lead_added);
        },
         sortnumber: function(a,b) {
             return a - b;
        },
        process_activepauseclient(index,row,descriptionLogs) {
            /* ==================== CARA BARU ==================== */
            const userData = this.$store.getters.userData;
            const _status = (row.disabled == 'F') ? 'T' : 'F';

            this.popProcessingTxt = (row.disabled == 'F') ? 'Please wait, pausing campaign ....' : 'Please wait, activating campaign ....'
            $('#processingArea').addClass('disabled-area');
            $('#popProcessing').show();

            this.$store.dispatch('activepauseLeadsPeek', {
                companyID: this.companyID,
                leadspeekID: row.id,
                status: _status,
                activeuser: row.active_user,
                userID: row.user_id,
                ip_user: userData.ip_login,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                idSys: this.$global.idsys,
            })
            .then(response => {
                $('#processingArea').removeClass('disabled-area');
                $('#popProcessing').hide();

                $('#activePause' + index).removeClass('fas fa-pause orange').addClass('fas fa-pause gray');
                $('#activePlay' + index).removeClass('fas fa-play gray').addClass('fas fa-play green nocursor');

                if (typeof (response.result) != 'undefined' && response.result == 'failed') {
                    // log action
                    const action = 'Campaign Failed Active';
                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action:  action,
                        target_id: row.user_id,
                    })
                    // log action

                    // get campaign and notify
                    this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
                    return this.$notify({
                        type: 'danger',
                        message: response.msg,
                        icon: 'fas fa-bug'
                    }); 
                    // get campaign and notify
                } else if (typeof (response.result) !== 'undefined' && response.result === 'failedPayment') { // jika payment failed
                    // log action
                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action: "Campaign failed payment",
                        target_id: row.user_id,
                    })
                    // log action
                    
                    // get campaign and notify
                    this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
                    return this.$notify({
                        type: 'danger',
                        message: response.msg,
                        icon: 'fas fa-bug'
                    }); 
                    // get campaign and notify
                } else if (typeof(response.result) !== 'undefined' && (response.result == 'failed_campaign_already_active' || response.result == 'failed_campaign_already_paused')) { // jika payment already active or pause
                    // log action
                    const action = (response.result == 'failed_campaign_already_active') ? 'Campaign Is Already Active' : 'Campaign Is Already Pause';
                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action:  action,
                        target_id: row.user_id,
                    })
                    // log action

                    // get campaign and notify
                    this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
                    return this.$notify({
                        type: 'danger',
                        message: response.msg,
                        icon: 'fas fa-bug'
                    }); 
                    // get campaign and notify
                }

                row.campaign_never_started = 'F';

                if (row.disabled == 'F') { // jika behasil pause campaign
                    // code, untuk sementara ini pause tidak ada, nanti kedepan siapa tau ada
                } else { // jika behasil play campaign
                    row.active = 'T';
                    row.disabled = 'F';
                    row.active_user = 'T';

                    this.$notify({
                        type: 'success',
                        message: 'Campaign successfully activated.',
                        icon: 'tim-icons icon-bell-55'
                    });

                    // log action
                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action: "Campaign Activate",
                        target_id: row.user_id,
                    })
                    // log action
                }
            })
            .catch(error => {
                console.log(error);

                $('#processingArea').removeClass('disabled-area');
                $('#popProcessing').hide();

                this.$notify({
                    type: 'primary',
                    message: 'sorry this campaign cannot be started, please contact your administrator with campaign ID : #' + row.leadspeek_api_id + ' (1)',
                    icon: 'fas fa-bug'
                }); 
            })
            /* ==================== CARA BARU ==================== */



            /* ==================== CARA LAMA ==================== */
            // const userData = this.$store.getters.userData
            // var _status = 'F';
            // if (row.disabled == 'F') {
            //     _status = 'T';
            // }

            // if (row.disabled == 'F') {
            //     this.popProcessingTxt = "Please wait, pausing campaign ....";
            // }else{
            //     this.popProcessingTxt = "Please wait, activating campaign ....";
            // }

            // $('#processingArea').addClass('disabled-area');
            // $('#popProcessing').show();

            // this.$store.dispatch('activepauseLeadsPeek', {
            //     companyID: this.companyID,
            //     leadspeekID: row.id,
            //     status: _status,
            //     activeuser: row.active_user,
            //     userID: row.user_id,
            //     ip_user: this.$store.getters.userData.ip_login,
            //     timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            //     idSys: this.$global.idsys,
            // }).then(response => {
            //     if(typeof (response.result) !== 'undefined' && response.result === 'failedPayment') {
            //         $('#processingArea').removeClass('disabled-area');
            //         $('#popProcessing').hide();

            //         $('#activePause' + index).removeClass('fas fa-pause gray').addClass('fas fa-pause orange nocursor');
            //         $('#activePlay' + index).removeClass('fas fa-play green nocursor').addClass('fas fa-play gray');
                    
            //         // LOG ACTION
            //         // const data = {
            //         //     userID: userData.id,
            //         //     action: "Campaign failed payment",
            //         //     desc: descriptionLogs,
            //         //     userIP: this.$store.getters.userData.ip_login,
            //         // }
            //         // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
            //         // if(userViewMode){
            //         //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
            //         //     data.userID = userRoot.id;
            //         // }
            //         // this.userLogSaved({ data });
            //         this.$store.dispatch('onSaveUserLogs', {
            //             desc: descriptionLogs,
            //             action: "Campaign failed payment",
            //             target_id: row.user_id,
            //         })
            //         // LOG ACTION
                    
            //         this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
            //         this.$notify({
            //                 type: 'danger',
            //                 message: response.msg,
            //                 icon: 'fas fa-bug'
            //             }); 
            //             return false;
            //     } else if(typeof(response.result) !== 'undefined' && (response.result == 'failed_campaign_already_active' || response.result == 'failed_campaign_already_paused')) {
            //         $('#processingArea').removeClass('disabled-area');
            //         $('#popProcessing').hide();

            //         $('#activePause' + index).removeClass('fas fa-pause gray').addClass('fas fa-pause orange nocursor');
            //         $('#activePlay' + index).removeClass('fas fa-play green nocursor').addClass('fas fa-play gray');

            //         /* LOG ACTION */
            //         const action = (response.result == 'failed_campaign_already_active') ? 'Campaign Is Already Active' : 'Campaign Is Already Pause'
            //         this.$store.dispatch('onSaveUserLogs', {
            //             desc: descriptionLogs,
            //             action:  action,
            //             target_id: row.user_id,
            //         })
            //         /* LOG ACTION */

            //         this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
            //         this.$notify({
            //             type: 'danger',
            //             message: response.msg,
            //             icon: 'fas fa-bug'
            //         });
            //         return false;
            //     } else {
            //          $('#processingArea').removeClass('disabled-area');
            //          $('#popProcessing').hide();

            //          if (row.disabled == 'F') { // for paused campaign
            //             row.active = 'F'
            //             row.disabled = 'T';
            //             row.active_users = 'T';
            //             $('#activePause' + index).removeClass('fas fa-pause gray').addClass('fas fa-pause orange nocursor');
            //             $('#activePlay' + index).removeClass('fas fa-play green nocursor').addClass('fas fa-play gray');
            //             this.$notify({
            //                 type: 'success',
            //                 message: 'Campaign successfully paused.',
            //                 icon: 'tim-icons icon-bell-55'
            //             });

            //             // LOG ACTION
            //             // const data = {
            //             //     userID: userData.id,
            //             //     action: "Campaign pause",
            //             //     desc: descriptionLogs,
            //             //     userIP: this.$store.getters.userData.ip_login,
            //             // }
            //             // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
            //             // if(userViewMode){
            //             //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
            //             //     data.userID = userRoot.id;
            //             // }
            //             // this.userLogSaved({ data });
            //             this.$store.dispatch('onSaveUserLogs', {
            //                 desc: descriptionLogs,
            //                 action: "Campaign pause",
            //                 target_id: row.user_id,
            //             })
            //             // LOG ACTION
            //          }else{ // for play campaign
            //             row.active = 'T';
            //             row.disabled = 'F';
            //             row.active_user = 'T';
            //             $('#activePause' + index).removeClass('fas fa-pause orange').addClass('fas fa-pause gray');
            //             $('#activePlay' + index).removeClass('fas fa-play gray').addClass('fas fa-play green nocursor');
            //             var msg = 'Campaign successfully activated.';
            //             if (row.active_user == 'F') {
            //                 msg = "Initial Campaign Start...";
            //             }
            //             this.$notify({
            //                 type: 'success',
            //                 message: msg,
            //                 icon: 'tim-icons icon-bell-55'
            //             });

            //             // LOG ACTION
            //             // const data = {
            //             //     userID: userData.id,
            //             //     action: "Campaign activate",
            //             //     desc: descriptionLogs,
            //             //     userIP: this.$store.getters.userData.ip_login,
            //             // }
            //             // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
            //             // if(userViewMode){
            //             //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
            //             //     data.userID = userRoot.id;
            //             // }
            //             // this.userLogSaved({ data });
            //             this.$store.dispatch('onSaveUserLogs', {
            //                 desc: descriptionLogs,
            //                 action: "Campaign activate",
            //                 target_id: row.user_id,
            //             })
            //             // LOG ACTION  
            //          }
            //     }
            // },error => {
            //     $('#processingArea').removeClass('disabled-area');
            //     $('#popProcessing').hide();

            //     this.$notify({
            //                 type: 'primary',
            //                 message: 'sorry this campaign cannot be started, please contact your administrator with campaign ID : #' + row.leadspeek_api_id + ' (1)',
            //                 icon: 'fas fa-bug'
            //             }); 
            //             return false;
            // });
            /* ==================== CARA LAMA ==================== */
        },
        async activepauseclient(index,row,action) {
            /* ==================== CARA BARU ==================== */
            // console.log({ index, row, action });
            // console.log(action, row.disabled, row.active_user);
            const userData = this.$store.getters.userData;

            if (action == 'play' && row.disabled == 'T' && row.active_user == 'F') { 
                // ul and li
                let btnOkName = 'I agree';
                let defaultText = '<p style="text-align: left; color: initial; margin: 4px 0 14px 8px;">Activating this campaign, you confirm the following:<br>';
                defaultText += '<ul style="display: flex; flex-direction: column; gap: 4px; text-align: left;">';
                defaultText += '<li class="alert-li">Once activated, the campaign will begin processing and generating leads on a weekly basis.</li>';
                defaultText += '<li class="alert-li">You can stop the campaign at any time from the campaign management page.</li>';
                defaultText += '<li class="alert-li">All campaign data and reports will be saved and can be downloaded even after the campaign ends.</li>';
                defaultText += '</ul>';
                // ul and li
                
                // swal
                let descriptionLogs = [
                    `campaign id: ${row.leadspeek_api_id}`,
                    `campaign type: ${row.leadspeek_type}`,
                    `campaign name: ${row.campaign_name}`
                ].join(" | ");
                
                swal.fire({
                    title: "Are you sure you want to activate this campaign?",
                    html: defaultText,
                    icon: '',
                    showCancelButton: true,
                    customClass: {
                        confirmButton: 'btn btn-default btn-fill',
                        cancelButton: 'btn btn-danger btn-fill'
                    },
                    confirmButtonText: btnOkName,
                    buttonsStyling: false,
                })
                .then(({ value }) => {
                    if(!value) {
                        return;
                    }
                    
                    this.process_activepauseclient(index,row,descriptionLogs);
                })
                // swal
            }
            /* ==================== CARA BARU ==================== */
            
            

            /* ==================== CARA LAMA ==================== */
            // if(row.paymentterm.toLowerCase() === 'prepaid' && (row.leadsbuy == 0 || row.leadsbuy == null)) {
            //     swal.fire({
            //         icon: "error",
            //         text: "You cannot start the campaign until you have set up the campaign financials. Please click the dollar icon to set them up.",
            //     })
            //     return false;
            // }
            
            // if ((action == 'pause' && row.disabled == 'T')) {
            //     return false;
            // }else if ((action == 'play' && row.disabled == 'F')) {
            //     return false;
            // }else if (action == 'play' && row.disabled == 'T' && row.active_user == 'F' && (row.customer_card_id == '' && this.$store.getters.userData.manual_bill == 'F')) {
            //     return false;
            // }

            // if((!row.leadspeek_locator_keyword || row.leadspeek_locator_keyword.trim() === "") && action == 'play'){
            //     this.$notify({
            //         type: 'danger',
            //         message: 'Keyword cannot be empty. Please provide a valid keyword.',
            //         icon: 'fas fa-bug'
            //     });

            //     return;
            // }

            // let descriptionLogs = `campaign id: ${row.leadspeek_api_id} | campaign type: ${row.leadspeek_type} | payment term: ${row.paymentterm.toLowerCase()} `;
            // if(row.paymentterm.toLowerCase() == 'prepaid') {
            //     descriptionLogs += `| top up options : ${row.topupoptions.toLowerCase()} `;
            //     if(row.topupoptions.toLowerCase() == 'continual') {
            //         descriptionLogs += `| continual buy options : ${row.continual_buy_options === true ? 'monthly': 'weekly'} | continual topup is : ${row.stopcontinual === 'T' ? 'disabled' : 'enabled'} `;
            //     } 
            // }

            // /* GET COSTAGENCY IF COST_PERLEAD ZERO */
            // this.contiDurationSelection = row.continual_buy_options;
            // if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //     this.selectsPaymentTerm.PaymentTermSelect = row.paymentterm;
            //     this.LeadspeekCostperlead = row.cost_perlead;
            //     try {
            //         const response = await this.$store.dispatch('getGeneralSetting', {
            //             companyID: this.companyID,
            //             settingname: 'costagency',
            //             idSys: this.$global.idsys,
            //             pk: row.company_id,
            //         });

            //         this.costagency = response.data;
            //         this.clientTypeLead = response.clientTypeLead;                    

            //         if(row.paymentterm.toLowerCase() == 'weekly') {
            //             this.m_LeadspeekPlatformFee = this.costagency.enhance.Weekly.EnhancePlatformFee;
            //             this.m_LeadspeekMinCostMonth =  this.costagency.enhance.Weekly.EnhanceMinCostMonth;
            //             this.m_LeadspeekCostperlead = this.costagency.enhance.Weekly.EnhanceCostperlead;
            //         } else if(row.paymentterm.toLowerCase() == 'monthly') {
            //             this.m_LeadspeekPlatformFee = this.costagency.enhance.Monthly.EnhancePlatformFee;
            //             this.m_LeadspeekMinCostMonth =  this.costagency.enhance.Monthly.EnhanceMinCostMonth;
            //             this.m_LeadspeekCostperlead = this.costagency.enhance.Monthly.EnhanceCostperlead;
            //         } else if(row.paymentterm.toLowerCase() == 'one time') {
            //             this.m_LeadspeekPlatformFee = this.costagency.enhance.OneTime.EnhancePlatformFee;
            //             this.m_LeadspeekMinCostMonth =  this.costagency.enhance.OneTime.EnhanceMinCostMonth;
            //             this.m_LeadspeekCostperlead = this.costagency.enhance.OneTime.EnhanceCostperlead;
            //         } else if(row.paymentterm.toLowerCase() == 'prepaid') {
            //             this.m_LeadspeekPlatformFee = this.costagency.enhance.Prepaid.EnhancePlatformFee;
            //             this.m_LeadspeekMinCostMonth =  this.costagency.enhance.Prepaid.EnhanceMinCostMonth;
            //             this.m_LeadspeekCostperlead = this.costagency.enhance.Prepaid.EnhanceCostperlead;
            //         }

            //         if(this.clientTypeLead.type == 'clientcapleadpercentage') {
            //             this.rootcostagency = response.rootcostagency;
            //             this.calculationMinimumCostPerLead();
            //         }

            //     } catch (error) {
            //         console.error(error);
            //         return false;
            //     }
            // }
            // /* GET COSTAGENCY IF COST_PERLEAD ZERO */

            // /* VALIDATION COST PER LEAD UNDER COSTAGENCY AND COST PER LEAD IS GREATHER THAN ZERO */
            // var cost_perlead_validate = row.cost_perlead;
            // if(cost_perlead_validate > 0 && cost_perlead_validate < this.m_LeadspeekCostperlead) {
            //     cost_perlead_validate = this.m_LeadspeekCostperlead;
            // }
            // /* VALIDATION COST PER LEAD UNDER COSTAGENCY AND COST PER LEAD IS GREATHER THAN ZERO */
            
            // if (action == 'play' && row.disabled == 'T' && row.active_user == 'F') {
            //     /** CHECK IF THE CAMPAIGN ID EXIST ON SIMPLI.FI */
            //     // if (row.clientcampaignsid == '') {
            //     //     this.$notify({
            //     //             type: 'primary',
            //     //             message: 'sorry this campaign cannot be started, please contact administrator with campaign ID : #' + row.leadspeek_api_id + ' (2)',
            //     //             icon: 'fas fa-bug'
            //     //         }); 
            //     //         return false;
            //     // }else if (row.campaign_startdate == '0000-00-00') {
            //     //     this.$notify({
            //     //             type: 'primary',
            //     //             message: 'sorry this campaign cannot be started, please check the campaign start and end date.',
            //     //             icon: 'fas fa-bug'
            //     //         }); 
            //     //         return false;
            //     // }
            //    /** CHECK IF THE CAMPAIGN ID EXIST ON SIMPLI.FI */
            //     // var defaultText = 'Activating this will charge a One Time startup fee of $' + row.platformfee + ' and the ' + row.paymentterm + ' fee of $' + row.lp_min_cost_month + '. This campaign is set up for ' + row.paymentterm.toLowerCase() + ' billing and your client will be billed on the same day each ' + row.paymentterm.toLowerCase() + '.';
            //     var btnOkName = 'Ok';
            //     var defaultText = '<p style="text-align: left; color: initial;">Activating this will authorize the following charges:<br>';
            //         defaultText += '<ul style="text-align: left;">';
            //         defaultText += '<li class="alert-li">A start up fee of $' + this.formatPrice(row.platformfee) + '</li>';
                    
            //         // jika prepaid
            //         if(row.paymentterm.toLowerCase() === 'prepaid') {
            //             defaultText += '<li class="alert-li">  A monthly campaign fee of $' + this.formatPrice(row.lp_min_cost_month) + ' starting one month after today</li>';
            //         } else {
            //             defaultText += '<li class="alert-li">  A  ' + row.paymentterm.toLowerCase() + ' campaign fee of $' + this.formatPrice(row.lp_min_cost_month) + '</li>';
            //         }

            //         defaultText += '<li class="alert-li">Up to ';
                        
            //         if (row.lp_limit_leads == 0){
            //             defaultText += 'Unlimited' + ' contacts per day at a cost of $' + this.formatPrice(cost_perlead_validate) + ' each contact </li>';
            //         }else{
            //             defaultText += row.lp_limit_leads + ' contacts per day at a cost of $' + this.formatPrice(cost_perlead_validate) + ' each contact </li>';
            //         }
            //         defaultText += '</ul>';

            //         // jika prepaid
            //         if(row.paymentterm.toLowerCase() === 'prepaid') {
            //             defaultText += 'This campaign is set up for ' + row.paymentterm.toLowerCase() + ' ' + row.topupoptions.toLowerCase() + ' billing';
            //             if(row.topupoptions.toLowerCase() == 'continual') {
            //                 defaultText += ' with continual buy options ' + (row.continual_buy_options === true ? 'monthly' : 'weekly') + ', continual topup is ' + (row.stopcontinual === 'T' ? 'disabled' : 'enabled') + ', ';
            //             }    
            //             defaultText += ' and will charge ';

            //             if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //                 defaultText += "immediately. The Client cost is  ";
            //             }
            //         } else {
            //             defaultText += 'This campaign is set up for ' + row.paymentterm.toLowerCase() + ' billing and will be billed on the same day each ' + row.paymentterm.toLowerCase().replace(/ly\b/g,'') + '. ';
            //             defaultText += 'If this campaign reaches its ' + row.paymentterm.toLowerCase() + ' contact limit goal, ';    
                        
            //             if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //                 defaultText += "the Clients cost for contacts will be ";
            //             } else {
            //                 defaultText += 'your total cost for contacts will be ';
            //             }
            //         }
                    
            //         if (row.lp_limit_leads == 0) {
            //             defaultText += 'unlimited.<br/>';
            //         }else{ 
            //             if(row.paymentterm.toLowerCase() === 'prepaid' && row.topupoptions === 'continual') {
            //                 var platformfee = parseFloat(row.platformfee);
            //                 var cost_perlead = parseFloat(cost_perlead_validate);
            //                 var lp_limit_leads = parseInt(row.lp_limit_leads);
            //                 var totalCost = this.contiDurationSelection ? this.formatPrice(platformfee + (((cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(platformfee + ((cost_perlead * lp_limit_leads) * 7));
            //                 //var totalCost = this.formatPrice(((cost_perlead * lp_limit_leads) * 7) * 4);
            //                 defaultText += '$' +  totalCost;

            //                 if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //                     var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
            //                     var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
            //                     var agency_total_cost = this.contiDurationSelection ? this.formatPrice(agency_platformfee + (((agency_cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(agency_platformfee + ((agency_cost_perlead * lp_limit_leads) * 7));
            //                     defaultText += ` and your Agency's cost is $${agency_total_cost}.`;
            //                 }
            //             }
            //             else if(row.paymentterm.toLowerCase() === 'prepaid' && row.topupoptions === 'onetime') {
            //                 var platformfee = parseFloat(row.platformfee);
            //                 var cost_perlead = parseFloat(cost_perlead_validate);
            //                 var leadsbuy = parseInt(row.leadsbuy);
            //                 var totalCost = this.formatPrice(platformfee + (cost_perlead * leadsbuy));
            //                 //var totalCost = this.formatPrice(cost_perlead * leadsbuy);
            //                 defaultText += '$' +  totalCost;
                            
            //                 if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //                     var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
            //                     var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
            //                     var agency_total_cost = this.formatPrice(agency_platformfee + (agency_cost_perlead * leadsbuy));
            //                     defaultText += ` and your Agency's cost is $${agency_total_cost}.`;
            //                 }
            //             }
            //             else {
            //                 var lp_min_cost_month = parseFloat(row.lp_min_cost_month);
            //                 var cost_perlead = parseFloat(cost_perlead_validate);
            //                 var lp_limit_leads = parseInt(row.lp_limit_leads);
            //                 // var totalCost = this.formatPrice(lp_min_cost_month + (((cost_perlead * lp_limit_leads) * 7)));
            //                 var totalCost = (row.paymentterm.toLowerCase() === 'weekly') ? this.formatPrice(lp_min_cost_month + (((cost_perlead * lp_limit_leads) * 7))) : this.formatPrice(lp_min_cost_month + (((cost_perlead * lp_limit_leads) * 7 * 4)));
            //                 defaultText += '$' +  totalCost;

            //                 if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //                     var agency_min_cost = parseFloat(this.m_LeadspeekMinCostMonth);
            //                     var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
            //                     var agency_total_cost = (row.paymentterm.toLowerCase() === 'weekly') ? this.formatPrice(agency_min_cost + (((agency_cost_perlead * lp_limit_leads) * 7))) : this.formatPrice(agency_min_cost + (((agency_cost_perlead * lp_limit_leads) * 7 * 4)));
            //                     defaultText += ` and your Agency's cost will be $${agency_total_cost}`;
            //                 }

            //                 defaultText += '.<br>';
            //             }
            //         }

            //         // jika prepaid
            //         if(row.paymentterm.toLowerCase() === 'prepaid') {
            //             if (row.topupoptions == 'continual') {
            //                 if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //                     defaultText += ' It will automatically rebill when the campaign falls to ' + row.lp_limit_leads + ' contacts available.'
            //                 } else {
            //                     defaultText += ' immediately, and again when the campaign falls to ' + row.lp_limit_leads + ' contacts available'
            //                 }
            //             }else if (row.topupoptions == 'onetime') {
            //                 if(this.$store.getters.userData.user_type == 'client') {
            //                     defaultText += ' immediately. ';
            //                 }
            //             }
            //         }
            //          /** IF PREPAID PUT THIS AGREEMENT */
            //          if(row.paymentterm.toLowerCase() === 'prepaid') {
            //             defaultText += '<br><br>';
            //             defaultText += 'I understand that the purchase of prepaid contacts is non-refundable.';
            //             btnOkName = 'I agree';
            //         }
            //         /** IF PREPAID PUT THIS AGREEMENT */
            //         defaultText += '<br>';
            //         if (row.lp_limit_leads == 0 ) {
            //             defaultText += '<span><strong style="color:red">WARNING: </strong>by setting a campaign to Unlimited contacts, the cost for this campaign could be thousands of dollars per day.</span>';
            //         }
            //         defaultText += '</p>';

            //     // const userData = this.$store.getters.userData;
            //     // if (userData.user_type == 'client') {
            //     //     defaultText = 'Activating this will charge a One Time startup fee of $' + row.platformfee + ' and the ' + row.paymentterm + ' fee of $' + row.lp_min_cost_month + '. This campaign is set up for ' + row.paymentterm.toLowerCase() + ' billing and you will be billed on the same day each ' + row.paymentterm.toLowerCase() + '.';
            //     // }
            //     descriptionLogs += `| setup fee: $${this.formatPrice(row.platformfee)} | campaign fee: $${this.formatPrice(row.lp_min_cost_month)} | cost per contact: $${this.formatPrice(row.cost_perlead)} | contact per day: ${row.lp_limit_leads} | client cost: $${totalCost} ${agency_total_cost == undefined ? '' : `| agency cost: $${agency_total_cost}`}`
            //     swal.fire({
            //         title: "Are you sure you want to activate this campaign?",
            //         html: defaultText,
            //         icon: '',
            //         showCancelButton: true,
            //         customClass: {
            //         confirmButton: 'btn btn-default btn-fill',
            //         cancelButton: 'btn btn-danger btn-fill'
            //         },
            //         confirmButtonText: btnOkName,
            //         buttonsStyling: false
            //     }).then(result => {
            //         if (result.value) {
            //             this.process_activepauseclient(index,row, descriptionLogs);
            //         }
            //     });
            // }else{
            //     if(row.paymentterm.toLowerCase() === 'prepaid' && row.topupoptions === 'continual') {
            //         var platformfee = parseFloat(row.platformfee);
            //         var cost_perlead = parseFloat(row.cost_perlead);
            //         var lp_limit_leads = parseInt(row.lp_limit_leads);
            //         var totalCost = this.contiDurationSelection ? this.formatPrice(platformfee + (((cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(platformfee + ((cost_perlead * lp_limit_leads) * 7));

            //         if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //             var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
            //             var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
            //             var agency_total_cost = this.contiDurationSelection ? this.formatPrice(agency_platformfee + (((agency_cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(agency_platformfee + ((agency_cost_perlead * lp_limit_leads) * 7));
            //         }
            //     }
            //     else if(row.paymentterm.toLowerCase() === 'prepaid' && row.topupoptions === 'onetime') {
            //         var platformfee = parseFloat(row.platformfee);
            //         var cost_perlead = parseFloat(row.cost_perlead);
            //         var leadsbuy = parseInt(row.leadsbuy);
            //         var totalCost = this.formatPrice(platformfee + (cost_perlead * leadsbuy));
                    
            //         if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //             var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
            //             var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
            //             var agency_total_cost = this.formatPrice(agency_platformfee + (agency_cost_perlead * leadsbuy));
            //         }
            //     }
            //     else {
            //         var lp_min_cost_month = parseFloat(row.lp_min_cost_month);
            //         var cost_perlead = parseFloat(row.cost_perlead);
            //         var lp_limit_leads = parseInt(row.lp_limit_leads);
            //         var totalCost = (row.paymentterm.toLowerCase() === 'weekly') ? this.formatPrice(lp_min_cost_month + (((cost_perlead * lp_limit_leads) * 7))) : this.formatPrice(lp_min_cost_month + (((cost_perlead * lp_limit_leads) * 7 * 4)));

            //         if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
            //             var agency_min_cost = parseFloat(this.m_LeadspeekMinCostMonth);
            //             var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
            //             var agency_total_cost = (row.paymentterm.toLowerCase() === 'weekly') ? this.formatPrice(agency_min_cost + (((agency_cost_perlead * lp_limit_leads) * 7))) : this.formatPrice(agency_min_cost + (((agency_cost_perlead * lp_limit_leads) * 7 * 4)));
            //         }
            //     }
            //     descriptionLogs += `| setup fee: $${this.formatPrice(row.platformfee)} | campaign fee: $${this.formatPrice(row.lp_min_cost_month)} | cost per contact: $${this.formatPrice(row.cost_perlead)} | contact per day: ${row.lp_limit_leads} | client cost: $${totalCost} ${agency_total_cost == undefined ? '' : `| agency cost: $${agency_total_cost}`}`;
            //     this.process_activepauseclient(index,row, descriptionLogs);
            // }
            /* ==================== CARA LAMA ==================== */
        },
        setIconReportType(row) {
            if(row.report_type == "CSV") {
                return  '<i class="fas fa-file-csv" style="color:white;padding-right:10px"></i> CSV File';
            }else if (row.report_type == "Excel") {
                return  '<i class="far fa-file-excel" style="color:white;padding-right:10px"></i> Microsoft Excel File';
            }else if (row.report_type == "GoogleSheet") {
                return  '<i class="fab fa-google-drive" style="color:white;padding-right:10px"></i> <a style="color:white" href="https://docs.google.com/spreadsheets/d/' + row.spreadsheet_id + '/edit#gid=0" target="_blank">Google Spreadsheet</a>';
            }
        },
        disconnect_googleSpreadSheet() {
            this.$store.dispatch('disconectGoogleSheet', {
                companyID: this.companyID,
            }).then(response => {
                //console.log(response.googleSpreadsheetConnected);
                this.GoogleConnectTrue = false;
                this.GoogleConnectFalse = true;
            },error => {
                
            });
        },
        connect_googleSpreadSheet() {
            window.removeEventListener('message', this.callbackGoogleConnected);
            window.addEventListener('message', this.callbackGoogleConnected);

            var left = (screen.width/2)-(1024/2);
            var top = (screen.height/2)-(800/2);
            var fbwindow = window.open(process.env.VUE_APP_DATASERVER_URL + '/auth/google-spreadSheet/' + this.companyID,'Google SpreadSheet Auth',"menubar=no,toolbar=no,status=no,width=640,height=800,toolbar=no,location=no,modal=1,left="+left+",top="+top);
        },
        onCompanyChange(_companySelected) {
            this.clearErrorInput('selectsCompany.companySelected');
            this.selectsCompany.companyId = _companySelected;

            for(let i=0;i<this.selectsCompany.companyList.length;i++) {
                if (this.selectsCompany.companyList[i].id == _companySelected) {
                    this.ClientFullName = this.selectsCompany.companyList[i].name;
                    this.ClientEmail = this.selectsCompany.companyList[i].email;
                    this.ClientPhone = this.selectsCompany.companyList[i].phonenum;
                    this.ClientUserID = this.selectsCompany.companyList[i].id;
                    this.ClientCompanyName = this.selectsCompany.companyList[i].company_name;
                    this.selectsCompany.companySelected = this.selectsCompany.companyList[i].company_name;
                    this.ClientReportSentTo = this.selectsCompany.companyList[i].email;
                    this.tmpClientReportSentTo = this.selectsCompany.companyList[i].email;
                    this.ClientCompanyID = this.selectsCompany.companyList[i].company_id;
                    this.ClientCompanyParent = this.selectsCompany.companyList[i].company_parent;

                    var enabled_phone_number;
                    if (this.selectsCompany.companyList[i].enabled_phone_number == 'T') {
                        enabled_phone_number = true;
                    } else {
                        enabled_phone_number = false;
                    }
                    this.checkboxes.phoneenabled = enabled_phone_number;
                }
            }

            for(let i=0;i<this.$global.selectsGroupCompany.companyGroupList.length;i++) {
                if (this.$global.selectsGroupCompany.companyGroupList[i].id == _companySelected) {
                    this.LeadspeekMinimumLeadsPerDayAdd = this.$global.selectsGroupCompany.companyGroupList[i].EnhanceLeadsPerday;
                    if(this.LeadspeekMinimumLeadsPerDayAdd < 1) {
                        this.LeadspeekMinimumLeadsPerDayAdd = 1;
                    }
                    
                    this.newcampaign.asec5_6 = this.LeadspeekMinimumLeadsPerDayAdd;
                    this.LeadspeekEnableMinimumLeadsPerDayAdd = this.$global.selectsGroupCompany.companyGroupList[i].EnhanceEnableMinimumLeadsPerday;
                }
            }
            // this.campaignBusinessInfo.name  = this.selectsCompany.companySelected
        },
        replaceCommaLine(data) {
            //convert string to array and remove whitespace
            let dataToArray = data.split(',').map(item => item.trim());
            //convert array to string replacing comma with new line
            return dataToArray.join("\n");
        },
        rowClicked(index,row) {
            this.modals.campaignEdit = !this.modals.campaignEdit
        },
        rowClickedEdit(index,row) {
            this.selectedRowData = row
            this.selectedRowData.leadspeek_locator_state = row.leadspeek_locator_state != '' ? row.leadspeek_locator_state.split(',') : ''
            this.selectedRowData.leadspeek_locator_city = row.leadspeek_locator_city != '' ? row.leadspeek_locator_city.split(',') : ''

            if(this.selectedRowData.leadspeek_locator_state.length == 1){
                this.stateCode = this.selectedRowData.leadspeek_locator_state
                this.getLocationBigDbm()
            }
            // if ($('.ClientRow' + index + '.expanded').length > 0) {
            //     this.CancelAddEditClient(row);
            //     return false;
            // }
            this.spreadsheet_id = row.spreadsheet_id

            row.target_nt = false;
            row.target_state = false;
            row.target_city = false;
            row.target_zip = false;
             
            if (row.national_targeting == 'T') {
                row.target_nt = true;
            }else{
                if (row.leadspeek_locator_zip != "" && row.leadspeek_locator_zip != null) {
                    row.target_zip = true;
                    row.leadspeek_locator_zip = this.replaceCommaLine(row.leadspeek_locator_zip);
                }

                if (row.leadspeek_locator_state != "" && row.leadspeek_locator_state != null) {
                    row.target_state = true;
                    // var _ClientLocatorState =  row.leadspeek_locator_state;
                    // var _ClientLocatorStateSifi = row.leadspeek_locator_state_external.split(',');

                    // for(var i=0;i<_ClientLocatorState.length;i++) {
                    //     if (_ClientLocatorStateSifi[i] != '' &&  _ClientLocatorState[i] != '') {
                    //         let newValue = _ClientLocatorStateSifi[i] + '|' + _ClientLocatorState[i];
                    //         let existingIndex = row.selects_state.findIndex(item => item === newValue);

                    //         if (existingIndex !== -1) {
                    //             row.selects_state[existingIndex] = newValue;
                    //         } else {
                    //             row.selects_state.push(newValue);
                    //         }

                    //     }
                    // }

                }

                if (row.leadspeek_locator_city != "" && row.leadspeek_locator_city != null) {
                    row.target_city = true;
                    // var _ClientLocatorCity =  row.leadspeek_locator_city;
                    // var _ClientLocatorCitySifi = row.leadspeek_locator_city_external.split(",");

                    // for(i=0;i<_ClientLocatorCity.length;i++) {
                    //     if (_ClientLocatorCitySifi[i] != '' && _ClientLocatorCity[i] != '') {
                    //         /** INITIAL LIST FOR CITY BEFOR DEFAULT SELECTED */
                    //         var _tmp = {
                    //             'active':true,
                    //             'id':_ClientLocatorCitySifi[i],
                    //             'metro_code_id': '',
                    //             'name': _ClientLocatorCity[i],
                    //             'parent_id' : '',
                    //             'resource':'',
                    //             'resources': [{}],
                    //             'update_date':'',
                    //         }
                    //         row.selects_citylist.push(_tmp);
                    //         /** INITIAL LIST FOR CITY BEFOR DEFAULT SELECTED */
                    //         row.selects_city.push(_ClientLocatorCitySifi[i] + '|' + _ClientLocatorCity[i]);
                    //     }
                    // }

                }
            }

            
            if (row.leadspeek_locator_keyword != "" && row.leadspeek_locator_keyword != null) {
                if(Array.isArray(row.leadspeek_locator_keyword)){
                    row.leadspeek_locator_keyword = row.leadspeek_locator_keyword;
                    row.leadspeek_locator_keyword_bulk = row.leadspeek_locator_keyword;
                } else {
                    row.leadspeek_locator_keyword_bulk = row.leadspeek_locator_keyword.split(',');
                    row.leadspeek_locator_keyword = row.leadspeek_locator_keyword.split(',');
                }
            }

            if (row.leadspeek_locator_keyword_contextual != null && row.leadspeek_locator_keyword_contextual != "") {
                row.leadspeek_locator_keyword_contextual = row.leadspeek_locator_keyword_contextual.split(",");
            }

            row.campaign_startdate = (row.campaign_startdate != '0000-00-00')?row.campaign_startdate:'';
            row.campaign_enddate = (row.campaign_enddate != '0000-00-00')?row.campaign_enddate:'';
            
            
            if (row.homeaddressenabled == 'T') {
                row.homeaddressenabled = true;
            }else{
                row.homeaddressenabled = false;
            }

            if (row.phoneenabled == 'T') {
                row.phoneenabled = true;
            }else{
                row.phoneenabled = false;
            }

            if (row.require_email == 'T') {
                row.require_email = true;
            }else{
                row.require_email = false;
            }

            if (row.applyreidentificationall == 'T') {
                row.applyreidentificationall = true;
            } else {
                row.applyreidentificationall = false;
            }
            
            row.statuscampaignplay = true;
            
            if (row.disabled == 'F' && row.active_user == 'T') {
                row.statuscampaignplay = true;
            }

            const payload = {
                campaign_id: row.id,
                type: 'play'
            }

            // Advanced Information
            this.rowCampaignInformationData = row.campaign_information_type;
            const toNumberRowAdvancedInformation = row.advance_information && row.advance_information.map((id) => Number(id))

            const listAllIdAdvanced = this.listAdvancedInformation.map((item) => item.id)
            this.idRowAdvancedInformation = toNumberRowAdvancedInformation;

            // this.checkAllRowAdvancedInformation = listAllIdAdvanced.length === toNumberRowAdvancedInformation.length;
            if(this.idRowAdvancedInformation.length === listAllIdAdvanced.length && this.selectedRowData.phoneenabled === true && this.selectedRowData.homeaddressenabled === true && this.selectedRowData.require_email === true) {
                this.checkAllRowAdvancedInformation = true;
            } else {
                this.checkAllRowAdvancedInformation = false;
            }

            // this.isIndeterminateRowAdvancedInformation = toNumberRowAdvancedInformation.length > 0 && this.idRowAdvancedInformation.length < listAllIdAdvanced.length
            if((this.idRowAdvancedInformation.length > 0 && this.idRowAdvancedInformation.length == listAllIdAdvanced.length) && (this.selectedRowData.phoneenabled === true && this.selectedRowData.homeaddressenabled === true && this.selectedRowData.require_email === true)) {
                this.isIndeterminateRowAdvancedInformation = false;
            } else if((this.idRowAdvancedInformation.length > 0 && this.idRowAdvancedInformation.length == listAllIdAdvanced.length) && (this.selectedRowData.phoneenabled === false || this.selectedRowData.homeaddressenabled === false || this.selectedRowData.require_email === false)) {
                this.isIndeterminateRowAdvancedInformation = true;
            } else if((this.idRowAdvancedInformation.length > 0 && this.idRowAdvancedInformation.length < listAllIdAdvanced.length) || (this.selectedRowData.phoneenabled === true || this.selectedRowData.homeaddressenabled === true || this.selectedRowData.require_email === true)) {
                this.isIndeterminateRowAdvancedInformation = true;
            } else if((this.idRowAdvancedInformation.length == 0 && this.idRowAdvancedInformation.length < listAllIdAdvanced.length) && (this.selectedRowData.phoneenabled === false && this.selectedRowData.homeaddressenabled === false && this.selectedRowData.require_email === false)) {
                this.isIndeterminateRowAdvancedInformation = false;
            }
            // Advanced Information
            
            this.getCountCampaignHistory(payload)
            const filterAdminNotifyTo = row.admin_notify_to.filter(admin => admin != null && !isNaN(admin))
            this.selectedRowData.admin_notify_to = filterAdminNotifyTo;

            this.modals.campaignEdit = !this.modals.campaignEdit
            //this.$refs.tableData.toggleRowExpansion(row);
        },
        rowClickedApprox(index,row) {
            this.prevRowData = { ...row }
            this.isDefaultTargetLocation = true
            this.isErrorFetchLeadCount = false
            this.fetchLeadCount(row)
        },
        tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
                return 'clickable-rows ClientRow' + rowIndex;
        },
        clearErrorInput(variableName) {
            // console.log(variableName)
            switch (variableName) {
                case 'selectsCompany.companySelected': this.err_companySelect = false; break;
                case 'ClientCampaignName': this.err_campaignName = false; break;
                case 'ClientCampaignType': this.err_campaignType = false; break;
                case 'campaignBusinessInfo.name': this.err_campaignBusinessName = false; break;
                case 'campaignBusinessInfo.website': this.err_campaignBusinessWebsite = false; break;
                case 'campaignBusinessInfo.industry': this.err_campaignBusinessIndustry = false; break;
                case 'campaignBusinessInfo.customIndustry': this.err_campaignBusinessCustomIndustry = false; break;
                case 'campaignBusinessInfo.businessDescription': this.err_campaignBusinessDescription = false; break;
                case 'campaignBusinessInfo.competitors': this.err_campaignBusinessCompetitors = false; break;
                case 'nationaltargetingselected': {
                    this.err_campaignCustomersFrom = false; 
                    this.err_campaignState = false; 
                    this.err_campaignZipCode = false; 
                    break;
                }
                case 'selects.state': this.err_campaignState = false; break;
                case 'newcampaign.asec5_3': this.err_campaignZipCode = false; break;
                case 'campaignBusinessInfo.customerUploadSources': {
                    this.err_campaignBusinessCustomerUploadSources = false;
                    this.err_campaignBusinessCrmProvider = false;
                    this.err_campaignBusinessCrmApiKey = false;
                    break;
                }
                case 'campaignBusinessInfo.crmProvider': this.err_campaignBusinessCrmProvider = false; break;
                case 'campaignBusinessInfo.crmApiKey': this.err_campaignBusinessCrmApiKey = false; break;
            }
        },
        ClearClientForm() { 
            this.ClientPerLead = '100';
            this.radios.reportType = 'GoogleSheet';
            this.selectsAdministrator.administratorSelected = [];
            this.ClientCampaignName = '';
            this.ClientUrlCode = '';
            this.ClientUrlCodeThankyou = '';
            Object.assign(this.campaignBusinessInfo, {
                name: '',
                website: '',
                idealCustomers: '',
                businessDescription: '',
                competitors: '',
                industry: '',
                customIndustry: '',
                businessType: '',
                customerUploadSources: {},
                crmProvider: '',
                crmApiKey: ''
            });
            this.resetBusinessInfoErrors();
            
            this.newcampaign.asec5_4_0_0 = false;
            this.newcampaign.asec5_4_0_1 = false;
            this.newcampaign.asec5_4_0_2 = false;
            this.newcampaign.asec5_4_0_3 = false;
            this.checkboxes.ApplyReidentificationToAll = false;

            this.selects.state = [];
            this.selects.city = [];
            this.selects.Citystate = [];
            this.tags.keywordlist = [];
            this.tags.keywordlistbulk = [];
            this.tags.keywordlistContextual = [];
            this.tags.keywordlistContextualBulk = [];
            this.newcampaign.asec5_3 = '';
            this.newcampaign.asec5_6 = '0';
            this.LeadspeekEnableMinimumLeadsPerDayAdd = false;
            this.newcampaign.target_lat = this.usDefaultCenter[0];
            this.newcampaign.target_lng = this.usDefaultCenter[1];
            this.newcampaign.target_radius_miles = 25;
            $('#err_locator_zip').removeClass("errwarning");

            let _tmpdefaultadmin = Array();
                $.each(this.tmpdefaultadmin,function(key, value) {
                     if(value['defaultadmin'] == 'T') {
                        _tmpdefaultadmin.push(value['id']);
                     }
                });
            
            this.selectsAdministrator.administratorSelected = _tmpdefaultadmin;
            if ((localStorage.getItem('companyGroupSelected') == null || localStorage.getItem('companyGroupSelected') == '')){
                this.ClientFullName = '';
                this.ClientEmail = '';
                this.ClientPhone = '';
                this.ClientUserID = '';
                this.ClientCompanyName = '';
                this.selectsCompany.companySelected = '';
                 this.ClientReportSentTo = this.tmpClientReportSentTo;
            }
            
        },
        ClearClientFormEdit(id) {
                if (id.leadspeek_locator_keyword != null && id.leadspeek_locator_keyword != '') {
                    id.leadspeek_locator_keyword = id.leadspeek_locator_keyword.join(',');
                }
                if (id.leadspeek_locator_keyword_contextual != null && id.leadspeek_locator_keyword_contextual != '') {
                    id.leadspeek_locator_keyword_contextual = id.leadspeek_locator_keyword_contextual.join(',');
                }
                id.selects_state = [];
                id.selects_city = [];
                id.selects_citylist = [];

                if (id.homeaddressenabled) {
                    id.homeaddressenabled = 'T';
                }else{
                    id.homeaddressenabled = 'F';
                }

                if (id.phoneenabled) {
                    id.phoneenabled = 'T';
                }else{
                    id.phoneenabled = 'F';
                }
                
                if (id.applyreidentificationall) {
                    id.applyreidentificationall = 'T';
                } else {
                    id.applyreidentificationall = 'F';
                }

                if (id.require_email) {
                    id.require_email = 'T';
                }else{
                    id.require_email = 'F';
                }

                $('#err_locator_zip' + id.id).removeClass("errwarning");
        },
        async AddEditClient(id) {
            const companyGroupSelected = localStorage.getItem('companyGroupSelected');
            if(companyGroupSelected != null && companyGroupSelected != '') {
                this.onCompanyChange(companyGroupSelected)
            } else if(this.selectsCompany.companyId != '') {
                this.onCompanyChange(this.selectsCompany.companyId)
            }
            // To DO 
            // Set the active step from backend if customer left the flow in between for edit campaign. this shold be done in mounted after fetching data
            this.campaignCreateActiveStep = 0
            if (this.modals.campaign) {
                this.promptCloseCreateCampaignModal();
            } else {
                try {
                    // Set loading state
                    this.isLoadingCheckCampaignLimit = true;

                    // Refresh Predict quota and max campaigns from costagency
                    await this.getMasterAgencyCost();

                    const usedCampaigns = Number(this.PredictQuotaCampaigns || 0);
                    const maximumCampaigns = Number(this.PredictMaxCampaigns || 1);

                    if (usedCampaigns >= maximumCampaigns) {
                        const message = `You've reached the maximum limit of ${maximumCampaigns} campaigns.`;
                        this.$notify({type: 'danger', message: message, icon: 'fas fa-exclamation-triangle'});
                        this.isLoadingCheckCampaignLimit = false;
                        return false;
                    }

                    // If validation passes, open the modal
                    this.modals.campaign = true;
                    this.isLoadingCheckCampaignLimit = false;
                } catch (error) {
                    console.error('Error checking maximum campaigns:', error);
                    this.modals.campaign = false;
                    const message = 'Failed to check campaign limits. Please try again.';
                    this.$notify({type: 'danger', message: message, icon: 'fas fa-exclamation-triangle'});
                    this.isLoadingCheckCampaignLimit = false;
                    return false;
                }
            }
        },
        CancelAddEditClient(id) {
            // TO DO 
            // Remove the unused logic from the code
            
            // old Logic
            // this.isErrorStopWords = false;
            // this.isErrorStopWordsEdit = false;
            // if(id == '') {
            //   this.ClearClientForm();
            //   this.modals.campaign = false
            // }else{
            //     //this.ClearClientFormEdit(id);
            //     this.modals.campaignEdit = false
            //     this.GetClientList(this.currSortBy,this.currOrderBy)
            // }
            // old logic end
            if(this.campaignCreateActiveStep > 0) {
                this.campaignCreateActiveStep--
            }

            
        },
        async promptCloseCreateCampaignModal() {
            if (this.skipCampaignClosePrompt) {
                this.skipCampaignClosePrompt = false;
                return;
            }
            const result = await swal.fire({
                title: 'Discard changes?',
                text: 'Closing will revert all changes you made in this campaign setup.',
                icon: '',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                focusCancel: true,
                reverseButtons: true,
            });
            if (result.isConfirmed) {
                this.forceCloseCampaignModal();
            } else {
                this.modals.campaign = true;
            }
        },
        forceCloseCampaignModal() {
            this.skipCampaignClosePrompt = true;
            this.modals.campaign = false;
            this.clearCampaignForm();
        },
        onCreateCampaignModalAttemptClose() {
            this.promptCloseCreateCampaignModal();
        },
        ResendLink(id) {
            if(id.id != '') {
                $('#btnResend' + id.id).attr('disabled',true);
                $('#btnResend' + id.id).html('Sending...');   

                /** RESEND THE INVITATION */
                this.$store.dispatch('ResendGoogleLink', {
                    companyID: this.companyID,
                    userID: id.company_id,
                    leadspeekID: id.id,
                    reportSentTo: id.report_sent_to,
                    adminNotifyTo: id.admin_notify_to,
                }).then(response => {
                    //console.log(response[0]);
                    this.modals.campaignEdit = false
                    // this.$refs.tableData.toggleRowExpansion(id);
                    $('#btnResend' + id.id).attr('disabled',false);
                    $('#btnResend' + id.id).html('Resend Google Sheet Link'); 

                    this.$notify({
                        type: 'success',
                        message: 'Invitation has been sent!',
                        icon: 'far fa-save'
                    });  

                },error => {
                    $('#btnResend' + id.id).attr('disabled',false);
                    $('#btnResend' + id.id).html('Resend Google Sheet Link'); 

                    this.$notify({
                        type: 'primary',
                        message: 'Sorry there is something wrong, pleast try again later',
                        icon: 'fas fa-bug'
                    }); 
                });
                /** RESEND THE INVITATION */
            }
        },
        async ProcessAddEditClient(id) {
            if(id == '') {
                /** PROCESS ADD / EDIT ORGANIZATION */

                // $('#err_startendcamp').hide();

                // /** VALIDATE QUESTIONNAIRE FORM */
                //     this.formpass = true;

                //     var saveConfPhoneNumber = this.checkboxes.phoneenabled;

                //     /** CHECK START AND END DATE CAMPAIGN */
                //     let todaydate = this.$moment().format('YYYYMMDD');
                   
                //     let startdatecampaign = this.$moment(this.StartDateCampaign).format('YYYYMMDD');
                //     let enddatecampaign =  this.$moment(this.EndDateCampaign).format('YYYYMMDD');

                //     // if (enddatecampaign <= startdatecampaign) {
                //     //     //this.ErrStartEndCampaign = '* Campaign end date must be on or after start date';
                //     //     this.ErrStartEndCampaign = '* Campaign end date must be after start / today date';
                //     //     $('#err_startendcamp').show();
                //     //     this.formpass = false;
                //     // }else if (enddatecampaign <= todaydate) {
                //     //     //this.ErrStartEndCampaign = '* Campaign end date must be on or after today date';
                //     //     this.ErrStartEndCampaign = '* Campaign end date must be after today date';
                //     //     $('#err_startendcamp').show();
                //     //     this.formpass = false;
                //     // // }else if (startdatecampaign < todaydate) {
                //     // //     //this.ErrStartEndCampaign = '* Campaign start date must be on or after today date';
                //     // //     this.ErrStartEndCampaign = '* Campaign start date must be after today date';
                //     // //     $('#err_startendcamp').show();
                //     // //     this.formpass = false;
                //     // }else{


                //     //     if (this.StartDateCampaign == "" || this.StartDateCampaign == null || this.EndDateCampaign == "" || this.EndDateCampaign == null) {
                //     //         this.ErrStartEndCampaign = '* Please fill the date when campaign start and end';
                //     //         this.formpass = false;
                //     //         $('#err_startendcamp').show();
                //     //     }else{
                //     //         $('#err_startendcamp').hide();
                //     //     }
                //     // }

                //  /** CHECK START AND END DATE CAMPAIGN */

                //  const regex = /^\s*$/;
                // if (this.ClientCampaignName == "" || regex.test(this.ClientCampaignName)) {
                //     this.formpass = false;
                //     $('#err_campaignname').show();
                // }else{
                //     $('#err_campaignname').hide();
                // }

                // if (this.selectsCompany.companySelected == '') {
                //     this.formpass = false;
                //     this.err_companySelect = true;
                // }else{
                //     this.err_companySelect = false;
                // }

                // if (this.newcampaign.asec5_9_1) {
                //     if (this.tags.keywordlist.length == 0) {
                //         this.formpass = false;
                //         $('#err_asec5_10').show();
                //     }else{
                //         $('#err_asec5_10').hide();
                //     }
                // }

                // if ((this.newcampaign.asec5_4_0_0 === false && this.newcampaign.asec5_4_0_1 === false && this.newcampaign.asec5_4_0_2 === false && this.newcampaign.asec5_4_0_3 === false) || this.tags.keywordlist.length == 0) {
                //     this.formpass = false;
                //     $('#err_asec5_10').show();
                // }else if (this.newcampaign.asec5_4_0_1 && this.selects.state.length == 0 || this.tags.keywordlist.length == 0) {
                //     this.formpass = false;
                //     $('#err_asec5_10').show();
                // }else{
                //     $('#err_asec5_10').hide();
                // }

                // /** VALIDATE ZIP CODE IF SELECTED SHOULD BE HAVE MINIMUM 1 zip code and MAX 50 zipcode*/
                // // if (this.newcampaign.asec5_4_0_3) {
                // //     //err_locator_zip
                // //     if (this.newcampaign.asec5_3 != '') {
                // //         if (this.newcampaign.asec5_3.split('\n').length > 50) {
                // //             this.formpass = false;
                // //             $('#err_locator_zip').addClass("errwarning");
                // //         }else{
                // //             $('#err_locator_zip').removeClass("errwarning");
                // //         }
                // //     }else{
                // //         this.formpass = false;
                // //         $('#err_locator_zip').addClass("errwarning");
                // //     }
                // // }

                // if (this.newcampaign.asec5_4_0_3) {
                //     this.alertzip = true;
                //     this.msgzip = '';
                //     //err_locator_zip
                //     if (this.newcampaign.asec5_3 != '') {
                //         var txzip = this.newcampaign.asec5_3.split('\n');
                //         if (txzip[0].trim() == '') {
                //             this.formpass = false;
                //             this.alertzip = false;
                //             this.msgzip = 'Please check the required fields (ZIP Codes).';
                //             $('#err_locator_zip').addClass("errwarning");
                //         }
                //         else if (txzip.length > 50) {
                //             this.formpass = false;
                //             this.alertzip = false;
                //             this.msgzip = 'Please check the required fields (Max 50 ZIP Codes).';
                //             $('#err_locator_zip').addClass("errwarning");
                //         }else{
                //             $('#err_locator_zip').removeClass("errwarning");
                //         }
                //     }else{
                //         this.formpass = false;
                //         this.alertzip = false;
                //         this.msgzip = 'Please check the required fields (Min 1 ZIP Codes).';
                //         $('#err_locator_zip').addClass("errwarning");
                //     }

                //     if (this.alertzip == false) {
                //         this.$notify({
                //             type: 'primary',
                //             // message: 'Please check the required fields (ZIP Codes).',
                //             message: this.msgzip,
                //             icon: 'fas fa-bug'
                //         }); 
                //         return false;
                //     }
                // }
                // /** VALIDATE ZIP CODE IF SELECTED SHOULD BE HAVE MINIMUM 1 zip code and MAX 50 zipcode*/

                // /* VALIDATE CONTACT PER DAY NOT INTEGER AND MINIMUM 1 */
                // if (!Number.isInteger(Number(this.newcampaign.asec5_6)) || Number(this.newcampaign.asec5_6) < 1) {
                //     this.formpass = false;
                // }
                // /* VALIDATE CONTACT PER DAY NOT INTEGER AND MINIMUM 1 */

                // this.$refs.form5.validate().then(res => {
                //     if (!res || !this.formpass) {
                //         return false;
                //     }
                // });
                
                // if (this.formpass == false) {
                //     this.$notify({
                //         type: 'primary',
                //         message: 'Please check the required fields.',
                //         icon: 'fas fa-bug'
                //     }); 
                //     return false;
                // }

                // this.newcampaign.asec5_4 = this.selects.state;
                // this.newcampaign.asec5_4_1 = '';
                // this.newcampaign.asec5_10 = this.tags.keywordlist;
                // this.newcampaign.asec5_10_1 = this.tags.keywordlistContextual;
                // this.newcampaign.asec5_4_2 = this.selectedCity;

                // if(this.newcampaign.asec5_4_2.length > 0){
                //     this.newcampaign.asec5_4_0_2 = true
                // }
                
                // let oriStartDateCampaign = this.$moment(this.StartDateCampaign).format('YYYY-MM-DD') + " 00:00:00";
                // let oriEndDateCampaign = this.$moment(this.EndDateCampaign).format('YYYY-MM-DD') + " 23:59:59";

                // this.StartDateCampaign =  this.format_date(this.$moment(this.StartDateCampaign).format('YYYY-MM-DD') + " 00:00:00",true,false);
                // this.EndDateCampaign =  this.format_date(this.$moment(this.EndDateCampaign).format('YYYY-MM-DD') + " 23:59:59",true,false);

                // this.newcampaign.startdatecampaign = this.StartDateCampaign;
                // this.newcampaign.enddatecampaign = this.EndDateCampaign;
                
                // /** VALIDATE QUESTIONNAIRE FORM */

                // // if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '')){
                //     // this.selectsGroupCompany.companyGroupID = localStorage.getItem('companyGroupSelected');
                // // }else{
                //     this.selectsGroupCompany.companyGroupID = this.ClientUserID;
                // // }
                // //HIDE PHONE WILL BE DEFAULT WHEN ADD CLIENT
                // var hidePhone = 'T';
                // if (this.checkboxes.hide_phone) {
                //     hidePhone = 'T';
                // }

                // //// checking enable phone number??
                // if (!saveConfPhoneNumber) {
                //     saveConfPhoneNumber = await this.openSaveConfirmationModal('add');
                // }

                this.popProcessingTxt = "Please wait, adding new campaign ....";
                $('#processingArea').addClass('disabled-area');
                $('#popProcessing').show();
               
                $('#btnSave' + id).attr('disabled',true);
                $('#btnSave' + id).html('Processing...');

                // get id campaignBusinessInfo.customerUploadSources when value true, and convert to array
                // const customerUploadSources = Object.values(this.campaignBusinessInfo.customerUploadSources)
                //                                     .filter(item => item.value === true)
                //                                     .map(item => item.id)
                const customerUploadSources = (this.selectedCustomerList && this.selectedCustomerList.id) ? [this.selectedCustomerList.id] : [];
                // get id campaignBusinessInfo.customerUploadSources when value true, and convert to array
                
                /** CREATE CLIENT */
                this.newcampaign.asec5_4 = this.selects.state;
                const payload = {
                    companyID: this.companyID,
                    userID:this.ClientUserID,
                    companyName: this.ClientCompanyName,
                    campaignName: this.ClientCampaignName,
                    answers: this.newcampaign,
                    campaignType: this.ClientCampaignType,
                    businessName: this.campaignBusinessInfo.name,
                    businessWebsite: this.campaignBusinessInfo.website,
                    businessIndustry: this.campaignBusinessInfo.industry,
                    businessCustomIndustry: this.campaignBusinessInfo.customIndustry,
                    businessDescription: this.campaignBusinessInfo.businessDescription,
                    businessCompetitors: this.campaignBusinessInfo.competitors,
                    customerUploadSources: customerUploadSources,
                    crmProvider: this.campaignBusinessInfo.crmProvider,
                    crmApiKey: this.campaignBusinessInfo.crmApiKey,
                    platformFee: this.LeadspeekPlatformFee,
                    minCostMonth: this.LeadspeekMinCostMonth,
                    timezone: this.$global.clientTimezone,
                    idSys: this.$global.idsys,
                    target_lat: this.newcampaign.target_lat,
                    target_lng: this.newcampaign.target_lng,
                    target_radius_miles: this.newcampaign.target_radius_miles,
                    finalAnalyzeCustomers: this.final_analyze_customers,
                    finalExpression: this.lastUpdatedExpression,
                    availableContacts: this.availableContacts,
                    customFieldId: this.selectedCustomFieldId === this.CUSTOM_FIELDS_OPTION_CUSTOM ? null : this.selectedCustomFieldId,
                    customFieldOrder: (this.selectedCustomFieldId === this.CUSTOM_FIELDS_OPTION_CUSTOM && this.customFieldOrderOnlyForCampaign && this.customFieldOrderOnlyForCampaign.length) ? this.customFieldOrderOnlyForCampaign : undefined,
                    customFieldName: (this.selectedCustomFieldId === this.CUSTOM_FIELDS_OPTION_CUSTOM && this.customFieldNameForCampaign) ? this.customFieldNameForCampaign : undefined,
                };
                // localStorage.setItem('PredictCreateCampaign', JSON.stringify(payload));
                this.modals.campaign = false;
                this
                .$store
                .dispatch('PredictCreateCampaign', payload)
                .then(response => {
                    // console.log(response);

                    $('#processingArea').removeClass('disabled-area');
                    $('#popProcessing').hide();

                    $('#btnSave' + id).attr('disabled',false)
                    $('#btnSave' + id).html('Next');

                    // this.$notify({
                    //     type: 'success',
                    //     message: 'Data has been added successfully',
                    //     icon: 'far fa-save'
                    // });

                    swal.fire({
                        icon: "success",
                        title: 'Success',
                        text: 'Your campaign has been started and connected to your integrations. Congratulations!'
                    });

                    this.GetClientList(this.currSortBy,this.currOrderBy);
                    this.getMasterAgencyCost();
                    this.forceCloseCampaignModal();
                })
                .catch(error => {
                    $('#processingArea').removeClass('disabled-area');
                    $('#popProcessing').hide();

                    $('#btnSave' + id).attr('disabled',false);
                    $('#btnSave' + id).html('Next'); 

                    if (error && error.status === 422 && error.errors) {
                        Object.entries(error.errors).forEach(([field, messages]) => {
                            messages.forEach(message => {
                                this.notificationError(message);
                            });
                        });
                    } else {
                        const message = error.message ? error.message : "Something's wrong, please try again later.";
                        this.notificationError(message);
                    }

                    this.getMasterAgencyCost();
                })
                /** CREATE CLIENT */
            }else{
            
                if ((id.report_type != '' && id.email != '') && (typeof id.report_type != 'undefined' && typeof id.email != 'undefined')) {
                    
                    var _formpass = true;
                    var saveConfPhoneNumber = id.phoneenabled;

                    this.userIdCampaign = id.user_id;

                    $('#err_startendcamp' + id.id).hide();

                    const regex = /^\s*$/;
                    if (id.campaign_name == "" || regex.test(id.campaign_name)) {
                        _formpass = false;
                        $('#err_campaignname' + id.id).show();
                    }else{
                        $('#err_campaignname' + id.id).hide();
                    }
                
                    /** CHECK START AND END DATE CAMPAIGN */
                        let todaydate = this.$moment().format('YYYYMMDD');

                        let startdatecampaign = this.$moment(id.campaign_startdate).format('YYYYMMDD');
                        let enddatecampaign = this.$moment(id.ori_campaign_enddate).format('YYYYMMDD');
                        // never execute
                        if (false) {
                            if (enddatecampaign <= startdatecampaign) {
                                //$('#ErrStartEndCampaign' + id.id).html('* Campaign end date must be on or after start date');
                                $('#ErrStartEndCampaign' + id.id).html('* Campaign end date must be after start / today date');
                                $('#err_startendcamp' + id.id).show();
                                _formpass = false;
                            }else if (enddatecampaign <= todaydate) {
                                //$('#ErrStartEndCampaign' + id.id).html('* Campaign end date must be on or after today date');
                                $('#ErrStartEndCampaign' + id.id).html('* Campaign end date must be after today date');
                                $('#err_startendcamp' + id.id).show();
                                _formpass = false;
                            }else{
                                if (id.campaign_startdate == "" ||id.campaign_startdate == null || id.campaign_enddate == "" || id.campaign_enddate == null) {
                                    $('#ErrStartEndCampaign' + id.id).html('* Please fill the date when campaign start and end');
                                    _formpass = false;
                                    $('#err_startendcamp' + id.id).show();
                                }else{
                                    $('#err_startendcamp' + id.id).hide();
                                }
                            }
                        }

                    /** CHECK START AND END DATE CAMPAIGN */

                    if (id.leadspeek_locator_keyword.length == 0) {
                        _formpass = false;
                        $('#err_asec5_10' + id.id).show();
                    }else{
                        $('#err_asec5_10' + id.id).hide();
                    }

                    // Check target locations
                    let selectedCount = 0;
                    if (this.selectedRowData.target_nt) selectedCount++;
                    if (this.selectedRowData.target_state) selectedCount++;
                    if (this.selectedRowData.target_zip) selectedCount++;

                    if (selectedCount === 0 ) {
                        this.$notify({
                            type: 'danger',
                            message: 'You must select at least one target locations.',
                            icon: 'fas fa-exclamation-circle'
                        })
                        return;
                    } else if (selectedCount > 1){
                        this.$notify({
                            type: 'danger',
                            message: 'You can only select one target locations.',
                            icon: 'fas fa-exclamation-circle'
                        });
                        return;
                    }
                    // Check target locations

                    // VALIDATION STATES > 5
                    if(id.leadspeek_locator_state.length > 5){
                        this.$notify({
                            type: 'danger',
                            message: 'A maximum of 5 states may be selected. Please reduce the number of choices.',
                            icon: 'fas fa-exclamation-circle'
                        })

                        return;
                    }
                    // VALIDATION STATES > 5

                    // VALIDATION CITY > 10
                    if(id.leadspeek_locator_city.length > 10){
                        this.$notify({
                            type: 'danger',
                            message: 'A maximum of 10 cities may be selected. Please reduce the number of choices.',
                            icon: 'fas fa-exclamation-circle'
                        })

                        return;
                    }
                    // VALIDATION CITY > 10

                    if ((id.target_nt === false && id.target_state === false && id.target_city === false && id.target_zip === false) || id.leadspeek_locator_keyword.length == 0) {
                        _formpass = false;
                        $('#err_asec5_10' + id.id).show();
                    }else if (id.target_state && id.leadspeek_locator_state.length == 0 || id.leadspeek_locator_keyword.length == 0) {
                       _formpass = false;
                        $('#err_asec5_10' + id.id).show();
                    }else{
                        $('#err_asec5_10' + id.id).hide();
                    }

                    /** VALIDATE ZIP CODE IF SELECTED SHOULD BE HAVE MINIMUM 1 zip code and MAX 50 zipcode*/
                    // if (id.target_zip) {
                    //     //err_locator_zip
                    //     if (id.leadspeek_locator_zip != '') {
                    //         if (id.leadspeek_locator_zip.split('\n').length > 50) {
                    //             _formpass = false;
                    //             $('#err_locator_zip' + id.id).addClass("errwarning");
                    //         }else{
                    //             $('#err_locator_zip' + id.id).removeClass("errwarning");
                    //         }
                    //     }else{
                    //         _formpass = false;
                    //         $('#err_locator_zip' + id.id).addClass("errwarning");
                    //     }
                    // }

                    if (id.target_zip) {
                        var _alertzip = true;
                        var _msgzip = '';
                        //err_locator_zip
                        if (id.leadspeek_locator_zip != '') {
                            var txzip = id.leadspeek_locator_zip.split('\n');
                            if (txzip[0].trim() == '') {
                                _formpass = false;
                                _alertzip = false;
                                _msgzip = 'Please check the required fields (ZIP Codes).';
                                $('#err_locator_zip').addClass("errwarning");
                            }
                            else if (txzip.length > 50) {
                                _formpass = false;
                                _alertzip = false;
                                _msgzip = 'Please check the required fields (Max 50 ZIP Codes).';
                                $('#err_locator_zip').addClass("errwarning");
                            } else {
                                $('#err_locator_zip').removeClass("errwarning");
                            }
                        }else{
                            _formpass = false;
                            _alertzip = false;
                            _msgzip = 'Please check the required fields (Min 1 ZIP Codes).';
                            $('#err_locator_zip').addClass("errwarning");
                        }

                        if (_alertzip == false) {
                            this.$notify({
                                type: 'primary',
                                // message: 'Please check the required fields (ZIP Codes).',
                                message: _msgzip,
                                icon: 'fas fa-bug'
                            }); 
                            return false;
                        }
                    }
                    /** VALIDATE ZIP CODE IF SELECTED SHOULD BE HAVE MINIMUM 1 zip code and MAX 50 zipcode*/
                    
                    if (_formpass == false) {
                        this.$notify({
                            type: 'primary',
                            message: 'Please check the required fields.',
                            icon: 'fas fa-bug'
                        }); 
                        return false;
                    }

                    //// checking enable phone number??
                    if (!saveConfPhoneNumber) {
                        saveConfPhoneNumber = await this.openSaveConfirmationModal(id.id);
                    }
                    
                    this.popProcessingTxt = "Please wait, updating campaign ....";
                    $('#processingArea').addClass('disabled-area');
                    $('#popProcessing').show();

                    $('#btnSave' + id.id).attr('disabled',true);
                    $('#btnSave' + id.id).html('Processing...'); 

                    var _locatorrequire = 'FirstName,LastName,MailingAddress,Phone';
           
                    _locatorrequire = _locatorrequire.replace(/,\s*$/, "");

                    let oriStartDate_Campaign = this.$moment(id.campaign_startdate).format('YYYY-MM-DD') + " 00:00:00";
                    let oriEndDate_Campaign = this.$moment(id.ori_campaign_enddate).format('YYYY-MM-DD') + " 23:59:59";
                    let StartDate_Campaign =  this.format_date(this.$moment(id.campaign_startdate).format('YYYY-MM-DD') + " 00:00:00",true,false);
                    let EndDate_Campaign = this.format_date(this.$moment(id.ori_campaign_enddate).format('YYYY-MM-DD') + " 23:59:59",true,false);

                    this.updateDataClient(id);
                    
                    /** UPDATE CLIENT */
                    this.$store.dispatch('UpdateLeadsPeekClient', {
                        companyID: this.companyID,
                        userID: id.company_id,
                        leadspeekID: id.id,
                        reportType: id.report_type,
                        reportSentTo: id.report_sent_to,
                        adminNotifyTo: id.admin_notify_to,
                        leadsAmountNotification: id.leads_amount_notification,
                        leadspeekType: id.leadspeek_type,
                        companyGroupID: id.group_company_id,
                        clientOrganizationID: id.clientorganizationid,
                        clientCampaignID: id.clientcampaignsid,
                        clientHidePhone: id.hide_phone,
                        campaignName: id.campaign_name,
                        urlCode: id.url_code,
                        urlCodeThankyou: id.url_code_thankyou,
    
                        locatorzip: id.leadspeek_locator_zip,
                        locatordesc: id.leadspeek_locator_desc,   
                        locatorkeyword: id.leadspeek_locator_keyword,
                        locatorkeywordcontextual: id.leadspeek_locator_keyword_contextual,
                        locatorstate: id.leadspeek_locator_state,
                        locatorrequire: _locatorrequire,
                        locatorcity: id.leadspeek_locator_city,
                        externalcampaign: id.clientcampaignsid,
                        externalorganizationid: id.clientorganizationid,
                        startdatecampaign: StartDate_Campaign,
                        enddatecampaign: EndDate_Campaign,
                        oristartdatecampaign: oriStartDate_Campaign,
                        orienddatecampaign: oriEndDate_Campaign,
                        target_lat: id.target_lat,
                        target_lng: id.target_lng,
                        target_radius_miles: id.target_radius_miles,

                        nationaltargeting: id.target_nt,
                        locationtarget: this.radios.locationTarget,
                        // phoneenabled: id.phoneenabled,
                        phoneenabled: saveConfPhoneNumber,
                        homeaddressenabled: id.homeaddressenabled,
                        requireemailaddress: id.require_email,
                        reidentificationtype: id.reidentification_type,
                        timezone: this.$global.clientTimezone,
                        applyreidentificationall: id.applyreidentificationall,
                        listAdvanceInformationId: this.idRowAdvancedInformation,
                        campaign_information_type: this.rowCampaignInformationData
                    }).then(response => {
                        //console.log(response[0]);
                        this.adjustmentDataClient(id,response[0]);
                       
                        // this.$refs.tableData.toggleRowExpansion(id);
                        $('#processingArea').removeClass('disabled-area');
                        $('#popProcessing').hide();

                        $('#btnSave' + id.id).attr('disabled',false);
                        $('#btnSave' + id.id).html('Save');

                        this.$notify({
                            type: 'success',
                            message: 'Data has been updated successfully',
                            icon: 'far fa-save'
                        });  
                        this.modals.campaignEdit = false
                        //this.ClearClientFormEdit(id);

                        if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '') && localStorage.getItem('companyGroupSelected') != id.group_company_id) {
                             this.deleteRow(id);
                        }

                        if (id.leadspeek_type != 'locator') {
                             this.deleteRow(id);
                        }

                        this.GetClientList(this.currSortBy,this.currOrderBy)
                    },error => {
                        $('#processingArea').removeClass('disabled-area');
                        $('#popProcessing').hide();
                        
                        $('#btnSave' + id.id).attr('disabled',false);
                        $('#btnSave' + id.id).html('Save'); 

                        this.$notify({
                            type: 'primary',
                            message: 'Server might be busy please try again later',
                            icon: 'fas fa-bug'
                        }); 
                    });
                    /** UPDATE CLIENT */
                }
            }
        },
        adjustmentDataClient(id,response) {
            id.leadspeek_locator_state = response['leadspeek_locator_state'];
            id.leadspeek_locator_state_external = response['leadspeek_locator_state_external'];
            id.leadspeek_locator_city = response['leadspeek_locator_city'];
            id.leadspeek_locator_city_external = response['leadspeek_locator_city_external'];
            id.national_targeting = response['national_targeting'];
            id.target_lat = response['target_lat'] || id.target_lat;
            id.target_lng = response['target_lng'] || id.target_lng;
            id.target_radius_miles = response['target_radius_miles'] || id.target_radius_miles;
        },
        updateDataClient(id) {
            if (id.target_nt == true) {
                id.target_state = false;
                id.target_city = false;
                id.target_zip = false;
                //this.radios.locationTarget = "Focus";

                id.leadspeek_locator_state = "";
                id.leadspeek_locator_state_external = "";
                id.selects_state = [];
                id.leadspeek_locator_city = "";
                id.leadspeek_locator_city_external = "";
                id.selects_city = [];
                id.leadspeek_locator_zip = "";
            }
        
            if (id.target_state || id.target_city || id.target_zip) {
                id.target_nt = false;
            }

            if(id.target_state){
                id.leadspeek_locator_zip = "";
            }

            if(id.target_zip){
                id.leadspeek_locator_state = "";
                id.leadspeek_locator_state_external = "";
                id.leadspeek_locator_city = "";
                id.leadspeek_locator_city_external = "";
                id.selects_state = [];
                id.selects_city = [];
            }
        },
        checkGoogleConnect() {
            this.$store.dispatch('checkGoogleConnectSheet', {
                companyID: this.companyID,
            }).then(response => {
                //console.log(response.googleSpreadsheetConnected);
                if (response.googleSpreadsheetConnected) {
                    this.GoogleConnectTrue = true;
                    this.GoogleConnectFalse = false;
                }else{
                    this.GoogleConnectTrue = false;
                    this.GoogleConnectFalse = true;
                }
            },error => {
                
            });
        },
        AttachedAdminNotify(response) {
            /** SET ADMIN NOTIFY */
            for (let i = 0; i < response.length; i++) {
                let tmp = response[i]['admin_notify_to'];
                let tmpArray = [];

                if (typeof tmp === 'string' && tmp.trim() !== '') {
                    // Split hanya angka valid
                    tmpArray = tmp
                        .split(',')
                        .map(item => parseInt(item))
                        .filter(num => !isNaN(num)); 
                }

                response[i]['admin_notify_to'] = tmpArray;
            }
            return response;
            /** SET ADMIN NOTIFY */
        },
        GetAdministratorList() {
            this.$store.dispatch('GetClientList', {
                companyID: this.companyID,
                idsys: this.$global.idsys,
                userType:'user',
            }).then(response => {
                let _tmpdefaultadmin = Array();
                $.each(response,function(key, value) {
                     if(value['defaultadmin'] == 'T') {
                        _tmpdefaultadmin.push(value['id']);
                     }
                });
                this.tmpdefaultadmin = response;
                this.selectsAdministrator.administratorSelected = _tmpdefaultadmin;
                this.selectsAdministrator.administratorList = response
            },error => {
                
            });
        },
        GetCompanyList() {
            this.fetchingCampaignData = true;
            // $('.el-select-dropdown__empty').html('Loading data...');
            var _groupCompanyID = '';

            if (this.userType == 'client') {
                const userData = this.$store.getters.userData;
                _groupCompanyID = userData.id;
            }
           
            /** GET CLIENT LIST */
            this.$store.dispatch('GetClientList', {
                companyID: this.companyID,
                idsys: this.$global.idsys,
                userType:'client',
                userModule: 'LeadsPeek',
                groupCompanyID: _groupCompanyID,
            }).then(response => {
                //console.log(response);
                if(response.length == 0) {
                    $('.el-select-dropdown__empty').html('No new client');
                }
                this.selectsCompany.companyList = response
                // console.log(this.selectsCompany.companyList);
                if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '')){
                    this.onCompanyChange(localStorage.getItem('companyGroupSelected'));
                    this.CompanyNamedisabled = true;
                }
            },error => {
                this.fetchingCampaignData = false;
            });
            /** GET CLIENT LIST */            
        },
        sortdynamic(column,order,prop) { 
            this.currSortBy = prop;
            this.currOrderBy = order;
            this.GetClientList(column,order);
        },
        hasProgressCampaign() {
            return this.tableData.some(campaign => 
                ['queue', 'progress'].includes(campaign.fetch_report_status)
            );
        },
        startAutoRefresh() {
            // console.log('startAutoRefresh 1')
            if (!this.refreshInterval) {
                // console.log('startAutoRefresh 2')
                this.refreshInterval = setInterval(() => {
                    this.GetClientList(this.currSortBy, this.currOrderBy);
                }, 60000); // 1 menit
            }
        },
        stopAutoRefresh() {
            // console.log('stopAutoRefresh 1')
            if (this.refreshInterval) {
                // console.log('stopAutoRefresh 2')
                clearInterval(this.refreshInterval);
                this.refreshInterval = null;
            }
        },
        checkAutoRefresh() {
            if (this.hasProgressCampaign()) {
                this.startAutoRefresh();
            } else {
                this.stopAutoRefresh();
            }
        },
        GetClientList(sortby,order,searchkey,isFilter) {
            this.fetchingCampaignData = true;
            var _sortby = 'created_at';
            var _order = 'descending';
            var _searchkey = '';

            if (typeof(sortby) != 'undefined' && sortby != '') {
                _sortby = sortby;
            }
            if (typeof(order) != 'undefined' && order != '') {
                _order = order;
            }
            if (this.searchQuery != '') {
                _searchkey = this.searchQuery;
               
            }
           
            //console.log(_sortby + ' | ' + _order);
            var _groupCompanyID = '';
            if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '')){
                _groupCompanyID = localStorage.getItem('companyGroupSelected');
            }
            /** GET CLIENT LIST */
            this.tableData = [];
            $('.el-table__empty-text').html('<i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...');
            this.$store.dispatch('GetLeadsPeekClientList', {
                companyID: this.companyID,
                leadspeekType: 'predict',
                groupCompanyID: _groupCompanyID,
                sortby: _sortby,
                order: _order,
                searchkey: _searchkey,
                page:this.pagination.currentPage,
                view: 'campaign',
                campaignStatus: this.filterCampaignStatus,
            }).then(response => {
                //console.log(response.length);
                this.pagination.currentPage = response.current_page? response.current_page : 1
               this.pagination.total = response.total ?response.total : 0
               this.pagination.lastPage = response.last_page ? response.last_page : 2
               this.pagination.from = response.from ? response.from : 0
               this.pagination.to = response.to ? response.to : 0
                if(response.data.length == 0) {
                    $('.el-table__empty-text').html('No Data');
                }
                //console.log(response);
                this.tableData = this.AttachedAdminNotify(response.data);
                //this.searchedData = this.tableData;
                //this.searchQuery = "";
                this.initialSearchFuse();
                this.fetchingCampaignData = false;
                
                this.getMasterAgencyCost();
                this.checkAutoRefresh();
            },error => {
                this.fetchingCampaignData = false;
                this.stopAutoRefresh();
            });
            /** GET CLIENT LIST */
        },
        GetClientListAll() {
            //console.log(_sortby + ' | ' + _order);
            var _groupCompanyID = '';
            if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '')){
                _groupCompanyID = localStorage.getItem('companyGroupSelected');
            }
            this.selectsCompany.campaignList = [];
           
            this.$store.dispatch('GetLeadsPeekClientList', {
                companyID: this.companyID,
                leadspeekType: 'predict',
                groupCompanyID: _groupCompanyID,
                view: 'campaign',
            }).then(response => {
                // console.log('GetLeadsPeekClientList', {
                //     response
                // });
                
                this.selectsCompany.campaignList = response;
                // this.selectsCompany.campaignSelected = response.data[0].id;
                // this.ClientActiveID = response.data[0].id;
            },error => {
                
            });
            /** GET CLIENT LIST */
        },
        GetCompanyGroup() {
            const userData = this.$store.getters.userData;
            const companyID = (userData.user_type != 'client') ? userData.company_id : userData.company_parent;
            /** GET COMPANY GROUP */
            this.$store.dispatch('GetCompanyGroup', {
                companyID: companyID,
                userModule: 'LeadsPeek',
            }).then(response => {
                //console.log(response.length);
                if (response.result == 'success') {
                    //this.$global.selectsGroupCompany.companyGroupList = [];
                    //this.$global.selectsGroupCompany.companyGroupList = response.params;
                    // this.selectsGroupCompany.companyGroupList = response.params;
                    // this.selectsGroupCompany.companyGroupList.unshift({'id':0,'group_name':'none'});

                    this.$global.selectsGroupCompany.companyGroupList = response.params;
                    this.$global.selectsGroupCompany.companyGroupList.unshift({'id':'','group_name':'View All'});
                    
                    if (localStorage.getItem('companyGroupSelected') == null && response.params.length > 1) {
                        localStorage.setItem('companyGroupSelected',response.params[1].id);
                    }
                }
            },error => {
                
            });
            /** GET COMPANY GROUP */
        },

        initialSearchFuse() {
            // Fuse search initialization.
            // this.fuseSearch = new Fuse(this.tableData, {
            //     keys: ['company_name','campaign_name','leadspeek_api_id','last_lead_added'],
            //     threshold: 0.1
            // });
        },

        handleLike(index, row) {
            swal.fire({
                title: `You liked ${row.name}`,
                buttonsStyling: false,
                icon: 'success',
                customClass: {
                confirmButton: 'btn btn-default btn-fill'
                }
            });
        },
        copytoclipboard(idembeded) {
            $('#' + idembeded).select();
            document.execCommand('copy');
            $('#' + idembeded + 'Link').html(' Copied!');

        },
        handleEmbededCode(index, row) {
            var codeembeded = '<script>';
                codeembeded += 'var ts = {';
                codeembeded += 'c: "14798651632618831906",';
                codeembeded += 'd: "oi.0o0o.io",';
                codeembeded += 's: ' + row.leadspeek_api_id + ',';
                codeembeded += '};';
                codeembeded += 'if("undefined"!=typeof ts){var url="//";ts.hasOwnProperty("d")?url+=ts.d:url+="oi.0o0o.io",url+="/ts.min.js",function(e,t,n,a,r){var o,s,d;e.ts=e.ts||[],o=function(){e.ts=ts},(s=t.createElement(n)).src=a,s.async=1,s.onload=s.onreadystatechange=function(){var e=this.readyState;e&&"loaded"!==e&&"complete"!==e||(o(),s.onload=s.onreadystatechange=null)},(d=t.getElementsByTagName(n)[0]).parentNode.insertBefore(s,d)}(window,document,"script",url)}';
                codeembeded += '<\/script>';
                codeembeded += '<noscript>';
                codeembeded += '<img src="https://oi.0o0o.io/i/14798651632618831906/s/' + row.leadspeek_api_id + '/tsimg.png" width="1" height="1" style="display:none;overflow:hidden">';
                codeembeded += '</noscript>';
                //console.log(codeembeded);
            $('#leadspeekembededcode').val(codeembeded);

            codeembeded = '<img src="https://oi.0o0o.io/c/14798651632618831906" style="width:1px;height:1px;border:0" />';
            $('#leadspeekembededcodesupression').val(codeembeded);
            this.modals.embededcode = true;
        },
        handleDelete(index, row) {
            const userData = this.$store.getters.userData
            var _status = 'F';
            if (row.active_user == 'F') {
                _status = 'T';
            }
            if (_status == 'T') {
                return false;
            }
            //console.log('Row: ' + index);
            
            //LOG ACTION
            let descriptionLogs = `campaign id: ${row.leadspeek_api_id} | campaign type: ${row.leadspeek_type} | campaign name: ${row.campaign_name}`;
            //LOG ACTION

            // Use custom StopCampaignModal instead of SweetAlert
            StopCampaignModal.fire().then((result) => {
                const stop_after_billing_period = result.stop_after_billing_period;
                if (stop_after_billing_period === null) { // User clicked Cancel
                    return;
                }
                
                // Display appropriate processing message
                this.popProcessingTxt = "Please wait, stopping campaign ....";
                $('#processingArea').addClass('disabled-area');
                $('#popProcessing').show();

                /** REMOVE ORGANIZATION */
                this.$store.dispatch('RemoveLeadsPeekClient', {
                    companyID: this.companyID,
                    leadspeekID: row.id,
                    status: _status,
                    userID: row.user_id,
                    stop_after_billing_period: stop_after_billing_period, // Send stop type to backend
                }).then(response => {
                    //console.log(response)
                    $('#processingArea').removeClass('disabled-area');
                    $('#popProcessing').hide();
                    $('#userstartstop' + index).removeClass('fas fa-stop green').addClass('fas fa-stop gray');

                    row.active = 'F';
                    row.disabled = 'T';
                    row.active_user = 'F';
                    this.GetClientList(this.currSortBy,this.currOrderBy);

                    if(typeof(response.result) != 'undefined' && response.result == 'failed_campaign_already_stopped') {
                        // NOTIFICAITON
                        this.$notify({ type: 'danger', message: response.message, icon: 'tim-icons icon-bell-55' }); 
                        // NOTIFICAITON

                        // LOG ACTION
                        this.$store.dispatch('onSaveUserLogs', {
                            desc: descriptionLogs,
                            action: "Campaign Is Already Stopped",
                            target_id: row.user_id,
                        })
                        // LOG ACTION
                    } else {
                        // NOTIICATION
                        const successMsg = stop_after_billing_period === 'F' ? 'Campaign successfully stopped now.' : 'Campaign scheduled to stop after current billing period.';
                        this.$notify({ type: 'success', message: successMsg, icon: 'tim-icons icon-bell-55' }); 
                        // NOTIICATION

                        // LOG ACTION
                        const logAction = stop_after_billing_period === 'F' ? "Campaign Stopped Now" : "Campaign Stopped After Current Period";
                        this.$store.dispatch('onSaveUserLogs', {
                            desc: descriptionLogs,
                            action: logAction,
                            target_id: row.user_id,
                        })
                        // LOG ACTION
                    }
                },error => {
                    console.log(error);
                    $('#processingArea').removeClass('disabled-area');
                    $('#popProcessing').hide();
                }); 
                /** REMOVE ORGANIZATION */
            });
        },
        deleteRow(row) {
            let indexToDelete = this.tableData.findIndex(
                tableRow => tableRow.id === row.id
            );
            if (indexToDelete >= 0) {
                this.tableData.splice(indexToDelete, 1);
            }
        },

        callbackGoogleConnected(e) {
            window.removeEventListener('message', this.callbackGoogleConnected);
            if (e.origin == process.env.VUE_APP_DATASERVER_URL) {
                if (e.data == 'success') {
                    this.GoogleConnectTrue = true;
                    this.GoogleConnectFalse = false;
                }
            }
        },
        initial_default_price() {
            this.resetAgencyCost();
            this.$store.dispatch('getGeneralSetting', {
                companyID: this.companyID,
                settingname: 'agencydefaultprice',
                idSys: this.$global.idsys
            }).then(response => {
                if (response.data != '') {
                    // this.locatorlead.lead_FirstName_LastName = (response.data.locatorlead.FirstName_LastName != '' && response.data.locatorlead.FirstName_LastName != '0')?this.formatPrice(response.data.locatorlead.FirstName_LastName):'1.50';
                    // this.locatorlead.lead_FirstName_LastName_MailingAddress  = (response.data.locatorlead.FirstName_LastName_MailingAddress != '' && response.data.locatorlead.FirstName_LastName_MailingAddress != '0')?this.formatPrice(response.data.locatorlead.FirstName_LastName_MailingAddress):'2.00';
                    // this.locatorlead.lead_FirstName_LastName_MailingAddress_Phone = (response.data.locatorlead.FirstName_LastName_MailingAddress_Phone != '' && response.data.locatorlead.FirstName_LastName_MailingAddress_Phone != '0')?this.formatPrice(response.data.locatorlead.FirstName_LastName_MailingAddress_Phone):'3.00';

                    this.defaultCostCampaign.enhance.Monthly.EnhancePlatformFee = (response.data.enhance.Monthly.EnhancePlatformFee != '')?response.data.enhance.Monthly.EnhancePlatformFee:'0';
                    this.defaultCostCampaign.enhance.Monthly.EnhanceCostperlead = (response.data.enhance.Monthly.EnhanceCostperlead != '')?response.data.enhance.Monthly.EnhanceCostperlead:'0';
                    this.defaultCostCampaign.enhance.Monthly.EnhanceMinCostMonth = (response.data.enhance.Monthly.EnhanceMinCostMonth != '')?response.data.enhance.Monthly.EnhanceMinCostMonth:'0';

                    this.defaultCostCampaign.enhance.Weekly.EnhancePlatformFee = (response.data.enhance.Weekly.EnhancePlatformFee != '')?response.data.enhance.Weekly.EnhancePlatformFee:'0';
                    this.defaultCostCampaign.enhance.Weekly.EnhanceCostperlead = (response.data.enhance.Weekly.EnhanceCostperlead != '')?response.data.enhance.Weekly.EnhanceCostperlead:'0';
                    this.defaultCostCampaign.enhance.Weekly.EnhanceMinCostMonth = (response.data.enhance.Weekly.EnhanceMinCostMonth != '')?response.data.enhance.Weekly.EnhanceMinCostMonth:'0';

                    this.defaultCostCampaign.enhance.OneTime.EnhancePlatformFee = (response.data.enhance.OneTime.EnhancePlatformFee != '')?response.data.enhance.OneTime.EnhancePlatformFee:'0';
                    this.defaultCostCampaign.enhance.OneTime.EnhanceCostperlead = (response.data.enhance.OneTime.EnhanceCostperlead != '')?response.data.enhance.OneTime.EnhanceCostperlead:'0';
                    this.defaultCostCampaign.enhance.OneTime.EnhanceMinCostMonth = (response.data.enhance.OneTime.EnhanceMinCostMonth != '')?response.data.enhance.OneTime.EnhanceMinCostMonth:'0';

                    this.defaultCostCampaign.enhance.Prepaid.EnhancePlatformFee = (response.data.enhance.Prepaid.EnhancePlatformFee != '')?response.data.enhance.Prepaid.EnhancePlatformFee:'0';
                    this.defaultCostCampaign.enhance.Prepaid.EnhanceCostperlead = (response.data.enhance.Prepaid.EnhanceCostperlead != '')?response.data.enhance.Prepaid.EnhanceCostperlead:'0';
                    this.defaultCostCampaign.enhance.Prepaid.EnhanceMinCostMonth = (response.data.enhance.Prepaid.EnhanceMinCostMonth != '')?response.data.enhance.Prepaid.EnhanceMinCostMonth:'0';

                }else{
                    // this.locatorlead.lead_FirstName_LastName = '1.50';
                    // this.locatorlead.lead_FirstName_LastName_MailingAddress = '2.00';
                    // this.locatorlead.lead_FirstName_LastName_MailingAddress_Phone = '3.00';
                }
                
            },error => {
                    
            });
        },
        resetDefaultCampaigndate() {
            const ServerlocalTime = this.$moment();
            const chicagoTime = ServerlocalTime.tz('America/New_York');

            var todayDate = this.$moment();
            this.StartDateCampaign = chicagoTime.format('YYYY-MM-DD');
            this.EndDateCampaign = todayDate.add(6,'months').format('YYYY-MM-DD');
        },
        handleVisibleChange(visible) {            
            this.dropdownVisible = visible;
        },
        applyFilters(event){
            event.stopPropagation();
            this.GetClientList(this.currSortBy, this.currOrderBy)
            this.dropdownVisible = false;
        },
        applyFilter(filter){
            this.filterCampaignStatus = filter.value
            this.GetClientList(this.currSortBy, this.currOrderBy)
            this.dropdownVisible = false;
        },
        getStopWords(){
            const userData = this.$store.getters.userData;

            this.$store.dispatch('getStopWords', {
                company_root_id: userData.company_root_id,
            }).then(response => {
                this.stopWords = response.data.stopWords
            }, error => {   
                console.error(error);
            })
        },
        onImportCampaignSelectedChange(campaign){
            this.newcampaign.asec5_3 = ''
            this.selects.state = []
            this.newcampaign.asec5_4_0_3 = false;
            this.newcampaign.asec5_4_0_0 = false;
            this.newcampaign.asec5_4_0_1 = false;
            let selected = this.selectsCompany.campaignList.filter(item => item.id === campaign)[0]
            this.ClientCampaignName = selected.campaign_name
            
            if (selected.national_targeting == 'T') {
                this.newcampaign.asec5_4_0_0 = true;
            }else{
               
                if (selected.leadspeek_locator_zip != "" && selected.leadspeek_locator_zip != null) {
                    this.newcampaign.asec5_4_0_3 = true;
                    this.newcampaign.asec5_3 = this.replaceCommaLine(selected.leadspeek_locator_zip);
                }

                if (selected.leadspeek_locator_state != "" && selected.leadspeek_locator_state != null) {
                    this.newcampaign.asec5_4_0_1 = true;
                    
                    let _ClientLocatorState =  selected.leadspeek_locator_state.split(",");
                    let _ClientLocatorStateSifi = selected.leadspeek_locator_state_external.split(",");

                    for(var i=0;i<_ClientLocatorState.length;i++) {
                        if (_ClientLocatorStateSifi[i] != '' &&  _ClientLocatorState[i] != '') {
                            this.selects.state.push(_ClientLocatorStateSifi[i] + '|' + _ClientLocatorState[i]);
                        }
                    }

                }else{
                  
                }
               
          

            }

            
            if (selected.leadspeek_locator_keyword != "" && selected.leadspeek_locator_keyword != null) {
                this.tags.keywordlistbulk = selected.leadspeek_locator_keyword.split(",");
                this.tags.keywordlist = selected.leadspeek_locator_keyword.split(",");

            }
            // console.log(selected.admin_notify_to,'admins notify to ')
            // if(selected.admin_notify_to != '' && selected.admin_notify_to != null){
            //     this.selectsAdministrator.administratorSelected = selected.admin_notify_to
            // }
            // if (row.leadspeek_locator_keyword_contextual != null && row.leadspeek_locator_keyword_contextual != "") {
            //     row.leadspeek_locator_keyword_contextual = row.leadspeek_locator_keyword_contextual.split(",");
            // }
           

            if(selected.reidentification_type !== '' && selected.reidentification_type == null){
                this.Reidentificationtime = selected.reidentification_type
            }
            this.StartDateCampaign = (selected.campaign_startdate != '0000-00-00')?selected.campaign_startdate:'';
            this.EndDateCampaign = (selected.campaign_enddate != '0000-00-00')?selected.campaign_enddate:'';
            
            
            if (selected.homeaddressenabled == 'T') {
                this.checkboxes.homeaddressenabled = true;
            }else{
                this.checkboxes.homeaddressenabled= false;
            }

            if (selected.phoneenabled == 'T') {
                this.checkboxes.phoneenabled = true;
            }else{
                this.checkboxes.phoneenabled = false;
            }

            if (selected.require_email == 'T') {
                this.checkboxes.requireemailaddress = true;
            }else{
                this.checkboxes.requireemailaddress = false;
            }

            if (selected.applyreidentificationall == 'T') {
                this.checkboxes.ApplyReidentificationToAll = true;
            } else {
                this.checkboxes.ApplyReidentificationToAll = false;
            }
            
            
        },
        getLocationBigDbm(){
            this.isLoadingOptionsCity = true

            return this.$store.dispatch('getLocationBigDbm', {
                type: 'city',
                param: this.stateCode.join(''),
                limit: this.limitOptionsCity,
                search: this.searchCity,
            }).then(response => {
                this.optionsCity = response.data
                this.totalCity = response.total
                this.isLoadingOptionsCity = false
            }, error => {
                console.error(error);
                this.isLoadingOptionsCity = false
            })
        },
        onStateChange(selectedState, row){
            const isFetchCity = selectedState.length == 1

            if(selectedState.length > 5){
                selectedState.splice(5);

                this.$notify({
                    type: 'danger',
                    message: 'A maximum of 5 states may be selected.',
                    icon: 'fas fa-exclamation-circle'
                })
            }

            if(isFetchCity){
                this.stateCode = selectedState;
                this.limitOptionsCity = 50;
                this.getLocationBigDbm();
            } else {
                this.selectedCity = '';

                if(row){
                    row.leadspeek_locator_city = ''
                }
            }

            this.clearErrorInput('selects.state')
        },
        onStateChangeApproxLeadCount(selectedState, row){
            const isFetchCity = selectedState.length == 1

            if(selectedState.length > 5){
                selectedState.splice(5);

                this.$notify({
                    type: 'danger',
                    message: 'A maximum of 5 states may be selected.',
                    icon: 'fas fa-exclamation-circle'
                })
            }

            if(isFetchCity){
                this.stateCode = selectedState;
                this.limitOptionsCity = 50;
                this.getLocationBigDbm();
            } else {
                this.selectedCity = '';

                if(row){
                    row.cities = ''
                }
            }
        },
        onCityChange(selectedCity){
            if(selectedCity.length > 10){
                selectedCity.splice(10);

                this.$notify({
                    type: 'danger',
                    message: 'A maximum of 10 cities may be selected.',
                    icon: 'fas fa-exclamation-circle'
                })
            }
        },
        onSearchCity(query){
            this.searchCity = query
            this.limitOptionsCity = 50
            this.getLocationBigDbm()
            this.scrollToTop()
        },
        onDropdownVisible(visible) {
            if (visible) {
                this.$nextTick(() => {
                    const dropdown = this.$refs.select.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
                    if (dropdown) {
                        dropdown.addEventListener('scroll', this.handleScroll);
                    } else {
                        console.error('Dropdown not found');
                    }
                });
            } else {
                this.searchCity = ''
                this.getLocationBigDbm()
            }
        },
        handleScroll(event) {
            const dropdown = event.target;
            if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 1) {
                
                if(this.limitOptionsCity > this.totalCity){
                    return;
                } else {
                    this.limitOptionsCity += 50
                    this.getLocationBigDbm()
                }

            }
        },
        scrollToTop() {
            this.$nextTick(() => {
                const dropdown = this.$refs.select.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
                if (dropdown) {
                    dropdown.scrollTop = 0;
                } else {
                    console.error('Dropdown not found');
                }
            });
        },
        onPasteEditZipCodes(event, row, type){
            event.preventDefault();
            let zipCodeRow = row

            const pastedText = (event.clipboardData || window.clipboardData).getData('text');

            let modifiedText = pastedText.replace(/,/g, '\n').replace(/\s+/g, '\n').trim();

            const input = event.target;
            const cursorPos = input.selectionStart;
            const selectionEnd = input.selectionEnd;

            // Check if any text is selected
            if (cursorPos !== selectionEnd) {
                // If there is text selected, replace the selected text with the pasted one
                const textBeforeSelection = input.value.substring(0, cursorPos);
                const textAfterSelection = input.value.substring(selectionEnd);
                zipCodeRow = textBeforeSelection + modifiedText + textAfterSelection;
            } else {
                // If no text is selected, add text at the cursor position
                const textBeforeCursor = input.value.substring(0, cursorPos);
                const textAfterCursor = input.value.substring(cursorPos);
                zipCodeRow = textBeforeCursor + modifiedText + textAfterCursor;
            }

            // Removes consecutive blank lines if any
            zipCodeRow = zipCodeRow.replace(/\n{2,}/g, '\n').trim();
            
            if (type == 'ApproxLeadCount'){
                this.formApproxLeadCount.zip_code = zipCodeRow
                return;
            }

            this.selectedRowData.leadspeek_locator_zip = zipCodeRow
        },
        fetchLeadCount(row){
            const userData = this.$store.getters.userData;
            this.tableDataApprox = []
            this.userIdCampaign = row.user_id;
            $('.el-table__empty-text').html('<i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...');
            
            const payload = {
                id: row.id
            }

            this.$store.dispatch('getApproxLeadCount', payload).then(response => {
                const data = response.data
    
                if(data.length == 0){
                    const formApproxLeadCount = {
                        ...this.formApproxLeadCount,
                        campaign_id: row.id,
                        leadspeek_api_id: row.leadspeek_api_id,
                        user_id: row.user_id,
                        email: userData.email,
                        keyword: [],
                        keyword_bulk: [],
                        rows: []
                    }
                    this.isProccessingLeadCount = false;
                    this.isFinishedApproxLeadCount = false;
                    this.formApproxLeadCount = formApproxLeadCount
                    this.useDefaultTargetLocation();
                    $('.el-table__empty-text').html('No Data');
                } else {
                    if (data.status != 'process' && this.intervalFetchLeadCount) {
                        clearInterval(this.intervalFetchLeadCount);
                        this.intervalFetchLeadCount = null;
                    }

                    const states = data.states.length != 0 ? data.states.split(',') : ''
                    if(states.length == 1){
                        this.stateCode = states
                        this.getLocationBigDbm()
                    }
                    
                    const splitFields = ['states', 'cities', 'keyword'];
                    splitFields.forEach(field => {
                        if (data[field].length !== 0) {
                            data[field] = data[field].split(",");
                        }
                    });

                    data.keyword_bulk = data.keyword
                    data.user_id = row.user_id
                    this.isProccessingLeadCount = data.status == 'process';
                    this.isFinishedApproxLeadCount = data.status == 'finished';
                    this.prevFormApproxLeadCount = { ...data }
                    this.formApproxLeadCount = { ...data };

                    this.tableDataApprox = data.rows
                    if(this.tableDataApprox == 0){
                        $('.el-table__empty-text').html('No Data');
                    }
                    
                    if(data.status === 'error'){
                        this.isErrorFetchLeadCount = true
                        this.isProccessingLeadCount = false;
                        if(this.intervalFetchLeadCount){
                            clearInterval(this.intervalFetchLeadCount);
                            this.intervalFetchLeadCount = null;
                        }
                    }
                }

                this.modals.approxLead = true
            }, err => {
                this.$notify({
                    type: 'primary',
                    message: 'Sorry there is something wrong, pleast try again later',
                    icon: 'fas fa-bug'
                });
            })
        },
        handleApproxLeadCountTargetLocationChange(event, value) {
            if (value == 'National Targeting'){
                this.formApproxLeadCount.states = []
                this.formApproxLeadCount.cities = []
                this.formApproxLeadCount.zip_code = ''
            } else if (value == 'State'){
                this.formApproxLeadCount.zip_code = ''
            } else if (value == 'Zip Code'){
                this.formApproxLeadCount.states = []
                this.formApproxLeadCount.cities = []
            }

            if (event.target.checked) {
                this.formApproxLeadCount.target_location = value;
            } else if (this.formApproxLeadCount.target_location === value) {
                this.formApproxLeadCount.target_location = '';
            }
        },
        handleGetCountApproxLead(){
            this.isLoadingGetCount = true
            const payloadApproxLeadCount = { ...this.formApproxLeadCount };            
            const validation = this.validationApproxLeadCount(payloadApproxLeadCount)

            if(!validation){
                this.isLoadingGetCount = false
                return false
            }

            payloadApproxLeadCount.company_id = this.companyID
            delete payloadApproxLeadCount.keyword_bulk
            if (payloadApproxLeadCount.target_location === 'National Targeting') {
                delete payloadApproxLeadCount.states;
                delete payloadApproxLeadCount.cities;
                delete payloadApproxLeadCount.zip_code;
            } else if (payloadApproxLeadCount.target_location === 'State') {
                delete payloadApproxLeadCount.zip_code;
            } else if (payloadApproxLeadCount.target_location === 'Zip Code') {
                delete payloadApproxLeadCount.states;
                delete payloadApproxLeadCount.cities;
            }

            this.$store.dispatch('onApproxLeadCount', payloadApproxLeadCount).then(response => {
                this.$notify({
                    type: 'success',
                    message: response.message,
                    icon: 'tim-icons icon-bell-55'
                });  
                this.isLoadingGetCount = false
                this.modals.approxLead = false

                this.userLogsGetCount(payloadApproxLeadCount)
            }, err => {
                this.isLoadingGetCount = false
                this.$notify({
                    type: 'danger',
                    message: 'Sorry there is something wrong, pleast try again later',
                    icon: 'fas fa-exclamation-circle'
                });  
            })
        },
        async handleAddToCampaignApproxLead(){
            const confirm = await swal.fire({
                title: 'Confirm Keywords Merge',
                html: `
                    <p style="font-size: 16px; color: black">Keywords from <strong>Volume Tools</strong> will be merged with the existing keywords in this campaign.</p>
                    <p style="font-size: 14px; color: red;">Please ensure the combined keywords do not exceed <strong>500 characters</strong>.</p>
                `,
                showCancelButton: true,
                confirmButtonText: 'Proceed & Merge',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn btn-default btn-fill mr-3',
                    cancelButton: 'btn btn-danger btn-fill'
                },
                buttonsStyling: false
            })

            if (!confirm.isConfirmed) {
                return;
            }

            this.isLoadingAddToCampaign = true
            const payloadApproxLeadCount = {...this.formApproxLeadCount}
            const validation = this.validationApproxLeadCount(payloadApproxLeadCount)

            if(!validation){
                this.isLoadingAddToCampaign = false
                return false
            }

            const hasChangedValue = this.hasChangedValue(this.prevFormApproxLeadCount, this.formApproxLeadCount)
            
            if(hasChangedValue){
                await swal.fire({
                    title: 'Data Changed',
                    text: "Some data has been modified. Please retest the contact count to ensure it is accurate.",
                    showCancelButton: true,
                    customClass: {
                        confirmButton: 'btn btn-fill mr-3',
                        cancelButton: 'btn btn-danger btn-fill'
                    },
                    confirmButtonText: 'Reset',
                    buttonsStyling: false
                }).then((result) => {
                    if(result.isConfirmed){
                        this.formApproxLeadCount = {...this.prevFormApproxLeadCount}
                    }
                })

                this.isLoadingAddToCampaign = false
                return;
            }

            const payload = {
                campaign_id: payloadApproxLeadCount.campaign_id,
                type: 'add',
                keywords: payloadApproxLeadCount.keyword,
            }

            this.$store.dispatch('onApplyCampaign', payload).then(response => {
                this.$notify({
                    type: 'success',
                    message: response.message,
                    icon: 'tim-icons icon-bell-55'
                });
                this.GetClientList(this.currSortBy,this.currOrderBy)
                this.isLoadingAddToCampaign = false
                this.modals.approxLead = false
            }, async err => {
                if(err.result == 'error validation'){
                    await swal.fire({
                        title: "Mismatch Detected",
                        html: `
                            <div style="display: flex; flex-direction: column; gap: 8px;">
                                <p style="color: #101111; margin-bottom: 16px; opacity: 0.7;">The Search Volume Estimate geo targeting settings do not match the existing settings on the campaign. <br /> Please confirm your geo targeting choice.</p>
                                <button id="btn-apply-campaign" style="background-color: #101111; color: white; padding: 9px 19px; border: none; border-radius: 8px; font-size: 0.935rem; font-weight: 600; width: 100%;">Update Geo Targeting</button>
                                <button id="btn-default-target" style="background-color: #686868; color: white; padding: 9px 19px; border: none; border-radius: 8px; font-size: 0.935rem; font-weight: 600; width: 100%;">Maintain Existing Geo Targeting</button>
                                <button id="btn-close" style="background-color: transparent; color: gray; padding: 8px 19px; border: 1px solid gray; border-radius: 8px; font-size: 0.935rem; font-weight: 600; width: 100%;">Close</button>
                            </div>
                        `,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        onOpen: () => {
                            const btnApply = document.getElementById('btn-apply-campaign');
                            btnApply.addEventListener('click', async () => {
                               btnApply.disabled = true
                               btnApply.style.backgroundColor = "#cccccc"
                               btnApply.style.cursor = "not-allowed";
                               btnApply.innerHTML = `<i class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i> Update Geo Targeting`
                               const result = await this.onApplyToCampaign(payloadApproxLeadCount)
                               if(result){
                                   swal.close()
                                   this.modals.approxLead = false
                                   this.GetClientList(this.currSortBy,this.currOrderBy)
                                   btnApply.disabled = false
                                   btnApply.style.backgroundColor = "#101111"
                                   btnApply.style.cursor = "pointer";
                                   btnApply.innerHTML = `Update Geo Targeting`
                               } else {
                                   btnApply.disabled = false
                                   btnApply.style.backgroundColor = "#101111"
                                   btnApply.style.cursor = "pointer";
                                   btnApply.innerHTML = `Update Geo Targeting`
                               }
                            });

                            document.getElementById('btn-default-target').addEventListener('click', () => {
                                this.useDefaultTargetLocation()
                                this.isDefaultTargetLocation = false
                                swal.close()
                            });
                            document.getElementById('btn-close').addEventListener('click', () => {
                                swal.close()
                            });
                        },
                    })
                    
                    this.isLoadingAddToCampaign = false
                    return;
                }

                this.$notify({
                    type: 'danger',
                    message: err.message,
                    icon: 'fas fa-exclamation-circle'
                });
                this.isLoadingAddToCampaign = false
            })
        },
        handleCancelApproxLead(){
            this.modals.approxLead = false
        },
        validationApproxLeadCount(form){
            if (!form.email){
                this.messageValidationRequired('Email')
                
                return false
            }
            
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(form.email)) {
                this.$notify({
                    type: 'danger',
                    message: `Email invalid`,
                    icon: 'fas fa-exclamation-circle'
                })

                return false
            }

            if(!form.target_location){
                this.messageValidationRequired('Target Location')

                return false
            }
            
            const isStatesNull = form.states.length == 0
            if(form.target_location === 'State' && isStatesNull){
                this.messageValidationRequired('States')
                return false
            }

            if(form.target_location === 'Zip Code' && !form.zip_code){
                this.messageValidationRequired('Zip Code')
                return false
            } else if(form.target_location === 'Zip Code' && form.zip_code){
                const zipArray = form.zip_code.split('\n');
                
                if (zipArray[0].trim() == '') {
                    this.$notify({
                        type: 'danger',
                        message: `Please check the required fields (ZIP Codes).`,
                        icon: 'fas fa-exclamation-circle'
                    })
                    return false
                } else if(zipArray.length > 50) {
                    this.$notify({
                        type: 'danger',
                        message: `Please check the required fields (Max 50 ZIP Codes).`,
                        icon: 'fas fa-exclamation-circle'
                    })
                    return false
                }
            }

            if(form.keyword.length == 0){
                this.messageValidationRequired('Keyword')
                return false
            }

            return true
        },
        messageValidationRequired(type){
            this.$notify({
                type: 'danger',
                message: `${type} is required`,
                icon: 'fas fa-exclamation-circle'
            })
        },
        hasChangedValue(prevData, currentData){
            const isNationalTargetingChanged = prevData.national_targeting !== currentData.national_targeting;
            const isZipCodeChanged = prevData.zip_code !== currentData.zip_code;
            const isStateChanges = this.hasChangedArray(prevData.states, currentData.states)
            const isCitiesChanges = this.hasChangedArray(prevData.cities, currentData.cities)
            // const isKeywordChanges = this.hasChangedArray(prevData.keyword, currentData.keyword)
            const rowsKeywords = currentData.rows.map(row => row.keyword);
            const missingKeywords = currentData.keyword.filter(keyword => !rowsKeywords.includes(keyword.toLowerCase()));
            const isKeywordMissing = missingKeywords.length > 0

            if(isStateChanges || isCitiesChanges || isNationalTargetingChanged || isZipCodeChanged || isKeywordMissing){
                return true
            }

        },
        hasChangedArray(prevData, currentData){
            if (prevData.length !== currentData.length) {
                return true;
            }

            // Check each element in the array
            for (let i = 0; i < prevData.length; i++) {
                if (prevData[i] !== currentData[i]) {
                    return true; // Return true if any element is different
                }
            }

            // Return false if all elements are the same
            return false;
        },
        useDefaultTargetLocation(){
            const data = this.prevRowData;
            if (data.national_targeting == 'T'){
                this.formApproxLeadCount = {
                    ...this.formApproxLeadCount,
                    target_location: 'National Targeting',
                    states: [],
                    cities: [],
                    zip_code: '',
                }
            } else if (data.leadspeek_locator_state){
                const states = data.leadspeek_locator_state != 0 ? data.leadspeek_locator_state.split(',') : '';
                if(states.length == 1){
                    this.stateCode = states
                    this.getLocationBigDbm()
                }

                let cities = [];
                if (data.leadspeek_locator_city){
                    const city = data.leadspeek_locator_city.split(',');
                    cities = city
                }

                this.formApproxLeadCount = {
                    ...this.formApproxLeadCount,
                    target_location: 'State',
                    states,
                    cities,
                    zip_code: '',
                }
            } else if (data.leadspeek_locator_zip){
                const zipCode = data.leadspeek_locator_zip.split(',').join('\n');
                this.formApproxLeadCount = {
                    ...this.formApproxLeadCount,
                    target_location: 'Zip Code',
                    states: [],
                    cities: [],
                    zip_code: zipCode,
                }
            }
        },
        async onApplyToCampaign(payloadApproxLeadCount){
            const payloadApply = {
                campaign_id: payloadApproxLeadCount.campaign_id,
                type: 'replace'
            }

            return await this.$store.dispatch('onApplyCampaign', payloadApply).then(response => {
                this.$notify({
                    type: 'success',
                    message: response.message,
                    icon: 'tim-icons icon-bell-55'
                });
                return true
            }, err => {
                this.$notify({
                    type: 'danger',
                    message: 'Sorry there is something wrong, pleast try again later',
                    icon: 'fas fa-exclamation-circle'
                });
                return false
            })
        },
        handleAutoOpenModal(){
            const query = this.$route.query
            if(!query.campaign_id && !query.type){
                return;
            }

            const payload = {
                campaign_id: query.campaign_id,
            }
            
            this.$store.dispatch('getCampaignById', payload).then(response => {
                const row = response.data
                if(row.admin_notify_to){
                    row.admin_notify_to = row.admin_notify_to.split(',')
                    const numberArray = row.admin_notify_to.map(Number);
                    row.admin_notify_to = numberArray;
                }

                row.target_nt = false;
                row.target_state = false;
                row.target_zip = false;

                if (row.national_targeting == 'T'){
                    row.target_nt = true;
                } else if (row.leadspeek_locator_state){
                    row.target_state = true;
                    if (row.leadspeek_locator_city){
                        row.target_city = true;
                    }

                } else if (row.leadspeek_locator_zip){
                    row.target_zip = true;
                }

                if(query.type == 'play'){
                    this.rowClickedEdit(row.id, row)
                }

                if(query.type == 'alc'){
                    this.rowClickedApprox(row.id, row)
                }
            }, err => {
                this.$notify({
                    type: 'danger',
                    message: err.message,
                    icon: 'fas fa-exclamation-circle'
                });
            })

        },
        getCountCampaignHistory(data){
            this.tableDataPlayApprox = []
            $('.el-table__empty-text').html('<i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...');

            const payload = {
                campaign_id: data.campaign_id,
                type: 'play'
            }

            this.$store.dispatch('getCountCampaignHistory', payload).then(response => {
                if(response.status == 'finished'){
                    this.tableDataPlayApprox = response.data
                } else {
                    this.tableDataPlayApprox = []
                    $('.el-table__empty-text').html('No Data');
                }
            }, err => {
                console.log(err);
                $('.el-table__empty-text').html('No Data');
            })
        },
        GetListAdvanceInformation() {
            this.isLoadingAdvancedInformation = true;
            this.isErrorAdvancedInformation = false,
            this.$store
                .dispatch('GetListAdvanceInformation')
                .then(response => {
                    this.listAdvancedInformation = response.listAdvanceInformation;

                    // harcode untuk menambahkan Phone1 Phone2 di type contactInformation
                    this.listAdvancedInformation.forEach((item, index) => {
                        if(item.type == 'contactInformation') {
                            this.listAdvancedInformation[index].description.unshift("Phone1", "Phone2");
                        }
                    });
                    
                    this.isLoadingAdvancedInformation = false;
                })
                .catch(error => {
                    this.isLoadingAdvancedInformation = false;
                    this.isErrorAdvancedInformation = true
                });
        },
        isRowsTableDataApproxReady(){
            if(this.formApproxLeadCount.rows.length > 0){
                return true
            }

            return false
        },
        onViewExampleData() {
            window.open(this.advanceExampleDataUrl, "_blank");
        },
        onSendTestLead(){
            this.isLoadingSendTestLead = true
            const payload = {
                type: this.selectedIntegration,
                date: this.$moment().format('YYYY-MM-DD'),
                company_id: this.selectedRowData.company_id,
                campaign_id: this.selectedRowData.leadspeek_api_id,
                format: {
                    home_address_enabled: this.selectedRowData.homeaddressenabled,
                    phone_enabled: this.selectedRowData.phoneenabled,
                },
            }

            if(this.selectedIntegration == 'gohighlevel'){
                if(this.ghl_tags.length > 0){
                    const tags_go_high_level = this.ghl_tags.map(item => { return item.includes('|') ? item.split('|')[1] : item });
                    payload.tags_go_high_level = tags_go_high_level
                }
                payload.status_keyword_to_tags = this.isActiveTagsAutomation;
            } else if (this.selectedIntegration == 'sendgrid'){
                if(this.selectedRowData.sendgrid_action.includes('add-to-list')){
                    payload.sendgrid_list = this.selectedRowData.sendgrid_list
                }
            } else if (this.selectedIntegration == 'mailboxpower'){
                if(this.mbp_groups.length > 0){
                    const group_mail_box_power = this.mbp_groups.map(item => item.split("|")[0]).filter(Boolean);
                    const new_group_mail_box_power = this.mbp_groups.filter(item => !item.includes('|'));
                    if(new_group_mail_box_power.length > 0){
                        payload.new_group_mail_box_power = new_group_mail_box_power
                    }
                    payload.group_mail_box_power = group_mail_box_power
                }
            } else if (this.selectedIntegration == 'zapier'){
                payload.webhook_url = this.zapierWebhook
                payload.webhook_tags = this.zapierTags
            } else if (this.selectedIntegration == 'kartra'){
                payload.campaign_id = this.selectedRowData.id;
                payload.kartra_list = this.selectedKartraList;
                payload.kartra_tags = this.selectedKartraTags;
                payload.date = this.$moment().format('YYYY-MM-DD');
            } else if (this.selectedIntegration == 'clickfunnels'){
                const listIdTagsClickFunnelsSelected = this.listTagsClickFunnelsSelected.map((tag) => tag.id)
                payload.clickfunnels_tags = listIdTagsClickFunnelsSelected;
            }

            this.$store.dispatch('onSendTestLead', payload).then(response => {
                this.$notify({
                    type: 'success',
                    message: 'Sent test contact successfully!',
                    icon: 'far fa-save'
                });
                this.isLoadingSendTestLead = false
            }, err => {
                this.isLoadingSendTestLead = false
                this.$notify({
                    type: 'danger',
                    message: err.message,
                    icon: 'fas fa-exclamation-circle'
                });
            })
        },
        onChangeCampaignInformationData(value){
            this.campaignInformationData = value;
            if(value == 'advanced') {
                this.onCheckItemAdvancedInformation();
            }
        },
        onChangeRowCampaignInformationData(value){
            this.rowCampaignInformationData = value;
            if(value == 'advanced') {
                this.onCheckItemRowAdvancedInformation();
            }
        },
        onCheckAllAdvancedInformation(value){
            /* ADVANCE */
            const listAllIdAdvanced = this.listAdvancedInformation.map((item) => item.id)
            this.idAdvancedInformation = value ? listAllIdAdvanced : [];
            this.isIndeterminateAdvancedInformation = false;
            /* ADVANCE */
            
            /* BASIC */
            if(value == true && this.checkboxes.phoneenabled == false) {
                this.openPhoneConfirmationModal('checkboxes');
            } else {
                this.checkboxes.phoneenabled = value;
            }
            this.checkboxes.homeaddressenabled = value;
            this.checkboxes.requireemailaddress = value;
            /* BASIC */
        },
        onCheckAllRowAdvancedInformation(value){
            /* ADVANCE */
            const listAllIdAdvanced = this.listAdvancedInformation.map((item) => item.id)
            this.idRowAdvancedInformation = value ? listAllIdAdvanced : [];
            this.isIndeterminateRowAdvancedInformation = false;
            /* ADVANCE */

            /* BASIC */
            if(value == true && this.selectedRowData.phoneenabled == false) {
                this.openPhoneConfirmationModal('selectedRowData');
            } else {
                this.selectedRowData.phoneenabled = value;
            }
            this.selectedRowData.homeaddressenabled = value;
            this.selectedRowData.require_email = value;
            /* BASIC */
        },
        onCheckItemAdvancedInformation(){
            const listAllIdAdvanced = this.listAdvancedInformation.map((item) => item.id)
            // this.checkAllAdvancedInformation = this.idAdvancedInformation.length === listAllIdAdvanced.length
            // this.isIndeterminateAdvancedInformation = this.idAdvancedInformation.length > 0 && this.idAdvancedInformation.length < listAllIdAdvanced.length

            if(this.idAdvancedInformation.length === listAllIdAdvanced.length && this.checkboxes.phoneenabled === true && this.checkboxes.homeaddressenabled === true && this.checkboxes.requireemailaddress === true) {
                this.checkAllAdvancedInformation = true;
            } else {
                this.checkAllAdvancedInformation = false;
            }

            if((this.idAdvancedInformation.length > 0 && this.idAdvancedInformation.length == listAllIdAdvanced.length) && (this.checkboxes.phoneenabled === true && this.checkboxes.homeaddressenabled === true && this.checkboxes.requireemailaddress === true)) {
                this.isIndeterminateAdvancedInformation = false;
            } else if((this.idRowAdvancedInformation.length > 0 && this.idRowAdvancedInformation.length == listAllIdAdvanced.length) && (this.checkboxes.phoneenabled === false || this.checkboxes.homeaddressenabled === false || this.checkboxes.require_email === false)) {
                this.isIndeterminateAdvancedInformation = true;
            } else if((this.idAdvancedInformation.length > 0 && this.idAdvancedInformation.length < listAllIdAdvanced.length) || (this.checkboxes.phoneenabled === true || this.checkboxes.homeaddressenabled === true || this.checkboxes.requireemailaddress === true)) {
                this.isIndeterminateAdvancedInformation = true;
            } else if((this.idAdvancedInformation.length == 0 && this.idAdvancedInformation.length < listAllIdAdvanced.length) && (this.checkboxes.phoneenabled === false && this.checkboxes.homeaddressenabled === false && this.checkboxes.requireemailaddress === false)) {
                this.isIndeterminateAdvancedInformation = false;
            }
        },
        onCheckItemRowAdvancedInformation(){
            const listAllIdAdvanced = this.listAdvancedInformation.map((item) => item.id)
            // this.checkAllRowAdvancedInformation = this.idRowAdvancedInformation.length === listAllIdAdvanced.length
            // this.isIndeterminateRowAdvancedInformation = this.idRowAdvancedInformation.length > 0 && this.idRowAdvancedInformation.length < listAllIdAdvanced.length
            
            if(this.idRowAdvancedInformation.length === listAllIdAdvanced.length && this.selectedRowData.phoneenabled === true && this.selectedRowData.homeaddressenabled === true && this.selectedRowData.require_email === true) {
                this.checkAllRowAdvancedInformation = true;
            } else {
                this.checkAllRowAdvancedInformation = false;
            }

            if((this.idRowAdvancedInformation.length > 0 && this.idRowAdvancedInformation.length == listAllIdAdvanced.length) && (this.selectedRowData.phoneenabled === true && this.selectedRowData.homeaddressenabled === true && this.selectedRowData.require_email === true)) {
                this.isIndeterminateRowAdvancedInformation = false;
            } else if((this.idRowAdvancedInformation.length > 0 && this.idRowAdvancedInformation.length == listAllIdAdvanced.length) && (this.selectedRowData.phoneenabled === false || this.selectedRowData.homeaddressenabled === false || this.selectedRowData.require_email === false)) {
                this.isIndeterminateRowAdvancedInformation = true;
            } else if((this.idRowAdvancedInformation.length > 0 && this.idRowAdvancedInformation.length < listAllIdAdvanced.length) || (this.selectedRowData.phoneenabled === true || this.selectedRowData.homeaddressenabled === true || this.selectedRowData.require_email === true)) {
                this.isIndeterminateRowAdvancedInformation = true;
            } else if((this.idRowAdvancedInformation.length == 0 && this.idRowAdvancedInformation.length < listAllIdAdvanced.length) && (this.selectedRowData.phoneenabled === false && this.selectedRowData.homeaddressenabled === false && this.selectedRowData.require_email === false)) {
                this.isIndeterminateRowAdvancedInformation = false;
            }
        },
        userLogsGetCount(payloadApproxLeadCount){
            const userData = this.$store.getters.userData;
            const previous = this.prevFormApproxLeadCount;
            let desc = `Campaign Id: ${payloadApproxLeadCount.leadspeek_api_id} | `;

            const appendDescription = (field, prevValue, newValue) => {
                desc += `${field} : Update values from ${prevValue || 'Empty'} to: ${newValue || 'Empty'} | `;
            };
            const joinArray = (arr) => (arr && arr.length > 0 ? arr.join(', ') : 'Empty');

            if(previous){
                if(previous.email != payloadApproxLeadCount.email){
                    appendDescription("Email", previous.email, payloadApproxLeadCount.email);
                }

                if(previous.target_location != payloadApproxLeadCount.target_location){
                    appendDescription("Target Location", previous.target_location, payloadApproxLeadCount.target_location);
                }

                const isChangedKeyword = this.hasChangedArray(previous.keyword, payloadApproxLeadCount.keyword)

                if(payloadApproxLeadCount.target_location == 'State'){
                    const isChangedStates = this.hasChangedArray(previous.states, payloadApproxLeadCount.states)
                    const isChangedCities = this.hasChangedArray(previous.cities, payloadApproxLeadCount.cities)

                    if(isChangedStates){
                        appendDescription(
                            "States",
                            joinArray(previous.states),
                            joinArray(payloadApproxLeadCount.states)
                        );
                    }
                    
                    if(isChangedCities){
                        appendDescription(
                            "Cities",
                            joinArray(previous.cities),
                            joinArray(payloadApproxLeadCount.cities)
                        );
                    }
                } else if (payloadApproxLeadCount.target_location == 'Zip Code'){
                    if(previous.zip_code != payloadApproxLeadCount.zip_code){
                        appendDescription(
                            "Zip Code",
                            previous.zip_code,
                            payloadApproxLeadCount.zip_code
                        );
                    }
                }

                if(isChangedKeyword){
                    appendDescription(
                        "Keyword",
                        joinArray(previous.keyword),
                        joinArray(payloadApproxLeadCount.keyword)
                    );
                }

                if(desc == `Campaign Id: ${payloadApproxLeadCount.leadspeek_api_id} | ` || desc == ''){
                    desc += 'No updates were made as all values remain unchanged.'
                }

                // const data = {
                //     userID: userData.id,
                //     action: "Search Volume Tools - Update Get Count",
                //     desc,
                //     userIP: this.$store.getters.userData.ip_login,
                // }
                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                // if(userViewMode){
                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                //     data.userID = userRoot.id;
                // }
                // this.userLogSaved({ data });
                this.$store.dispatch('onSaveUserLogs', {
                    desc: desc,
                    action: "Search Volume Tools - Update Get Count",
                    // target_id: this.selectedRowData.user_id,
                    target_id: this.userIdCampaign,
                })
                
            } else {
                desc += `Email : ${payloadApproxLeadCount.email} | `
                desc += `Target Location : ${payloadApproxLeadCount.target_location} | `
                
                if(payloadApproxLeadCount.target_location == 'State'){
                    desc += `States : ${joinArray(payloadApproxLeadCount.states)} | `;
                    desc += `Cities : ${joinArray(payloadApproxLeadCount.cities)} | `;
                } 
                
                if(payloadApproxLeadCount.target_location == 'Zip Code'){
                    desc += `Zip Code : ${payloadApproxLeadCount.zip_code} | `
                }
                
                desc += `Keyword : ${joinArray(payloadApproxLeadCount.keyword)} | `;
                
                // const data = {
                //     userID: userData.id,
                //     action: "Search Volume Tools - New Get Count",
                //     desc,
                //     userIP: this.$store.getters.userData.ip_login,
                // }
                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                // if(userViewMode){
                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                //     data.userID = userRoot.id;
                // }
                // this.userLogSaved({ data })
                this.$store.dispatch('onSaveUserLogs', {
                    desc: desc,
                    action: "Search Volume Tools - New Get Count",
                    // target_id: this.selectedRowData.user_id,
                    target_id: this.userIdCampaign,
                })
                
            }
        },
        async onSendTestSpreadsheet() { 
            try {
                this.$store.dispatch('onSendTestSpreadsheet', {
                    campaignID : this.selectedRowData.id
                }).then(response => {

                    if (response.data.result == 'success') {
                        this.$notify({
                            type: response.data.result,
                            message: response.data.message,
                            icon: 'far fa-check'
                        });
                    } else {
                        const status = response.data.status || 'UNKNOWN';

                        swal.fire({
                              title: `<span style='font-size:21px;'><b>Spreadsheet Connection Failed</b><br><br><span style='font-size:16px;'>We couldn’t connect to the spreadsheet. It may belong to a different Google account. <br>Please switch to the correct account in the General Settings, or create a new spreadsheet to begin writing data. <br><br><span style='font-size:13px;'>Reason: ${status}</span></span></span>`,
                              text: '',
                              icon: '',
                              width: '600px',
                              showCancelButton: true,
                              customClass: {
                                confirmButton: 'btn btn-fill mr-3',
                                cancelButton: 'btn btn-danger btn-fill'
                              },
                              confirmButtonText: "Create New Spreadsheet",
                              buttonsStyling: false
                        }).then(result => {
                            if (result.isConfirmed) {
                                this.resetSpreadsheet(this.selectedRowData.id, this.selectedRowData.leadspeek_api_id);
                            }
                        });
                    }
                    
                }, err => {
                    this.$notify({
                        type: 'danger',
                        message: `Spreadsheet connection failed. Please ensure your Google account is connected in the General Settings menu.`,
                        icon: 'far fa-warning'
                    });
                })

            } catch (error) {

            }

        },
        resetSpreadsheet(id, leadspeek_api_id) {
            // panggil API / dispatch Vuex / logika reset di sini
            this.isLoadingResetSpreadsheet = true;
            this.$store.dispatch('onResetSpreadsheet', {
                campaignID: id
            }).then(response => {
                this.isLoadingResetSpreadsheet = false;
                // getHistorySpreadsheet(leadspeek_api_id);

                if (response.data.result == 'success') {
                    this.$notify({
                        type: 'success',
                        message: 'Reset Spreadsheet successfully',
                        icon: 'far fa-save'
                    });
                } else {
                    this.$notify({
                        type: response.data.result,
                        message: response.data.message,
                        icon: 'far fa-info'
                    });
                }
                
                this.modals.integrations = false;
                this.GetClientList(this.currSortBy,this.currOrderBy)
                
            }, error => {
                console.log('eror : ', error);
                this.isLoadingResetSpreadsheet = false;

                this.$notify({
                    type: 'error',
                    message: 'Reset Spreadsheet Error. Try Again',
                    icon: 'far fa-warning'
                });

                this.modals.integrations = false;
                this.GetClientList(this.currSortBy,this.currOrderBy)
                // getHistorySpreadsheet(leadspeek_api_id);
            });
        },
        getHistorySpreadsheet(leadspeek_api_id) {

            this.$store.dispatch('getHistorySpreadsheet', {
                campaignID: leadspeek_api_id
            }).then(response => {
                this.spreadsheetHistory = response.data; // bisa juga langsung dari state
            });
            
        },
        handleClickMenuClickFunnels(value){
            if(this.menuClickFunnels === value){
                return;
            }

            if(value == 'choose-tag'){
                this.getListTagsClickFunnels();
            }

            this.menuClickFunnels = value;
        },
        onColorClickFunnels(value){
            this.formNewTagClickFunnels.color = value;
            this.$refs.formNewTagClickFunnels.clearValidate(['color']);
        },
        removeTagClickFunnels(tag) {
            this.listTagsClickFunnelsSelected = this.listTagsClickFunnelsSelected.filter(t => t.id !== tag.id);
        },
        getListTagsClickFunnels(){
            this.isLoadingGetTagsClickFunnels = true;
            this.errors.clickfunnels = false;
            const payload = {
                company_id: this.selectedRowData.company_id,
            }
            
            this.$store.dispatch('getListTagsClickFunnels', payload).then(response => {
                this.listTagsClickFunnels = response.data;
                this.isLoadingGetTagsClickFunnels = false;
                this.getCampaignTagsClickFunnels();
            }, error => {
                this.errors.clickfunnels = true;
                this.isLoadingGetTagsClickFunnels = false;
            })
        },
        getCampaignTagsClickFunnels(){
            this.isLoadingGetCampaignTagsClickFunnels = true;
            const payload = {
                campaign_id: this.selectedRowData.id,
            }
            
            this.$store.dispatch('getCampaignTagsClickFunnels', payload).then(response => {
                const tagId = response.data.clickfunnels_tags;
                const filterTags = this.listTagsClickFunnels.filter(tag => tagId.includes(tag.id))
                this.listTagsClickFunnelsSelected = filterTags;
                this.selectedRowData.clickfunnels_is_active = response.data.clickfunnels_is_active === 1;
                this.isLoadingGetCampaignTagsClickFunnels = false;
            }, error => {
                this.errors.clickfunnels = true;
                this.isLoadingGetCampaignTagsClickFunnels = false;
            })
        },
        onCreateTagsClickFunnels(){
            if(!this.formNewTagClickFunnels.name.trim()){
                this.$refs.formNewTagClickFunnels.validateField(['name']);
                return;
            }
            
            if(!this.formNewTagClickFunnels.color.trim()){
                this.$refs.formNewTagClickFunnels.validateField(['color']);
                return;
            }

            this.isLoadingCreateTagsClickFunnels = true;
            const payload = {
                company_id: this.selectedRowData.company_id,
                name: this.formNewTagClickFunnels.name,
                color: this.formNewTagClickFunnels.color,
            }

            this.$store.dispatch('createTagsClickFunnels', payload).then(response => {
                this.isLoadingCreateTagsClickFunnels = false;
                this.$notify({
                    type: 'success',
                    message: `${response.message} ${response.data.name}`,
                    icon: 'tim-icons icon-bell-55'
                });
                this.$refs.formNewTagClickFunnels.resetFields();
                this.formNewTagClickFunnels.name = '';
                this.formNewTagClickFunnels.color = '';
            }, error => {
                this.$notify({
                    type: 'danger',
                    message: error.message,
                    icon: 'tim-icons icon-bell-55'
                });
                this.isLoadingCreateTagsClickFunnels = false;
            })
        },
        getTextColor(backgroundColor) {
            const rgb = this.hexToRgb(backgroundColor);
            const luminance = (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
            return luminance > 0.5 ? '#000' : '#fff';
        },
        hexToRgb(hex) {
            const match = hex.match(/^#([0-9a-fA-F]{6})$/);
            if (match) {
                const r = parseInt(match[1].substring(0, 2), 16);
                const g = parseInt(match[1].substring(2, 4), 16);
                const b = parseInt(match[1].substring(4, 6), 16);
                return { r, g, b };
            }
            return { r: 255, g: 255, b: 255 };  // Default to white if the color is invalid
        },
        handleWindowResize(){
            this.isCollapseMenuClickFunnels = window.innerWidth < 768;
            this.windowWidth = window.innerWidth;
        },
        async getStatusKeywordToTags(slug){
            const params = {
                leadspeek_api_id: this.selectedRowData.leadspeek_api_id,
                slug,
            }
            this.isLoadingTagsAutomation = true;
            this.isActiveTagsAutomation = false;
            this.isErrorTagsAutomation = false;

            await this.$store.dispatch('getStatusKeywordToTags', params).then(response => {
                this.isActiveTagsAutomation = response.data;
                this.isLoadingTagsAutomation = false;
            }).catch(error => {
                console.error(error);
                this.isErrorTagsAutomation = true;
                this.isLoadingTagsAutomation = false;
            })
        },
        onTagsAutomation(){
            this.isActiveTagsAutomation = !this.isActiveTagsAutomation;
            this.changeGhlTags();
        },
        openGoogleSheet() {
            window.open(this.sheetUrl, '_blank');
        },
    },

    mounted() {
        this.GetCompanyGroup();
        if(this.$global.settingMenuShow && !this.$global.systemUser && this.$global.creditcardsetup && this.$global.stripeaccountconnected){
        this.steps.splice(2,0,   {
            target: '.client-filter-anchor',  // We're using document.querySelector() under the hood
            content: 'Filter to view only specific clients',
            params: {
                 enableScrolling: false,
            },
          },)
       }
        const userData = this.$store.getters.userData;
        if (userData.user_type == 'client') {
            localStorage.setItem('companyGroupSelected',userData.id);
            this.companyID = userData.company_parent;
        }else{
            this.companyID = userData.company_id;
        }
        this.selectsPaymentTerm.PaymentTerm = this.$global.rootpaymentterm;
        this.leadlocatorname = userData.leadlocatorname;
        this.leadlocalname = userData.leadlocalname;
        if (this.$global.globalviewmode) {
            this.userTypeOri = userData.user_type_ori;
        }
        const protectAccessMenu = () => {
            if(!this.$global.stripeaccountconnected) {
                if(userData.user_type == 'client') {
                    this.$router.push({ name: 'Profile Setup' });
                } else if (userData.user_type == 'userdownline' || userData.user_type == 'user')  {
                    this.$router.push({ name: 'General Setting' });
                }
                return;
            }

            if(userData.user_type == 'client'){
                const sidebar = this.$global.clientsidebar

                if (!sidebar['predict']){
                    this.$router.push({ name: 'Profile Setup' });
                    return;
                }
                
            } else if (userData.user_type == 'userdownline' || userData.user_type == 'user'){
                const sidebarAgency = this.$global.agency_side_menu && this.$global.agency_side_menu.find(menu => menu.type == 'predict')

                if((sidebarAgency && !sidebarAgency.status) || !this.validateBetaFeature('predict_module')){
                    this.$router.push({ name: 'Profile Setup' });
                    return;
                }
            }
        }

        protectAccessMenu()
        this.userType = userData.user_type;
        this.getBusinessResources();
        // this.getBusinessIndustries();
        // this.getCrmLists();
        this.getStopWords();
        this.checkGoogleConnect();
        this.GetCompanyList();
        this.GetAdministratorList();
        this.GetListAdvanceInformation();
        this.getMasterAgencyCost();
        //this.GetClientList();
        CHECK_GROUPCOMPANY = setInterval(() => {
            if ((localStorage.getItem('companyGroupSelected') != null) && this.selectsAdministrator.administratorList.length != 0){
                clearInterval(CHECK_GROUPCOMPANY);
                this.GetClientList();
                this.GetClientListAll()
                this.handleAutoOpenModal()
            }
        }, 1000);
        this.getStateList();  
        this.initial_default_price();
        this.resetDefaultCampaigndate();
        this.reset();
        window.addEventListener("resize", this.handleWindowResize);
    },

    watch: {
        LeadspeekEnableMinimumLeadsPerDayAdd(newValue) {
            this.showInputLeadspeekPerDayAdd = (newValue == true) ? true : false;
        },
        LeadspeekEnableMinimumLeadsPerDay(newValue) {
            this.showInputLeadspeekPerDay = (newValue == true) ? true : false;
        },
        'modals.whitelist': function(newValue) {
            if(!newValue) {
                this.supressionProgress = [];
                clearTimeout(this.supressionTimeout);
                clearInterval(this.supressionInterval);
            }
        },

        prepaidType(newValue, oldvalue) {
            if(Number(this.totalLeads.oneTime) < Number(this.minimumLeadPrepaidOneTime)) {
                this.totalLeads.oneTime = this.minimumLeadPrepaidOneTime;
                this.err_totalleads = '';
            }
            if(newValue === 'continual' && oldvalue === 'onetime') {
                this.profitcalculation();
            }
        },

        'modals.campaignEdit': function(newValue){
            if(!newValue){
                this.GetClientList(this.currSortBy,this.currOrderBy)
            }
        },
        'modals.campaign': function(newValue){
            if(newValue){
                this.fetchCustomFieldsList();
            }
        },

        'modals.approxLead'(newVal) {
            if (newVal) {
                if(this.isProccessingLeadCount){
                    // start interval
                    this.intervalFetchLeadCount = setInterval(() => {
                        const data = {
                            id: this.formApproxLeadCount.campaign_id,
                            user_id: this.formApproxLeadCount.user_id,
                            leadspeek_api_id: this.formApproxLeadCount.leadspeek_api_id,
                        }
    
                        this.fetchLeadCount(data);
                    }, 60000); // 60000 ms = 1 minute
                }
            } else {
                // Modal closed - clear interval
                if (this.intervalFetchLeadCount) {
                    clearInterval(this.intervalFetchLeadCount);
                    this.intervalFetchLeadCount = null;
                }
            }
        },
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        // searchQuery(value) {
        //     if (value.length > 3) {
        //          this.GetClientList(this.currSortBy,this.currOrderBy,value);
        //     }
            
        // }
    },
    beforeDestroy(){
        // Stop auto refresh
        this.stopAutoRefresh();

        // Safely remove dropdown scroll listener - check if refs exist first
        const selectRef = this.$refs.select;
        if (
            selectRef &&
            selectRef.$refs &&
            selectRef.$refs.popper &&
            selectRef.$refs.popper.$el
        ) {
            const dropdown = selectRef.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
            if (dropdown && this.handleScroll) {
                dropdown.removeEventListener('scroll', this.handleScroll);
            }
        }

        // Clear intervals
        if (this.intervalFetchLeadCount) {
            clearInterval(this.intervalFetchLeadCount);
            this.intervalFetchLeadCount = null;
        }
        if (this.supressionInterval) {
            clearInterval(this.supressionInterval);
            this.supressionInterval = null;
        }

        // Remove window resize listener
        if (this.handleWindowResize) {
            window.removeEventListener("resize", this.handleWindowResize);
        }

        // Safely remove GHL tags input listener - check if ref exists first
        const selectGhlTagsRef = this.$refs.selectGhlTags;
        if (selectGhlTagsRef && selectGhlTagsRef.$el) {
            const inputGhlTags = selectGhlTagsRef.$el.querySelector('.select-integration-ghl .el-select__input');
            if (inputGhlTags && this.keydownInputGhlTags) {
                inputGhlTags.removeEventListener('keyup', this.keydownInputGhlTags);
            }
        }

        // Remove message listener if it exists
        if (this.callbackGoogleConnected) {
            window.removeEventListener('message', this.callbackGoogleConnected);
        }
    }
}
</script>
<style scoped>
.icon_btn_download {
    margin-left: 0 !important;
}
.llm-option-stack {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
}

.llm-option-panel {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 12px;
}

.llm-option-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
}

.llm-option-title {
    font-weight: 700;
    color: #111827;
}

.llm-option-subtitle {
    font-size: 12px;
    color: #6b7280;
}

.llm-option-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.llm-option-body.is-inline {
    flex-direction: row;
    flex-wrap: wrap;
}

.llm-option-chip {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 8px 10px;
    background: #fff;
    cursor: pointer;
    text-align: left;
}

.llm-option-chip.button {
    background: #f9fafb;
}

.llm-option-chip:hover {
    border-color: #cbd5e1;
}

.llm-option-chip input[type="radio"] {
    margin-top: 2px;
}

.llm-option-copy {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.llm-option-label {
    font-weight: 700;
    color: #111827;
}

.llm-option-desc {
    font-size: 12px;
    color: #4b5563;
    line-height: 1.3;
}
.llm-option-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
}

.marginEnableMinimumContactPerDay {
    margin: 12px 0;
}

@media (min-width: 768px) {
    .inputCostPerContact {
        margin-top: 23.5px;
    }
    .inputCostPerContactEnableMinimum {
        margin-top: -4px;
    }
    .containerMinimumLeadsPerDay {
        margin-top: -5px;
    }
}

.spinRefund {
  animation: spinRefund 1s linear infinite;
}
@keyframes spinRefund {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.campaign-detail-modal {
    max-width: 1080px;
}

.campaign-detail-body {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.campaign-detail-section {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 18px 20px;
    box-shadow: 0 4px 12px rgba(17, 24, 39, 0.04);
}

.campaign-detail-section-title {
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 14px;
}

.campaign-detail-modal .el-divider--horizontal {
    margin: 16px 0;
}

/* Analyze Customer Choices - Simple Create Campaign Style */
.analysis-choices-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.analysis-choice-item {
    display: flex;
    flex-direction: column;
    padding: 16px 18px;
    background: #ffffff;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.analysis-choice-item:hover {
    background: #f9f9f9;
    border-color: #bbb;
}

.choice-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.choice-name {
    font-size: 15px;
    font-weight: 700;
    color: #000000;
    margin: 0;
    word-break: break-word;
    line-height: 1.5;
    opacity: 1;
}

.choice-description {
    font-size: 13px;
    line-height: 1.65;
    color: #555;
    margin: 0;
    word-break: break-word;
}

@media (max-width: 768px) {
    .analysis-choices-container {
        gap: 14px;
    }

    .analysis-choice-item {
        padding: 14px 16px;
    }

    .choice-name {
        font-size: 14px;
    }

    .choice-description {
        font-size: 12px;
    }
}

.selected-pill-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.selected-pill {
    display: inline-flex;
    align-items: center;
    padding: 6px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fff;
    color: #111827;
    font-size: 13px;
    line-height: 1.4;
}

.selected-location-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 8px;
}

.selected-location-item {
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fff;
    color: #111827;
    font-size: 13px;
    line-height: 1.4;
}

/* Custom Fields Config modal (create campaign) */
.custom-fields-campaign-modal-content {
    max-height: 70vh;
    overflow-y: auto;
    padding: 4px 0;
}
.custom-fields-campaign-modal-content .custom-fields-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 4px;
}
.custom-fields-campaign-modal-content .custom-fields-section:last-of-type {
    margin-bottom: 0;
}
.custom-fields-campaign-modal-content .custom-fields-title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
}
.custom-fields-list-inline {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 8px 12px;
}
.custom-field-item-inline {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #111827;
    cursor: pointer;
}
.custom-field-item-inline input { cursor: pointer; }
.custom-fields-order-title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 6px;
}
.custom-fields-empty-inline {
    font-size: 13px;
    color: #6b7280;
    padding: 16px 12px;
    text-align: center;
    background: #f9fafb;
    border-radius: 6px;
    border: 1px dashed #e5e7eb;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.custom-fields-order-list-inline {
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-height: 315px;
    overflow-y: auto;
}
.custom-fields-order-item-inline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #fff;
    cursor: grab;
}
.custom-fields-order-item-inline:active {
    cursor: grabbing;
}
.custom-fields-order-item-inline.is-dragging {
    opacity: 0.5;
    cursor: grabbing;
}
.custom-fields-order-item-inline.is-drag-over {
    border-color: #3b82f6;
    background-color: #eff6ff;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}
.order-label-inline {
    font-size: 13px;
    color: #111827;
    display: flex;
    align-items: center;
    gap: 8px;
}
.drag-handle-inline {
    color: #9ca3af;
    cursor: grab;
    font-size: 16px;
}
.drag-handle-inline:active {
    cursor: grabbing;
}
.order-actions-inline { display: flex; gap: 6px; }
.custom-fields-config-modal-card >>> .el-card__body,
.custom-fields-config-modal-card ::v-deep .el-card__body {
    padding: 20px 24px !important;
}
.btn-custom-fields-modal-cancel,
.btn-custom-fields-modal-save {
    min-height: 40px;
    height: 40px;
    padding-top: 0;
    padding-bottom: 0;
}
</style>
<style>
.el-card__body {
  padding: 10px 20px !important;
}
.select-integration-ghl .el-tag.el-tag--info.el-tag--small.el-tag--light.red-tag {
    background-color: red !important;
    color: white !important;
}

.primary__text__color, 
.primary__text__color input {
    color: #222a42;
}

.mailboxzipcode .el-textarea__inner {
    line-height: 2;
}

.popProcessing {
    font-weight: bold;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    position: fixed;
    color: gray;
    background-color: white;
    height: 60px;
    width: 320px;
    padding-left: 30px;
    padding-top: 18px;
    border: 1px solid green;
}

.qanswer {
    font-weight: bold;
    font-style: italic;
    padding-bottom: 10px;
}
.clickable-rows td {
    cursor: pointer;
}
/* .el-table__expanded-cell {
    background-color: red;
} */
/* .clickable-rows .el-table, .el-table__expanded-cell {
    background-color:#1e1e2f;
} */
.clickable-rows tr .el-table__expanded-cell {
    cursor: default;
}

.select-fullwidth {
    width: 100%;
}
.perleads {
    width: 60px;
    display: inline-block !important;
}

.table .form-check label .form-check-sign::before, .el-table table .form-check label .form-check-sign::before, .table .form-check label .form-check-sign::after, .el-table table .form-check label .form-check-sign::after {
    top:3px;
    left: 0px;
}

.green {
    color: green;
}
.red {
    color: red;
}
.gray {
    color: #6c757d;
}
.orange {
    color: #fb6340;
}
.cursordefault {
    cursor: default;
}
.cursornodrop {
    cursor: no-drop;
}

.el-table__fixed-right::before, .el-table__fixed::before {
    background-color: transparent;
}

tr.hover-row > td {
    background-color: transparent !important;
}

.el-table__fixed-body-wrapper .el-table__row > td:not(.is-hidden)  {
    border-top: transparent !important;
}

.frmSetCost .input-group input[type=text], .frmSetCost input[type=text],.frmSetCost .input-group .input-group-prepend .input-group-text {
    color: #525f7f;
    border-color: #525f7f;
}
.el-date-editor .el-input__suffix-inner .el-input__icon{
  display: none;
}

.errwarning {
    color: #942434 !important;
    font-weight: bold !important;
}
.alert-li{
color:initial !important;
}
.el-tabs__nav {
    width: 100%;
}
.el-tabs__item{
    width: 50%;
}
.el-badge__content{
    height: 20px;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
    color: #222a42 !important;
    font-weight: 600 !important;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
    color: #222a42 !important;
}
.el-badge__content--success{
    background-color: green !important;
}

.container__input__campaign__management {
    /* padding-inline: 16px; */
}

.input__campaign__management {
    width: 22vw;
}

.container__filter__campaign__management {
    /* padding-inline: 16px; */
    margin-top: -2px;
}

.button_add__client__campaign__management {
    margin-inline: 16px;
}

.dropdown-hidden {
  display: none !important;
}

.input__campaign__management .el-input__inner {
    padding-left: 30px;
    padding-right: 30px;
}

.add-new-integration-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    border: 1px dotted rgb(155, 155, 155);
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 16px;
    transition: all 0.5s ease-in-out;
}

.add-new-integration-wrapper i {
    transition: all 0.5s ease-in-out;
    user-select: none;
}

.add-new-integration-wrapper:hover i {
    transform: rotate(180deg);
}

.add-new-integration-wrapper:hover {
    border-color: rgb(120, 120, 120);
}

.success-banner {
    padding: 8px 16px;
    background-color: #e6ffed; /* Light green background */
    border-radius: 4px;
    border-left: 5px solid #28a745; /* Green border */
    margin: 20px 0;
    font-size: 14px;
    color: #2f4f4f; /* Darker green text for readability */
    line-height: 1.5em;
}

.success-banner p {
    margin: 0;
}

.info-banner {
    padding: 8px 16px;
    background-color: #e6f7ff; /* Light blue background for info */
    border-radius: 4px;
    border-left: 5px solid #17a2b8; /* Blue border for info */
    margin: 20px 0;
    font-size: 14px;
    color: #3c8dbc; /* Darker blue text for readability */
    line-height: 1.5em;
}

.info-banner p {
    margin: 0;
}

.error-banner {
    padding: 8px 16px;
    background-color: #ffe6e6; /* Light red background for error */
    border-radius: 4px;
    border-left: 5px solid #dc3545; /* Red border for error */
    margin: 20px 0;
    font-size: 14px;
    color: #721c24; /* Darker red text for readability */
    line-height: 1.5em;
}

.error-banner p {
    margin: 0;
}

.empty-banner {
    padding: 8px 16px;
    background-color: #fff3cd; /* Light yellow background for warning */
    border-radius: 4px;
    border-left: 5px solid #ffc107; /* Yellow border for warning */
    margin: 20px 0;
    font-size: 14px;
    color: #856404; /* Dark yellow text for readability */
    line-height: 1.5em;
}

.empty-banner p {
    margin: 0;
}

.grid-container-campaign-information {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.container-checkbox-item-advanced-information {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

.business-mode-tabs-wrapper {
    display: flex;
    justify-content: center;
}
.business-mode-tabs-wrapper .el-tabs__item.is-active{
    border-bottom-color: #E4E7ED !important;
}
.business-mode-tabs {
    width: 100%;
}

.campaign-information-active {
  border: 1px solid #222a42;
}

.checkbox-advanced-information .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #686868;
}

.checkbox-advanced-information .el-checkbox__inner {
    border-color: #686868;
    border-radius: 3px;
}

.checkbox-advanced-information .el-checkbox__inner:hover {
    border-color: #686868;
}

.checkbox-advanced-information .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #000000;
}

.checkbox-advanced-information .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #686868;
    background-color: #686868;
    border-radius: 3px;
}

.checkbox-advanced-information .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #686868;
    background-color: #686868;
}

.select__form__client .el-input__inner {
    border-radius: 0.4285rem;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}
.el-form--label-top .el-form-item__label {
    padding: 0;
}

.el-form-item {
    margin-bottom: 16px;
}

.click-funnels-tag-select .el-select__tags {
  display: none;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-item {
  display: flex;
  align-items: center;
  padding: 6px 10px; 
  border-radius: 6px;
  border: 1px solid;
  word-wrap: break-word; 
  word-break: break-word;
  white-space: normal;
}

.tag-text {
  flex: 1;
  overflow-wrap: break-word;
  font-size: 12px;
}

.close-icon {
  margin-left: 6px;
  cursor: pointer;
}

.skeleton-tag {
  width: 80px;
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 6px;
  margin-right: 8px;
  margin-bottom: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

@media (max-width: 991.98px) {
    .input__campaign__management {
        width: 100%;
    }
    .container__input__campaign__management {
        width: 100%;
    }
    .container-checkbox-item-advanced-information {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 575.98px) { 
    .container__filter__campaign__management {
        width: 100%;
    }
    .dropdown__filter__campaign__management {
        width: 100%;
    }
    .button__filter__campaign__management {
        width: 100%;
    }
    .button_add__client__campaign__management {
        margin-inline: 0px;
    }
    .input__campaign__management{
        margin-bottom: 4px;
    }
    .grid-container-campaign-information {
        grid-template-columns: repeat(1, 1fr);
    }
    .container-checkbox-item-advanced-information {
        grid-template-columns: repeat(1, 1fr);
    }
}
.el-alert .el-alert__description {
    margin: 0px;
}

.gsheet-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  /* grid-template-columns: repeat(auto-fit, minmax(120px, auto)); */
  gap: 10px;
}

.gsheet-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f7f7;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: background-color 0.2s;
}

.gsheet-item:hover {
  background-color: #e0e0e0;
  transition: background-color 0.2s ease;
}

.campaign-type-option {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  white-space: normal;
  padding: 12px 0px; 
}

.campaign-type-option__title {
  font-weight: 600;
  color: #303133;
}

.campaign-type-option__desc {
  font-size: 12px;
  color: #606266;
}

.history-grid {
  display: grid;
  /* grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); */
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}

.history-label {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f7f7;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: background-color 0.2s;
}

.history-item:hover {
  background-color: #e0e0e0;
  transition: background-color 0.2s ease;
}

.step-into-title{
    margin-bottom: 0;
    letter-spacing: -0.025em;
    font-weight: 600;
    font-size: 1.875rem;
    line-height: 2.25rem !important;
    color: #171717 !important;
}

/* Customer List View Table - Using el-table */
.customer-list-view-table.el-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.customer-list-view-table.el-table table {
  color: #606266 !important;
}

.customer-list-action-icon:hover {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.step-info-desc{
color: #525252 !important;
}

/* Custom max-height untuk textarea tertentu */
.textarea-custom-height.form-control {
  max-height: 95px !important;
}

/* Campaign Stop Badges */
.campaign-card-stop-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.campaign-card-stop-badge.immediate {
  background-color: #d32f2f;
  color: white;
}

.campaign-card-stop-badge.period-end {
  background-color: #f57c00;
  color: white;
  cursor: help;
}

.campaign-card-stop-badge.period-end:hover {
  background-color: #e65100;
}

/* Tooltip styling untuk stop status */
.el-tooltip__popper[x-placement^="top"] {
  font-size: 12px;
}
</style>
